(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (global){
"use strict";

window.debug = require('debug');
window.idb = require('idb');
window.Dropbox = require('dropbox');
window['recordingTransactionsClient'] = require('@zencastr/socket-transactions').recordingTransactionsClient;
window['jwtClient'] = require('@zencastr/jwt-fetch-client');
window['datadogRum'] = require('@datadog/browser-rum').datadogRum;

require('regenerator-runtime/runtime'); // take this directly from dist because we need the js file.


global.ResumableUploadB2 = require('../dist/media/scripts/lib/mixins/upload_b2')["default"];
global.ResumableUploadGcs = require('../dist/media/scripts/lib/mixins/upload_gcs')["default"];

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../dist/media/scripts/lib/mixins/upload_b2":2,"../dist/media/scripts/lib/mixins/upload_gcs":3,"@datadog/browser-rum":118,"@zencastr/jwt-fetch-client":123,"@zencastr/socket-transactions":134,"debug":139,"dropbox":146,"idb":153,"regenerator-runtime/runtime":155}],2:[function(require,module,exports){
"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var deferred_1 = require("../promises/deferred");

var CHUNK_SIZE = 5 * 1024 * 1024;
var MTU_SIZE = 1300;
var BANDWIDTHS = {
  'audio/mpeg': 16,
  'audio/wav': 96
};

var ResumableUploadB2 = /*#__PURE__*/function () {
  function ResumableUploadB2(options) {
    _classCallCheck(this, ResumableUploadB2);

    this.isConnected = true;
    this.shouldUsePacing = false;
    this.shouldEstimateBandwith = true;
    this.bandwidth = 0;

    if (!options.url) {
      throw new Error("Missing argument url");
    }

    if (!options.contentType) {
      throw new Error("Missing argument contentType");
    }

    if (['audio/mpeg', 'audio/wav'].includes(options.contentType)) {
      this.shouldEstimateBandwith = false;
      this.bandwidth = BANDWIDTHS[options.contentType];
    }

    this.url = options.url;
    this.contentType = options.contentType;
    this.progressCb = options.progressCb;
    this.bytesUploaded = 0;
    this.bytesUploadedCurrentChunk = 0;
    this.shouldUsePacing = options.shouldUsePacing;
    this.supportsStreamBody = ResumableUploadB2.doesSupportStreamBody();
  }

  _createClass(ResumableUploadB2, [{
    key: "enableProgressTracker",
    value: function enableProgressTracker() {}
  }, {
    key: "disableProgressTracker",
    value: function disableProgressTracker() {}
  }, {
    key: "uploadChunk",
    value: function () {
      var _uploadChunk = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(chunk, partNumber, isLastChunk) {
        var valid, logs, url, response, _JSON$parse, etag, logLine;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                valid = this.isValidChunkSize(chunk, isLastChunk);

                if (valid) {
                  _context.next = 3;
                  break;
                }

                throw new Error("Invalid chunk size. Received: ".concat(chunk.size));

              case 3:
                console.debug("Uploading chunk with size ".concat(chunk.size, ", number ").concat(partNumber, ", contentType ").concat(this.contentType));
                logs = [];
                _context.prev = 5;
                this.bytesUploadedCurrentChunk = 0;
                url = this.url + "&partNumber=".concat(partNumber);
                _context.next = 10;
                return this.fetchOrXhrWithRetries('PUT', url, {
                  'Content-Type': this.contentType
                }, this.buildFetchBody(chunk, logs));

              case 10:
                response = _context.sent;

                if (!response.ok) {
                  _context.next = 17;
                  break;
                }

                this.bytesUploadedCurrentChunk = 0;
                this.bytesUploaded += chunk.size;
                this.progressCb(this.bytesUploaded);
                _context.next = 18;
                break;

              case 17:
                throw new Error("Upload failed with http status ".concat(response.status, ": ").concat(response.text));

              case 18:
                _JSON$parse = JSON.parse(response.text), etag = _JSON$parse.etag;
                return _context.abrupt("return", {
                  etag: etag
                });

              case 22:
                _context.prev = 22;
                _context.t0 = _context["catch"](5);
                console.error('Upload fetch failed', _context.t0.toString());

                if (this.shouldUsePacing) {
                  this.shouldUsePacing = false;
                  console.log('Turning off pacing');
                }

                if (logs.length) {
                  logLine = logs.map(function (logLine) {
                    return logLine.join(',');
                  }).join('\n');
                  console.warn('controller pulled chunk \n' + logLine);
                }

                throw new Error('Failed uploading a chunk');

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 22]]);
      }));

      function uploadChunk(_x, _x2, _x3) {
        return _uploadChunk.apply(this, arguments);
      }

      return uploadChunk;
    }()
  }, {
    key: "completeMultipartUpload",
    value: function () {
      var _completeMultipartUpload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(parts) {
        var finalResponse;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("Completing the upload after all parts have been uploaded. Number of parts:", parts.length);
                _context2.next = 3;
                return this.fetchOrXhrWithRetries('POST', this.url, {
                  'Content-Type': 'application/json'
                }, JSON.stringify({
                  parts: parts
                }));

              case 3:
                finalResponse = _context2.sent;

                if (!finalResponse.ok) {
                  _context2.next = 9;
                  break;
                }

                console.log("Upload done");
                return _context2.abrupt("return", JSON.parse(finalResponse.text));

              case 9:
                throw new Error('Error finalizing the file');

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function completeMultipartUpload(_x4) {
        return _completeMultipartUpload.apply(this, arguments);
      }

      return completeMultipartUpload;
    }()
  }, {
    key: "fetchOrXhrWithRetries",
    value: function fetchOrXhrWithRetries(method, url, headers, body) {
      var _this = this;

      return this.callWithRetries(function () {
        return _this.fetchOrXhr(method, url, headers, body);
      });
    }
  }, {
    key: "fetchOrXhr",
    value: function () {
      var _fetchOrXhr = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(method, url, headers, body) {
        var _this2 = this;

        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(body instanceof ReadableStream)) {
                  _context3.next = 10;
                  break;
                }

                _context3.next = 3;
                return fetch(url, {
                  method: method,
                  headers: headers,
                  body: body,
                  cache: 'no-cache',
                  credentials: 'omit',
                  redirect: 'follow',
                  referrerPolicy: 'no-referrer'
                });

              case 3:
                response = _context3.sent;
                _context3.t0 = response.ok;
                _context3.t1 = response.status;
                _context3.next = 8;
                return response.text();

              case 8:
                _context3.t2 = _context3.sent;
                return _context3.abrupt("return", {
                  ok: _context3.t0,
                  status: _context3.t1,
                  text: _context3.t2
                });

              case 10:
                return _context3.abrupt("return", new Promise(function (resolve, reject) {
                  try {
                    var xhr = new XMLHttpRequest();
                    xhr.upload.addEventListener('progress', function (event) {
                      if (event.lengthComputable) {
                        _this2.bytesUploadedCurrentChunk = event.loaded;

                        _this2.progressCb(_this2.bytesUploaded + _this2.bytesUploadedCurrentChunk);
                      }
                    });
                    xhr.addEventListener('loadend', function () {
                      var ok = 200 <= xhr.status && xhr.status < 300;
                      if (xhr.readyState === 4) resolve({
                        ok: ok,
                        status: xhr.status,
                        text: xhr.responseText
                      });else reject(new Error("Upload request didn't reach the ready state"));
                    });
                    xhr.addEventListener('error', function () {
                      return reject(new Error('Upload request failed'));
                    });
                    xhr.addEventListener('timeout', function () {
                      return reject(new Error('Upload request timed out'));
                    });
                    xhr.open(method, url, true);
                    Object.entries(headers).forEach(function (_ref) {
                      var _ref2 = _slicedToArray(_ref, 2),
                          key = _ref2[0],
                          value = _ref2[1];

                      xhr.setRequestHeader(key, value);
                    });
                    xhr.send(body);
                  } catch (error) {
                    reject(error);
                  }
                }));

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function fetchOrXhr(_x5, _x6, _x7, _x8) {
        return _fetchOrXhr.apply(this, arguments);
      }

      return fetchOrXhr;
    }()
  }, {
    key: "buildFetchBody",
    value: function buildFetchBody(body) {
      var _this3 = this;

      var logs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (!this.supportsStreamBody || !this.shouldUsePacing) return body;

      if (this.shouldEstimateBandwith) {
        var now = Date.now();

        if (this.chunkTimestamp) {
          var newValue = body.size / (now - this.chunkTimestamp);
          this.bandwidth = (this.bandwidth + newValue) / 2;
        } else {
          this.chunkTimestamp = now;
          return body;
        }

        this.chunkTimestamp = now;
      }

      var sent = 0;
      var lastTimeOfPull = null;
      var options = {
        pull: function () {
          var _pull = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(controller) {
            var toSend, buffer, _now, chunkSize, timePassed, multiplier, _toSend, _buffer, timeout;

            return regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    if (_this3.shouldUsePacing) {
                      _context4.next = 8;
                      break;
                    }

                    toSend = body.slice(sent, body.size);
                    _context4.next = 4;
                    return toSend.arrayBuffer();

                  case 4:
                    buffer = _context4.sent;
                    controller.enqueue(new Uint8Array(buffer));
                    controller.close();
                    return _context4.abrupt("return");

                  case 8:
                    _context4.prev = 8;
                    _now = Date.now();
                    chunkSize = MTU_SIZE;

                    if (lastTimeOfPull) {
                      timePassed = Math.min(_now - lastTimeOfPull, 100);
                      multiplier = Math.floor(_this3.bandwidth * timePassed / MTU_SIZE);

                      if (multiplier > 0) {
                        chunkSize = multiplier * MTU_SIZE;
                      }

                      logs.push([_now, lastTimeOfPull, timePassed, multiplier, chunkSize]);
                    }

                    lastTimeOfPull = _now;
                    _toSend = body.slice(sent, sent + chunkSize);
                    _context4.next = 16;
                    return _toSend.arrayBuffer();

                  case 16:
                    _buffer = _context4.sent;
                    controller.enqueue(new Uint8Array(_buffer));
                    sent += _toSend.size;

                    if (!(sent >= body.size)) {
                      _context4.next = 23;
                      break;
                    }

                    logs.push('controller closing');
                    controller.close();
                    return _context4.abrupt("return");

                  case 23:
                    timeout = MTU_SIZE / _this3.bandwidth;
                    _context4.next = 26;
                    return _this3.sleep(timeout);

                  case 26:
                    _context4.next = 32;
                    break;

                  case 28:
                    _context4.prev = 28;
                    _context4.t0 = _context4["catch"](8);
                    _this3.shouldUsePacing = false;
                    logs.push(['Error inside pull method', _context4.t0.toString()]);

                  case 32:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, null, [[8, 28]]);
          }));

          function pull(_x9) {
            return _pull.apply(this, arguments);
          }

          return pull;
        }()
      };
      return new ReadableStream(options);
    }
  }, {
    key: "sleep",
    value: function sleep(ms) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, ms);
      });
    }
  }, {
    key: "callWithRetries",
    value: function () {
      var _callWithRetries = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(fn) {
        var options,
            _args5 = arguments;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                options = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {
                  times: 5,
                  wait: 2,
                  exponentialBackoff: 4
                };
                _context5.prev = 1;
                _context5.next = 4;
                return this.ensureConnection();

              case 4:
                _context5.next = 6;
                return fn();

              case 6:
                return _context5.abrupt("return", _context5.sent);

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](1);

                if (!(options.times > 1)) {
                  _context5.next = 17;
                  break;
                }

                _context5.next = 14;
                return this.sleep(options.wait * 1000);

              case 14:
                _context5.next = 16;
                return this.ensureConnection();

              case 16:
                return _context5.abrupt("return", this.callWithRetries(fn, {
                  times: options.times - 1,
                  wait: options.wait * options.exponentialBackoff,
                  exponentialBackoff: options.exponentialBackoff
                }));

              case 17:
                console.error("".concat(fn.toString(), " failed too many times, giving up with error:"), _context5.t0);
                throw _context5.t0;

              case 19:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[1, 9]]);
      }));

      function callWithRetries(_x10) {
        return _callWithRetries.apply(this, arguments);
      }

      return callWithRetries;
    }()
  }, {
    key: "ensureConnection",
    value: function ensureConnection() {
      return !this.isConnected && this.deferredConnection ? this.deferredConnection.promise : Promise.resolve();
    }
  }, {
    key: "connectionStatusChanged",
    value: function connectionStatusChanged(isConnected) {
      var _a;

      if (isConnected) {
        this.isConnected = true;
        (_a = this.deferredConnection) === null || _a === void 0 ? void 0 : _a.resolve();
        this.deferredConnection = undefined;
      } else {
        this.isConnected = false;
        this.deferredConnection = deferred_1.deferred();
      }
    }
  }, {
    key: "getUploadProgress",
    value: function () {
      var _getUploadProgress = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", {
                  bytesUploaded: this.bytesUploaded + this.bytesUploadedCurrentChunk,
                  status: 200
                });

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getUploadProgress() {
        return _getUploadProgress.apply(this, arguments);
      }

      return getUploadProgress;
    }()
  }, {
    key: "isValidChunkSize",
    value: function isValidChunkSize(chunk, isLastChunk) {
      if (isLastChunk) return true;
      var size = chunk.size;

      if (size < CHUNK_SIZE) {
        return false;
      } else {
        return size % CHUNK_SIZE === 0;
      }
    }
  }], [{
    key: "doesSupportStreamBody",
    value: function doesSupportStreamBody() {
      return ReadableStream && !new Request('', {
        body: new ReadableStream(),
        method: 'POST',
        duplex: 'half'
      }).headers.has('Content-Type');
    }
  }]);

  return ResumableUploadB2;
}();

exports["default"] = ResumableUploadB2;

},{"../promises/deferred":4}],3:[function(require,module,exports){
"use strict";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CHUNK_SIZE = 262144;
var CHUNK_UPLOAD_WAIT = 120000;
var PROGRESS_TIMEOUT = 30000;
var MAX_EXPONENTIAL_BACKOFF = 120000;
var RANGE_REQUEST_TIMOUT = 60000;
var MTU_SIZE = 1300;
var BANDWIDTHS = {
  'audio/mpeg': 16,
  'audio/wav': 96
};

var ResumableUploadGcs = /*#__PURE__*/function () {
  function ResumableUploadGcs(options) {
    _classCallCheck(this, ResumableUploadGcs);

    this.exponentialBackoff = 500;
    this.shouldUsePacing = true;
    this.shouldEstimateBandwith = true;
    this.bandwidth = 0;

    if (!options.url) {
      throw new Error("Missing argument url");
    }

    if (!options.contentType) {
      throw new Error("Missing argument contentType");
    }

    if (['audio/mpeg', 'audio/wav'].includes(options.contentType)) {
      this.shouldEstimateBandwith = false;
      this.bandwidth = BANDWIDTHS[options.contentType];
    }

    this.url = options.url;
    this.contentType = options.contentType;
    this.progressCb = options.progressCb;
    this.bytesUploaded = 0;
    this.chunkProgress = null;
    this.shouldUsePacing = options.shouldUsePacing;
    this.supportsStreamBody = ResumableUploadGcs.doesSupportStreamBody();
  }

  _createClass(ResumableUploadGcs, [{
    key: "enableProgressTracker",
    value: function enableProgressTracker() {
      var _this = this;

      if (this.statusTimeoutHandler !== undefined) return;

      var statusFunc = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var shouldReschedule, _yield$_this$fetch, status, headers, ok, uploaded;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  shouldReschedule = true;
                  _context.prev = 1;
                  _context.next = 4;
                  return _this.fetch({});

                case 4:
                  _yield$_this$fetch = _context.sent;
                  status = _yield$_this$fetch.status;
                  headers = _yield$_this$fetch.headers;
                  ok = _yield$_this$fetch.ok;

                  if (!ok) {
                    _context.next = 11;
                    break;
                  }

                  shouldReschedule = false;
                  return _context.abrupt("return");

                case 11:
                  uploaded = _this.parseRangeHeader(headers);

                  _this.progressCb(uploaded);

                  _context.next = 18;
                  break;

                case 15:
                  _context.prev = 15;
                  _context.t0 = _context["catch"](1);
                  console.warn("Range is not reported from GCS");

                case 18:
                  _context.prev = 18;

                  if (shouldReschedule) {
                    _this.statusTimeoutHandler = setTimeout(statusFunc, PROGRESS_TIMEOUT);
                  }

                  return _context.finish(18);

                case 21:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[1, 15, 18, 21]]);
        }));

        return function statusFunc() {
          return _ref.apply(this, arguments);
        };
      }();

      this.statusTimeoutHandler = setTimeout(statusFunc, PROGRESS_TIMEOUT);
    }
  }, {
    key: "disableProgressTracker",
    value: function disableProgressTracker() {
      if (this.statusTimeoutHandler) {
        clearTimeout(this.statusTimeoutHandler);
        this.statusTimeoutHandler = undefined;
      }
    }
  }, {
    key: "uploadChunk",
    value: function () {
      var _uploadChunk = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(chunk, partNumber, isLastChunk) {
        var valid, contentRange, controller, response, logs, logLine, _response, status, headers, ok, bytesReceived;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                valid = this.isValidChunkSize(chunk, isLastChunk);

                if (valid) {
                  _context2.next = 3;
                  break;
                }

                throw new Error("Invalid chunk size. Received: ".concat(chunk.size));

              case 3:
                contentRange = this.getContentRange(chunk, isLastChunk);
                controller = new AbortController();
                console.debug(" chunk with size ".concat(chunk.size, ", range ").concat(contentRange, ", contentType ").concat(this.contentType));
                this.currentChunk = chunk;
                this.currentFlag = isLastChunk;
                logs = [];
                _context2.prev = 9;
                this.watchChunkUpload(controller);
                _context2.next = 13;
                return this.fetch({
                  body: this.buildFetchBody(chunk, logs),
                  controller: controller,
                  contentRange: contentRange
                });

              case 13:
                response = _context2.sent;
                _context2.next = 24;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](9);
                console.error('Upload fetch failed', _context2.t0.toString());

                if (this.shouldUsePacing) {
                  this.shouldUsePacing = false;
                  console.log('Turning off pacing');
                }

                if (logs.length) {
                  logLine = logs.map(function (logLine) {
                    return logLine.join(',');
                  }).join('\n');
                  console.warn('controller pulled chunk \n' + logLine);
                }

                _context2.next = 23;
                return this.exponentialRetry();

              case 23:
                return _context2.abrupt("return", _context2.sent);

              case 24:
                this.clearChunkUploadWatcher();
                _response = response, status = _response.status, headers = _response.headers, ok = _response.ok;

                if (!ok) {
                  _context2.next = 33;
                  break;
                }

                console.assert(isLastChunk, "Should get 200 only for the last chunk");
                console.log("Upload done");
                this.disableProgressTracker();
                return _context2.abrupt("return", {});

              case 33:
                if (!(status === 308)) {
                  _context2.next = 49;
                  break;
                }

                _context2.prev = 34;
                bytesReceived = this.parseRangeHeader(headers);
                _context2.next = 38;
                return this.interpretRange(bytesReceived);

              case 38:
                return _context2.abrupt("return", _context2.sent);

              case 41:
                _context2.prev = 41;
                _context2.t1 = _context2["catch"](34);
                console.error("Error in uploadChunk:", _context2.t1, "for range:", contentRange);
                _context2.next = 46;
                return this.exponentialRetry();

              case 46:
                return _context2.abrupt("return", _context2.sent);

              case 47:
                _context2.next = 53;
                break;

              case 49:
                console.warn("Performing handleFailedChunkUpload for range:", contentRange);
                _context2.next = 52;
                return this.handleFailedChunkUpload(status);

              case 52:
                return _context2.abrupt("return", _context2.sent);

              case 53:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[9, 16], [34, 41]]);
      }));

      function uploadChunk(_x2, _x3, _x4) {
        return _uploadChunk.apply(this, arguments);
      }

      return uploadChunk;
    }()
  }, {
    key: "completeMultipartUpload",
    value: function () {
      var _completeMultipartUpload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(parts) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", {});

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function completeMultipartUpload(_x5) {
        return _completeMultipartUpload.apply(this, arguments);
      }

      return completeMultipartUpload;
    }()
  }, {
    key: "fetch",
    value: function (_fetch) {
      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(params) {
        var _a, timeoutPid, controller, headers;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                timeoutPid = null;
                controller = params.controller || new AbortController();

                if (params.timeout) {
                  timeoutPid = setTimeout(function () {
                    console.error("fetch timeout for range ".concat(params.contentRange));
                    controller.abort();
                  }, params.timeout);
                }

                headers = {
                  'Content-Type': this.contentType,
                  'Content-Range': (_a = params.contentRange) !== null && _a !== void 0 ? _a : 'bytes */*'
                };
                _context4.prev = 4;
                _context4.next = 7;
                return fetch(this.url, {
                  method: 'PUT',
                  mode: 'cors',
                  cache: 'no-cache',
                  credentials: 'omit',
                  headers: headers,
                  redirect: 'follow',
                  referrerPolicy: 'no-referrer',
                  signal: controller.signal,
                  body: params.body
                });

              case 7:
                return _context4.abrupt("return", _context4.sent);

              case 8:
                _context4.prev = 8;
                if (timeoutPid) clearTimeout(timeoutPid);
                return _context4.finish(8);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4,, 8, 11]]);
      }));

      return function (_x6) {
        return _ref2.apply(this, arguments);
      };
    }())
  }, {
    key: "buildFetchBody",
    value: function buildFetchBody(body) {
      var _this2 = this;

      var logs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (!this.supportsStreamBody || !this.shouldUsePacing) return body;

      if (this.shouldEstimateBandwith) {
        var now = Date.now();

        if (this.chunkTimestamp) {
          var newValue = body.size / (now - this.chunkTimestamp);
          this.bandwidth = (this.bandwidth + newValue) / 2;
        } else {
          this.chunkTimestamp = now;
          return body;
        }

        this.chunkTimestamp = now;
      }

      var sent = 0;
      var lastTimeOfPull = null;
      var options = {
        pull: function () {
          var _pull = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(controller) {
            var toSend, buffer, _now, chunkSize, timePassed, multiplier, _toSend, _buffer, timeout;

            return regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    if (_this2.shouldUsePacing) {
                      _context5.next = 8;
                      break;
                    }

                    toSend = body.slice(sent, body.size);
                    _context5.next = 4;
                    return toSend.arrayBuffer();

                  case 4:
                    buffer = _context5.sent;
                    controller.enqueue(new Uint8Array(buffer));
                    controller.close();
                    return _context5.abrupt("return");

                  case 8:
                    _context5.prev = 8;
                    _now = Date.now();
                    chunkSize = MTU_SIZE;

                    if (lastTimeOfPull) {
                      timePassed = Math.min(_now - lastTimeOfPull, 100);
                      multiplier = Math.floor(_this2.bandwidth * timePassed / MTU_SIZE);

                      if (multiplier > 0) {
                        chunkSize = multiplier * MTU_SIZE;
                      }

                      logs.push([_now, lastTimeOfPull, timePassed, multiplier, chunkSize]);
                    }

                    lastTimeOfPull = _now;
                    _toSend = body.slice(sent, sent + chunkSize);
                    _context5.next = 16;
                    return _toSend.arrayBuffer();

                  case 16:
                    _buffer = _context5.sent;
                    controller.enqueue(new Uint8Array(_buffer));
                    sent += _toSend.size;

                    if (!(sent >= body.size)) {
                      _context5.next = 23;
                      break;
                    }

                    logs.push('controller closing');
                    controller.close();
                    return _context5.abrupt("return");

                  case 23:
                    timeout = MTU_SIZE / _this2.bandwidth;
                    _context5.next = 26;
                    return _this2.sleep(timeout);

                  case 26:
                    _context5.next = 32;
                    break;

                  case 28:
                    _context5.prev = 28;
                    _context5.t0 = _context5["catch"](8);
                    _this2.shouldUsePacing = false;
                    logs.push(['Error inside pull method', _context5.t0.toString()]);

                  case 32:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, null, [[8, 28]]);
          }));

          function pull(_x7) {
            return _pull.apply(this, arguments);
          }

          return pull;
        }()
      };
      return new ReadableStream(options);
    }
  }, {
    key: "watchChunkUpload",
    value: function () {
      var _watchChunkUpload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(controller) {
        var _this3 = this;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!this.chunkProgressPid) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                this.chunkProgressPid = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                  var _yield$_this3$getUplo, bytesUploaded;

                  return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          _context6.next = 2;
                          return _this3.getUploadProgress();

                        case 2:
                          _yield$_this3$getUplo = _context6.sent;
                          bytesUploaded = _yield$_this3$getUplo.bytesUploaded;

                          _this3.progressCb(bytesUploaded);

                          if (!(bytesUploaded === _this3.bytesUploaded || bytesUploaded === _this3.chunkProgress)) {
                            _context6.next = 8;
                            break;
                          }

                          controller.abort();
                          return _context6.abrupt("return");

                        case 8:
                          _this3.chunkProgress = bytesUploaded;

                          _this3.watchChunkUpload(controller);

                        case 10:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6);
                })), CHUNK_UPLOAD_WAIT);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function watchChunkUpload(_x8) {
        return _watchChunkUpload.apply(this, arguments);
      }

      return watchChunkUpload;
    }()
  }, {
    key: "clearChunkUploadWatcher",
    value: function clearChunkUploadWatcher() {
      this.chunkProgress = null;
      clearTimeout(this.chunkProgressPid);
      this.chunkProgressPid = null;
    }
  }, {
    key: "interpretRange",
    value: function () {
      var _interpretRange = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(bytesReceived) {
        var _a, _b, chunkSize, uploadedPart, newChunk;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                chunkSize = (_b = (_a = this.currentChunk) === null || _a === void 0 ? void 0 : _a.size) !== null && _b !== void 0 ? _b : 0;

                if (!(bytesReceived === this.bytesUploaded + chunkSize)) {
                  _context8.next = 7;
                  break;
                }

                this.exponentialBackoff = 500;
                this.bytesUploaded += chunkSize;
                return _context8.abrupt("return", {});

              case 7:
                if (!(bytesReceived < this.bytesUploaded)) {
                  _context8.next = 9;
                  break;
                }

                throw new Error('Uploaded less then we believed');

              case 9:
                if (bytesReceived === this.bytesUploaded) {
                  console.error("Full chunk not uploaded. Size: ".concat(chunkSize, ", contentType ").concat(this.contentType));
                } else {
                  console.error("Only part of chunk got uploaded to google: ".concat(bytesReceived - this.bytesUploaded, " out of ").concat(chunkSize, ", contentType ").concat(this.contentType));
                }

                uploadedPart = bytesReceived - this.bytesUploaded;
                newChunk = this.currentChunk.slice(uploadedPart);
                this.bytesUploaded += uploadedPart;
                _context8.next = 15;
                return this.uploadChunk(newChunk, 0, this.currentFlag);

              case 15:
                return _context8.abrupt("return", _context8.sent);

              case 16:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function interpretRange(_x9) {
        return _interpretRange.apply(this, arguments);
      }

      return interpretRange;
    }()
  }, {
    key: "handleFailedChunkUpload",
    value: function () {
      var _handleFailedChunkUpload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(status) {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.t0 = status;
                _context9.next = _context9.t0 === 400 ? 3 : _context9.t0 === 404 ? 4 : _context9.t0 === 408 ? 6 : _context9.t0 === 499 ? 6 : _context9.t0 === 500 ? 6 : _context9.t0 === 502 ? 6 : _context9.t0 === 503 ? 6 : _context9.t0 === 504 ? 6 : 9;
                break;

              case 3:
                throw new Error("Invalid url, code 400");

              case 4:
                console.error('Received 404 for the upload url');
                throw new Error("Received 404 for the upload url");

              case 6:
                _context9.next = 8;
                return this.exponentialRetry();

              case 8:
                return _context9.abrupt("return", _context9.sent);

              case 9:
                console.warn('Uncaught http status code:', status);
                throw new Error("Uncaught http status code: ".concat(status));

              case 11:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function handleFailedChunkUpload(_x10) {
        return _handleFailedChunkUpload.apply(this, arguments);
      }

      return handleFailedChunkUpload;
    }()
  }, {
    key: "sleep",
    value: function sleep(ms) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, ms);
      });
    }
  }, {
    key: "connectionStatusChanged",
    value: function connectionStatusChanged(isConnected) {}
  }, {
    key: "exponentialRetry",
    value: function () {
      var _exponentialRetry = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var _yield$this$getUpload, bytesUploaded;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.exponentialBackoff = Math.min(this.exponentialBackoff * 2, MAX_EXPONENTIAL_BACKOFF);
                console.warn('Trying exponential backoff. Time:', this.exponentialBackoff);

                if (!(this.exponentialBackoff === MAX_EXPONENTIAL_BACKOFF)) {
                  _context10.next = 4;
                  break;
                }

                throw new Error("Maximum retry timeout reached");

              case 4:
                _context10.next = 6;
                return this.sleep(this.exponentialBackoff);

              case 6:
                _context10.prev = 6;
                _context10.next = 9;
                return this.getUploadProgress();

              case 9:
                _yield$this$getUpload = _context10.sent;
                bytesUploaded = _yield$this$getUpload.bytesUploaded;
                return _context10.abrupt("return", this.interpretRange(bytesUploaded));

              case 14:
                _context10.prev = 14;
                _context10.t0 = _context10["catch"](6);
                console.error("Error in uploadedSize: ".concat(_context10.t0));
                return _context10.abrupt("return", this.exponentialRetry());

              case 18:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[6, 14]]);
      }));

      function exponentialRetry() {
        return _exponentialRetry.apply(this, arguments);
      }

      return exponentialRetry;
    }()
  }, {
    key: "getUploadProgress",
    value: function () {
      var _getUploadProgress = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var response, status, headers, ok, uploadMeta, uploadSize;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.fetch({
                  timeout: RANGE_REQUEST_TIMOUT
                });

              case 2:
                response = _context11.sent;
                status = response.status, headers = response.headers, ok = response.ok;
                console.log("Get uploadedSize status: ".concat(status, ", headers:"), headers);

                if (!ok) {
                  _context11.next = 15;
                  break;
                }

                _context11.next = 8;
                return response.json();

              case 8:
                uploadMeta = _context11.sent;
                uploadSize = Number(uploadMeta.size);

                if (!isNaN(uploadSize)) {
                  _context11.next = 12;
                  break;
                }

                throw new Error("Unexpected response body size: ".concat(uploadMeta.size));

              case 12:
                return _context11.abrupt("return", {
                  bytesUploaded: uploadSize,
                  status: status
                });

              case 15:
                if (!(status === 308)) {
                  _context11.next = 25;
                  break;
                }

                _context11.prev = 16;
                return _context11.abrupt("return", {
                  bytesUploaded: this.parseRangeHeader(headers),
                  status: status
                });

              case 20:
                _context11.prev = 20;
                _context11.t0 = _context11["catch"](16);
                return _context11.abrupt("return", {
                  bytesUploaded: 0,
                  status: status
                });

              case 23:
                _context11.next = 26;
                break;

              case 25:
                throw new Error("Status: ".concat(status));

              case 26:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[16, 20]]);
      }));

      function getUploadProgress() {
        return _getUploadProgress.apply(this, arguments);
      }

      return getUploadProgress;
    }()
  }, {
    key: "isValidChunkSize",
    value: function isValidChunkSize(chunk, isLastChunk) {
      if (isLastChunk) return true;
      var size = chunk.size;

      if (size < CHUNK_SIZE) {
        return false;
      } else {
        return size % CHUNK_SIZE === 0;
      }
    }
  }, {
    key: "getContentRange",
    value: function getContentRange(chunk, isLastChunk) {
      var start = this.bytesUploaded;
      var end = start + Math.max(chunk.size - 1, 0);

      if (isLastChunk) {
        return "bytes ".concat(start, "-").concat(end, "/").concat(end + 1);
      } else {
        return "bytes ".concat(start, "-").concat(end, "/*");
      }
    }
  }, {
    key: "parseRangeHeader",
    value: function parseRangeHeader(headers) {
      var _a;

      var rangeValues = (_a = headers.get('Range')) === null || _a === void 0 ? void 0 : _a.match(/(\d+?)-(\d+?)$/);

      if (rangeValues && rangeValues[2]) {
        return parseInt(rangeValues[2]) + 1;
      }

      throw new Error("Can't parse Range header");
    }
  }], [{
    key: "doesSupportStreamBody",
    value: function doesSupportStreamBody() {
      return ReadableStream && !new Request('', {
        body: new ReadableStream(),
        method: 'POST',
        duplex: 'half'
      }).headers.has('Content-Type');
    }
  }]);

  return ResumableUploadGcs;
}();

exports["default"] = ResumableUploadGcs;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deferred = void 0;

function deferred() {
  var obj = {};
  obj.promise = new Promise(function (resolve, reject) {
    obj.resolve = resolve;
    obj.reject = reject;
  });
  return obj;
}

exports.deferred = deferred;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defineGlobal = exports.makePublicApi = void 0;

var catchUserErrors_1 = require("../tools/catchUserErrors");

var monitor_1 = require("../tools/monitor");

var utils_1 = require("../tools/utils");

function makePublicApi(stub) {
  var publicApi = (0, utils_1.assign)({
    version: "4.21.2",
    // This API method is intentionally not monitored, since the only thing executed is the
    // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
    // we don't want to interfere with the user uncaught exceptions.
    onReady: function onReady(callback) {
      callback();
    }
  }, stub); // Add a "hidden" property to set debug mode. We define it that way to hide it
  // as much as possible but of course it's not a real protection.

  Object.defineProperty(publicApi, '_setDebug', {
    get: function get() {
      return monitor_1.setDebugMode;
    },
    enumerable: false
  });
  return publicApi;
}

exports.makePublicApi = makePublicApi;

function defineGlobal(global, name, api) {
  var existingGlobalVariable = global[name];
  global[name] = api;

  if (existingGlobalVariable && existingGlobalVariable.q) {
    existingGlobalVariable.q.forEach(function (fn) {
      return (0, catchUserErrors_1.catchUserErrors)(fn, 'onReady callback threw an error:')();
    });
  }
}

exports.defineGlobal = defineGlobal;

},{"../tools/catchUserErrors":35,"../tools/monitor":43,"../tools/utils":47}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentSite = exports.areCookiesAuthorized = exports.deleteCookie = exports.getCookie = exports.setCookie = exports.COOKIE_ACCESS_DELAY = void 0;

var display_1 = require("../tools/display");

var utils_1 = require("../tools/utils");

exports.COOKIE_ACCESS_DELAY = utils_1.ONE_SECOND;

function setCookie(name, value, expireDelay, options) {
  var date = new Date();
  date.setTime(date.getTime() + expireDelay);
  var expires = "expires=".concat(date.toUTCString());
  var sameSite = options && options.crossSite ? 'none' : 'strict';
  var domain = options && options.domain ? ";domain=".concat(options.domain) : '';
  var secure = options && options.secure ? ';secure' : '';
  document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure);
}

exports.setCookie = setCookie;

function getCookie(name) {
  return (0, utils_1.findCommaSeparatedValue)(document.cookie, name);
}

exports.getCookie = getCookie;

function deleteCookie(name, options) {
  setCookie(name, '', 0, options);
}

exports.deleteCookie = deleteCookie;

function areCookiesAuthorized(options) {
  if (document.cookie === undefined || document.cookie === null) {
    return false;
  }

  try {
    // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
    // the test cookie lifetime
    var testCookieName = "dd_cookie_test_".concat((0, utils_1.generateUUID)());
    var testCookieValue = 'test';
    setCookie(testCookieName, testCookieValue, utils_1.ONE_SECOND, options);
    var isCookieCorrectlySet = getCookie(testCookieName) === testCookieValue;
    deleteCookie(testCookieName, options);
    return isCookieCorrectlySet;
  } catch (error) {
    display_1.display.error(error);
    return false;
  }
}

exports.areCookiesAuthorized = areCookiesAuthorized;
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */

var getCurrentSiteCache;

function getCurrentSite() {
  if (getCurrentSiteCache === undefined) {
    // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
    // the test cookie lifetime
    var testCookieName = "dd_site_test_".concat((0, utils_1.generateUUID)());
    var testCookieValue = 'test';
    var domainLevels = window.location.hostname.split('.');
    var candidateDomain = domainLevels.pop();

    while (domainLevels.length && !getCookie(testCookieName)) {
      candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
      setCookie(testCookieName, testCookieValue, utils_1.ONE_SECOND, {
        domain: candidateDomain
      });
    }

    deleteCookie(testCookieName, {
      domain: candidateDomain
    });
    getCurrentSiteCache = candidateDomain;
  }

  return getCurrentSiteCache;
}

exports.getCurrentSite = getCurrentSite;

},{"../tools/display":39,"../tools/utils":47}],7:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initFetchObservable = void 0;

var instrumentMethod_1 = require("../tools/instrumentMethod");

var monitor_1 = require("../tools/monitor");

var observable_1 = require("../tools/observable");

var timeUtils_1 = require("../tools/timeUtils");

var urlPolyfill_1 = require("../tools/urlPolyfill");

var fetchObservable;

function initFetchObservable() {
  if (!fetchObservable) {
    fetchObservable = createFetchObservable();
  }

  return fetchObservable;
}

exports.initFetchObservable = initFetchObservable;

function createFetchObservable() {
  var observable = new observable_1.Observable(function () {
    if (!window.fetch) {
      return;
    }

    var stop = (0, instrumentMethod_1.instrumentMethod)(window, 'fetch', function (originalFetch) {
      return function (input, init) {
        var responsePromise;
        var context = (0, monitor_1.callMonitored)(beforeSend, null, [observable, input, init]);

        if (context) {
          responsePromise = originalFetch.call(this, context.input, context.init);
          (0, monitor_1.callMonitored)(afterSend, null, [observable, responsePromise, context]);
        } else {
          responsePromise = originalFetch.call(this, input, init);
        }

        return responsePromise;
      };
    }).stop;
    return stop;
  });
  return observable;
}

function beforeSend(observable, input, init) {
  var method = init && init.method || _typeof(input) === 'object' && input.method || 'GET';
  var url = (0, urlPolyfill_1.normalizeUrl)(_typeof(input) === 'object' && input.url || input);
  var startClocks = (0, timeUtils_1.clocksNow)();
  var context = {
    state: 'start',
    init: init,
    input: input,
    method: method,
    startClocks: startClocks,
    url: url
  };
  observable.notify(context);
  return context;
}

function afterSend(observable, responsePromise, startContext) {
  var reportFetch = function reportFetch(response) {
    var context = startContext;
    context.state = 'complete';
    context.duration = (0, timeUtils_1.elapsed)(context.startClocks.timeStamp, (0, timeUtils_1.timeStampNow)());

    if ('stack' in response || response instanceof Error) {
      context.status = 0;
      context.isAborted = response instanceof DOMException && response.code === DOMException.ABORT_ERR;
      context.error = response;
      observable.notify(context);
    } else if ('status' in response) {
      context.response = response;
      context.responseType = response.type;
      context.status = response.status;
      context.isAborted = false;
      observable.notify(context);
    }
  };

  responsePromise.then((0, monitor_1.monitor)(reportFetch), (0, monitor_1.monitor)(reportFetch));
}

},{"../tools/instrumentMethod":41,"../tools/monitor":43,"../tools/observable":44,"../tools/timeUtils":45,"../tools/urlPolyfill":46}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initXhrObservable = void 0;

var instrumentMethod_1 = require("../tools/instrumentMethod");

var monitor_1 = require("../tools/monitor");

var observable_1 = require("../tools/observable");

var timeUtils_1 = require("../tools/timeUtils");

var urlPolyfill_1 = require("../tools/urlPolyfill");

var utils_1 = require("../tools/utils");

var xhrObservable;
var xhrContexts = new WeakMap();

function initXhrObservable() {
  if (!xhrObservable) {
    xhrObservable = createXhrObservable();
  }

  return xhrObservable;
}

exports.initXhrObservable = initXhrObservable;

function createXhrObservable() {
  var observable = new observable_1.Observable(function () {
    var stopInstrumentingStart = (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(XMLHttpRequest.prototype, 'open', {
      before: openXhr
    }).stop;
    var stopInstrumentingSend = (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(XMLHttpRequest.prototype, 'send', {
      before: function before() {
        sendXhr.call(this, observable);
      }
    }).stop;
    var stopInstrumentingAbort = (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(XMLHttpRequest.prototype, 'abort', {
      before: abortXhr
    }).stop;
    return function () {
      stopInstrumentingStart();
      stopInstrumentingSend();
      stopInstrumentingAbort();
    };
  });
  return observable;
}

function openXhr(method, url) {
  xhrContexts.set(this, {
    state: 'open',
    method: method,
    url: (0, urlPolyfill_1.normalizeUrl)(String(url))
  });
}

function sendXhr(observable) {
  var _this = this;

  var context = xhrContexts.get(this);

  if (!context) {
    return;
  }

  var startContext = context;
  startContext.state = 'start';
  startContext.startTime = (0, timeUtils_1.relativeNow)();
  startContext.startClocks = (0, timeUtils_1.clocksNow)();
  startContext.isAborted = false;
  startContext.xhr = this;
  var hasBeenReported = false;
  var stopInstrumentingOnReadyStateChange = (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(this, 'onreadystatechange', {
    before: function before() {
      if (this.readyState === XMLHttpRequest.DONE) {
        // Try to report the XHR as soon as possible, because the XHR may be mutated by the
        // application during a future event. For example, Angular is calling .abort() on
        // completed requests during a onreadystatechange event, so the status becomes '0'
        // before the request is collected.
        onEnd();
      }
    }
  }).stop;
  var onEnd = (0, monitor_1.monitor)(function () {
    _this.removeEventListener('loadend', onEnd);

    stopInstrumentingOnReadyStateChange();

    if (hasBeenReported) {
      return;
    }

    hasBeenReported = true;
    var completeContext = context;
    completeContext.state = 'complete';
    completeContext.duration = (0, timeUtils_1.elapsed)(startContext.startClocks.timeStamp, (0, timeUtils_1.timeStampNow)());
    completeContext.status = _this.status;
    observable.notify((0, utils_1.shallowClone)(completeContext));
  });
  this.addEventListener('loadend', onEnd);
  observable.notify(startContext);
}

function abortXhr() {
  var context = xhrContexts.get(this);

  if (context) {
    context.isAborted = true;
  }
}

},{"../tools/instrumentMethod":41,"../tools/monitor":43,"../tools/observable":44,"../tools/timeUtils":45,"../tools/urlPolyfill":46,"../tools/utils":47}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildCookieOptions = exports.validateAndBuildConfiguration = exports.DefaultPrivacyLevel = void 0;

var cookie_1 = require("../../browser/cookie");

var catchUserErrors_1 = require("../../tools/catchUserErrors");

var display_1 = require("../../tools/display");

var utils_1 = require("../../tools/utils");

var experimentalFeatures_1 = require("./experimentalFeatures");

var simulation_1 = require("./simulation");

var transportConfiguration_1 = require("./transportConfiguration");

exports.DefaultPrivacyLevel = {
  ALLOW: 'allow',
  MASK: 'mask',
  MASK_USER_INPUT: 'mask-user-input'
};

function validateAndBuildConfiguration(initConfiguration) {
  var _a, _b;

  if (!initConfiguration || !initConfiguration.clientToken) {
    display_1.display.error('Client Token is not configured, we will not send any data.');
    return;
  }

  if (initConfiguration.sampleRate !== undefined && !(0, utils_1.isPercentage)(initConfiguration.sampleRate)) {
    display_1.display.error('Sample Rate should be a number between 0 and 100');
    return;
  }

  if (initConfiguration.telemetrySampleRate !== undefined && !(0, utils_1.isPercentage)(initConfiguration.telemetrySampleRate)) {
    display_1.display.error('Telemetry Sample Rate should be a number between 0 and 100');
    return;
  } // Set the experimental feature flags as early as possible, so we can use them in most places


  (0, experimentalFeatures_1.updateExperimentalFeatures)(initConfiguration.enableExperimentalFeatures);
  (0, simulation_1.initSimulation)(initConfiguration.simulationStart, initConfiguration.simulationEnd, initConfiguration.simulationLabel);
  return (0, utils_1.assign)({
    beforeSend: initConfiguration.beforeSend && (0, catchUserErrors_1.catchUserErrors)(initConfiguration.beforeSend, 'beforeSend threw an error:'),
    cookieOptions: buildCookieOptions(initConfiguration),
    sampleRate: (_a = initConfiguration.sampleRate) !== null && _a !== void 0 ? _a : 100,
    telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
    service: initConfiguration.service,
    silentMultipleInit: !!initConfiguration.silentMultipleInit,

    /**
     * beacon payload max queue size implementation is 64kb
     * ensure that we leave room for logs, rum and potential other users
     */
    batchBytesLimit: 16 * utils_1.ONE_KIBI_BYTE,
    eventRateLimiterThreshold: 3000,
    maxTelemetryEventsPerPage: 15,

    /**
     * flush automatically, aim to be lower than ALB connection timeout
     * to maximize connection reuse.
     */
    flushTimeout: 30 * utils_1.ONE_SECOND,

    /**
     * Logs intake limit
     */
    batchMessagesLimit: 50,
    messageBytesLimit: 256 * utils_1.ONE_KIBI_BYTE
  }, (0, transportConfiguration_1.computeTransportConfiguration)(initConfiguration));
}

exports.validateAndBuildConfiguration = validateAndBuildConfiguration;

function buildCookieOptions(initConfiguration) {
  var cookieOptions = {};
  cookieOptions.secure = mustUseSecureCookie(initConfiguration);
  cookieOptions.crossSite = !!initConfiguration.useCrossSiteSessionCookie;

  if (initConfiguration.trackSessionAcrossSubdomains) {
    cookieOptions.domain = (0, cookie_1.getCurrentSite)();
  }

  return cookieOptions;
}

exports.buildCookieOptions = buildCookieOptions;

function mustUseSecureCookie(initConfiguration) {
  return !!initConfiguration.useSecureSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
}

},{"../../browser/cookie":6,"../../tools/catchUserErrors":35,"../../tools/display":39,"../../tools/utils":47,"./experimentalFeatures":11,"./simulation":14,"./transportConfiguration":16}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createEndpointBuilder = exports.ENDPOINTS = void 0;

var timeUtils_1 = require("../../tools/timeUtils");

var urlPolyfill_1 = require("../../tools/urlPolyfill");

var utils_1 = require("../../tools/utils");

var intakeSites_1 = require("./intakeSites");

exports.ENDPOINTS = {
  logs: 'logs',
  rum: 'rum',
  sessionReplay: 'session-replay'
};
var INTAKE_TRACKS = {
  logs: 'logs',
  rum: 'rum',
  sessionReplay: 'replay'
};

function createEndpointBuilder(initConfiguration, endpointType, tags) {
  var _a = initConfiguration.site,
      site = _a === void 0 ? intakeSites_1.INTAKE_SITE_US1 : _a,
      clientToken = initConfiguration.clientToken;
  var domainParts = site.split('.');
  var extension = domainParts.pop();
  var host = "".concat(exports.ENDPOINTS[endpointType], ".browser-intake-").concat(domainParts.join('-'), ".").concat(extension);
  var baseUrl = "https://".concat(host, "/api/v2/").concat(INTAKE_TRACKS[endpointType]);
  var proxyUrl = initConfiguration.proxyUrl && (0, urlPolyfill_1.normalizeUrl)(initConfiguration.proxyUrl);
  return {
    build: function build() {
      var parameters = 'ddsource=browser' + "&ddtags=".concat(encodeURIComponent(["sdk_version:".concat("4.21.2")].concat(tags).join(','))) + "&dd-api-key=".concat(clientToken) + "&dd-evp-origin-version=".concat(encodeURIComponent("4.21.2")) + '&dd-evp-origin=browser' + "&dd-request-id=".concat((0, utils_1.generateUUID)());

      if (endpointType === 'rum') {
        parameters += "&batch_time=".concat((0, timeUtils_1.timeStampNow)());
      }

      var endpointUrl = "".concat(baseUrl, "?").concat(parameters);
      return proxyUrl ? "".concat(proxyUrl, "?ddforward=").concat(encodeURIComponent(endpointUrl)) : endpointUrl;
    },
    buildIntakeUrl: function buildIntakeUrl() {
      return proxyUrl ? "".concat(proxyUrl, "?ddforward") : baseUrl;
    },
    endpointType: endpointType
  };
}

exports.createEndpointBuilder = createEndpointBuilder;

},{"../../tools/timeUtils":45,"../../tools/urlPolyfill":46,"../../tools/utils":47,"./intakeSites":13}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExperimentalFeatures = exports.resetExperimentalFeatures = exports.isExperimentalFeatureEnabled = exports.updateExperimentalFeatures = void 0;
/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 */

var utils_1 = require("../../tools/utils");

var display_1 = require("../../tools/display");

var enabledExperimentalFeatures;

function updateExperimentalFeatures(enabledFeatures) {
  // Safely handle external data
  if (!Array.isArray(enabledFeatures)) {
    return;
  }

  if (!enabledExperimentalFeatures) {
    enabledExperimentalFeatures = new Set(enabledFeatures);
  }

  enabledFeatures.filter(function (flag) {
    return typeof flag === 'string';
  }).forEach(function (flag) {
    if ((0, utils_1.includes)(flag, '-')) {
      display_1.display.warn("please use snake case for '".concat(flag, "'"));
    }

    enabledExperimentalFeatures.add(flag);
  });
}

exports.updateExperimentalFeatures = updateExperimentalFeatures;

function isExperimentalFeatureEnabled(featureName) {
  return !!enabledExperimentalFeatures && enabledExperimentalFeatures.has(featureName);
}

exports.isExperimentalFeatureEnabled = isExperimentalFeatureEnabled;

function resetExperimentalFeatures() {
  enabledExperimentalFeatures = new Set();
}

exports.resetExperimentalFeatures = resetExperimentalFeatures;

function getExperimentalFeatures() {
  return enabledExperimentalFeatures || new Set();
}

exports.getExperimentalFeatures = getExperimentalFeatures;

},{"../../tools/display":39,"../../tools/utils":47}],12:[function(require,module,exports){
"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = void 0 && (void 0).__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSimulationLabel = exports.isSimulationActive = exports.getExperimentalFeatures = exports.resetExperimentalFeatures = exports.updateExperimentalFeatures = exports.isExperimentalFeatureEnabled = exports.createEndpointBuilder = exports.validateAndBuildConfiguration = exports.DefaultPrivacyLevel = exports.buildCookieOptions = void 0;

var configuration_1 = require("./configuration");

Object.defineProperty(exports, "buildCookieOptions", {
  enumerable: true,
  get: function get() {
    return configuration_1.buildCookieOptions;
  }
});
Object.defineProperty(exports, "DefaultPrivacyLevel", {
  enumerable: true,
  get: function get() {
    return configuration_1.DefaultPrivacyLevel;
  }
});
Object.defineProperty(exports, "validateAndBuildConfiguration", {
  enumerable: true,
  get: function get() {
    return configuration_1.validateAndBuildConfiguration;
  }
});

var endpointBuilder_1 = require("./endpointBuilder");

Object.defineProperty(exports, "createEndpointBuilder", {
  enumerable: true,
  get: function get() {
    return endpointBuilder_1.createEndpointBuilder;
  }
});

var experimentalFeatures_1 = require("./experimentalFeatures");

Object.defineProperty(exports, "isExperimentalFeatureEnabled", {
  enumerable: true,
  get: function get() {
    return experimentalFeatures_1.isExperimentalFeatureEnabled;
  }
});
Object.defineProperty(exports, "updateExperimentalFeatures", {
  enumerable: true,
  get: function get() {
    return experimentalFeatures_1.updateExperimentalFeatures;
  }
});
Object.defineProperty(exports, "resetExperimentalFeatures", {
  enumerable: true,
  get: function get() {
    return experimentalFeatures_1.resetExperimentalFeatures;
  }
});
Object.defineProperty(exports, "getExperimentalFeatures", {
  enumerable: true,
  get: function get() {
    return experimentalFeatures_1.getExperimentalFeatures;
  }
});

__exportStar(require("./intakeSites"), exports);

var simulation_1 = require("./simulation");

Object.defineProperty(exports, "isSimulationActive", {
  enumerable: true,
  get: function get() {
    return simulation_1.isSimulationActive;
  }
});
Object.defineProperty(exports, "getSimulationLabel", {
  enumerable: true,
  get: function get() {
    return simulation_1.getSimulationLabel;
  }
});

},{"./configuration":9,"./endpointBuilder":10,"./experimentalFeatures":11,"./intakeSites":13,"./simulation":14}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTAKE_SITE_US1_FED = exports.INTAKE_SITE_US1 = exports.INTAKE_SITE_STAGING = void 0;
exports.INTAKE_SITE_STAGING = 'datad0g.com';
exports.INTAKE_SITE_US1 = 'datadoghq.com';
exports.INTAKE_SITE_US1_FED = 'ddog-gov.com';

},{}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSimulationLabel = exports.isSimulationActive = exports.initSimulation = void 0;

var timeUtils_1 = require("../../tools/timeUtils");

var simulation;

function initSimulation(simulationStart, simulationEnd, simulationLabel) {
  if (simulationStart && simulationEnd && simulationLabel) {
    simulation = {
      start: new Date(simulationStart).getTime(),
      end: new Date(simulationEnd).getTime(),
      label: simulationLabel
    };
  }
}

exports.initSimulation = initSimulation;

function isSimulationActive() {
  var now = (0, timeUtils_1.dateNow)();
  return simulation !== undefined && now >= simulation.start && now <= simulation.end;
}

exports.isSimulationActive = isSimulationActive;

function getSimulationLabel() {
  return simulation === null || simulation === void 0 ? void 0 : simulation.label;
}

exports.getSimulationLabel = getSimulationLabel;

},{"../../tools/timeUtils":45}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildTag = exports.buildTags = exports.TAG_SIZE_LIMIT = void 0;

var display_1 = require("../../tools/display");

exports.TAG_SIZE_LIMIT = 200;

function buildTags(configuration) {
  var env = configuration.env,
      service = configuration.service,
      version = configuration.version,
      datacenter = configuration.datacenter;
  var tags = [];

  if (env) {
    tags.push(buildTag('env', env));
  }

  if (service) {
    tags.push(buildTag('service', service));
  }

  if (version) {
    tags.push(buildTag('version', version));
  }

  if (datacenter) {
    tags.push(buildTag('datacenter', datacenter));
  }

  return tags;
}

exports.buildTags = buildTags;
var FORBIDDEN_CHARACTERS = /[^a-z0-9_:./-]/;

function buildTag(key, rawValue) {
  // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
  // that the backend may not follow the exact same rules, so we only want to display an informal
  // warning.
  var valueSizeLimit = exports.TAG_SIZE_LIMIT - key.length - 1;

  if (rawValue.length > valueSizeLimit || FORBIDDEN_CHARACTERS.test(rawValue)) {
    display_1.display.warn("".concat(key, " value doesn't meet tag requirements and will be sanitized"));
  } // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
  // by forging a value containing commas.


  var sanitizedValue = rawValue.replace(/,/g, '_');
  return "".concat(key, ":").concat(sanitizedValue);
}

exports.buildTag = buildTag;

},{"../../tools/display":39}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.computeTransportConfiguration = void 0;

var utils_1 = require("../../tools/utils");

var endpointBuilder_1 = require("./endpointBuilder");

var tags_1 = require("./tags");

var intakeSites_1 = require("./intakeSites");

function computeTransportConfiguration(initConfiguration) {
  var tags = (0, tags_1.buildTags)(initConfiguration);
  var endpointBuilders = computeEndpointBuilders(initConfiguration, tags);
  var intakeEndpoints = (0, utils_1.objectValues)(endpointBuilders).map(function (builder) {
    return builder.buildIntakeUrl();
  });
  var replicaConfiguration = computeReplicaConfiguration(initConfiguration, intakeEndpoints, tags);
  return (0, utils_1.assign)({
    isIntakeUrl: function isIntakeUrl(url) {
      return intakeEndpoints.some(function (intakeEndpoint) {
        return url.indexOf(intakeEndpoint) === 0;
      });
    },
    replica: replicaConfiguration,
    site: initConfiguration.site || intakeSites_1.INTAKE_SITE_US1
  }, endpointBuilders);
}

exports.computeTransportConfiguration = computeTransportConfiguration;

function computeEndpointBuilders(initConfiguration, tags) {
  return {
    logsEndpointBuilder: (0, endpointBuilder_1.createEndpointBuilder)(initConfiguration, 'logs', tags),
    rumEndpointBuilder: (0, endpointBuilder_1.createEndpointBuilder)(initConfiguration, 'rum', tags),
    sessionReplayEndpointBuilder: (0, endpointBuilder_1.createEndpointBuilder)(initConfiguration, 'sessionReplay', tags)
  };
}

function computeReplicaConfiguration(initConfiguration, intakeEndpoints, tags) {
  if (!initConfiguration.replica) {
    return;
  }

  var replicaConfiguration = (0, utils_1.assign)({}, initConfiguration, {
    site: intakeSites_1.INTAKE_SITE_US1,
    clientToken: initConfiguration.replica.clientToken
  });
  var replicaEndpointBuilders = {
    logsEndpointBuilder: (0, endpointBuilder_1.createEndpointBuilder)(replicaConfiguration, 'logs', tags),
    rumEndpointBuilder: (0, endpointBuilder_1.createEndpointBuilder)(replicaConfiguration, 'rum', tags)
  };
  intakeEndpoints.push.apply(intakeEndpoints, (0, utils_1.objectValues)(replicaEndpointBuilders).map(function (builder) {
    return builder.buildIntakeUrl();
  }));
  return (0, utils_1.assign)({
    applicationId: initConfiguration.replica.applicationId
  }, replicaEndpointBuilders);
}

},{"../../tools/utils":47,"./endpointBuilder":10,"./intakeSites":13,"./tags":15}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initConsoleObservable = void 0;

var tracekit_1 = require("../tracekit");

var error_1 = require("../../tools/error");

var observable_1 = require("../../tools/observable");

var utils_1 = require("../../tools/utils");

var display_1 = require("../../tools/display");

var monitor_1 = require("../../tools/monitor");

var consoleObservablesByApi = {};

function initConsoleObservable(apis) {
  var consoleObservables = apis.map(function (api) {
    if (!consoleObservablesByApi[api]) {
      consoleObservablesByApi[api] = createConsoleObservable(api);
    }

    return consoleObservablesByApi[api];
  });
  return observable_1.mergeObservables.apply(void 0, consoleObservables);
}

exports.initConsoleObservable = initConsoleObservable;
/* eslint-disable no-console */

function createConsoleObservable(api) {
  var observable = new observable_1.Observable(function () {
    var originalConsoleApi = console[api];

    console[api] = function () {
      var params = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
      }

      originalConsoleApi.apply(console, params);
      var handlingStack = (0, error_1.createHandlingStack)();
      (0, monitor_1.callMonitored)(function () {
        observable.notify(buildConsoleLog(params, api, handlingStack));
      });
    };

    return function () {
      console[api] = originalConsoleApi;
    };
  });
  return observable;
}

function buildConsoleLog(params, api, handlingStack) {
  // Todo: remove console error prefix in the next major version
  var message = params.map(function (param) {
    return formatConsoleParameters(param);
  }).join(' ');
  var stack;

  if (api === display_1.ConsoleApiName.error) {
    var firstErrorParam = (0, utils_1.find)(params, function (param) {
      return param instanceof Error;
    });
    stack = firstErrorParam ? (0, error_1.toStackTraceString)((0, tracekit_1.computeStackTrace)(firstErrorParam)) : undefined;
    message = "console error: ".concat(message);
  }

  return {
    api: api,
    message: message,
    stack: stack,
    handlingStack: handlingStack
  };
}

function formatConsoleParameters(param) {
  if (typeof param === 'string') {
    return param;
  }

  if (param instanceof Error) {
    return (0, error_1.formatErrorMessage)((0, tracekit_1.computeStackTrace)(param));
  }

  return (0, utils_1.jsonStringify)(param, undefined, 2);
}

},{"../../tools/display":39,"../../tools/error":40,"../../tools/monitor":43,"../../tools/observable":44,"../../tools/utils":47,"../tracekit":30}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackRuntimeError = void 0;

var error_1 = require("../../tools/error");

var timeUtils_1 = require("../../tools/timeUtils");

var tracekit_1 = require("../tracekit");

function trackRuntimeError(errorObservable) {
  return (0, tracekit_1.startUnhandledErrorCollection)(function (stackTrace, originalError) {
    errorObservable.notify((0, error_1.computeRawError)({
      stackTrace: stackTrace,
      originalError: originalError,
      startClocks: (0, timeUtils_1.clocksNow)(),
      nonErrorPrefix: 'Uncaught',
      source: error_1.ErrorSource.SOURCE,
      handling: "unhandled"
      /* UNHANDLED */

    }));
  });
}

exports.trackRuntimeError = trackRuntimeError;

},{"../../tools/error":40,"../../tools/timeUtils":45,"../tracekit":30}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initReportObservable = exports.RawReportType = void 0;

var error_1 = require("../../tools/error");

var monitor_1 = require("../../tools/monitor");

var observable_1 = require("../../tools/observable");

var utils_1 = require("../../tools/utils");

exports.RawReportType = {
  intervention: 'intervention',
  deprecation: 'deprecation',
  cspViolation: 'csp_violation'
};

function initReportObservable(apis) {
  var observables = [];

  if ((0, utils_1.includes)(apis, exports.RawReportType.cspViolation)) {
    observables.push(createCspViolationReportObservable());
  }

  var reportTypes = apis.filter(function (api) {
    return api !== exports.RawReportType.cspViolation;
  });

  if (reportTypes.length) {
    observables.push(createReportObservable(reportTypes));
  }

  return observable_1.mergeObservables.apply(void 0, observables);
}

exports.initReportObservable = initReportObservable;

function createReportObservable(reportTypes) {
  var observable = new observable_1.Observable(function () {
    if (!window.ReportingObserver) {
      return;
    }

    var handleReports = (0, monitor_1.monitor)(function (reports) {
      return reports.forEach(function (report) {
        observable.notify(buildRawReportFromReport(report));
      });
    });
    var observer = new window.ReportingObserver(handleReports, {
      types: reportTypes,
      buffered: true
    });
    observer.observe();
    return function () {
      observer.disconnect();
    };
  });
  return observable;
}

function createCspViolationReportObservable() {
  var observable = new observable_1.Observable(function () {
    var handleCspViolation = (0, monitor_1.monitor)(function (event) {
      observable.notify(buildRawReportFromCspViolation(event));
    });
    var stop = (0, utils_1.addEventListener)(document, "securitypolicyviolation"
    /* SECURITY_POLICY_VIOLATION */
    , handleCspViolation).stop;
    return stop;
  });
  return observable;
}

function buildRawReportFromReport(_a) {
  var type = _a.type,
      body = _a.body;
  return {
    type: type,
    subtype: body.id,
    message: "".concat(type, ": ").concat(body.message),
    stack: buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber)
  };
}

function buildRawReportFromCspViolation(event) {
  var type = exports.RawReportType.cspViolation;
  var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
  return {
    type: exports.RawReportType.cspViolation,
    subtype: event.effectiveDirective,
    message: "".concat(type, ": ").concat(message),
    stack: buildStack(event.effectiveDirective, event.originalPolicy ? "".concat(message, " of the policy \"").concat((0, utils_1.safeTruncate)(event.originalPolicy, 100, '...'), "\"") : 'no policy', event.sourceFile, event.lineNumber, event.columnNumber)
  };
}

function buildStack(name, message, sourceFile, lineNumber, columnNumber) {
  return sourceFile && (0, error_1.toStackTraceString)({
    name: name,
    message: message,
    stack: [{
      func: '?',
      url: sourceFile,
      line: lineNumber,
      column: columnNumber
    }]
  });
}

},{"../../tools/error":40,"../../tools/monitor":43,"../../tools/observable":44,"../../tools/utils":47}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tryOldCookiesMigration = exports.LOGS_SESSION_KEY = exports.RUM_SESSION_KEY = exports.OLD_LOGS_COOKIE_NAME = exports.OLD_RUM_COOKIE_NAME = exports.OLD_SESSION_COOKIE_NAME = void 0;

var cookie_1 = require("../../browser/cookie");

var sessionCookieStore_1 = require("./sessionCookieStore");

exports.OLD_SESSION_COOKIE_NAME = '_dd';
exports.OLD_RUM_COOKIE_NAME = '_dd_r';
exports.OLD_LOGS_COOKIE_NAME = '_dd_l'; // duplicate values to avoid dependency issues

exports.RUM_SESSION_KEY = 'rum';
exports.LOGS_SESSION_KEY = 'logs';
/**
 * This migration should remain in the codebase as long as older versions are available/live
 * to allow older sdk versions to be upgraded to newer versions without compatibility issues.
 */

function tryOldCookiesMigration(options) {
  var sessionString = (0, cookie_1.getCookie)(sessionCookieStore_1.SESSION_COOKIE_NAME);
  var oldSessionId = (0, cookie_1.getCookie)(exports.OLD_SESSION_COOKIE_NAME);
  var oldRumType = (0, cookie_1.getCookie)(exports.OLD_RUM_COOKIE_NAME);
  var oldLogsType = (0, cookie_1.getCookie)(exports.OLD_LOGS_COOKIE_NAME);

  if (!sessionString) {
    var session = {};

    if (oldSessionId) {
      session.id = oldSessionId;
    }

    if (oldLogsType && /^[01]$/.test(oldLogsType)) {
      session[exports.LOGS_SESSION_KEY] = oldLogsType;
    }

    if (oldRumType && /^[012]$/.test(oldRumType)) {
      session[exports.RUM_SESSION_KEY] = oldRumType;
    }

    (0, sessionCookieStore_1.persistSession)(session, options);
  }
}

exports.tryOldCookiesMigration = tryOldCookiesMigration;

},{"../../browser/cookie":6,"./sessionCookieStore":22}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SESSION_EXPIRATION_DELAY = exports.SESSION_TIME_OUT_DELAY = void 0;

var utils_1 = require("../../tools/utils");

exports.SESSION_TIME_OUT_DELAY = 4 * utils_1.ONE_HOUR;
exports.SESSION_EXPIRATION_DELAY = 15 * utils_1.ONE_MINUTE;

},{"../../tools/utils":47}],22:[function(require,module,exports){
"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retrieveSession = exports.toSessionString = exports.persistSession = exports.withCookieLockAccess = exports.MAX_NUMBER_OF_LOCK_RETRIES = exports.LOCK_RETRY_DELAY = exports.SESSION_COOKIE_NAME = void 0;

var cookie_1 = require("../../browser/cookie");

var browserDetection_1 = require("../../tools/browserDetection");

var monitor_1 = require("../../tools/monitor");

var timeUtils_1 = require("../../tools/timeUtils");

var utils = __importStar(require("../../tools/utils"));

var sessionConstants_1 = require("./sessionConstants");

var SESSION_ENTRY_REGEXP = /^([a-z]+)=([a-z0-9-]+)$/;
var SESSION_ENTRY_SEPARATOR = '&';
exports.SESSION_COOKIE_NAME = '_dd_s'; // arbitrary values

exports.LOCK_RETRY_DELAY = 10;
exports.MAX_NUMBER_OF_LOCK_RETRIES = 100;
var bufferedOperations = [];
var ongoingOperations;

function withCookieLockAccess(operations, numberOfRetries) {
  var _a;

  if (numberOfRetries === void 0) {
    numberOfRetries = 0;
  }

  if (!ongoingOperations) {
    ongoingOperations = operations;
  }

  if (operations !== ongoingOperations) {
    bufferedOperations.push(operations);
    return;
  }

  if (numberOfRetries >= exports.MAX_NUMBER_OF_LOCK_RETRIES) {
    next();
    return;
  }

  var currentLock;
  var currentSession = retrieveSession();

  if (isCookieLockEnabled()) {
    // if someone has lock, retry later
    if (currentSession.lock) {
      retryLater(operations, numberOfRetries);
      return;
    } // acquire lock


    currentLock = utils.generateUUID();
    currentSession.lock = currentLock;
    setSession(currentSession, operations.options); // if lock is not acquired, retry later

    currentSession = retrieveSession();

    if (currentSession.lock !== currentLock) {
      retryLater(operations, numberOfRetries);
      return;
    }
  }

  var processedSession = operations.process(currentSession);

  if (isCookieLockEnabled()) {
    // if lock corrupted after process, retry later
    currentSession = retrieveSession();

    if (currentSession.lock !== currentLock) {
      retryLater(operations, numberOfRetries);
      return;
    }
  }

  if (processedSession) {
    persistSession(processedSession, operations.options);
  }

  if (isCookieLockEnabled()) {
    // correctly handle lock around expiration would require to handle this case properly at several levels
    // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
    if (!(processedSession && isExpiredState(processedSession))) {
      // if lock corrupted after persist, retry later
      currentSession = retrieveSession();

      if (currentSession.lock !== currentLock) {
        retryLater(operations, numberOfRetries);
        return;
      }

      delete currentSession.lock;
      setSession(currentSession, operations.options);
      processedSession = currentSession;
    }
  } // call after even if session is not persisted in order to perform operations on
  // up-to-date cookie value, the value could have been modified by another tab


  (_a = operations.after) === null || _a === void 0 ? void 0 : _a.call(operations, processedSession || currentSession);
  next();
}

exports.withCookieLockAccess = withCookieLockAccess;
/**
 * Cookie lock strategy allows mitigating issues due to concurrent access to cookie.
 * This issue concerns only chromium browsers and enabling this on firefox increase cookie write failures.
 */

function isCookieLockEnabled() {
  return (0, browserDetection_1.isChromium)();
}

function retryLater(operations, currentNumberOfRetries) {
  setTimeout((0, monitor_1.monitor)(function () {
    withCookieLockAccess(operations, currentNumberOfRetries + 1);
  }), exports.LOCK_RETRY_DELAY);
}

function next() {
  ongoingOperations = undefined;
  var nextOperations = bufferedOperations.shift();

  if (nextOperations) {
    withCookieLockAccess(nextOperations);
  }
}

function persistSession(session, options) {
  if (isExpiredState(session)) {
    clearSession(options);
    return;
  }

  session.expire = String((0, timeUtils_1.dateNow)() + sessionConstants_1.SESSION_EXPIRATION_DELAY);
  setSession(session, options);
}

exports.persistSession = persistSession;

function setSession(session, options) {
  (0, cookie_1.setCookie)(exports.SESSION_COOKIE_NAME, toSessionString(session), sessionConstants_1.SESSION_EXPIRATION_DELAY, options);
}

function toSessionString(session) {
  return utils.objectEntries(session).map(function (_a) {
    var key = _a[0],
        value = _a[1];
    return "".concat(key, "=").concat(value);
  }).join(SESSION_ENTRY_SEPARATOR);
}

exports.toSessionString = toSessionString;

function retrieveSession() {
  var sessionString = (0, cookie_1.getCookie)(exports.SESSION_COOKIE_NAME);
  var session = {};

  if (isValidSessionString(sessionString)) {
    sessionString.split(SESSION_ENTRY_SEPARATOR).forEach(function (entry) {
      var matches = SESSION_ENTRY_REGEXP.exec(entry);

      if (matches !== null) {
        var key = matches[1],
            value = matches[2];
        session[key] = value;
      }
    });
  }

  return session;
}

exports.retrieveSession = retrieveSession;

function isValidSessionString(sessionString) {
  return sessionString !== undefined && (sessionString.indexOf(SESSION_ENTRY_SEPARATOR) !== -1 || SESSION_ENTRY_REGEXP.test(sessionString));
}

function isExpiredState(session) {
  return utils.isEmptyObject(session);
}

function clearSession(options) {
  (0, cookie_1.setCookie)(exports.SESSION_COOKIE_NAME, '', 0, options);
}

},{"../../browser/cookie":6,"../../tools/browserDetection":34,"../../tools/monitor":43,"../../tools/timeUtils":45,"../../tools/utils":47,"./sessionConstants":21}],23:[function(require,module,exports){
"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stopSessionManager = exports.startSessionManager = exports.VISIBILITY_CHECK_DELAY = void 0;

var utils = __importStar(require("../../tools/utils"));

var contextHistory_1 = require("../../tools/contextHistory");

var timeUtils_1 = require("../../tools/timeUtils");

var monitor_1 = require("../../tools/monitor");

var oldCookiesMigration_1 = require("./oldCookiesMigration");

var sessionStore_1 = require("./sessionStore");

var sessionConstants_1 = require("./sessionConstants");

exports.VISIBILITY_CHECK_DELAY = utils.ONE_MINUTE;
var SESSION_CONTEXT_TIMEOUT_DELAY = sessionConstants_1.SESSION_TIME_OUT_DELAY;
var stopCallbacks = [];

function startSessionManager(options, productKey, computeSessionState) {
  (0, oldCookiesMigration_1.tryOldCookiesMigration)(options);
  var sessionStore = (0, sessionStore_1.startSessionStore)(options, productKey, computeSessionState);
  stopCallbacks.push(function () {
    return sessionStore.stop();
  });
  var sessionContextHistory = new contextHistory_1.ContextHistory(SESSION_CONTEXT_TIMEOUT_DELAY);
  stopCallbacks.push(function () {
    return sessionContextHistory.stop();
  });
  sessionStore.renewObservable.subscribe(function () {
    sessionContextHistory.add(buildSessionContext(), (0, timeUtils_1.relativeNow)());
  });
  sessionStore.expireObservable.subscribe(function () {
    sessionContextHistory.closeActive((0, timeUtils_1.relativeNow)());
  });
  sessionStore.expandOrRenewSession();
  sessionContextHistory.add(buildSessionContext(), (0, timeUtils_1.clocksOrigin)().relative);
  trackActivity(function () {
    return sessionStore.expandOrRenewSession();
  });
  trackVisibility(function () {
    return sessionStore.expandSession();
  });

  function buildSessionContext() {
    return {
      id: sessionStore.getSession().id,
      trackingType: sessionStore.getSession()[productKey]
    };
  }

  return {
    findActiveSession: function findActiveSession(startTime) {
      return sessionContextHistory.find(startTime);
    },
    renewObservable: sessionStore.renewObservable,
    expireObservable: sessionStore.expireObservable
  };
}

exports.startSessionManager = startSessionManager;

function stopSessionManager() {
  stopCallbacks.forEach(function (e) {
    return e();
  });
  stopCallbacks = [];
}

exports.stopSessionManager = stopSessionManager;

function trackActivity(expandOrRenewSession) {
  var stop = utils.addEventListeners(window, ["click"
  /* CLICK */
  , "touchstart"
  /* TOUCH_START */
  , "keydown"
  /* KEY_DOWN */
  , "scroll"
  /* SCROLL */
  ], expandOrRenewSession, {
    capture: true,
    passive: true
  }).stop;
  stopCallbacks.push(stop);
}

function trackVisibility(expandSession) {
  var expandSessionWhenVisible = (0, monitor_1.monitor)(function () {
    if (document.visibilityState === 'visible') {
      expandSession();
    }
  });
  var stop = utils.addEventListener(document, "visibilitychange"
  /* VISIBILITY_CHANGE */
  , expandSessionWhenVisible).stop;
  stopCallbacks.push(stop);
  var visibilityCheckInterval = setInterval(expandSessionWhenVisible, exports.VISIBILITY_CHECK_DELAY);
  stopCallbacks.push(function () {
    clearInterval(visibilityCheckInterval);
  });
}

},{"../../tools/contextHistory":36,"../../tools/monitor":43,"../../tools/timeUtils":45,"../../tools/utils":47,"./oldCookiesMigration":20,"./sessionConstants":21,"./sessionStore":24}],24:[function(require,module,exports){
"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startSessionStore = void 0;

var cookie_1 = require("../../browser/cookie");

var monitor_1 = require("../../tools/monitor");

var observable_1 = require("../../tools/observable");

var timeUtils_1 = require("../../tools/timeUtils");

var utils = __importStar(require("../../tools/utils"));

var sessionConstants_1 = require("./sessionConstants");

var sessionCookieStore_1 = require("./sessionCookieStore");
/**
 * Different session concepts:
 * - tracked, the session has an id and is updated along the user navigation
 * - not tracked, the session does not have an id but it is updated along the user navigation
 * - inactive, no session in store or session expired, waiting for a renew session
 */


function startSessionStore(options, productKey, computeSessionState) {
  var renewObservable = new observable_1.Observable();
  var expireObservable = new observable_1.Observable();
  var watchSessionTimeoutId = setInterval((0, monitor_1.monitor)(watchSession), cookie_1.COOKIE_ACCESS_DELAY);
  var sessionCache = retrieveActiveSession();

  function expandOrRenewSession() {
    var isTracked;
    (0, sessionCookieStore_1.withCookieLockAccess)({
      options: options,
      process: function process(cookieSession) {
        var synchronizedSession = synchronizeSession(cookieSession);
        isTracked = expandOrRenewCookie(synchronizedSession);
        return synchronizedSession;
      },
      after: function after(cookieSession) {
        if (isTracked && !hasSessionInCache()) {
          renewSession(cookieSession);
        }

        sessionCache = cookieSession;
      }
    });
  }

  function expandSession() {
    (0, sessionCookieStore_1.withCookieLockAccess)({
      options: options,
      process: function process(cookieSession) {
        return hasSessionInCache() ? synchronizeSession(cookieSession) : undefined;
      }
    });
  }
  /**
   * allows two behaviors:
   * - if the session is active, synchronize the session cache without updating the session cookie
   * - if the session is not active, clear the session cookie and expire the session cache
   */


  function watchSession() {
    (0, sessionCookieStore_1.withCookieLockAccess)({
      options: options,
      process: function process(cookieSession) {
        return !isActiveSession(cookieSession) ? {} : undefined;
      },
      after: synchronizeSession
    });
  }

  function synchronizeSession(cookieSession) {
    if (!isActiveSession(cookieSession)) {
      cookieSession = {};
    }

    if (hasSessionInCache()) {
      if (isSessionInCacheOutdated(cookieSession)) {
        expireSession();
      } else {
        sessionCache = cookieSession;
      }
    }

    return cookieSession;
  }

  function expandOrRenewCookie(cookieSession) {
    var _a = computeSessionState(cookieSession[productKey]),
        trackingType = _a.trackingType,
        isTracked = _a.isTracked;

    cookieSession[productKey] = trackingType;

    if (isTracked && !cookieSession.id) {
      cookieSession.id = utils.generateUUID();
      cookieSession.created = String((0, timeUtils_1.dateNow)());
    }

    return isTracked;
  }

  function hasSessionInCache() {
    return sessionCache[productKey] !== undefined;
  }

  function isSessionInCacheOutdated(cookieSession) {
    return sessionCache.id !== cookieSession.id || sessionCache[productKey] !== cookieSession[productKey];
  }

  function expireSession() {
    sessionCache = {};
    expireObservable.notify();
  }

  function renewSession(cookieSession) {
    sessionCache = cookieSession;
    renewObservable.notify();
  }

  function retrieveActiveSession() {
    var session = (0, sessionCookieStore_1.retrieveSession)();

    if (isActiveSession(session)) {
      return session;
    }

    return {};
  }

  function isActiveSession(session) {
    // created and expire can be undefined for versions which was not storing them
    // these checks could be removed when older versions will not be available/live anymore
    return (session.created === undefined || (0, timeUtils_1.dateNow)() - Number(session.created) < sessionConstants_1.SESSION_TIME_OUT_DELAY) && (session.expire === undefined || (0, timeUtils_1.dateNow)() < Number(session.expire));
  }

  return {
    expandOrRenewSession: utils.throttle((0, monitor_1.monitor)(expandOrRenewSession), cookie_1.COOKIE_ACCESS_DELAY).throttled,
    expandSession: expandSession,
    getSession: function getSession() {
      return sessionCache;
    },
    renewObservable: renewObservable,
    expireObservable: expireObservable,
    stop: function stop() {
      clearInterval(watchSessionTimeoutId);
    }
  };
}

exports.startSessionStore = startSessionStore;

},{"../../browser/cookie":6,"../../tools/monitor":43,"../../tools/observable":44,"../../tools/timeUtils":45,"../../tools/utils":47,"./sessionConstants":21,"./sessionCookieStore":22}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSyntheticsResultId = exports.getSyntheticsTestId = exports.willSyntheticsInjectRum = exports.SYNTHETICS_INJECTS_RUM_COOKIE_NAME = exports.SYNTHETICS_RESULT_ID_COOKIE_NAME = exports.SYNTHETICS_TEST_ID_COOKIE_NAME = void 0;

var cookie_1 = require("../../browser/cookie");

exports.SYNTHETICS_TEST_ID_COOKIE_NAME = 'datadog-synthetics-public-id';
exports.SYNTHETICS_RESULT_ID_COOKIE_NAME = 'datadog-synthetics-result-id';
exports.SYNTHETICS_INJECTS_RUM_COOKIE_NAME = 'datadog-synthetics-injects-rum';

function willSyntheticsInjectRum() {
  return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || (0, cookie_1.getCookie)(exports.SYNTHETICS_INJECTS_RUM_COOKIE_NAME));
}

exports.willSyntheticsInjectRum = willSyntheticsInjectRum;

function getSyntheticsTestId() {
  var value = window._DATADOG_SYNTHETICS_PUBLIC_ID || (0, cookie_1.getCookie)(exports.SYNTHETICS_TEST_ID_COOKIE_NAME);
  return typeof value === 'string' ? value : undefined;
}

exports.getSyntheticsTestId = getSyntheticsTestId;

function getSyntheticsResultId() {
  var value = window._DATADOG_SYNTHETICS_RESULT_ID || (0, cookie_1.getCookie)(exports.SYNTHETICS_RESULT_ID_COOKIE_NAME);
  return typeof value === 'string' ? value : undefined;
}

exports.getSyntheticsResultId = getSyntheticsResultId;

},{"../../browser/cookie":6}],26:[function(require,module,exports){
"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = void 0 && (void 0).__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTelemetryReplicationAllowed = exports.startTelemetry = exports.resetTelemetry = exports.startFakeTelemetry = exports.addTelemetryError = exports.addTelemetryDebug = void 0;

var telemetry_1 = require("./telemetry");

Object.defineProperty(exports, "addTelemetryDebug", {
  enumerable: true,
  get: function get() {
    return telemetry_1.addTelemetryDebug;
  }
});
Object.defineProperty(exports, "addTelemetryError", {
  enumerable: true,
  get: function get() {
    return telemetry_1.addTelemetryError;
  }
});
Object.defineProperty(exports, "startFakeTelemetry", {
  enumerable: true,
  get: function get() {
    return telemetry_1.startFakeTelemetry;
  }
});
Object.defineProperty(exports, "resetTelemetry", {
  enumerable: true,
  get: function get() {
    return telemetry_1.resetTelemetry;
  }
});
Object.defineProperty(exports, "startTelemetry", {
  enumerable: true,
  get: function get() {
    return telemetry_1.startTelemetry;
  }
});
Object.defineProperty(exports, "isTelemetryReplicationAllowed", {
  enumerable: true,
  get: function get() {
    return telemetry_1.isTelemetryReplicationAllowed;
  }
});

__exportStar(require("./telemetryEvent.types"), exports);

},{"./telemetry":27,"./telemetryEvent.types":28}],27:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrubCustomerFrames = exports.formatError = exports.addTelemetryError = exports.addTelemetryDebug = exports.isTelemetryReplicationAllowed = exports.resetTelemetry = exports.startFakeTelemetry = exports.startTelemetry = void 0;

var display_1 = require("../../tools/display");

var error_1 = require("../../tools/error");

var utils_1 = require("../../tools/utils");

var configuration_1 = require("../configuration");

var tracekit_1 = require("../tracekit");

var observable_1 = require("../../tools/observable");

var timeUtils_1 = require("../../tools/timeUtils");

var monitor_1 = require("../../tools/monitor");

var ALLOWED_FRAME_URLS = ['https://www.datadoghq-browser-agent.com', 'https://www.datad0g-browser-agent.com', 'http://localhost', '<anonymous>'];
var TELEMETRY_EXCLUDED_SITES = [configuration_1.INTAKE_SITE_US1_FED];
var telemetryConfiguration = {
  maxEventsPerPage: 0,
  sentEventCount: 0,
  telemetryEnabled: false
};
var onRawTelemetryEventCollected;

function startTelemetry(configuration) {
  var contextProvider;
  var observable = new observable_1.Observable();
  telemetryConfiguration.telemetryEnabled = (0, utils_1.performDraw)(configuration.telemetrySampleRate);

  onRawTelemetryEventCollected = function onRawTelemetryEventCollected(event) {
    if (!(0, utils_1.includes)(TELEMETRY_EXCLUDED_SITES, configuration.site) && telemetryConfiguration.telemetryEnabled) {
      observable.notify(toTelemetryEvent(event));
    }
  };

  (0, monitor_1.startMonitorErrorCollection)(addTelemetryError);
  (0, utils_1.assign)(telemetryConfiguration, {
    maxEventsPerPage: configuration.maxTelemetryEventsPerPage,
    sentEventCount: 0
  });

  function toTelemetryEvent(event) {
    return (0, utils_1.combine)({
      type: 'telemetry',
      date: (0, timeUtils_1.timeStampNow)(),
      service: 'browser-sdk',
      version: "4.21.2",
      source: 'browser',
      _dd: {
        format_version: 2
      },
      telemetry: event,
      experimental_features: (0, utils_1.arrayFrom)((0, configuration_1.getExperimentalFeatures)())
    }, contextProvider !== undefined ? contextProvider() : {}, (0, configuration_1.isSimulationActive)() ? {
      telemetry: {
        simulation_label: (0, configuration_1.getSimulationLabel)()
      }
    } : {});
  }

  return {
    setContextProvider: function setContextProvider(provider) {
      contextProvider = provider;
    },
    observable: observable
  };
}

exports.startTelemetry = startTelemetry;

function startFakeTelemetry() {
  var events = [];
  (0, utils_1.assign)(telemetryConfiguration, {
    maxEventsPerPage: Infinity,
    sentEventCount: 0
  });

  onRawTelemetryEventCollected = function onRawTelemetryEventCollected(event) {
    events.push(event);
  };

  return events;
}

exports.startFakeTelemetry = startFakeTelemetry;

function resetTelemetry() {
  onRawTelemetryEventCollected = undefined;
}

exports.resetTelemetry = resetTelemetry;
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */

function isTelemetryReplicationAllowed(configuration) {
  return configuration.site === configuration_1.INTAKE_SITE_STAGING;
}

exports.isTelemetryReplicationAllowed = isTelemetryReplicationAllowed;

function addTelemetryDebug(message, context) {
  (0, monitor_1.displayIfDebugEnabled)(display_1.ConsoleApiName.debug, message, context);
  addTelemetry((0, utils_1.assign)({
    message: message,
    status: "debug"
    /* debug */

  }, context));
}

exports.addTelemetryDebug = addTelemetryDebug;

function addTelemetryError(e) {
  addTelemetry((0, utils_1.assign)({
    status: "error"
    /* error */

  }, formatError(e)));
}

exports.addTelemetryError = addTelemetryError;

function addTelemetry(event) {
  if (onRawTelemetryEventCollected && telemetryConfiguration.sentEventCount < telemetryConfiguration.maxEventsPerPage) {
    telemetryConfiguration.sentEventCount += 1;
    onRawTelemetryEventCollected(event);
  }
}

function formatError(e) {
  if (e instanceof Error) {
    var stackTrace = (0, tracekit_1.computeStackTrace)(e);
    return {
      error: {
        kind: stackTrace.name,
        stack: (0, error_1.toStackTraceString)(scrubCustomerFrames(stackTrace))
      },
      message: stackTrace.message
    };
  }

  return {
    error: {
      stack: 'Not an instance of error'
    },
    message: "Uncaught ".concat((0, utils_1.jsonStringify)(e))
  };
}

exports.formatError = formatError;

function scrubCustomerFrames(stackTrace) {
  stackTrace.stack = stackTrace.stack.filter(function (frame) {
    return !frame.url || ALLOWED_FRAME_URLS.some(function (allowedFrameUrl) {
      return (0, utils_1.startsWith)(frame.url, allowedFrameUrl);
    });
  });
  return stackTrace;
}

exports.scrubCustomerFrames = scrubCustomerFrames;

},{"../../tools/display":39,"../../tools/error":40,"../../tools/monitor":43,"../../tools/observable":44,"../../tools/timeUtils":45,"../../tools/utils":47,"../configuration":12,"../tracekit":30}],28:[function(require,module,exports){
"use strict";
/* eslint-disable */

/**
 * DO NOT MODIFY IT BY HAND. Run `yarn rum-events-format:sync` instead.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

},{}],29:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.computeStackTrace = void 0;

var utils_1 = require("../../tools/utils");

var UNKNOWN_FUNCTION = '?';
/**
 * Computes a stack trace for an exception.
 */

function computeStackTrace(ex) {
  var stack = [];
  var stackProperty = tryToGetString(ex, 'stack');
  var exString = String(ex);

  if (stackProperty && (0, utils_1.startsWith)(stackProperty, exString)) {
    stackProperty = stackProperty.slice(exString.length);
  }

  if (stackProperty) {
    stackProperty.split('\n').forEach(function (line) {
      var stackFrame = parseChromeLine(line) || parseChromeAnonymousLine(line) || parseWinLine(line) || parseGeckoLine(line);

      if (stackFrame) {
        if (!stackFrame.func && stackFrame.line) {
          stackFrame.func = UNKNOWN_FUNCTION;
        }

        stack.push(stackFrame);
      }
    });
  }

  return {
    message: tryToGetString(ex, 'message'),
    name: tryToGetString(ex, 'name'),
    stack: stack
  };
}

exports.computeStackTrace = computeStackTrace;
var fileUrl = '((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\\w+\\.|\\/).*?)';
var filePosition = '(?::(\\d+))';
var CHROME_LINE_RE = new RegExp("^\\s*at (.*?) ?\\(".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "?\\)?\\s*$"), 'i');
var CHROME_EVAL_RE = new RegExp("\\((\\S*)".concat(filePosition).concat(filePosition, "\\)"));

function parseChromeLine(line) {
  var parts = CHROME_LINE_RE.exec(line);

  if (!parts) {
    return;
  }

  var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line

  var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line

  var submatch = CHROME_EVAL_RE.exec(parts[2]);

  if (isEval && submatch) {
    // throw out eval line/column and use top-most line/column number
    parts[2] = submatch[1]; // url

    parts[3] = submatch[2]; // line

    parts[4] = submatch[3]; // column
  }

  return {
    args: isNative ? [parts[2]] : [],
    column: parts[4] ? +parts[4] : undefined,
    func: parts[1] || UNKNOWN_FUNCTION,
    line: parts[3] ? +parts[3] : undefined,
    url: !isNative ? parts[2] : undefined
  };
}

var CHROME_ANONYMOUS_FUNCTION_RE = new RegExp("^\\s*at ?".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "??\\s*$"), 'i');

function parseChromeAnonymousLine(line) {
  var parts = CHROME_ANONYMOUS_FUNCTION_RE.exec(line);

  if (!parts) {
    return;
  }

  return {
    args: [],
    column: parts[3] ? +parts[3] : undefined,
    func: UNKNOWN_FUNCTION,
    line: parts[2] ? +parts[2] : undefined,
    url: parts[1]
  };
}

var WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;

function parseWinLine(line) {
  var parts = WINJS_LINE_RE.exec(line);

  if (!parts) {
    return;
  }

  return {
    args: [],
    column: parts[4] ? +parts[4] : undefined,
    func: parts[1] || UNKNOWN_FUNCTION,
    line: +parts[3],
    url: parts[2]
  };
}

var GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
var GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;

function parseGeckoLine(line) {
  var parts = GECKO_LINE_RE.exec(line);

  if (!parts) {
    return;
  }

  var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
  var submatch = GECKO_EVAL_RE.exec(parts[3]);

  if (isEval && submatch) {
    // throw out eval line/column and use top-most line number
    parts[3] = submatch[1];
    parts[4] = submatch[2];
    parts[5] = undefined; // no column when eval
  }

  return {
    args: parts[2] ? parts[2].split(',') : [],
    column: parts[5] ? +parts[5] : undefined,
    func: parts[1] || UNKNOWN_FUNCTION,
    line: parts[4] ? +parts[4] : undefined,
    url: parts[3]
  };
}

function tryToGetString(candidate, property) {
  if (_typeof(candidate) !== 'object' || !candidate || !(property in candidate)) {
    return undefined;
  }

  var value = candidate[property];
  return typeof value === 'string' ? value : undefined;
}

},{"../../tools/utils":47}],30:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startUnhandledErrorCollection = exports.computeStackTrace = void 0;

var computeStackTrace_1 = require("./computeStackTrace");

Object.defineProperty(exports, "computeStackTrace", {
  enumerable: true,
  get: function get() {
    return computeStackTrace_1.computeStackTrace;
  }
});

var tracekit_1 = require("./tracekit");

Object.defineProperty(exports, "startUnhandledErrorCollection", {
  enumerable: true,
  get: function get() {
    return tracekit_1.startUnhandledErrorCollection;
  }
});

},{"./computeStackTrace":29,"./tracekit":31}],31:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startUnhandledErrorCollection = void 0;

var instrumentMethod_1 = require("../../tools/instrumentMethod");

var computeStackTrace_1 = require("./computeStackTrace"); // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types


var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
/**
 * Cross-browser collection of unhandled errors
 *
 * Supports:
 * - Firefox: full stack trace with line numbers, plus column number
 * on top frame; column number is not guaranteed
 * - Opera: full stack trace with line and column numbers
 * - Chrome: full stack trace with line and column numbers
 * - Safari: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 * - IE: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 * - IE5.5+ (only 8.0 tested)
 * - Firefox 0.9+ (only 3.5+ tested)
 * - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 * Exceptions Have Stacktrace to be enabled in opera:config)
 * - Safari 3+ (only 4+ tested)
 * - Chrome 1+ (only 5+ tested)
 * - Konqueror 3.5+ (untested)
 *
 * Tries to catch all unhandled errors and report them to the
 * callback.
 *
 * Callbacks receive a StackTrace object as described in the
 * computeStackTrace docs.
 *
 * @memberof TraceKit
 * @namespace
 */

function startUnhandledErrorCollection(callback) {
  var stopInstrumentingOnError = instrumentOnError(callback).stop;
  var stopInstrumentingOnUnhandledRejection = instrumentUnhandledRejection(callback).stop;
  return {
    stop: function stop() {
      stopInstrumentingOnError();
      stopInstrumentingOnUnhandledRejection();
    }
  };
}

exports.startUnhandledErrorCollection = startUnhandledErrorCollection;
/**
 * Install a global onerror handler
 */

function instrumentOnError(callback) {
  return (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(window, 'onerror', {
    before: function before(message, url, lineNo, columnNo, errorObj) {
      var stack;

      if (errorObj) {
        stack = (0, computeStackTrace_1.computeStackTrace)(errorObj);
        callback(stack, errorObj);
      } else {
        var location_1 = {
          url: url,
          column: columnNo,
          line: lineNo
        };
        var name_1;
        var msg = message;

        if ({}.toString.call(message) === '[object String]') {
          var groups = ERROR_TYPES_RE.exec(msg);

          if (groups) {
            name_1 = groups[1];
            msg = groups[2];
          }
        }

        stack = {
          name: name_1,
          message: typeof msg === 'string' ? msg : undefined,
          stack: [location_1]
        };
        callback(stack, message);
      }
    }
  });
}
/**
 * Install a global onunhandledrejection handler
 */


function instrumentUnhandledRejection(callback) {
  return (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(window, 'onunhandledrejection', {
    before: function before(e) {
      var reason = e.reason || 'Empty reason';
      var stack = (0, computeStackTrace_1.computeStackTrace)(reason);
      callback(stack, reason);
    }
  });
}

},{"../../tools/instrumentMethod":41,"./computeStackTrace":29}],32:[function(require,module,exports){
"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = void 0 && (void 0).__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BoundedBuffer = exports.initConsoleObservable = exports.initFetchObservable = exports.initXhrObservable = exports.COOKIE_ACCESS_DELAY = exports.deleteCookie = exports.setCookie = exports.getCookie = exports.areCookiesAuthorized = exports.getFileFromStackTraceString = exports.toStackTraceString = exports.createHandlingStack = exports.computeRawError = exports.ErrorSource = exports.instrumentSetter = exports.instrumentMethodAndCallOriginal = exports.instrumentMethod = exports.startBatchWithReplica = exports.getEventBridge = exports.canUseEventBridge = exports.Batch = exports.createHttpRequest = exports.SESSION_TIME_OUT_DELAY = exports.stopSessionManager = exports.startSessionManager = exports.Observable = exports.setDebugMode = exports.callMonitored = exports.monitor = exports.monitored = exports.isTelemetryReplicationAllowed = exports.resetTelemetry = exports.startFakeTelemetry = exports.addTelemetryError = exports.addTelemetryDebug = exports.startTelemetry = exports.RawReportType = exports.initReportObservable = exports.makePublicApi = exports.defineGlobal = exports.computeStackTrace = exports.trackRuntimeError = exports.getSimulationLabel = exports.isSimulationActive = exports.resetExperimentalFeatures = exports.updateExperimentalFeatures = exports.isExperimentalFeatureEnabled = exports.DefaultPrivacyLevel = exports.validateAndBuildConfiguration = exports.buildCookieOptions = void 0;
exports.getSyntheticsResultId = exports.getSyntheticsTestId = exports.willSyntheticsInjectRum = exports.SESSION_COOKIE_NAME = exports.CLEAR_OLD_CONTEXTS_INTERVAL = exports.ContextHistory = exports.limitModification = exports.createContextManager = exports.catchUserErrors = void 0;

var configuration_1 = require("./domain/configuration");

Object.defineProperty(exports, "buildCookieOptions", {
  enumerable: true,
  get: function get() {
    return configuration_1.buildCookieOptions;
  }
});
Object.defineProperty(exports, "validateAndBuildConfiguration", {
  enumerable: true,
  get: function get() {
    return configuration_1.validateAndBuildConfiguration;
  }
});
Object.defineProperty(exports, "DefaultPrivacyLevel", {
  enumerable: true,
  get: function get() {
    return configuration_1.DefaultPrivacyLevel;
  }
});
Object.defineProperty(exports, "isExperimentalFeatureEnabled", {
  enumerable: true,
  get: function get() {
    return configuration_1.isExperimentalFeatureEnabled;
  }
});
Object.defineProperty(exports, "updateExperimentalFeatures", {
  enumerable: true,
  get: function get() {
    return configuration_1.updateExperimentalFeatures;
  }
});
Object.defineProperty(exports, "resetExperimentalFeatures", {
  enumerable: true,
  get: function get() {
    return configuration_1.resetExperimentalFeatures;
  }
});
Object.defineProperty(exports, "isSimulationActive", {
  enumerable: true,
  get: function get() {
    return configuration_1.isSimulationActive;
  }
});
Object.defineProperty(exports, "getSimulationLabel", {
  enumerable: true,
  get: function get() {
    return configuration_1.getSimulationLabel;
  }
});

var trackRuntimeError_1 = require("./domain/error/trackRuntimeError");

Object.defineProperty(exports, "trackRuntimeError", {
  enumerable: true,
  get: function get() {
    return trackRuntimeError_1.trackRuntimeError;
  }
});

var tracekit_1 = require("./domain/tracekit");

Object.defineProperty(exports, "computeStackTrace", {
  enumerable: true,
  get: function get() {
    return tracekit_1.computeStackTrace;
  }
});

var init_1 = require("./boot/init");

Object.defineProperty(exports, "defineGlobal", {
  enumerable: true,
  get: function get() {
    return init_1.defineGlobal;
  }
});
Object.defineProperty(exports, "makePublicApi", {
  enumerable: true,
  get: function get() {
    return init_1.makePublicApi;
  }
});

var reportObservable_1 = require("./domain/report/reportObservable");

Object.defineProperty(exports, "initReportObservable", {
  enumerable: true,
  get: function get() {
    return reportObservable_1.initReportObservable;
  }
});
Object.defineProperty(exports, "RawReportType", {
  enumerable: true,
  get: function get() {
    return reportObservable_1.RawReportType;
  }
});

var telemetry_1 = require("./domain/telemetry");

Object.defineProperty(exports, "startTelemetry", {
  enumerable: true,
  get: function get() {
    return telemetry_1.startTelemetry;
  }
});
Object.defineProperty(exports, "addTelemetryDebug", {
  enumerable: true,
  get: function get() {
    return telemetry_1.addTelemetryDebug;
  }
});
Object.defineProperty(exports, "addTelemetryError", {
  enumerable: true,
  get: function get() {
    return telemetry_1.addTelemetryError;
  }
});
Object.defineProperty(exports, "startFakeTelemetry", {
  enumerable: true,
  get: function get() {
    return telemetry_1.startFakeTelemetry;
  }
});
Object.defineProperty(exports, "resetTelemetry", {
  enumerable: true,
  get: function get() {
    return telemetry_1.resetTelemetry;
  }
});
Object.defineProperty(exports, "isTelemetryReplicationAllowed", {
  enumerable: true,
  get: function get() {
    return telemetry_1.isTelemetryReplicationAllowed;
  }
});

var monitor_1 = require("./tools/monitor");

Object.defineProperty(exports, "monitored", {
  enumerable: true,
  get: function get() {
    return monitor_1.monitored;
  }
});
Object.defineProperty(exports, "monitor", {
  enumerable: true,
  get: function get() {
    return monitor_1.monitor;
  }
});
Object.defineProperty(exports, "callMonitored", {
  enumerable: true,
  get: function get() {
    return monitor_1.callMonitored;
  }
});
Object.defineProperty(exports, "setDebugMode", {
  enumerable: true,
  get: function get() {
    return monitor_1.setDebugMode;
  }
});

var observable_1 = require("./tools/observable");

Object.defineProperty(exports, "Observable", {
  enumerable: true,
  get: function get() {
    return observable_1.Observable;
  }
});

var sessionManager_1 = require("./domain/session/sessionManager");

Object.defineProperty(exports, "startSessionManager", {
  enumerable: true,
  get: function get() {
    return sessionManager_1.startSessionManager;
  }
}); // Exposed for tests

Object.defineProperty(exports, "stopSessionManager", {
  enumerable: true,
  get: function get() {
    return sessionManager_1.stopSessionManager;
  }
});

var sessionConstants_1 = require("./domain/session/sessionConstants");

Object.defineProperty(exports, "SESSION_TIME_OUT_DELAY", {
  enumerable: true,
  get: function get() {
    return sessionConstants_1.SESSION_TIME_OUT_DELAY;
  }
});

var transport_1 = require("./transport");

Object.defineProperty(exports, "createHttpRequest", {
  enumerable: true,
  get: function get() {
    return transport_1.createHttpRequest;
  }
});
Object.defineProperty(exports, "Batch", {
  enumerable: true,
  get: function get() {
    return transport_1.Batch;
  }
});
Object.defineProperty(exports, "canUseEventBridge", {
  enumerable: true,
  get: function get() {
    return transport_1.canUseEventBridge;
  }
});
Object.defineProperty(exports, "getEventBridge", {
  enumerable: true,
  get: function get() {
    return transport_1.getEventBridge;
  }
});
Object.defineProperty(exports, "startBatchWithReplica", {
  enumerable: true,
  get: function get() {
    return transport_1.startBatchWithReplica;
  }
});

__exportStar(require("./tools/display"), exports);

__exportStar(require("./tools/urlPolyfill"), exports);

__exportStar(require("./tools/timeUtils"), exports);

__exportStar(require("./tools/utils"), exports);

__exportStar(require("./tools/createEventRateLimiter"), exports);

__exportStar(require("./tools/browserDetection"), exports);

var instrumentMethod_1 = require("./tools/instrumentMethod");

Object.defineProperty(exports, "instrumentMethod", {
  enumerable: true,
  get: function get() {
    return instrumentMethod_1.instrumentMethod;
  }
});
Object.defineProperty(exports, "instrumentMethodAndCallOriginal", {
  enumerable: true,
  get: function get() {
    return instrumentMethod_1.instrumentMethodAndCallOriginal;
  }
});
Object.defineProperty(exports, "instrumentSetter", {
  enumerable: true,
  get: function get() {
    return instrumentMethod_1.instrumentSetter;
  }
});

var error_1 = require("./tools/error");

Object.defineProperty(exports, "ErrorSource", {
  enumerable: true,
  get: function get() {
    return error_1.ErrorSource;
  }
});
Object.defineProperty(exports, "computeRawError", {
  enumerable: true,
  get: function get() {
    return error_1.computeRawError;
  }
});
Object.defineProperty(exports, "createHandlingStack", {
  enumerable: true,
  get: function get() {
    return error_1.createHandlingStack;
  }
});
Object.defineProperty(exports, "toStackTraceString", {
  enumerable: true,
  get: function get() {
    return error_1.toStackTraceString;
  }
});
Object.defineProperty(exports, "getFileFromStackTraceString", {
  enumerable: true,
  get: function get() {
    return error_1.getFileFromStackTraceString;
  }
});

var cookie_1 = require("./browser/cookie");

Object.defineProperty(exports, "areCookiesAuthorized", {
  enumerable: true,
  get: function get() {
    return cookie_1.areCookiesAuthorized;
  }
});
Object.defineProperty(exports, "getCookie", {
  enumerable: true,
  get: function get() {
    return cookie_1.getCookie;
  }
});
Object.defineProperty(exports, "setCookie", {
  enumerable: true,
  get: function get() {
    return cookie_1.setCookie;
  }
});
Object.defineProperty(exports, "deleteCookie", {
  enumerable: true,
  get: function get() {
    return cookie_1.deleteCookie;
  }
});
Object.defineProperty(exports, "COOKIE_ACCESS_DELAY", {
  enumerable: true,
  get: function get() {
    return cookie_1.COOKIE_ACCESS_DELAY;
  }
});

var xhrObservable_1 = require("./browser/xhrObservable");

Object.defineProperty(exports, "initXhrObservable", {
  enumerable: true,
  get: function get() {
    return xhrObservable_1.initXhrObservable;
  }
});

var fetchObservable_1 = require("./browser/fetchObservable");

Object.defineProperty(exports, "initFetchObservable", {
  enumerable: true,
  get: function get() {
    return fetchObservable_1.initFetchObservable;
  }
});

var consoleObservable_1 = require("./domain/console/consoleObservable");

Object.defineProperty(exports, "initConsoleObservable", {
  enumerable: true,
  get: function get() {
    return consoleObservable_1.initConsoleObservable;
  }
});

var boundedBuffer_1 = require("./tools/boundedBuffer");

Object.defineProperty(exports, "BoundedBuffer", {
  enumerable: true,
  get: function get() {
    return boundedBuffer_1.BoundedBuffer;
  }
});

var catchUserErrors_1 = require("./tools/catchUserErrors");

Object.defineProperty(exports, "catchUserErrors", {
  enumerable: true,
  get: function get() {
    return catchUserErrors_1.catchUserErrors;
  }
});

var contextManager_1 = require("./tools/contextManager");

Object.defineProperty(exports, "createContextManager", {
  enumerable: true,
  get: function get() {
    return contextManager_1.createContextManager;
  }
});

var limitModification_1 = require("./tools/limitModification");

Object.defineProperty(exports, "limitModification", {
  enumerable: true,
  get: function get() {
    return limitModification_1.limitModification;
  }
});

var contextHistory_1 = require("./tools/contextHistory");

Object.defineProperty(exports, "ContextHistory", {
  enumerable: true,
  get: function get() {
    return contextHistory_1.ContextHistory;
  }
});
Object.defineProperty(exports, "CLEAR_OLD_CONTEXTS_INTERVAL", {
  enumerable: true,
  get: function get() {
    return contextHistory_1.CLEAR_OLD_CONTEXTS_INTERVAL;
  }
});

var sessionCookieStore_1 = require("./domain/session/sessionCookieStore");

Object.defineProperty(exports, "SESSION_COOKIE_NAME", {
  enumerable: true,
  get: function get() {
    return sessionCookieStore_1.SESSION_COOKIE_NAME;
  }
});

var syntheticsWorkerValues_1 = require("./domain/synthetics/syntheticsWorkerValues");

Object.defineProperty(exports, "willSyntheticsInjectRum", {
  enumerable: true,
  get: function get() {
    return syntheticsWorkerValues_1.willSyntheticsInjectRum;
  }
});
Object.defineProperty(exports, "getSyntheticsTestId", {
  enumerable: true,
  get: function get() {
    return syntheticsWorkerValues_1.getSyntheticsTestId;
  }
});
Object.defineProperty(exports, "getSyntheticsResultId", {
  enumerable: true,
  get: function get() {
    return syntheticsWorkerValues_1.getSyntheticsResultId;
  }
});

},{"./boot/init":5,"./browser/cookie":6,"./browser/fetchObservable":7,"./browser/xhrObservable":8,"./domain/configuration":12,"./domain/console/consoleObservable":17,"./domain/error/trackRuntimeError":18,"./domain/report/reportObservable":19,"./domain/session/sessionConstants":21,"./domain/session/sessionCookieStore":22,"./domain/session/sessionManager":23,"./domain/synthetics/syntheticsWorkerValues":25,"./domain/telemetry":26,"./domain/tracekit":30,"./tools/boundedBuffer":33,"./tools/browserDetection":34,"./tools/catchUserErrors":35,"./tools/contextHistory":36,"./tools/contextManager":37,"./tools/createEventRateLimiter":38,"./tools/display":39,"./tools/error":40,"./tools/instrumentMethod":41,"./tools/limitModification":42,"./tools/monitor":43,"./tools/observable":44,"./tools/timeUtils":45,"./tools/urlPolyfill":46,"./tools/utils":47,"./transport":51}],33:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BoundedBuffer = void 0;
var BUFFER_LIMIT = 500;

var BoundedBuffer =
/** @class */
function () {
  function BoundedBuffer() {
    this.buffer = [];
  }

  BoundedBuffer.prototype.add = function (callback) {
    var length = this.buffer.push(callback);

    if (length > BUFFER_LIMIT) {
      this.buffer.splice(0, 1);
    }
  };

  BoundedBuffer.prototype.drain = function () {
    this.buffer.forEach(function (callback) {
      return callback();
    });
    this.buffer.length = 0;
  };

  return BoundedBuffer;
}();

exports.BoundedBuffer = BoundedBuffer;

},{}],34:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isChromium = exports.isIE = void 0;

function isIE() {
  return Boolean(document.documentMode);
}

exports.isIE = isIE;

function isChromium() {
  return !!window.chrome || /HeadlessChrome/.test(window.navigator.userAgent);
}

exports.isChromium = isChromium;

},{}],35:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.catchUserErrors = void 0;

var display_1 = require("./display");

function catchUserErrors(fn, errorMsg) {
  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    try {
      return fn.apply(void 0, args);
    } catch (err) {
      display_1.display.error(errorMsg, err);
    }
  };
}

exports.catchUserErrors = catchUserErrors;

},{"./display":39}],36:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContextHistory = exports.CLEAR_OLD_CONTEXTS_INTERVAL = void 0;

var timeUtils_1 = require("./timeUtils");

var utils_1 = require("./utils");

var END_OF_TIMES = Infinity;
exports.CLEAR_OLD_CONTEXTS_INTERVAL = utils_1.ONE_MINUTE;
/**
 * Store and keep track of contexts spans. This whole class assumes that contexts are added in
 * chronological order (i.e. all entries have an increasing start time).
 */

var ContextHistory =
/** @class */
function () {
  function ContextHistory(expireDelay) {
    var _this = this;

    this.expireDelay = expireDelay;
    this.entries = [];
    this.clearOldContextsInterval = setInterval(function () {
      return _this.clearOldContexts();
    }, exports.CLEAR_OLD_CONTEXTS_INTERVAL);
  }
  /**
   * Add a context to the history associated with a start time. Returns a reference to this newly
   * added entry that can be removed or closed.
   */


  ContextHistory.prototype.add = function (context, startTime) {
    var _this = this;

    var entry = {
      context: context,
      startTime: startTime,
      endTime: END_OF_TIMES,
      remove: function remove() {
        var index = _this.entries.indexOf(entry);

        if (index >= 0) {
          _this.entries.splice(index, 1);
        }
      },
      close: function close(endTime) {
        entry.endTime = endTime;
      }
    };
    this.entries.unshift(entry);
    return entry;
  };
  /**
   * Return the latest context that was active during `startTime`, or the currently active context
   * if no `startTime` is provided. This method assumes that entries are not overlapping.
   */


  ContextHistory.prototype.find = function (startTime) {
    if (startTime === void 0) {
      startTime = END_OF_TIMES;
    }

    for (var _i = 0, _a = this.entries; _i < _a.length; _i++) {
      var entry = _a[_i];

      if (entry.startTime <= startTime) {
        if (startTime <= entry.endTime) {
          return entry.context;
        }

        break;
      }
    }
  };
  /**
   * Helper function to close the currently active context, if any. This method assumes that entries
   * are not overlapping.
   */


  ContextHistory.prototype.closeActive = function (endTime) {
    var latestEntry = this.entries[0];

    if (latestEntry && latestEntry.endTime === END_OF_TIMES) {
      latestEntry.close(endTime);
    }
  };
  /**
   * Return all contexts that were active during `startTime`, or all currently active contexts if no
   * `startTime` is provided.
   */


  ContextHistory.prototype.findAll = function (startTime) {
    if (startTime === void 0) {
      startTime = END_OF_TIMES;
    }

    return this.entries.filter(function (entry) {
      return entry.startTime <= startTime && startTime <= entry.endTime;
    }).map(function (entry) {
      return entry.context;
    });
  };
  /**
   * Remove all entries from this collection.
   */


  ContextHistory.prototype.reset = function () {
    this.entries = [];
  };
  /**
   * Stop internal garbage collection of past entries.
   */


  ContextHistory.prototype.stop = function () {
    clearInterval(this.clearOldContextsInterval);
  };

  ContextHistory.prototype.clearOldContexts = function () {
    var oldTimeThreshold = (0, timeUtils_1.relativeNow)() - this.expireDelay;

    while (this.entries.length > 0 && this.entries[this.entries.length - 1].endTime < oldTimeThreshold) {
      this.entries.pop();
    }
  };

  return ContextHistory;
}();

exports.ContextHistory = ContextHistory;

},{"./timeUtils":45,"./utils":47}],37:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createContextManager = void 0;

var utils_1 = require("./utils");

function createContextManager() {
  var context = {};
  return {
    /** @deprecated use getContext instead */
    get: function get() {
      return context;
    },

    /** @deprecated use setContextProperty instead */
    add: function add(key, value) {
      context[key] = value;
    },

    /** @deprecated renamed to removeContextProperty */
    remove: function remove(key) {
      delete context[key];
    },

    /** @deprecated use setContext instead */
    set: function set(newContext) {
      context = newContext;
    },
    getContext: function getContext() {
      return (0, utils_1.deepClone)(context);
    },
    setContext: function setContext(newContext) {
      context = (0, utils_1.deepClone)(newContext);
    },
    setContextProperty: function setContextProperty(key, property) {
      context[key] = (0, utils_1.deepClone)(property);
    },
    removeContextProperty: function removeContextProperty(key) {
      delete context[key];
    },
    clearContext: function clearContext() {
      context = {};
    }
  };
}

exports.createContextManager = createContextManager;

},{"./utils":47}],38:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createEventRateLimiter = void 0;

var error_1 = require("./error");

var timeUtils_1 = require("./timeUtils");

var utils_1 = require("./utils");

function createEventRateLimiter(eventType, limit, onLimitReached) {
  var eventCount = 0;
  var allowNextEvent = false;
  return {
    isLimitReached: function isLimitReached() {
      if (eventCount === 0) {
        setTimeout(function () {
          eventCount = 0;
        }, utils_1.ONE_MINUTE);
      }

      eventCount += 1;

      if (eventCount <= limit || allowNextEvent) {
        allowNextEvent = false;
        return false;
      }

      if (eventCount === limit + 1) {
        allowNextEvent = true;

        try {
          onLimitReached({
            message: "Reached max number of ".concat(eventType, "s by minute: ").concat(limit),
            source: error_1.ErrorSource.AGENT,
            startClocks: (0, timeUtils_1.clocksNow)()
          });
        } finally {
          allowNextEvent = false;
        }
      }

      return true;
    }
  };
}

exports.createEventRateLimiter = createEventRateLimiter;

},{"./error":40,"./timeUtils":45,"./utils":47}],39:[function(require,module,exports){
"use strict";
/* eslint-disable no-console, local-rules/disallow-side-effects */

/**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.display = exports.ConsoleApiName = void 0;
exports.ConsoleApiName = {
  log: 'log',
  debug: 'debug',
  info: 'info',
  warn: 'warn',
  error: 'error'
};

var display = function display(api) {
  var args = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }

  if (!Object.prototype.hasOwnProperty.call(exports.ConsoleApiName, api)) {
    api = exports.ConsoleApiName.log;
  }

  exports.display[api].apply(exports.display, args);
};

exports.display = display;
exports.display.debug = console.debug.bind(console);
exports.display.log = console.log.bind(console);
exports.display.info = console.info.bind(console);
exports.display.warn = console.warn.bind(console);
exports.display.error = console.error.bind(console);

},{}],40:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenErrorCauses = exports.createHandlingStack = exports.formatErrorMessage = exports.getFileFromStackTraceString = exports.toStackTraceString = exports.computeRawError = exports.ErrorSource = void 0;

var tracekit_1 = require("../domain/tracekit");

var monitor_1 = require("./monitor");

var utils_1 = require("./utils");

exports.ErrorSource = {
  AGENT: 'agent',
  CONSOLE: 'console',
  CUSTOM: 'custom',
  LOGGER: 'logger',
  NETWORK: 'network',
  SOURCE: 'source',
  REPORT: 'report'
};

function computeRawError(_a) {
  var stackTrace = _a.stackTrace,
      originalError = _a.originalError,
      handlingStack = _a.handlingStack,
      startClocks = _a.startClocks,
      nonErrorPrefix = _a.nonErrorPrefix,
      source = _a.source,
      handling = _a.handling;

  if (!stackTrace || stackTrace.message === undefined && !(originalError instanceof Error)) {
    return {
      startClocks: startClocks,
      source: source,
      handling: handling,
      originalError: originalError,
      message: "".concat(nonErrorPrefix, " ").concat((0, utils_1.jsonStringify)(originalError)),
      stack: 'No stack, consider using an instance of Error',
      handlingStack: handlingStack,
      type: stackTrace && stackTrace.name
    };
  }

  return {
    startClocks: startClocks,
    source: source,
    handling: handling,
    originalError: originalError,
    message: stackTrace.message || 'Empty message',
    stack: toStackTraceString(stackTrace),
    handlingStack: handlingStack,
    type: stackTrace.name,
    causes: flattenErrorCauses(originalError, source)
  };
}

exports.computeRawError = computeRawError;

function toStackTraceString(stack) {
  var result = formatErrorMessage(stack);
  stack.stack.forEach(function (frame) {
    var func = frame.func === '?' ? '<anonymous>' : frame.func;
    var args = frame.args && frame.args.length > 0 ? "(".concat(frame.args.join(', '), ")") : '';
    var line = frame.line ? ":".concat(frame.line) : '';
    var column = frame.line && frame.column ? ":".concat(frame.column) : '';
    result += "\n  at ".concat(func).concat(args, " @ ").concat(frame.url).concat(line).concat(column);
  });
  return result;
}

exports.toStackTraceString = toStackTraceString;

function getFileFromStackTraceString(stack) {
  var _a;

  return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}

exports.getFileFromStackTraceString = getFileFromStackTraceString;

function formatErrorMessage(stack) {
  return "".concat(stack.name || 'Error', ": ").concat(stack.message);
}

exports.formatErrorMessage = formatErrorMessage;
/**
 Creates a stacktrace without SDK internal frames.
 
 Constraints:
 - Has to be called at the utmost position of the call stack.
 - No monitored function should encapsulate it, that is why we need to use callMonitored inside it.
 */

function createHandlingStack() {
  /**
   * Skip the two internal frames:
   * - SDK API (console.error, ...)
   * - this function
   * in order to keep only the user calls
   */
  var internalFramesToSkip = 2;
  var error = new Error();
  var formattedStack; // IE needs to throw the error to fill in the stack trace

  if (!error.stack) {
    try {
      throw error;
    } catch (e) {
      (0, utils_1.noop)();
    }
  }

  (0, monitor_1.callMonitored)(function () {
    var stackTrace = (0, tracekit_1.computeStackTrace)(error);
    stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
    formattedStack = toStackTraceString(stackTrace);
  });
  return formattedStack;
}

exports.createHandlingStack = createHandlingStack;

function flattenErrorCauses(error, parentSource) {
  var currentError = error;
  var causes = [];

  while ((currentError === null || currentError === void 0 ? void 0 : currentError.cause) instanceof Error && causes.length < 10) {
    var stackTrace = (0, tracekit_1.computeStackTrace)(currentError.cause);
    causes.push({
      message: currentError.cause.message,
      source: parentSource,
      type: stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name,
      stack: stackTrace && toStackTraceString(stackTrace)
    });
    currentError = currentError.cause;
  }

  return causes.length ? causes : undefined;
}

exports.flattenErrorCauses = flattenErrorCauses;

},{"../domain/tracekit":30,"./monitor":43,"./utils":47}],41:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instrumentSetter = exports.instrumentMethodAndCallOriginal = exports.instrumentMethod = void 0;

var monitor_1 = require("./monitor");

var utils_1 = require("./utils");

function instrumentMethod(object, method, instrumentationFactory) {
  var original = object[method];
  var instrumentation = instrumentationFactory(original);

  var instrumentationWrapper = function instrumentationWrapper() {
    if (typeof instrumentation !== 'function') {
      return undefined;
    } // eslint-disable-next-line @typescript-eslint/no-unsafe-return


    return instrumentation.apply(this, arguments);
  };

  object[method] = instrumentationWrapper;
  return {
    stop: function stop() {
      if (object[method] === instrumentationWrapper) {
        object[method] = original;
      } else {
        instrumentation = original;
      }
    }
  };
}

exports.instrumentMethod = instrumentMethod;

function instrumentMethodAndCallOriginal(object, method, _a) {
  var before = _a.before,
      after = _a.after;
  return instrumentMethod(object, method, function (original) {
    return function () {
      var args = arguments;
      var result;

      if (before) {
        (0, monitor_1.callMonitored)(before, this, args);
      }

      if (typeof original === 'function') {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        result = original.apply(this, args);
      }

      if (after) {
        (0, monitor_1.callMonitored)(after, this, args);
      } // eslint-disable-next-line @typescript-eslint/no-unsafe-return


      return result;
    };
  });
}

exports.instrumentMethodAndCallOriginal = instrumentMethodAndCallOriginal;

function instrumentSetter(object, property, after) {
  var originalDescriptor = Object.getOwnPropertyDescriptor(object, property);

  if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) {
    return {
      stop: utils_1.noop
    };
  }

  var instrumentation = function instrumentation(thisObject, value) {
    // put hooked setter into event loop to avoid of set latency
    setTimeout((0, monitor_1.monitor)(function () {
      after(thisObject, value);
    }), 0);
  };

  var instrumentationWrapper = function instrumentationWrapper(value) {
    originalDescriptor.set.call(this, value);
    instrumentation(this, value);
  };

  Object.defineProperty(object, property, {
    set: instrumentationWrapper
  });
  return {
    stop: function stop() {
      var _a;

      if (((_a = Object.getOwnPropertyDescriptor(object, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) {
        Object.defineProperty(object, property, originalDescriptor);
      } else {
        instrumentation = utils_1.noop;
      }
    }
  };
}

exports.instrumentSetter = instrumentSetter;

},{"./monitor":43,"./utils":47}],42:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.limitModification = void 0;

var utils_1 = require("./utils");
/**
 * Current limitation:
 * - field path do not support array, 'a.b.c' only
 */


function limitModification(object, modifiableFieldPaths, modifier) {
  var clone = (0, utils_1.deepClone)(object);
  var result = modifier(clone);
  modifiableFieldPaths.forEach(function (path) {
    var originalValue = get(object, path);
    var newValue = get(clone, path);
    var originalType = (0, utils_1.getType)(originalValue);
    var newType = (0, utils_1.getType)(newValue);

    if (newType === originalType) {
      set(object, path, newValue);
    } else if (originalType === 'object' && (newType === 'undefined' || newType === 'null')) {
      set(object, path, {});
    }
  });
  return result;
}

exports.limitModification = limitModification;

function get(object, path) {
  var current = object;

  for (var _i = 0, _a = path.split('.'); _i < _a.length; _i++) {
    var field = _a[_i];

    if (!isValidObjectContaining(current, field)) {
      return;
    }

    current = current[field];
  }

  return current;
}

function set(object, path, value) {
  var current = object;
  var fields = path.split('.');

  for (var i = 0; i < fields.length; i += 1) {
    var field = fields[i];

    if (!isValidObjectContaining(current, field)) {
      return;
    }

    if (i !== fields.length - 1) {
      current = current[field];
    } else {
      current[field] = value;
    }
  }
}

function isValidObjectContaining(object, field) {
  return _typeof(object) === 'object' && object !== null && Object.prototype.hasOwnProperty.call(object, field);
}

},{"./utils":47}],43:[function(require,module,exports){
"use strict";

var __spreadArray = void 0 && (void 0).__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.displayIfDebugEnabled = exports.callMonitored = exports.monitor = exports.monitored = exports.resetMonitor = exports.setDebugMode = exports.startMonitorErrorCollection = void 0;

var display_1 = require("./display");

var onMonitorErrorCollected;
var debugMode = false;

function startMonitorErrorCollection(newOnMonitorErrorCollected) {
  onMonitorErrorCollected = newOnMonitorErrorCollected;
}

exports.startMonitorErrorCollection = startMonitorErrorCollection;

function setDebugMode(newDebugMode) {
  debugMode = newDebugMode;
}

exports.setDebugMode = setDebugMode;

function resetMonitor() {
  onMonitorErrorCollected = undefined;
  debugMode = false;
}

exports.resetMonitor = resetMonitor;

function monitored(_, __, descriptor) {
  var originalMethod = descriptor.value;

  descriptor.value = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    var decorated = onMonitorErrorCollected ? monitor(originalMethod) : originalMethod;
    return decorated.apply(this, args);
  };
}

exports.monitored = monitored;

function monitor(fn) {
  return function () {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return callMonitored(fn, this, arguments);
  }; // consider output type has input type
}

exports.monitor = monitor;

function callMonitored(fn, context, args) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return fn.apply(context, args);
  } catch (e) {
    displayIfDebugEnabled(display_1.ConsoleApiName.error, e);

    if (onMonitorErrorCollected) {
      try {
        onMonitorErrorCollected(e);
      } catch (e) {
        displayIfDebugEnabled(display_1.ConsoleApiName.error, e);
      }
    }
  }
}

exports.callMonitored = callMonitored;

function displayIfDebugEnabled(api) {
  var args = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }

  if (debugMode) {
    display_1.display.apply(void 0, __spreadArray([api, '[MONITOR]'], args, false));
  }
}

exports.displayIfDebugEnabled = displayIfDebugEnabled;

},{"./display":39}],44:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeObservables = exports.Observable = void 0;

var Observable =
/** @class */
function () {
  function Observable(onFirstSubscribe) {
    this.onFirstSubscribe = onFirstSubscribe;
    this.observers = [];
  }

  Observable.prototype.subscribe = function (f) {
    var _this = this;

    if (!this.observers.length && this.onFirstSubscribe) {
      this.onLastUnsubscribe = this.onFirstSubscribe() || undefined;
    }

    this.observers.push(f);
    return {
      unsubscribe: function unsubscribe() {
        _this.observers = _this.observers.filter(function (other) {
          return f !== other;
        });

        if (!_this.observers.length && _this.onLastUnsubscribe) {
          _this.onLastUnsubscribe();
        }
      }
    };
  };

  Observable.prototype.notify = function (data) {
    this.observers.forEach(function (observer) {
      return observer(data);
    });
  };

  return Observable;
}();

exports.Observable = Observable;

function mergeObservables() {
  var observables = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    observables[_i] = arguments[_i];
  }

  var globalObservable = new Observable(function () {
    var subscriptions = observables.map(function (observable) {
      return observable.subscribe(function (data) {
        return globalObservable.notify(data);
      });
    });
    return function () {
      return subscriptions.forEach(function (subscription) {
        return subscription.unsubscribe();
      });
    };
  });
  return globalObservable;
}

exports.mergeObservables = mergeObservables;

},{}],45:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetNavigationStart = exports.looksLikeRelativeTime = exports.getTimeStamp = exports.getRelativeTime = exports.addDuration = exports.elapsed = exports.clocksOrigin = exports.clocksNow = exports.relativeNow = exports.timeStampNow = exports.dateNow = exports.toServerDuration = exports.currentDrift = exports.relativeToClocks = void 0;

var utils_1 = require("./utils");

function relativeToClocks(relative) {
  return {
    relative: relative,
    timeStamp: getCorrectedTimeStamp(relative)
  };
}

exports.relativeToClocks = relativeToClocks;

function getCorrectedTimeStamp(relativeTime) {
  var correctedOrigin = dateNow() - performance.now(); // apply correction only for positive drift

  if (correctedOrigin > getNavigationStart()) {
    return Math.round(addDuration(correctedOrigin, relativeTime));
  }

  return getTimeStamp(relativeTime);
}

function currentDrift() {
  return Math.round(dateNow() - addDuration(getNavigationStart(), performance.now()));
}

exports.currentDrift = currentDrift;

function toServerDuration(duration) {
  if (!(0, utils_1.isNumber)(duration)) {
    return duration;
  }

  return (0, utils_1.round)(duration * 1e6, 0);
}

exports.toServerDuration = toServerDuration;

function dateNow() {
  // Do not use `Date.now` because sometimes websites are wrongly "polyfilling" it. For example, we
  // had some users using a very old version of `datejs`, which patched `Date.now` to return a Date
  // instance instead of a timestamp[1]. Those users are unlikely to fix this, so let's handle this
  // case ourselves.
  // [1]: https://github.com/datejs/Datejs/blob/97f5c7c58c5bc5accdab8aa7602b6ac56462d778/src/core-debug.js#L14-L16
  return new Date().getTime();
}

exports.dateNow = dateNow;

function timeStampNow() {
  return dateNow();
}

exports.timeStampNow = timeStampNow;

function relativeNow() {
  return performance.now();
}

exports.relativeNow = relativeNow;

function clocksNow() {
  return {
    relative: relativeNow(),
    timeStamp: timeStampNow()
  };
}

exports.clocksNow = clocksNow;

function clocksOrigin() {
  return {
    relative: 0,
    timeStamp: getNavigationStart()
  };
}

exports.clocksOrigin = clocksOrigin;

function elapsed(start, end) {
  return end - start;
}

exports.elapsed = elapsed;

function addDuration(a, b) {
  return a + b;
}

exports.addDuration = addDuration;
/**
 * Get the time since the navigation was started.
 *
 * Note: this does not use `performance.timeOrigin` because it doesn't seem to reflect the actual
 * time on which the navigation has started: it may be much farther in the past, at least in Firefox 71.
 * Related issue in Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926
 */

function getRelativeTime(timestamp) {
  return timestamp - getNavigationStart();
}

exports.getRelativeTime = getRelativeTime;

function getTimeStamp(relativeTime) {
  return Math.round(addDuration(getNavigationStart(), relativeTime));
}

exports.getTimeStamp = getTimeStamp;

function looksLikeRelativeTime(time) {
  return time < utils_1.ONE_YEAR;
}

exports.looksLikeRelativeTime = looksLikeRelativeTime;
/**
 * Navigation start slightly change on some rare cases
 */

var navigationStart;

function getNavigationStart() {
  if (navigationStart === undefined) {
    navigationStart = performance.timing.navigationStart;
  }

  return navigationStart;
}

function resetNavigationStart() {
  navigationStart = undefined;
}

exports.resetNavigationStart = resetNavigationStart;

},{"./utils":47}],46:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildUrl = exports.getHash = exports.getSearch = exports.getPathName = exports.getOrigin = exports.haveSameOrigin = exports.isValidUrl = exports.normalizeUrl = void 0;

var utils_1 = require("./utils");

function normalizeUrl(url) {
  return buildUrl(url, (0, utils_1.getLocationOrigin)()).href;
}

exports.normalizeUrl = normalizeUrl;

function isValidUrl(url) {
  try {
    return !!buildUrl(url);
  } catch (_a) {
    return false;
  }
}

exports.isValidUrl = isValidUrl;

function haveSameOrigin(url1, url2) {
  return getOrigin(url1) === getOrigin(url2);
}

exports.haveSameOrigin = haveSameOrigin;

function getOrigin(url) {
  return (0, utils_1.getLinkElementOrigin)(buildUrl(url));
}

exports.getOrigin = getOrigin;

function getPathName(url) {
  var pathname = buildUrl(url).pathname;
  return pathname[0] === '/' ? pathname : "/".concat(pathname);
}

exports.getPathName = getPathName;

function getSearch(url) {
  return buildUrl(url).search;
}

exports.getSearch = getSearch;

function getHash(url) {
  return buildUrl(url).hash;
}

exports.getHash = getHash;

function buildUrl(url, base) {
  if (checkURLSupported()) {
    return base !== undefined ? new URL(url, base) : new URL(url);
  }

  if (base === undefined && !/:/.test(url)) {
    throw new Error("Invalid URL: '".concat(url, "'"));
  }

  var doc = document;
  var anchorElement = doc.createElement('a');

  if (base !== undefined) {
    doc = document.implementation.createHTMLDocument('');
    var baseElement = doc.createElement('base');
    baseElement.href = base;
    doc.head.appendChild(baseElement);
    doc.body.appendChild(anchorElement);
  }

  anchorElement.href = url;
  return anchorElement;
}

exports.buildUrl = buildUrl;
var isURLSupported;

function checkURLSupported() {
  if (isURLSupported !== undefined) {
    return isURLSupported;
  }

  try {
    var url = new URL('http://test/path');
    isURLSupported = url.href === 'http://test/path';
    return isURLSupported;
  } catch (_a) {
    isURLSupported = false;
  }

  return isURLSupported;
}

},{"./utils":47}],47:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cssEscape = exports.matchList = exports.removeDuplicates = exports.requestIdleCallback = exports.combine = exports.deepClone = exports.mergeInto = exports.getType = exports.runOnReadyState = exports.elementMatches = exports.addEventListeners = exports.addEventListener = exports.safeTruncate = exports.findCommaSeparatedValue = exports.getLinkElementOrigin = exports.getLocationOrigin = exports.getGlobalObject = exports.endsWith = exports.startsWith = exports.mapValues = exports.isEmptyObject = exports.objectEntries = exports.objectHasValue = exports.objectValues = exports.isNumber = exports.isPercentage = exports.findLast = exports.find = exports.arrayFrom = exports.includes = exports.jsonStringify = exports.noop = exports.round = exports.performDraw = exports.generateUUID = exports.shallowClone = exports.assign = exports.throttle = exports.ONE_MEBI_BYTE = exports.ONE_KIBI_BYTE = exports.ONE_YEAR = exports.ONE_DAY = exports.ONE_HOUR = exports.ONE_MINUTE = exports.ONE_SECOND = void 0;

var monitor_1 = require("./monitor");

exports.ONE_SECOND = 1000;
exports.ONE_MINUTE = 60 * exports.ONE_SECOND;
exports.ONE_HOUR = 60 * exports.ONE_MINUTE;
exports.ONE_DAY = 24 * exports.ONE_HOUR;
exports.ONE_YEAR = 365 * exports.ONE_DAY;
exports.ONE_KIBI_BYTE = 1024;
exports.ONE_MEBI_BYTE = 1024 * exports.ONE_KIBI_BYTE; // use lodash API

function throttle(fn, wait, options) {
  var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
  var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
  var inWaitPeriod = false;
  var pendingExecutionWithParameters;
  var pendingTimeoutId;
  return {
    throttled: function throttled() {
      var parameters = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        parameters[_i] = arguments[_i];
      }

      if (inWaitPeriod) {
        pendingExecutionWithParameters = parameters;
        return;
      }

      if (needLeadingExecution) {
        fn.apply(void 0, parameters);
      } else {
        pendingExecutionWithParameters = parameters;
      }

      inWaitPeriod = true;
      pendingTimeoutId = setTimeout(function () {
        if (needTrailingExecution && pendingExecutionWithParameters) {
          fn.apply(void 0, pendingExecutionWithParameters);
        }

        inWaitPeriod = false;
        pendingExecutionWithParameters = undefined;
      }, wait);
    },
    cancel: function cancel() {
      clearTimeout(pendingTimeoutId);
      inWaitPeriod = false;
      pendingExecutionWithParameters = undefined;
    }
  };
}

exports.throttle = throttle;

function assign(target) {
  var toAssign = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    toAssign[_i - 1] = arguments[_i];
  }

  toAssign.forEach(function (source) {
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  });
  return target;
}

exports.assign = assign;

function shallowClone(object) {
  return assign({}, object);
}

exports.shallowClone = shallowClone;
/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */

function generateUUID(placeholder) {
  return placeholder ? // eslint-disable-next-line  no-bitwise
  (parseInt(placeholder, 10) ^ Math.random() * 16 >> parseInt(placeholder, 10) / 4).toString(16) : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, generateUUID);
}

exports.generateUUID = generateUUID;
/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */

function performDraw(threshold) {
  return threshold !== 0 && Math.random() * 100 <= threshold;
}

exports.performDraw = performDraw;

function round(num, decimals) {
  return +num.toFixed(decimals);
}

exports.round = round; // eslint-disable-next-line @typescript-eslint/no-empty-function

function noop() {}

exports.noop = noop;
/**
 * Custom implementation of JSON.stringify that ignores some toJSON methods. We need to do that
 * because some sites badly override toJSON on certain objects. Removing all toJSON methods from
 * nested values would be too costly, so we just detach them from the root value, and native classes
 * used to build JSON values (Array and Object).
 *
 * Note: this still assumes that JSON.stringify is correct.
 */

function jsonStringify(value, replacer, space) {
  if (_typeof(value) !== 'object' || value === null) {
    return JSON.stringify(value);
  } // Note: The order matter here. We need to detach toJSON methods on parent classes before their
  // subclasses.


  var restoreObjectPrototypeToJson = detachToJsonMethod(Object.prototype);
  var restoreArrayPrototypeToJson = detachToJsonMethod(Array.prototype);
  var restoreValuePrototypeToJson = detachToJsonMethod(Object.getPrototypeOf(value));
  var restoreValueToJson = detachToJsonMethod(value);

  try {
    return JSON.stringify(value, replacer, space);
  } catch (_a) {
    return '<error: unable to serialize object>';
  } finally {
    restoreObjectPrototypeToJson();
    restoreArrayPrototypeToJson();
    restoreValuePrototypeToJson();
    restoreValueToJson();
  }
}

exports.jsonStringify = jsonStringify;

function detachToJsonMethod(value) {
  var object = value;
  var objectToJson = object.toJSON;

  if (objectToJson) {
    delete object.toJSON;
    return function () {
      object.toJSON = objectToJson;
    };
  }

  return noop;
}

function includes(candidate, search) {
  return candidate.indexOf(search) !== -1;
}

exports.includes = includes;

function arrayFrom(arrayLike) {
  if (Array.from) {
    return Array.from(arrayLike);
  }

  var array = [];

  if (arrayLike instanceof Set) {
    arrayLike.forEach(function (item) {
      return array.push(item);
    });
  } else {
    for (var i = 0; i < arrayLike.length; i++) {
      array.push(arrayLike[i]);
    }
  }

  return array;
}

exports.arrayFrom = arrayFrom;

function find(array, predicate) {
  for (var i = 0; i < array.length; i += 1) {
    var item = array[i];

    if (predicate(item, i)) {
      return item;
    }
  }

  return undefined;
}

exports.find = find;

function findLast(array, predicate) {
  for (var i = array.length - 1; i >= 0; i -= 1) {
    var item = array[i];

    if (predicate(item, i, array)) {
      return item;
    }
  }

  return undefined;
}

exports.findLast = findLast;

function isPercentage(value) {
  return isNumber(value) && value >= 0 && value <= 100;
}

exports.isPercentage = isPercentage;

function isNumber(value) {
  return typeof value === 'number';
}

exports.isNumber = isNumber;

function objectValues(object) {
  return Object.keys(object).map(function (key) {
    return object[key];
  });
}

exports.objectValues = objectValues;

function objectHasValue(object, value) {
  return Object.keys(object).some(function (key) {
    return object[key] === value;
  });
}

exports.objectHasValue = objectHasValue;

function objectEntries(object) {
  return Object.keys(object).map(function (key) {
    return [key, object[key]];
  });
}

exports.objectEntries = objectEntries;

function isEmptyObject(object) {
  return Object.keys(object).length === 0;
}

exports.isEmptyObject = isEmptyObject;

function mapValues(object, fn) {
  var newObject = {};

  for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
    var key = _a[_i];
    newObject[key] = fn(object[key]);
  }

  return newObject;
}

exports.mapValues = mapValues;

function startsWith(candidate, search) {
  return candidate.slice(0, search.length) === search;
}

exports.startsWith = startsWith;

function endsWith(candidate, search) {
  return candidate.slice(-search.length) === search;
}

exports.endsWith = endsWith;
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */

function getGlobalObject() {
  if ((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) === 'object') {
    return globalThis;
  }

  Object.defineProperty(Object.prototype, '_dd_temp_', {
    get: function get() {
      return this;
    },
    configurable: true
  }); // @ts-ignore _dd_temp is defined using defineProperty

  var globalObject = _dd_temp_; // @ts-ignore _dd_temp is defined using defineProperty

  delete Object.prototype._dd_temp_;

  if (_typeof(globalObject) !== 'object') {
    // on safari _dd_temp_ is available on window but not globally
    // fallback on other browser globals check
    if ((typeof self === "undefined" ? "undefined" : _typeof(self)) === 'object') {
      globalObject = self;
    } else if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object') {
      globalObject = window;
    } else {
      globalObject = {};
    }
  }

  return globalObject;
}

exports.getGlobalObject = getGlobalObject;

function getLocationOrigin() {
  return getLinkElementOrigin(window.location);
}

exports.getLocationOrigin = getLocationOrigin;
/**
 * IE fallback
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLHyperlinkElementUtils/origin
 */

function getLinkElementOrigin(element) {
  if (element.origin) {
    return element.origin;
  }

  var sanitizedHost = element.host.replace(/(:80|:443)$/, '');
  return "".concat(element.protocol, "//").concat(sanitizedHost);
}

exports.getLinkElementOrigin = getLinkElementOrigin;

function findCommaSeparatedValue(rawString, name) {
  var regex = new RegExp("(?:^|;)\\s*".concat(name, "\\s*=\\s*([^;]+)"));
  var matches = regex.exec(rawString);
  return matches ? matches[1] : undefined;
}

exports.findCommaSeparatedValue = findCommaSeparatedValue;

function safeTruncate(candidate, length, suffix) {
  if (suffix === void 0) {
    suffix = '';
  }

  var lastChar = candidate.charCodeAt(length - 1);
  var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
  var correctedLength = isLastCharSurrogatePair ? length + 1 : length;
  if (candidate.length <= correctedLength) return candidate;
  return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}

exports.safeTruncate = safeTruncate;
/**
 * Add an event listener to an event emitter object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 */

function addEventListener(emitter, event, listener, options) {
  return addEventListeners(emitter, [event], listener, options);
}

exports.addEventListener = addEventListener;
/**
 * Add event listeners to an event emitter object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 *
 * * with `once: true`, the listener will be called at most once, even if different events are listened
 */

function addEventListeners(emitter, events, listener, _a) {
  var _b = _a === void 0 ? {} : _a,
      once = _b.once,
      capture = _b.capture,
      passive = _b.passive;

  var wrappedListener = (0, monitor_1.monitor)(once ? function (event) {
    stop();
    listener(event);
  } : listener);
  var options = passive ? {
    capture: capture,
    passive: passive
  } : capture;
  events.forEach(function (event) {
    return emitter.addEventListener(event, wrappedListener, options);
  });

  var stop = function stop() {
    return events.forEach(function (event) {
      return emitter.removeEventListener(event, wrappedListener, options);
    });
  };

  return {
    stop: stop
  };
}

exports.addEventListeners = addEventListeners;

function elementMatches(element, selector) {
  if (element.matches) {
    return element.matches(selector);
  } // IE11 support


  if (element.msMatchesSelector) {
    return element.msMatchesSelector(selector);
  }

  return false;
}

exports.elementMatches = elementMatches;

function runOnReadyState(expectedReadyState, callback) {
  if (document.readyState === expectedReadyState || document.readyState === 'complete') {
    callback();
  } else {
    var eventName = expectedReadyState === 'complete' ? "load"
    /* LOAD */
    : "DOMContentLoaded"
    /* DOM_CONTENT_LOADED */
    ;
    addEventListener(window, eventName, callback, {
      once: true
    });
  }
}

exports.runOnReadyState = runOnReadyState;
/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */

function getType(value) {
  if (value === null) {
    return 'null';
  }

  if (Array.isArray(value)) {
    return 'array';
  }

  return _typeof(value);
}

exports.getType = getType;

function createCircularReferenceChecker() {
  if (typeof WeakSet !== 'undefined') {
    var set_1 = new WeakSet();
    return {
      hasAlreadyBeenSeen: function hasAlreadyBeenSeen(value) {
        var has = set_1.has(value);

        if (!has) {
          set_1.add(value);
        }

        return has;
      }
    };
  }

  var array = [];
  return {
    hasAlreadyBeenSeen: function hasAlreadyBeenSeen(value) {
      var has = array.indexOf(value) >= 0;

      if (!has) {
        array.push(value);
      }

      return has;
    }
  };
}
/**
 * Iterate over source and affect its sub values into destination, recursively.
 * If the source and destination can't be merged, return source.
 */


function mergeInto(destination, source, circularReferenceChecker) {
  if (circularReferenceChecker === void 0) {
    circularReferenceChecker = createCircularReferenceChecker();
  } // ignore the source if it is undefined


  if (source === undefined) {
    return destination;
  }

  if (_typeof(source) !== 'object' || source === null) {
    // primitive values - just return source
    return source;
  } else if (source instanceof Date) {
    return new Date(source.getTime());
  } else if (source instanceof RegExp) {
    var flags = source.flags || // old browsers compatibility
    [source.global ? 'g' : '', source.ignoreCase ? 'i' : '', source.multiline ? 'm' : '', source.sticky ? 'y' : '', source.unicode ? 'u' : ''].join('');
    return new RegExp(source.source, flags);
  }

  if (circularReferenceChecker.hasAlreadyBeenSeen(source)) {
    // remove circular references
    return undefined;
  } else if (Array.isArray(source)) {
    var merged_1 = Array.isArray(destination) ? destination : [];

    for (var i = 0; i < source.length; ++i) {
      merged_1[i] = mergeInto(merged_1[i], source[i], circularReferenceChecker);
    }

    return merged_1;
  }

  var merged = getType(destination) === 'object' ? destination : {};

  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      merged[key] = mergeInto(merged[key], source[key], circularReferenceChecker);
    }
  }

  return merged;
}

exports.mergeInto = mergeInto;
/**
 * A simplistic implementation of a deep clone algorithm.
 * Caveats:
 * - It doesn't maintain prototype chains - don't use with instances of custom classes.
 * - It doesn't handle Map and Set
 */

function deepClone(value) {
  return mergeInto(undefined, value);
}

exports.deepClone = deepClone;

function combine() {
  var sources = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    sources[_i] = arguments[_i];
  }

  var destination;

  for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
    var source = sources_1[_a]; // Ignore any undefined or null sources.

    if (source === undefined || source === null) {
      continue;
    }

    destination = mergeInto(destination, source);
  }

  return destination;
}

exports.combine = combine;

function requestIdleCallback(callback, opts) {
  // Use 'requestIdleCallback' when available: it will throttle the mutation processing if the
  // browser is busy rendering frames (ex: when frames are below 60fps). When not available, the
  // fallback on 'requestAnimationFrame' will still ensure the mutations are processed after any
  // browser rendering process (Layout, Recalculate Style, etc.), so we can serialize DOM nodes
  // efficiently.
  if (window.requestIdleCallback) {
    var id_1 = window.requestIdleCallback((0, monitor_1.monitor)(callback), opts);
    return function () {
      return window.cancelIdleCallback(id_1);
    };
  }

  var id = window.requestAnimationFrame((0, monitor_1.monitor)(callback));
  return function () {
    return window.cancelAnimationFrame(id);
  };
}

exports.requestIdleCallback = requestIdleCallback;

function removeDuplicates(array) {
  var set = new Set();
  array.forEach(function (item) {
    return set.add(item);
  });
  return arrayFrom(set);
}

exports.removeDuplicates = removeDuplicates;

function matchList(list, value) {
  return list.some(function (item) {
    return item === value || item instanceof RegExp && item.test(value);
  });
}

exports.matchList = matchList; // https://github.com/jquery/jquery/blob/a684e6ba836f7c553968d7d026ed7941e1a612d8/src/selector/escapeSelector.js

function cssEscape(str) {
  if (window.CSS && window.CSS.escape) {
    return window.CSS.escape(str);
  } // eslint-disable-next-line no-control-regex


  return str.replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function (ch, asCodePoint) {
    if (asCodePoint) {
      // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
      if (ch === '\0') {
        return "\uFFFD";
      } // Control characters and (dependent upon position) numbers get escaped as code points


      return "".concat(ch.slice(0, -1), "\\").concat(ch.charCodeAt(ch.length - 1).toString(16), " ");
    } // Other potentially-special ASCII characters get backslash-escaped


    return "\\".concat(ch);
  });
}

exports.cssEscape = cssEscape;

},{"./monitor":43}],48:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Batch = void 0;

var display_1 = require("../tools/display");

var utils_1 = require("../tools/utils");

var monitor_1 = require("../tools/monitor"); // https://en.wikipedia.org/wiki/UTF-8
// eslint-disable-next-line no-control-regex


var HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;

var Batch =
/** @class */
function () {
  function Batch(request, batchMessagesLimit, batchBytesLimit, messageBytesLimit, flushTimeout, beforeUnloadCallback) {
    if (beforeUnloadCallback === void 0) {
      beforeUnloadCallback = utils_1.noop;
    }

    this.request = request;
    this.batchMessagesLimit = batchMessagesLimit;
    this.batchBytesLimit = batchBytesLimit;
    this.messageBytesLimit = messageBytesLimit;
    this.flushTimeout = flushTimeout;
    this.beforeUnloadCallback = beforeUnloadCallback;
    this.pushOnlyBuffer = [];
    this.upsertBuffer = {};
    this.bufferBytesCount = 0;
    this.bufferMessagesCount = 0;
    this.setupFlushOnExit();
    this.flushPeriodically();
  }

  Batch.prototype.add = function (message) {
    this.addOrUpdate(message);
  };

  Batch.prototype.upsert = function (message, key) {
    this.addOrUpdate(message, key);
  };

  Batch.prototype.flush = function (sendFn) {
    if (sendFn === void 0) {
      sendFn = this.request.send;
    }

    if (this.bufferMessagesCount !== 0) {
      var messages = this.pushOnlyBuffer.concat((0, utils_1.objectValues)(this.upsertBuffer));
      var bytesCount = this.bufferBytesCount;
      this.pushOnlyBuffer = [];
      this.upsertBuffer = {};
      this.bufferBytesCount = 0;
      this.bufferMessagesCount = 0;
      sendFn({
        data: messages.join('\n'),
        bytesCount: bytesCount
      });
    }
  };

  Batch.prototype.flushOnExit = function () {
    this.flush(this.request.sendOnExit);
  };

  Batch.prototype.computeBytesCount = function (candidate) {
    // Accurate bytes count computations can degrade performances when there is a lot of events to process
    if (!HAS_MULTI_BYTES_CHARACTERS.test(candidate)) {
      return candidate.length;
    }

    if (window.TextEncoder !== undefined) {
      return new TextEncoder().encode(candidate).length;
    }

    return new Blob([candidate]).size;
  };

  Batch.prototype.addOrUpdate = function (message, key) {
    var _a = this.process(message),
        processedMessage = _a.processedMessage,
        messageBytesCount = _a.messageBytesCount;

    if (messageBytesCount >= this.messageBytesLimit) {
      display_1.display.warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(this.messageBytesLimit, "KB."));
      return;
    }

    if (this.hasMessageFor(key)) {
      this.remove(key);
    }

    if (this.willReachedBytesLimitWith(messageBytesCount)) {
      this.flush();
    }

    this.push(processedMessage, messageBytesCount, key);

    if (this.isFull()) {
      this.flush();
    }
  };

  Batch.prototype.process = function (message) {
    var processedMessage = (0, utils_1.jsonStringify)(message);
    var messageBytesCount = this.computeBytesCount(processedMessage);
    return {
      processedMessage: processedMessage,
      messageBytesCount: messageBytesCount
    };
  };

  Batch.prototype.push = function (processedMessage, messageBytesCount, key) {
    if (this.bufferMessagesCount > 0) {
      // \n separator at serialization
      this.bufferBytesCount += 1;
    }

    if (key !== undefined) {
      this.upsertBuffer[key] = processedMessage;
    } else {
      this.pushOnlyBuffer.push(processedMessage);
    }

    this.bufferBytesCount += messageBytesCount;
    this.bufferMessagesCount += 1;
  };

  Batch.prototype.remove = function (key) {
    var removedMessage = this.upsertBuffer[key];
    delete this.upsertBuffer[key];
    var messageBytesCount = this.computeBytesCount(removedMessage);
    this.bufferBytesCount -= messageBytesCount;
    this.bufferMessagesCount -= 1;

    if (this.bufferMessagesCount > 0) {
      this.bufferBytesCount -= 1;
    }
  };

  Batch.prototype.hasMessageFor = function (key) {
    return key !== undefined && this.upsertBuffer[key] !== undefined;
  };

  Batch.prototype.willReachedBytesLimitWith = function (messageBytesCount) {
    // byte of the separator at the end of the message
    return this.bufferBytesCount + messageBytesCount + 1 >= this.batchBytesLimit;
  };

  Batch.prototype.isFull = function () {
    return this.bufferMessagesCount === this.batchMessagesLimit || this.bufferBytesCount >= this.batchBytesLimit;
  };

  Batch.prototype.flushPeriodically = function () {
    var _this = this;

    setTimeout((0, monitor_1.monitor)(function () {
      _this.flush();

      _this.flushPeriodically();
    }), this.flushTimeout);
  };

  Batch.prototype.setupFlushOnExit = function () {
    var _this = this;
    /**
     * With sendBeacon, requests are guaranteed to be successfully sent during document unload
     */
    // @ts-ignore this function is not always defined


    if (navigator.sendBeacon) {
      /**
       * beforeunload is called before visibilitychange
       * register first to be sure to be called before flush on beforeunload
       * caveat: unload can still be canceled by another listener
       */
      (0, utils_1.addEventListener)(window, "beforeunload"
      /* BEFORE_UNLOAD */
      , this.beforeUnloadCallback);
      /**
       * Only event that guarantee to fire on mobile devices when the page transitions to background state
       * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
       */

      (0, utils_1.addEventListener)(document, "visibilitychange"
      /* VISIBILITY_CHANGE */
      , function () {
        if (document.visibilityState === 'hidden') {
          _this.flushOnExit();
        }
      });
      /**
       * Safari does not support yet to send a request during:
       * - a visibility change during doc unload (cf: https://bugs.webkit.org/show_bug.cgi?id=194897)
       * - a page hide transition (cf: https://bugs.webkit.org/show_bug.cgi?id=188329)
       */

      (0, utils_1.addEventListener)(window, "beforeunload"
      /* BEFORE_UNLOAD */
      , function () {
        return _this.flushOnExit();
      });
    }
  };

  return Batch;
}();

exports.Batch = Batch;

},{"../tools/display":39,"../tools/monitor":43,"../tools/utils":47}],49:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseEventBridge = exports.getEventBridge = void 0;

var utils_1 = require("../tools/utils");

function getEventBridge() {
  var eventBridgeGlobal = getEventBridgeGlobal();

  if (!eventBridgeGlobal) {
    return;
  }

  return {
    getAllowedWebViewHosts: function getAllowedWebViewHosts() {
      return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
    },
    send: function send(eventType, event) {
      eventBridgeGlobal.send(JSON.stringify({
        eventType: eventType,
        event: event
      }));
    }
  };
}

exports.getEventBridge = getEventBridge;

function canUseEventBridge(currentHost) {
  var _a;

  if (currentHost === void 0) {
    currentHost = (_a = (0, utils_1.getGlobalObject)().location) === null || _a === void 0 ? void 0 : _a.hostname;
  }

  var bridge = getEventBridge();
  return !!bridge && bridge.getAllowedWebViewHosts().some(function (allowedHost) {
    return currentHost === allowedHost || (0, utils_1.endsWith)(currentHost, ".".concat(allowedHost));
  });
}

exports.canUseEventBridge = canUseEventBridge;

function getEventBridgeGlobal() {
  return (0, utils_1.getGlobalObject)().DatadogEventBridge;
}

},{"../tools/utils":47}],50:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchKeepAliveStrategy = exports.createHttpRequest = void 0;

var telemetry_1 = require("../domain/telemetry");

var monitor_1 = require("../tools/monitor");

var configuration_1 = require("../domain/configuration");

var sendWithRetryStrategy_1 = require("./sendWithRetryStrategy");

function createHttpRequest(endpointBuilder, bytesLimit, reportError, toPrimaryEndpoint) {
  var retryState = (0, sendWithRetryStrategy_1.newRetryState)();

  var sendStrategyForRetry = function sendStrategyForRetry(payload, onResponse) {
    return fetchKeepAliveStrategy(endpointBuilder, bytesLimit, payload, onResponse);
  };

  return {
    send: function send(payload) {
      if (!(0, configuration_1.isExperimentalFeatureEnabled)('retry')) {
        fetchKeepAliveStrategy(endpointBuilder, bytesLimit, payload);
      } else {
        (0, sendWithRetryStrategy_1.sendWithRetryStrategy)(payload, retryState, sendStrategyForRetry, endpointBuilder.endpointType, toPrimaryEndpoint, reportError);
      }
    },

    /**
     * Since fetch keepalive behaves like regular fetch on Firefox,
     * keep using sendBeaconStrategy on exit
     */
    sendOnExit: function sendOnExit(payload) {
      if ((0, configuration_1.isExperimentalFeatureEnabled)('retry') && endpointBuilder.endpointType !== 'sessionReplay' && toPrimaryEndpoint && (0, configuration_1.isSimulationActive)()) {
        return;
      }

      sendBeaconStrategy(endpointBuilder, bytesLimit, payload);
    }
  };
}

exports.createHttpRequest = createHttpRequest;

function sendBeaconStrategy(endpointBuilder, bytesLimit, _a) {
  var data = _a.data,
      bytesCount = _a.bytesCount;
  var url = endpointBuilder.build();
  var canUseBeacon = !!navigator.sendBeacon && bytesCount < bytesLimit;

  if (canUseBeacon) {
    try {
      var isQueued = navigator.sendBeacon(url, data);

      if (isQueued) {
        return;
      }
    } catch (e) {
      reportBeaconError(e);
    }
  }

  sendXHR(url, data);
}

var hasReportedBeaconError = false;

function reportBeaconError(e) {
  if (!hasReportedBeaconError) {
    hasReportedBeaconError = true;
    (0, telemetry_1.addTelemetryError)(e);
  }
}

function fetchKeepAliveStrategy(endpointBuilder, bytesLimit, _a, onResponse) {
  var data = _a.data,
      bytesCount = _a.bytesCount;
  var url = endpointBuilder.build();
  var canUseKeepAlive = isKeepAliveSupported() && bytesCount < bytesLimit;

  if (canUseKeepAlive) {
    fetch(url, {
      method: 'POST',
      body: data,
      keepalive: true
    }).then((0, monitor_1.monitor)(function (response) {
      return onResponse === null || onResponse === void 0 ? void 0 : onResponse({
        status: response.status
      });
    }), (0, monitor_1.monitor)(function () {
      // failed to queue the request
      sendXHR(url, data, onResponse);
    }));
  } else {
    sendXHR(url, data, onResponse);
  }
}

exports.fetchKeepAliveStrategy = fetchKeepAliveStrategy;

function isKeepAliveSupported() {
  // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
  try {
    return window.Request && 'keepalive' in new Request('http://a');
  } catch (_a) {
    return false;
  }
}

function sendXHR(url, data, onResponse) {
  var request = new XMLHttpRequest();
  request.open('POST', url, true);
  request.send(data);
  request.addEventListener('loadend', (0, monitor_1.monitor)(function () {
    onResponse === null || onResponse === void 0 ? void 0 : onResponse({
      status: request.status
    });
  }));
}

},{"../domain/configuration":12,"../domain/telemetry":26,"../tools/monitor":43,"./sendWithRetryStrategy":52}],51:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startBatchWithReplica = exports.getEventBridge = exports.canUseEventBridge = exports.Batch = exports.createHttpRequest = void 0;

var httpRequest_1 = require("./httpRequest");

Object.defineProperty(exports, "createHttpRequest", {
  enumerable: true,
  get: function get() {
    return httpRequest_1.createHttpRequest;
  }
});

var batch_1 = require("./batch");

Object.defineProperty(exports, "Batch", {
  enumerable: true,
  get: function get() {
    return batch_1.Batch;
  }
});

var eventBridge_1 = require("./eventBridge");

Object.defineProperty(exports, "canUseEventBridge", {
  enumerable: true,
  get: function get() {
    return eventBridge_1.canUseEventBridge;
  }
});
Object.defineProperty(exports, "getEventBridge", {
  enumerable: true,
  get: function get() {
    return eventBridge_1.getEventBridge;
  }
});

var startBatchWithReplica_1 = require("./startBatchWithReplica");

Object.defineProperty(exports, "startBatchWithReplica", {
  enumerable: true,
  get: function get() {
    return startBatchWithReplica_1.startBatchWithReplica;
  }
});

},{"./batch":48,"./eventBridge":49,"./httpRequest":50,"./startBatchWithReplica":53}],52:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newRetryState = exports.sendWithRetryStrategy = exports.INITIAL_BACKOFF_TIME = exports.MAX_BACKOFF_TIME = exports.MAX_QUEUE_BYTES_COUNT = exports.MAX_ONGOING_REQUESTS = exports.MAX_ONGOING_BYTES_COUNT = void 0;

var telemetry_1 = require("../domain/telemetry");

var configuration_1 = require("../domain/configuration");

var monitor_1 = require("../tools/monitor");

var timeUtils_1 = require("../tools/timeUtils");

var utils_1 = require("../tools/utils");

var error_1 = require("../tools/error");

exports.MAX_ONGOING_BYTES_COUNT = 80 * utils_1.ONE_KIBI_BYTE;
exports.MAX_ONGOING_REQUESTS = 32;
exports.MAX_QUEUE_BYTES_COUNT = 3 * utils_1.ONE_MEBI_BYTE;
exports.MAX_BACKOFF_TIME = utils_1.ONE_MINUTE;
exports.INITIAL_BACKOFF_TIME = utils_1.ONE_SECOND;

function sendWithRetryStrategy(payload, state, sendStrategy, endpointType, toPrimaryEndpoint, reportError) {
  if (state.transportStatus === 0
  /* UP */
  && state.queuedPayloads.size() === 0 && state.bandwidthMonitor.canHandle(payload)) {
    send(payload, state, sendStrategy, toPrimaryEndpoint, {
      onSuccess: function onSuccess() {
        return retryQueuedPayloads(0
        /* AFTER_SUCCESS */
        , state, sendStrategy, endpointType, toPrimaryEndpoint, reportError);
      },
      onFailure: function onFailure() {
        state.queuedPayloads.enqueue(payload);
        scheduleRetry(state, sendStrategy, endpointType, toPrimaryEndpoint, reportError);
      }
    });
  } else {
    state.queuedPayloads.enqueue(payload);
  }
}

exports.sendWithRetryStrategy = sendWithRetryStrategy;

function scheduleRetry(state, sendStrategy, endpointType, toPrimaryEndpoint, reportError) {
  if (state.transportStatus !== 2
  /* DOWN */
  ) {
      return;
    }

  setTimeout((0, monitor_1.monitor)(function () {
    var payload = state.queuedPayloads.first();
    send(payload, state, sendStrategy, toPrimaryEndpoint, {
      onSuccess: function onSuccess() {
        state.queuedPayloads.dequeue();

        if (state.lastFailureStatus !== 0) {
          (0, telemetry_1.addTelemetryDebug)('resuming after transport down', {
            failureStatus: state.lastFailureStatus
          });
        }

        state.currentBackoffTime = exports.INITIAL_BACKOFF_TIME;
        retryQueuedPayloads(1
        /* AFTER_RESUME */
        , state, sendStrategy, endpointType, toPrimaryEndpoint, reportError);
      },
      onFailure: function onFailure() {
        state.currentBackoffTime = Math.min(exports.MAX_BACKOFF_TIME, state.currentBackoffTime * 2);
        scheduleRetry(state, sendStrategy, endpointType, toPrimaryEndpoint, reportError);
      }
    });
  }), state.currentBackoffTime);
}

function send(payload, state, sendStrategy, toPrimaryEndpoint, _a) {
  var onSuccess = _a.onSuccess,
      onFailure = _a.onFailure;

  if ((0, configuration_1.isSimulationActive)() && toPrimaryEndpoint) {
    state.transportStatus = state.bandwidthMonitor.ongoingRequestCount > 0 ? 1
    /* FAILURE_DETECTED */
    : 2
    /* DOWN */
    ;
    state.lastFailureStatus = 555;
    onFailure();
    return;
  }

  state.bandwidthMonitor.add(payload);
  sendStrategy(payload, function (response) {
    state.bandwidthMonitor.remove(payload);

    if (!shouldRetryRequest(response)) {
      state.transportStatus = 0
      /* UP */
      ;
      onSuccess();
    } else {
      // do not consider transport down if another ongoing request could succeed
      state.transportStatus = state.bandwidthMonitor.ongoingRequestCount > 0 ? 1
      /* FAILURE_DETECTED */
      : 2
      /* DOWN */
      ;
      state.lastFailureStatus = response.status;
      onFailure();
    }
  });
}

function retryQueuedPayloads(reason, state, sendStrategy, endpointType, toPrimaryEndpoint, reportError) {
  if (reason === 0
  /* AFTER_SUCCESS */
  && state.queuedPayloads.isFull() && !state.queueFullReported) {
    reportError({
      message: "Reached max ".concat(endpointType, " events size queued for upload: ").concat(exports.MAX_QUEUE_BYTES_COUNT / utils_1.ONE_MEBI_BYTE, "MiB"),
      source: error_1.ErrorSource.AGENT,
      startClocks: (0, timeUtils_1.clocksNow)()
    });
    state.queueFullReported = true;
  }

  var previousQueue = state.queuedPayloads;
  state.queuedPayloads = newPayloadQueue();

  while (previousQueue.size() > 0) {
    sendWithRetryStrategy(previousQueue.dequeue(), state, sendStrategy, endpointType, toPrimaryEndpoint, reportError);
  }
}

function shouldRetryRequest(response) {
  return response.status === 0 || response.status === 408 || response.status === 429 || response.status >= 500;
}

function newRetryState() {
  return {
    transportStatus: 0
    /* UP */
    ,
    lastFailureStatus: 0,
    currentBackoffTime: exports.INITIAL_BACKOFF_TIME,
    bandwidthMonitor: newBandwidthMonitor(),
    queuedPayloads: newPayloadQueue(),
    queueFullReported: false
  };
}

exports.newRetryState = newRetryState;

function newPayloadQueue() {
  var queue = [];
  return {
    bytesCount: 0,
    enqueue: function enqueue(payload) {
      if (this.isFull()) {
        return;
      }

      queue.push(payload);
      this.bytesCount += payload.bytesCount;
    },
    first: function first() {
      return queue[0];
    },
    dequeue: function dequeue() {
      var payload = queue.shift();

      if (payload) {
        this.bytesCount -= payload.bytesCount;
      }

      return payload;
    },
    size: function size() {
      return queue.length;
    },
    isFull: function isFull() {
      return this.bytesCount >= exports.MAX_QUEUE_BYTES_COUNT;
    }
  };
}

function newBandwidthMonitor() {
  return {
    ongoingRequestCount: 0,
    ongoingByteCount: 0,
    canHandle: function canHandle(payload) {
      return this.ongoingRequestCount === 0 || this.ongoingByteCount + payload.bytesCount <= exports.MAX_ONGOING_BYTES_COUNT && this.ongoingRequestCount < exports.MAX_ONGOING_REQUESTS;
    },
    add: function add(payload) {
      this.ongoingRequestCount += 1;
      this.ongoingByteCount += payload.bytesCount;
    },
    remove: function remove(payload) {
      this.ongoingRequestCount -= 1;
      this.ongoingByteCount -= payload.bytesCount;
    }
  };
}

},{"../domain/configuration":12,"../domain/telemetry":26,"../tools/error":40,"../tools/monitor":43,"../tools/timeUtils":45,"../tools/utils":47}],53:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startBatchWithReplica = void 0;

var batch_1 = require("./batch");

var httpRequest_1 = require("./httpRequest");

function startBatchWithReplica(configuration, endpoint, reportError, replicaEndpoint) {
  var primaryBatch = createBatch(endpoint, true);
  var replicaBatch;

  if (replicaEndpoint) {
    replicaBatch = createBatch(replicaEndpoint, false);
  }

  function createBatch(endpointBuilder, toPrimaryEndpoint) {
    return new batch_1.Batch((0, httpRequest_1.createHttpRequest)(endpointBuilder, configuration.batchBytesLimit, reportError, toPrimaryEndpoint), configuration.batchMessagesLimit, configuration.batchBytesLimit, configuration.messageBytesLimit, configuration.flushTimeout);
  }

  return {
    add: function add(message, replicated) {
      if (replicated === void 0) {
        replicated = true;
      }

      primaryBatch.add(message);

      if (replicaBatch && replicated) {
        replicaBatch.add(message);
      }
    }
  };
}

exports.startBatchWithReplica = startBatchWithReplica;

},{"./batch":48,"./httpRequest":50}],54:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeRumPublicApi = void 0;

var browser_core_1 = require("@datadog/browser-core");

var configuration_1 = require("../domain/configuration");

function makeRumPublicApi(startRumImpl, recorderApi, _a) {
  var _b = _a === void 0 ? {} : _a,
      _c = _b.ignoreInitIfSyntheticsWillInjectRum,
      ignoreInitIfSyntheticsWillInjectRum = _c === void 0 ? true : _c;

  var isAlreadyInitialized = false;
  var globalContextManager = (0, browser_core_1.createContextManager)();
  var userContextManager = (0, browser_core_1.createContextManager)();

  var getInternalContextStrategy = function getInternalContextStrategy() {
    return undefined;
  };

  var getInitConfigurationStrategy = function getInitConfigurationStrategy() {
    return undefined;
  };

  var bufferApiCalls = new browser_core_1.BoundedBuffer();

  var _addTimingStrategy = function addTimingStrategy(name, time) {
    if (time === void 0) {
      time = (0, browser_core_1.timeStampNow)();
    }

    bufferApiCalls.add(function () {
      return _addTimingStrategy(name, time);
    });
  };

  var _startViewStrategy = function startViewStrategy(options, startClocks) {
    if (startClocks === void 0) {
      startClocks = (0, browser_core_1.clocksNow)();
    }

    bufferApiCalls.add(function () {
      return _startViewStrategy(options, startClocks);
    });
  };

  var _addActionStrategy = function addActionStrategy(action, commonContext) {
    if (commonContext === void 0) {
      commonContext = {
        context: globalContextManager.getContext(),
        user: userContextManager.getContext()
      };
    }

    bufferApiCalls.add(function () {
      return _addActionStrategy(action, commonContext);
    });
  };

  var _addErrorStrategy = function addErrorStrategy(providedError, commonContext) {
    if (commonContext === void 0) {
      commonContext = {
        context: globalContextManager.getContext(),
        user: userContextManager.getContext()
      };
    }

    bufferApiCalls.add(function () {
      return _addErrorStrategy(providedError, commonContext);
    });
  };

  function initRum(initConfiguration) {
    // If we are in a Synthetics test configured to automatically inject a RUM instance, we want to
    // completely discard the customer application RUM instance by ignoring their init() call.  But,
    // we should not ignore the init() call from the Synthetics-injected RUM instance, so the
    // internal `ignoreInitIfSyntheticsWillInjectRum` option is here to bypass this condition.
    if (ignoreInitIfSyntheticsWillInjectRum && (0, browser_core_1.willSyntheticsInjectRum)()) {
      return;
    }

    if ((0, browser_core_1.canUseEventBridge)()) {
      initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
    } else if (!canHandleSession(initConfiguration)) {
      return;
    }

    if (!canInitRum(initConfiguration)) {
      return;
    }

    var configuration = (0, configuration_1.validateAndBuildRumConfiguration)(initConfiguration);

    if (!configuration) {
      return;
    }

    if (!configuration.trackViewsManually) {
      doStartRum(configuration);
    } else {
      // drain beforeInitCalls by buffering them until we start RUM
      // if we get a startView, drain re-buffered calls before continuing to drain beforeInitCalls
      // in order to ensure that calls are processed in order
      var beforeInitCalls = bufferApiCalls;
      bufferApiCalls = new browser_core_1.BoundedBuffer();

      _startViewStrategy = function _startViewStrategy(options) {
        doStartRum(configuration, options);
      };

      beforeInitCalls.drain();
    }

    getInitConfigurationStrategy = function getInitConfigurationStrategy() {
      return (0, browser_core_1.deepClone)(initConfiguration);
    };

    isAlreadyInitialized = true;
  }

  function doStartRum(configuration, initialViewOptions) {
    var startRumResults = startRumImpl(configuration, function () {
      return {
        user: userContextManager.getContext(),
        context: globalContextManager.getContext(),
        hasReplay: recorderApi.isRecording() ? true : undefined
      };
    }, recorderApi, initialViewOptions);
    _startViewStrategy = startRumResults.startView, _addActionStrategy = startRumResults.addAction, _addErrorStrategy = startRumResults.addError, _addTimingStrategy = startRumResults.addTiming, getInternalContextStrategy = startRumResults.getInternalContext;
    bufferApiCalls.drain();
    recorderApi.onRumStart(startRumResults.lifeCycle, configuration, startRumResults.session, startRumResults.viewContexts);
  }

  var startView = (0, browser_core_1.monitor)(function (options) {
    var sanitizedOptions = _typeof(options) === 'object' ? options : {
      name: options
    };

    _startViewStrategy(sanitizedOptions);
  });
  var rumPublicApi = (0, browser_core_1.makePublicApi)({
    init: (0, browser_core_1.monitor)(initRum),

    /** @deprecated: use setGlobalContextProperty instead */
    addRumGlobalContext: (0, browser_core_1.monitor)(globalContextManager.add),
    setGlobalContextProperty: (0, browser_core_1.monitor)(globalContextManager.setContextProperty),

    /** @deprecated: use removeGlobalContextProperty instead */
    removeRumGlobalContext: (0, browser_core_1.monitor)(globalContextManager.remove),
    removeGlobalContextProperty: (0, browser_core_1.monitor)(globalContextManager.removeContextProperty),

    /** @deprecated: use getGlobalContext instead */
    getRumGlobalContext: (0, browser_core_1.monitor)(globalContextManager.get),
    getGlobalContext: (0, browser_core_1.monitor)(globalContextManager.getContext),

    /** @deprecated: use setGlobalContext instead */
    setRumGlobalContext: (0, browser_core_1.monitor)(globalContextManager.set),
    setGlobalContext: (0, browser_core_1.monitor)(globalContextManager.setContext),
    clearGlobalContext: (0, browser_core_1.monitor)(globalContextManager.clearContext),
    getInternalContext: (0, browser_core_1.monitor)(function (startTime) {
      return getInternalContextStrategy(startTime);
    }),
    getInitConfiguration: (0, browser_core_1.monitor)(function () {
      return getInitConfigurationStrategy();
    }),
    addAction: (0, browser_core_1.monitor)(function (name, context) {
      _addActionStrategy({
        name: name,
        context: (0, browser_core_1.deepClone)(context),
        startClocks: (0, browser_core_1.clocksNow)(),
        type: "custom"
        /* CUSTOM */

      });
    }),
    addError: function addError(error, context) {
      var handlingStack = (0, browser_core_1.createHandlingStack)();
      (0, browser_core_1.callMonitored)(function () {
        _addErrorStrategy({
          error: error,
          handlingStack: handlingStack,
          context: (0, browser_core_1.deepClone)(context),
          startClocks: (0, browser_core_1.clocksNow)()
        });
      });
    },
    addTiming: (0, browser_core_1.monitor)(function (name, time) {
      _addTimingStrategy(name, time);
    }),
    setUser: (0, browser_core_1.monitor)(function (newUser) {
      if (_typeof(newUser) !== 'object' || !newUser) {
        browser_core_1.display.error('Unsupported user:', newUser);
      } else {
        userContextManager.setContext(sanitizeUser(newUser));
      }
    }),
    getUser: (0, browser_core_1.monitor)(userContextManager.getContext),
    setUserProperty: (0, browser_core_1.monitor)(function (key, property) {
      var _a;

      var sanitizedProperty = sanitizeUser((_a = {}, _a[key] = property, _a))[key];
      userContextManager.setContextProperty(key, sanitizedProperty);
    }),
    removeUserProperty: (0, browser_core_1.monitor)(userContextManager.removeContextProperty),

    /** @deprecated: renamed to clearUser */
    removeUser: (0, browser_core_1.monitor)(userContextManager.clearContext),
    clearUser: (0, browser_core_1.monitor)(userContextManager.clearContext),
    startView: startView,
    startSessionReplayRecording: (0, browser_core_1.monitor)(recorderApi.start),
    stopSessionReplayRecording: (0, browser_core_1.monitor)(recorderApi.stop)
  });
  return rumPublicApi;

  function sanitizeUser(newUser) {
    var shallowClonedUser = (0, browser_core_1.assign)(newUser, {});

    if ('id' in shallowClonedUser) {
      shallowClonedUser.id = String(shallowClonedUser.id);
    }

    if ('name' in shallowClonedUser) {
      shallowClonedUser.name = String(shallowClonedUser.name);
    }

    if ('email' in shallowClonedUser) {
      shallowClonedUser.email = String(shallowClonedUser.email);
    }

    return shallowClonedUser;
  }

  function canHandleSession(initConfiguration) {
    if (!(0, browser_core_1.areCookiesAuthorized)((0, browser_core_1.buildCookieOptions)(initConfiguration))) {
      browser_core_1.display.warn('Cookies are not authorized, we will not send any data.');
      return false;
    }

    if (isLocalFile()) {
      browser_core_1.display.error('Execution is not allowed in the current context.');
      return false;
    }

    return true;
  }

  function canInitRum(initConfiguration) {
    if (isAlreadyInitialized) {
      if (!initConfiguration.silentMultipleInit) {
        browser_core_1.display.error('DD_RUM is already initialized.');
      }

      return false;
    }

    return true;
  }

  function overrideInitConfigurationForBridge(initConfiguration) {
    return (0, browser_core_1.assign)({}, initConfiguration, {
      applicationId: '00000000-aaaa-0000-aaaa-000000000000',
      clientToken: 'empty',
      sampleRate: 100
    });
  }

  function isLocalFile() {
    return window.location.protocol === 'file:';
  }
}

exports.makeRumPublicApi = makeRumPublicApi;

},{"../domain/configuration":61,"@datadog/browser-core":32}],55:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startRumEventCollection = exports.startRum = void 0;

var browser_core_1 = require("@datadog/browser-core");

var domMutationObservable_1 = require("../browser/domMutationObservable");

var performanceCollection_1 = require("../browser/performanceCollection");

var assembly_1 = require("../domain/assembly");

var foregroundContexts_1 = require("../domain/contexts/foregroundContexts");

var internalContext_1 = require("../domain/contexts/internalContext");

var lifeCycle_1 = require("../domain/lifeCycle");

var viewContexts_1 = require("../domain/contexts/viewContexts");

var requestCollection_1 = require("../domain/requestCollection");

var actionCollection_1 = require("../domain/rumEventsCollection/action/actionCollection");

var errorCollection_1 = require("../domain/rumEventsCollection/error/errorCollection");

var longTaskCollection_1 = require("../domain/rumEventsCollection/longTask/longTaskCollection");

var resourceCollection_1 = require("../domain/rumEventsCollection/resource/resourceCollection");

var viewCollection_1 = require("../domain/rumEventsCollection/view/viewCollection");

var rumSessionManager_1 = require("../domain/rumSessionManager");

var startRumBatch_1 = require("../transport/startRumBatch");

var startRumEventBridge_1 = require("../transport/startRumEventBridge");

var urlContexts_1 = require("../domain/contexts/urlContexts");

var locationChangeObservable_1 = require("../browser/locationChangeObservable");

function startRum(configuration, getCommonContext, recorderApi, initialViewOptions) {
  var lifeCycle = new lifeCycle_1.LifeCycle();
  var telemetry = startRumTelemetry(configuration);
  telemetry.setContextProvider(function () {
    var _a, _b;

    return {
      application: {
        id: configuration.applicationId
      },
      session: {
        id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id
      },
      view: {
        id: (_b = viewContexts.findView()) === null || _b === void 0 ? void 0 : _b.id
      },
      action: {
        id: actionContexts.findActionId()
      }
    };
  });

  var reportError = function reportError(error) {
    lifeCycle.notify(12
    /* RAW_ERROR_COLLECTED */
    , {
      error: error
    });
  };

  if (!(0, browser_core_1.canUseEventBridge)()) {
    (0, startRumBatch_1.startRumBatch)(configuration, lifeCycle, telemetry.observable, reportError);
  } else {
    (0, startRumEventBridge_1.startRumEventBridge)(lifeCycle);
  }

  var session = !(0, browser_core_1.canUseEventBridge)() ? (0, rumSessionManager_1.startRumSessionManager)(configuration, lifeCycle) : (0, rumSessionManager_1.startRumSessionManagerStub)();
  var domMutationObservable = (0, domMutationObservable_1.createDOMMutationObservable)();
  var locationChangeObservable = (0, locationChangeObservable_1.createLocationChangeObservable)(location);

  var _a = startRumEventCollection(lifeCycle, configuration, location, session, locationChangeObservable, domMutationObservable, getCommonContext, reportError),
      viewContexts = _a.viewContexts,
      foregroundContexts = _a.foregroundContexts,
      urlContexts = _a.urlContexts,
      actionContexts = _a.actionContexts,
      addAction = _a.addAction;

  (0, longTaskCollection_1.startLongTaskCollection)(lifeCycle, session);
  (0, resourceCollection_1.startResourceCollection)(lifeCycle, configuration, session);

  var _b = (0, viewCollection_1.startViewCollection)(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, foregroundContexts, recorderApi, initialViewOptions),
      addTiming = _b.addTiming,
      startView = _b.startView;

  var addError = (0, errorCollection_1.startErrorCollection)(lifeCycle, foregroundContexts).addError;
  (0, requestCollection_1.startRequestCollection)(lifeCycle, configuration, session);
  (0, performanceCollection_1.startPerformanceCollection)(lifeCycle, configuration);
  var internalContext = (0, internalContext_1.startInternalContext)(configuration.applicationId, session, viewContexts, actionContexts, urlContexts);
  return {
    addAction: addAction,
    addError: addError,
    addTiming: addTiming,
    startView: startView,
    lifeCycle: lifeCycle,
    viewContexts: viewContexts,
    session: session,
    getInternalContext: internalContext.get
  };
}

exports.startRum = startRum;

function startRumTelemetry(configuration) {
  var telemetry = (0, browser_core_1.startTelemetry)(configuration);

  if ((0, browser_core_1.canUseEventBridge)()) {
    var bridge_1 = (0, browser_core_1.getEventBridge)();
    telemetry.observable.subscribe(function (event) {
      return bridge_1.send('internal_telemetry', event);
    });
  }

  return telemetry;
}

function startRumEventCollection(lifeCycle, configuration, location, sessionManager, locationChangeObservable, domMutationObservable, getCommonContext, reportError) {
  var viewContexts = (0, viewContexts_1.startViewContexts)(lifeCycle);
  var urlContexts = (0, urlContexts_1.startUrlContexts)(lifeCycle, locationChangeObservable, location);
  var foregroundContexts = (0, foregroundContexts_1.startForegroundContexts)();

  var _a = (0, actionCollection_1.startActionCollection)(lifeCycle, domMutationObservable, configuration, foregroundContexts),
      addAction = _a.addAction,
      actionContexts = _a.actionContexts;

  (0, assembly_1.startRumAssembly)(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, getCommonContext, reportError);
  return {
    viewContexts: viewContexts,
    foregroundContexts: foregroundContexts,
    urlContexts: urlContexts,
    addAction: addAction,
    actionContexts: actionContexts,
    stop: function stop() {
      viewContexts.stop();
      foregroundContexts.stop();
    }
  };
}

exports.startRumEventCollection = startRumEventCollection;

},{"../browser/domMutationObservable":56,"../browser/locationChangeObservable":57,"../browser/performanceCollection":58,"../domain/assembly":60,"../domain/contexts/foregroundContexts":64,"../domain/contexts/internalContext":65,"../domain/contexts/urlContexts":67,"../domain/contexts/viewContexts":68,"../domain/lifeCycle":69,"../domain/requestCollection":70,"../domain/rumEventsCollection/action/actionCollection":71,"../domain/rumEventsCollection/error/errorCollection":78,"../domain/rumEventsCollection/longTask/longTaskCollection":81,"../domain/rumEventsCollection/resource/resourceCollection":83,"../domain/rumEventsCollection/view/viewCollection":89,"../domain/rumSessionManager":90,"../transport/startRumBatch":96,"../transport/startRumEventBridge":97,"@datadog/browser-core":32}],56:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMutationObserverConstructor = exports.createDOMMutationObservable = void 0;

var browser_core_1 = require("@datadog/browser-core");

function createDOMMutationObservable() {
  var MutationObserver = getMutationObserverConstructor();
  var observable = new browser_core_1.Observable(function () {
    if (!MutationObserver) {
      return;
    }

    var observer = new MutationObserver((0, browser_core_1.monitor)(function () {
      return observable.notify();
    }));
    observer.observe(document, {
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true
    });
    return function () {
      return observer.disconnect();
    };
  });
  return observable;
}

exports.createDOMMutationObservable = createDOMMutationObservable;

function getMutationObserverConstructor() {
  var constructor;
  var browserWindow = window; // Angular uses Zone.js to provide a context persisting across async tasks.  Zone.js replaces the
  // global MutationObserver constructor with a patched version to support the context propagation.
  // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
  // component: on some occasions, the callback is being called in an infinite loop, causing the
  // page to freeze (even if the callback is completely empty).
  //
  // To work around this issue, we try to get the original MutationObserver constructor stored by
  // Zone.js.
  //
  // [1] https://github.com/angular/angular/issues/26948
  // [2] https://github.com/angular/angular/issues/31712

  if (browserWindow.Zone) {
    var zoneSymbol = browserWindow.Zone.__symbol__; // Zone.js 0.8.6+ is storing original class constructors into the browser 'window' object[3].
    //
    // [3] https://github.com/angular/angular/blob/6375fa79875c0fe7b815efc45940a6e6f5c9c9eb/packages/zone.js/lib/common/utils.ts#L288

    constructor = browserWindow[zoneSymbol('MutationObserver')];

    if (!constructor && browserWindow.MutationObserver) {
      // Anterior Zone.js versions (used in Angular 2) does not expose the original MutationObserver
      // in the 'window' object. Luckily, the patched MutationObserver class is storing an original
      // instance in its properties[4]. Let's get the original MutationObserver constructor from
      // there.
      //
      // [4] https://github.com/angular/zone.js/blob/v0.8.5/lib/common/utils.ts#L412
      var patchedInstance = new browserWindow.MutationObserver(browser_core_1.noop);
      var originalInstance = patchedInstance[zoneSymbol('originalInstance')];
      constructor = originalInstance && originalInstance.constructor;
    }
  }

  if (!constructor) {
    constructor = browserWindow.MutationObserver;
  }

  return constructor;
}

exports.getMutationObserverConstructor = getMutationObserverConstructor;

},{"@datadog/browser-core":32}],57:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLocationChangeObservable = void 0;

var browser_core_1 = require("@datadog/browser-core");

function createLocationChangeObservable(location) {
  var currentLocation = (0, browser_core_1.shallowClone)(location);
  var observable = new browser_core_1.Observable(function () {
    var stopHistoryTracking = trackHistory(onLocationChange).stop;
    var stopHashTracking = trackHash(onLocationChange).stop;
    return function () {
      stopHistoryTracking();
      stopHashTracking();
    };
  });

  function onLocationChange() {
    if (currentLocation.href === location.href) {
      return;
    }

    var newLocation = (0, browser_core_1.shallowClone)(location);
    observable.notify({
      newLocation: newLocation,
      oldLocation: currentLocation
    });
    currentLocation = newLocation;
  }

  return observable;
}

exports.createLocationChangeObservable = createLocationChangeObservable;

function trackHistory(onHistoryChange) {
  var stopInstrumentingPushState = (0, browser_core_1.instrumentMethodAndCallOriginal)(history, 'pushState', {
    after: onHistoryChange
  }).stop;
  var stopInstrumentingReplaceState = (0, browser_core_1.instrumentMethodAndCallOriginal)(history, 'replaceState', {
    after: onHistoryChange
  }).stop;
  var removeListener = (0, browser_core_1.addEventListener)(window, "popstate"
  /* POP_STATE */
  , onHistoryChange).stop;
  return {
    stop: function stop() {
      stopInstrumentingPushState();
      stopInstrumentingReplaceState();
      removeListener();
    }
  };
}

function trackHash(onHashChange) {
  return (0, browser_core_1.addEventListener)(window, "hashchange"
  /* HASH_CHANGE */
  , onHashChange);
}

},{"@datadog/browser-core":32}],58:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retrieveInitialDocumentResourceTiming = exports.startPerformanceCollection = exports.supportPerformanceTimingEvent = void 0;

var browser_core_1 = require("@datadog/browser-core");

var resourceUtils_1 = require("../domain/rumEventsCollection/resource/resourceUtils");

var getDocumentTraceId_1 = require("../domain/tracing/getDocumentTraceId");

function supportPerformanceObject() {
  return window.performance !== undefined && 'getEntries' in performance;
}

function supportPerformanceTimingEvent(entryType) {
  return window.PerformanceObserver && PerformanceObserver.supportedEntryTypes !== undefined && PerformanceObserver.supportedEntryTypes.includes(entryType);
}

exports.supportPerformanceTimingEvent = supportPerformanceTimingEvent;

function startPerformanceCollection(lifeCycle, configuration) {
  retrieveInitialDocumentResourceTiming(function (timing) {
    handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
  });

  if (supportPerformanceObject()) {
    var performanceEntries_1 = performance.getEntries(); // Because the performance entry list can be quite large
    // delay the computation to prevent the SDK from blocking the main thread on init

    setTimeout((0, browser_core_1.monitor)(function () {
      return handleRumPerformanceEntries(lifeCycle, configuration, performanceEntries_1);
    }));
  }

  if (window.PerformanceObserver) {
    var handlePerformanceEntryList_1 = (0, browser_core_1.monitor)(function (entries) {
      return handleRumPerformanceEntries(lifeCycle, configuration, entries.getEntries());
    });
    var mainEntries = ['resource', 'navigation', 'longtask', 'paint'];
    var experimentalEntries = ['largest-contentful-paint', 'first-input', 'layout-shift'];

    try {
      // Experimental entries are not retrieved by performance.getEntries()
      // use a single PerformanceObserver with buffered flag by type
      // to get values that could happen before SDK init
      experimentalEntries.forEach(function (type) {
        var observer = new PerformanceObserver(handlePerformanceEntryList_1);
        observer.observe({
          type: type,
          buffered: true
        });
      });
    } catch (e) {
      // Some old browser versions (ex: chrome 67) don't support the PerformanceObserver type and buffered options
      // In these cases, fallback to PerformanceObserver with entryTypes
      mainEntries.push.apply(mainEntries, experimentalEntries);
    }

    var mainObserver = new PerformanceObserver(handlePerformanceEntryList_1);
    mainObserver.observe({
      entryTypes: mainEntries
    });

    if (supportPerformanceObject() && 'addEventListener' in performance) {
      // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
      performance.addEventListener('resourcetimingbufferfull', function () {
        performance.clearResourceTimings();
      });
    }
  }

  if (!supportPerformanceTimingEvent('navigation')) {
    retrieveNavigationTiming(function (timing) {
      handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
    });
  }

  if (!supportPerformanceTimingEvent('first-input')) {
    retrieveFirstInputTiming(function (timing) {
      handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
    });
  }
}

exports.startPerformanceCollection = startPerformanceCollection;

function retrieveInitialDocumentResourceTiming(callback) {
  (0, browser_core_1.runOnReadyState)('interactive', function () {
    var timing;
    var forcedAttributes = {
      entryType: 'resource',
      initiatorType: resourceUtils_1.FAKE_INITIAL_DOCUMENT,
      traceId: (0, getDocumentTraceId_1.getDocumentTraceId)(document)
    };

    if (supportPerformanceTimingEvent('navigation') && performance.getEntriesByType('navigation').length > 0) {
      var navigationEntry = performance.getEntriesByType('navigation')[0];
      timing = (0, browser_core_1.assign)(navigationEntry.toJSON(), forcedAttributes);
    } else {
      var relativePerformanceTiming = computeRelativePerformanceTiming();
      timing = (0, browser_core_1.assign)(relativePerformanceTiming, {
        decodedBodySize: 0,
        duration: relativePerformanceTiming.responseEnd,
        name: window.location.href,
        startTime: 0
      }, forcedAttributes);
    }

    callback(timing);
  });
}

exports.retrieveInitialDocumentResourceTiming = retrieveInitialDocumentResourceTiming;

function retrieveNavigationTiming(callback) {
  function sendFakeTiming() {
    callback((0, browser_core_1.assign)(computeRelativePerformanceTiming(), {
      entryType: 'navigation'
    }));
  }

  (0, browser_core_1.runOnReadyState)('complete', function () {
    // Send it a bit after the actual load event, so the "loadEventEnd" timing is accurate
    setTimeout((0, browser_core_1.monitor)(sendFakeTiming));
  });
}
/**
 * first-input timing entry polyfill based on
 * https://github.com/GoogleChrome/web-vitals/blob/master/src/lib/polyfills/firstInputPolyfill.ts
 */


function retrieveFirstInputTiming(callback) {
  var startTimeStamp = (0, browser_core_1.dateNow)();
  var timingSent = false;
  var removeEventListeners = (0, browser_core_1.addEventListeners)(window, ["click"
  /* CLICK */
  , "mousedown"
  /* MOUSE_DOWN */
  , "keydown"
  /* KEY_DOWN */
  , "touchstart"
  /* TOUCH_START */
  , "pointerdown"
  /* POINTER_DOWN */
  ], function (evt) {
    // Only count cancelable events, which should trigger behavior important to the user.
    if (!evt.cancelable) {
      return;
    } // This timing will be used to compute the "first Input delay", which is the delta between
    // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
    // (e.g. performance.now()).


    var timing = {
      entryType: 'first-input',
      processingStart: (0, browser_core_1.relativeNow)(),
      startTime: evt.timeStamp
    };

    if (evt.type === "pointerdown"
    /* POINTER_DOWN */
    ) {
        sendTimingIfPointerIsNotCancelled(timing);
      } else {
      sendTiming(timing);
    }
  }, {
    passive: true,
    capture: true
  }).stop;
  /**
   * Pointer events are a special case, because they can trigger main or compositor thread behavior.
   * We differentiate these cases based on whether or not we see a pointercancel event, which are
   * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
   * scrolling and pinch/zooming.
   */

  function sendTimingIfPointerIsNotCancelled(timing) {
    (0, browser_core_1.addEventListeners)(window, ["pointerup"
    /* POINTER_UP */
    , "pointercancel"
    /* POINTER_CANCEL */
    ], function (event) {
      if (event.type === "pointerup"
      /* POINTER_UP */
      ) {
          sendTiming(timing);
        }
    }, {
      once: true
    });
  }

  function sendTiming(timing) {
    if (!timingSent) {
      timingSent = true;
      removeEventListeners(); // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
      // the time between now and when the page was loaded.
      // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
      // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
      // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7

      var delay = timing.processingStart - timing.startTime;

      if (delay >= 0 && delay < (0, browser_core_1.dateNow)() - startTimeStamp) {
        callback(timing);
      }
    }
  }
}

function computeRelativePerformanceTiming() {
  var result = {};
  var timing = performance.timing;

  for (var key in timing) {
    if ((0, browser_core_1.isNumber)(timing[key])) {
      var numberKey = key;
      var timingElement = timing[numberKey];
      result[numberKey] = timingElement === 0 ? 0 : (0, browser_core_1.getRelativeTime)(timingElement);
    }
  }

  return result;
}

function handleRumPerformanceEntries(lifeCycle, configuration, entries) {
  var rumPerformanceEntries = entries.filter(function (entry) {
    return entry.entryType === 'resource' || entry.entryType === 'navigation' || entry.entryType === 'paint' || entry.entryType === 'longtask' || entry.entryType === 'largest-contentful-paint' || entry.entryType === 'first-input' || entry.entryType === 'layout-shift';
  });
  var rumAllowedPerformanceEntries = rumPerformanceEntries.filter(function (entry) {
    return !isIncompleteNavigation(entry) && !isForbiddenResource(configuration, entry);
  });

  if (rumAllowedPerformanceEntries.length) {
    lifeCycle.notify(0
    /* PERFORMANCE_ENTRIES_COLLECTED */
    , rumAllowedPerformanceEntries);
  }
}

function isIncompleteNavigation(entry) {
  return entry.entryType === 'navigation' && entry.loadEventEnd <= 0;
}

function isForbiddenResource(configuration, entry) {
  return entry.entryType === 'resource' && !(0, resourceUtils_1.isAllowedRequestUrl)(configuration, entry.name);
}

},{"../domain/rumEventsCollection/resource/resourceUtils":84,"../domain/tracing/getDocumentTraceId":91,"@datadog/browser-core":32}],59:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getViewportDimension = exports.createViewportObservable = exports.initViewportObservable = void 0;

var browser_core_1 = require("@datadog/browser-core");

var viewportObservable;

function initViewportObservable() {
  if (!viewportObservable) {
    viewportObservable = createViewportObservable();
  }

  return viewportObservable;
}

exports.initViewportObservable = initViewportObservable;

function createViewportObservable() {
  var observable = new browser_core_1.Observable(function () {
    var updateDimension = (0, browser_core_1.throttle)((0, browser_core_1.monitor)(function () {
      observable.notify(getViewportDimension());
    }), 200).throttled;
    return (0, browser_core_1.addEventListener)(window, "resize"
    /* RESIZE */
    , updateDimension, {
      capture: true,
      passive: true
    }).stop;
  });
  return observable;
}

exports.createViewportObservable = createViewportObservable; // excludes the width and height of any rendered classic scrollbar that is fixed to the visual viewport

function getViewportDimension() {
  var visual = window.visualViewport;

  if (visual) {
    return {
      width: Number(visual.width * visual.scale),
      height: Number(visual.height * visual.scale)
    };
  }

  return {
    width: Number(window.innerWidth || 0),
    height: Number(window.innerHeight || 0)
  };
}

exports.getViewportDimension = getViewportDimension;

},{"@datadog/browser-core":32}],60:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startRumAssembly = void 0;

var browser_core_1 = require("@datadog/browser-core");

var syntheticsContext_1 = require("./contexts/syntheticsContext");

var ciTestContext_1 = require("./contexts/ciTestContext");

var displayContext_1 = require("./contexts/displayContext");

var VIEW_EVENTS_MODIFIABLE_FIELD_PATHS = [// Fields with sensitive data
'view.url', 'view.referrer', 'action.target.name', 'error.message', 'error.stack', 'error.resource.url', 'resource.url'];
var OTHER_EVENTS_MODIFIABLE_FIELD_PATHS = VIEW_EVENTS_MODIFIABLE_FIELD_PATHS.concat([// User-customizable field
'context']);

function startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, getCommonContext, reportError) {
  var _a;

  var eventRateLimiters = (_a = {}, _a["error"
  /* ERROR */
  ] = (0, browser_core_1.createEventRateLimiter)("error"
  /* ERROR */
  , configuration.eventRateLimiterThreshold, reportError), _a["action"
  /* ACTION */
  ] = (0, browser_core_1.createEventRateLimiter)("action"
  /* ACTION */
  , configuration.eventRateLimiterThreshold, reportError), _a);
  var syntheticsContext = (0, syntheticsContext_1.getSyntheticsContext)();
  var ciTestContext = (0, ciTestContext_1.getCiTestContext)();
  lifeCycle.subscribe(10
  /* RAW_RUM_EVENT_COLLECTED */
  , function (_a) {
    var startTime = _a.startTime,
        rawRumEvent = _a.rawRumEvent,
        domainContext = _a.domainContext,
        savedCommonContext = _a.savedCommonContext,
        customerContext = _a.customerContext;
    var viewContext = viewContexts.findView(startTime);
    var urlContext = urlContexts.findUrl(startTime); // allow to send events if the session was tracked when they start
    // except for views which are continuously updated
    // TODO: stop sending view updates when session is expired

    var session = sessionManager.findTrackedSession(rawRumEvent.type !== "view"
    /* VIEW */
    ? startTime : undefined);

    if (session && viewContext && urlContext) {
      var commonContext = savedCommonContext || getCommonContext();
      var actionId = actionContexts.findActionId(startTime);
      var rumContext = {
        _dd: {
          format_version: 2,
          drift: (0, browser_core_1.currentDrift)(),
          session: {
            plan: session.plan
          },
          browser_sdk_version: (0, browser_core_1.canUseEventBridge)() ? "4.21.2" : undefined
        },
        application: {
          id: configuration.applicationId
        },
        date: (0, browser_core_1.timeStampNow)(),
        service: viewContext.service || configuration.service,
        version: viewContext.version || configuration.version,
        source: 'browser',
        session: {
          id: session.id,
          type: syntheticsContext ? "synthetics"
          /* SYNTHETICS */
          : ciTestContext ? "ci_test"
          /* CI_TEST */
          : "user"
          /* USER */

        },
        view: {
          id: viewContext.id,
          name: viewContext.name,
          url: urlContext.url,
          referrer: urlContext.referrer
        },
        action: needToAssembleWithAction(rawRumEvent) && actionId ? {
          id: actionId
        } : undefined,
        synthetics: syntheticsContext,
        ci_test: ciTestContext,
        display: (0, displayContext_1.getDisplayContext)()
      };
      var serverRumEvent = (0, browser_core_1.combine)(rumContext, rawRumEvent);
      serverRumEvent.context = (0, browser_core_1.combine)(commonContext.context, customerContext);

      if ((0, browser_core_1.isSimulationActive)()) {
        serverRumEvent.context.simulation_label = (0, browser_core_1.getSimulationLabel)();
      }

      if (!('has_replay' in serverRumEvent.session)) {
        ;
        serverRumEvent.session.has_replay = commonContext.hasReplay;
      }

      if (!(0, browser_core_1.isEmptyObject)(commonContext.user)) {
        ;
        serverRumEvent.usr = commonContext.user;
      }

      if (shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
        if ((0, browser_core_1.isEmptyObject)(serverRumEvent.context)) {
          delete serverRumEvent.context;
        }

        lifeCycle.notify(11
        /* RUM_EVENT_COLLECTED */
        , serverRumEvent);
      }
    }
  });
}

exports.startRumAssembly = startRumAssembly;

function shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
  var _a;

  if (beforeSend) {
    var result = (0, browser_core_1.limitModification)(event, event.type === "view"
    /* VIEW */
    ? VIEW_EVENTS_MODIFIABLE_FIELD_PATHS : OTHER_EVENTS_MODIFIABLE_FIELD_PATHS, function (event) {
      return beforeSend(event, domainContext);
    });

    if (result === false && event.type !== "view"
    /* VIEW */
    ) {
        return false;
      }

    if (result === false) {
      browser_core_1.display.warn("Can't dismiss view events using beforeSend!");
    }
  }

  var rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
  return !rateLimitReached;
}

function needToAssembleWithAction(event) {
  return ["error"
  /* ERROR */
  , "resource"
  /* RESOURCE */
  , "long_task"
  /* LONG_TASK */
  ].indexOf(event.type) !== -1;
}

},{"./contexts/ciTestContext":62,"./contexts/displayContext":63,"./contexts/syntheticsContext":66,"@datadog/browser-core":32}],61:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateAndBuildRumConfiguration = void 0;

var browser_core_1 = require("@datadog/browser-core");

function validateAndBuildRumConfiguration(initConfiguration) {
  var _a, _b, _c, _d, _e;

  if (!initConfiguration.applicationId) {
    browser_core_1.display.error('Application ID is not configured, no RUM data will be collected.');
    return;
  }

  if (initConfiguration.sessionReplaySampleRate !== undefined && !(0, browser_core_1.isPercentage)(initConfiguration.sessionReplaySampleRate)) {
    browser_core_1.display.error('Session Replay Sample Rate should be a number between 0 and 100');
    return;
  } // TODO remove fallback in next major


  var premiumSampleRate = (_a = initConfiguration.premiumSampleRate) !== null && _a !== void 0 ? _a : initConfiguration.replaySampleRate;

  if (premiumSampleRate !== undefined && initConfiguration.sessionReplaySampleRate !== undefined) {
    browser_core_1.display.warn('Ignoring Premium Sample Rate because Session Replay Sample Rate is set');
    premiumSampleRate = undefined;
  }

  if (premiumSampleRate !== undefined && !(0, browser_core_1.isPercentage)(premiumSampleRate)) {
    browser_core_1.display.error('Premium Sample Rate should be a number between 0 and 100');
    return;
  }

  if (initConfiguration.tracingSampleRate !== undefined && !(0, browser_core_1.isPercentage)(initConfiguration.tracingSampleRate)) {
    browser_core_1.display.error('Tracing Sample Rate should be a number between 0 and 100');
    return;
  }

  if (initConfiguration.allowedTracingOrigins !== undefined) {
    if (!Array.isArray(initConfiguration.allowedTracingOrigins)) {
      browser_core_1.display.error('Allowed Tracing Origins should be an array');
      return;
    }

    if (initConfiguration.allowedTracingOrigins.length !== 0 && initConfiguration.service === undefined) {
      browser_core_1.display.error('Service need to be configured when tracing is enabled');
      return;
    }
  }

  if (initConfiguration.excludedActivityUrls !== undefined && !Array.isArray(initConfiguration.excludedActivityUrls)) {
    browser_core_1.display.error('Excluded Activity Urls should be an array');
    return;
  }

  var baseConfiguration = (0, browser_core_1.validateAndBuildConfiguration)(initConfiguration);

  if (!baseConfiguration) {
    return;
  }

  var trackFrustrations = !!initConfiguration.trackFrustrations;
  return (0, browser_core_1.assign)({
    applicationId: initConfiguration.applicationId,
    version: initConfiguration.version,
    actionNameAttribute: initConfiguration.actionNameAttribute,
    sessionReplaySampleRate: (_c = (_b = initConfiguration.sessionReplaySampleRate) !== null && _b !== void 0 ? _b : premiumSampleRate) !== null && _c !== void 0 ? _c : 100,
    oldPlansBehavior: initConfiguration.sessionReplaySampleRate === undefined,
    allowedTracingOrigins: (_d = initConfiguration.allowedTracingOrigins) !== null && _d !== void 0 ? _d : [],
    tracingSampleRate: initConfiguration.tracingSampleRate,
    excludedActivityUrls: (_e = initConfiguration.excludedActivityUrls) !== null && _e !== void 0 ? _e : [],
    trackInteractions: !!initConfiguration.trackInteractions || trackFrustrations,
    trackFrustrations: trackFrustrations,
    trackViewsManually: !!initConfiguration.trackViewsManually,
    trackResources: initConfiguration.trackResources,
    trackLongTasks: initConfiguration.trackLongTasks,
    defaultPrivacyLevel: (0, browser_core_1.objectHasValue)(browser_core_1.DefaultPrivacyLevel, initConfiguration.defaultPrivacyLevel) ? initConfiguration.defaultPrivacyLevel : browser_core_1.DefaultPrivacyLevel.MASK_USER_INPUT
  }, baseConfiguration);
}

exports.validateAndBuildRumConfiguration = validateAndBuildRumConfiguration;

},{"@datadog/browser-core":32}],62:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCiTestContext = void 0;

function getCiTestContext() {
  var _a;

  var testExecutionId = (_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env('traceId');

  if (typeof testExecutionId === 'string') {
    return {
      test_execution_id: testExecutionId
    };
  }
}

exports.getCiTestContext = getCiTestContext;

},{}],63:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetDisplayContext = exports.getDisplayContext = void 0;

var browser_core_1 = require("@datadog/browser-core");

var viewportObservable_1 = require("../../browser/viewportObservable");

var viewport;
var stopListeners;

function getDisplayContext() {
  if (!(0, browser_core_1.isExperimentalFeatureEnabled)('clickmap')) return;

  if (!viewport) {
    viewport = (0, viewportObservable_1.getViewportDimension)();
    stopListeners = (0, viewportObservable_1.initViewportObservable)().subscribe(function (viewportDimension) {
      viewport = viewportDimension;
    }).unsubscribe;
  }

  return {
    viewport: viewport
  };
}

exports.getDisplayContext = getDisplayContext;

function resetDisplayContext() {
  if (stopListeners) stopListeners();
  viewport = undefined;
}

exports.resetDisplayContext = resetDisplayContext;

},{"../../browser/viewportObservable":59,"@datadog/browser-core":32}],64:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeForegroundPeriod = exports.addNewForegroundPeriod = exports.startForegroundContexts = exports.MAX_NUMBER_OF_STORED_FOREGROUND_PERIODS = exports.MAX_NUMBER_OF_SELECTABLE_FOREGROUND_PERIODS = void 0;

var browser_core_1 = require("@datadog/browser-core"); // Arbitrary value to cap number of element mostly for backend & to save bandwidth


exports.MAX_NUMBER_OF_SELECTABLE_FOREGROUND_PERIODS = 500; // Arbitrary value to cap number of element mostly for memory consumption in the browser

exports.MAX_NUMBER_OF_STORED_FOREGROUND_PERIODS = 2500;
var foregroundPeriods = [];

function startForegroundContexts() {
  if (document.hasFocus()) {
    addNewForegroundPeriod();
  }

  var stopForegroundTracking = trackFocus(addNewForegroundPeriod).stop;
  var stopBlurTracking = trackBlur(closeForegroundPeriod).stop;
  return {
    isInForegroundAt: isInForegroundAt,
    selectInForegroundPeriodsFor: selectInForegroundPeriodsFor,
    stop: function stop() {
      foregroundPeriods = [];
      stopForegroundTracking();
      stopBlurTracking();
    }
  };
}

exports.startForegroundContexts = startForegroundContexts;

function addNewForegroundPeriod() {
  if (foregroundPeriods.length > exports.MAX_NUMBER_OF_STORED_FOREGROUND_PERIODS) {
    return;
  }

  var currentForegroundPeriod = foregroundPeriods[foregroundPeriods.length - 1];
  var now = (0, browser_core_1.relativeNow)();

  if (currentForegroundPeriod !== undefined && currentForegroundPeriod.end === undefined) {
    return;
  }

  foregroundPeriods.push({
    start: now
  });
}

exports.addNewForegroundPeriod = addNewForegroundPeriod;

function closeForegroundPeriod() {
  if (foregroundPeriods.length === 0) {
    return;
  }

  var currentForegroundPeriod = foregroundPeriods[foregroundPeriods.length - 1];
  var now = (0, browser_core_1.relativeNow)();

  if (currentForegroundPeriod.end !== undefined) {
    return;
  }

  currentForegroundPeriod.end = now;
}

exports.closeForegroundPeriod = closeForegroundPeriod;

function trackFocus(onFocusChange) {
  return (0, browser_core_1.addEventListener)(window, "focus"
  /* FOCUS */
  , function (event) {
    if (!event.isTrusted) {
      return;
    }

    onFocusChange();
  });
}

function trackBlur(onBlurChange) {
  return (0, browser_core_1.addEventListener)(window, "blur"
  /* BLUR */
  , function (event) {
    if (!event.isTrusted) {
      return;
    }

    onBlurChange();
  });
}

function isInForegroundAt(startTime) {
  for (var i = foregroundPeriods.length - 1; i >= 0; i--) {
    var foregroundPeriod = foregroundPeriods[i];

    if (foregroundPeriod.end !== undefined && startTime > foregroundPeriod.end) {
      break;
    }

    if (startTime > foregroundPeriod.start && (foregroundPeriod.end === undefined || startTime < foregroundPeriod.end)) {
      return true;
    }
  }

  return false;
}

function selectInForegroundPeriodsFor(eventStartTime, duration) {
  var eventEndTime = (0, browser_core_1.addDuration)(eventStartTime, duration);
  var filteredForegroundPeriods = [];
  var earliestIndex = Math.max(0, foregroundPeriods.length - exports.MAX_NUMBER_OF_SELECTABLE_FOREGROUND_PERIODS);

  for (var i = foregroundPeriods.length - 1; i >= earliestIndex; i--) {
    var foregroundPeriod = foregroundPeriods[i];

    if (foregroundPeriod.end !== undefined && eventStartTime > foregroundPeriod.end) {
      // event starts after the end of the current focus period
      // since the array is sorted, we can stop looking for foreground periods
      break;
    }

    if (eventEndTime < foregroundPeriod.start) {
      // event ends before the start of the current focus period
      // continue to previous one
      continue;
    }

    var startTime = eventStartTime > foregroundPeriod.start ? eventStartTime : foregroundPeriod.start;
    var startDuration = (0, browser_core_1.elapsed)(eventStartTime, startTime);
    var endTime = foregroundPeriod.end === undefined || eventEndTime < foregroundPeriod.end ? eventEndTime : foregroundPeriod.end;
    var endDuration = (0, browser_core_1.elapsed)(startTime, endTime);
    filteredForegroundPeriods.unshift({
      start: (0, browser_core_1.toServerDuration)(startDuration),
      duration: (0, browser_core_1.toServerDuration)(endDuration)
    });
  }

  return filteredForegroundPeriods;
}

},{"@datadog/browser-core":32}],65:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startInternalContext = void 0;
/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */

function startInternalContext(applicationId, sessionManager, viewContexts, actionContexts, urlContexts) {
  return {
    get: function get(startTime) {
      var viewContext = viewContexts.findView(startTime);
      var urlContext = urlContexts.findUrl(startTime);
      var session = sessionManager.findTrackedSession(startTime);

      if (session && viewContext && urlContext) {
        var actionId = actionContexts.findActionId(startTime);
        return {
          application_id: applicationId,
          session_id: session.id,
          user_action: actionId ? {
            id: actionId
          } : undefined,
          view: {
            id: viewContext.id,
            name: viewContext.name,
            referrer: urlContext.referrer,
            url: urlContext.url
          }
        };
      }
    }
  };
}

exports.startInternalContext = startInternalContext;

},{}],66:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSyntheticsContext = void 0;

var browser_core_1 = require("@datadog/browser-core");

function getSyntheticsContext() {
  var testId = (0, browser_core_1.getSyntheticsTestId)();
  var resultId = (0, browser_core_1.getSyntheticsResultId)();

  if (testId && resultId) {
    return {
      test_id: testId,
      result_id: resultId,
      injected: (0, browser_core_1.willSyntheticsInjectRum)()
    };
  }
}

exports.getSyntheticsContext = getSyntheticsContext;

},{"@datadog/browser-core":32}],67:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startUrlContexts = exports.URL_CONTEXT_TIME_OUT_DELAY = void 0;

var browser_core_1 = require("@datadog/browser-core");
/**
 * We want to attach to an event:
 * - the url corresponding to its start
 * - the referrer corresponding to the previous view url (or document referrer for initial view)
 */


exports.URL_CONTEXT_TIME_OUT_DELAY = browser_core_1.SESSION_TIME_OUT_DELAY;

function startUrlContexts(lifeCycle, locationChangeObservable, location) {
  var urlContextHistory = new browser_core_1.ContextHistory(exports.URL_CONTEXT_TIME_OUT_DELAY);
  var previousViewUrl;
  lifeCycle.subscribe(4
  /* VIEW_ENDED */
  , function (_a) {
    var endClocks = _a.endClocks;
    urlContextHistory.closeActive(endClocks.relative);
  });
  lifeCycle.subscribe(2
  /* VIEW_CREATED */
  , function (_a) {
    var startClocks = _a.startClocks;
    var viewUrl = location.href;
    urlContextHistory.add(buildUrlContext({
      url: viewUrl,
      referrer: !previousViewUrl ? document.referrer : previousViewUrl
    }), startClocks.relative);
    previousViewUrl = viewUrl;
  });
  var locationChangeSubscription = locationChangeObservable.subscribe(function (_a) {
    var newLocation = _a.newLocation;
    var current = urlContextHistory.find();

    if (current) {
      var changeTime = (0, browser_core_1.relativeNow)();
      urlContextHistory.closeActive(changeTime);
      urlContextHistory.add(buildUrlContext({
        url: newLocation.href,
        referrer: current.referrer
      }), changeTime);
    }
  });

  function buildUrlContext(_a) {
    var url = _a.url,
        referrer = _a.referrer;
    return {
      url: url,
      referrer: referrer
    };
  }

  return {
    findUrl: function findUrl(startTime) {
      return urlContextHistory.find(startTime);
    },
    stop: function stop() {
      locationChangeSubscription.unsubscribe();
      urlContextHistory.stop();
    }
  };
}

exports.startUrlContexts = startUrlContexts;

},{"@datadog/browser-core":32}],68:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startViewContexts = exports.VIEW_CONTEXT_TIME_OUT_DELAY = void 0;

var browser_core_1 = require("@datadog/browser-core");

exports.VIEW_CONTEXT_TIME_OUT_DELAY = browser_core_1.SESSION_TIME_OUT_DELAY;

function startViewContexts(lifeCycle) {
  var viewContextHistory = new browser_core_1.ContextHistory(exports.VIEW_CONTEXT_TIME_OUT_DELAY);
  lifeCycle.subscribe(2
  /* VIEW_CREATED */
  , function (view) {
    viewContextHistory.add(buildViewContext(view), view.startClocks.relative);
  });
  lifeCycle.subscribe(4
  /* VIEW_ENDED */
  , function (_a) {
    var endClocks = _a.endClocks;
    viewContextHistory.closeActive(endClocks.relative);
  });
  lifeCycle.subscribe(8
  /* SESSION_RENEWED */
  , function () {
    viewContextHistory.reset();
  });

  function buildViewContext(view) {
    return {
      service: view.service,
      version: view.version,
      id: view.id,
      name: view.name
    };
  }

  return {
    findView: function findView(startTime) {
      return viewContextHistory.find(startTime);
    },
    stop: function stop() {
      viewContextHistory.stop();
    }
  };
}

exports.startViewContexts = startViewContexts;

},{"@datadog/browser-core":32}],69:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LifeCycle = void 0;

var LifeCycle =
/** @class */
function () {
  function LifeCycle() {
    this.callbacks = {};
  }

  LifeCycle.prototype.notify = function (eventType, data) {
    var eventCallbacks = this.callbacks[eventType];

    if (eventCallbacks) {
      eventCallbacks.forEach(function (callback) {
        return callback(data);
      });
    }
  };

  LifeCycle.prototype.subscribe = function (eventType, callback) {
    var _this = this;

    if (!this.callbacks[eventType]) {
      this.callbacks[eventType] = [];
    }

    this.callbacks[eventType].push(callback);
    return {
      unsubscribe: function unsubscribe() {
        _this.callbacks[eventType] = _this.callbacks[eventType].filter(function (other) {
          return callback !== other;
        });
      }
    };
  };

  return LifeCycle;
}();

exports.LifeCycle = LifeCycle;

},{}],70:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackFetch = exports.trackXhr = exports.startRequestCollection = void 0;

var browser_core_1 = require("@datadog/browser-core");

var resourceUtils_1 = require("./rumEventsCollection/resource/resourceUtils");

var tracer_1 = require("./tracing/tracer");

var nextRequestIndex = 1;

function startRequestCollection(lifeCycle, configuration, sessionManager) {
  var tracer = (0, tracer_1.startTracer)(configuration, sessionManager);
  trackXhr(lifeCycle, configuration, tracer);
  trackFetch(lifeCycle, configuration, tracer);
}

exports.startRequestCollection = startRequestCollection;

function trackXhr(lifeCycle, configuration, tracer) {
  var subscription = (0, browser_core_1.initXhrObservable)().subscribe(function (rawContext) {
    var context = rawContext;

    if (!(0, resourceUtils_1.isAllowedRequestUrl)(configuration, context.url)) {
      return;
    }

    switch (context.state) {
      case 'start':
        tracer.traceXhr(context, context.xhr);
        context.requestIndex = getNextRequestIndex();
        lifeCycle.notify(5
        /* REQUEST_STARTED */
        , {
          requestIndex: context.requestIndex,
          url: context.url
        });
        break;

      case 'complete':
        tracer.clearTracingIfNeeded(context);
        lifeCycle.notify(6
        /* REQUEST_COMPLETED */
        , {
          duration: context.duration,
          method: context.method,
          requestIndex: context.requestIndex,
          spanId: context.spanId,
          startClocks: context.startClocks,
          status: context.status,
          traceId: context.traceId,
          traceSampled: context.traceSampled,
          type: "xhr"
          /* XHR */
          ,
          url: context.url,
          xhr: context.xhr
        });
        break;
    }
  });
  return {
    stop: function stop() {
      return subscription.unsubscribe();
    }
  };
}

exports.trackXhr = trackXhr;

function trackFetch(lifeCycle, configuration, tracer) {
  var subscription = (0, browser_core_1.initFetchObservable)().subscribe(function (rawContext) {
    var context = rawContext;

    if (!(0, resourceUtils_1.isAllowedRequestUrl)(configuration, context.url)) {
      return;
    }

    switch (context.state) {
      case 'start':
        tracer.traceFetch(context);
        context.requestIndex = getNextRequestIndex();
        lifeCycle.notify(5
        /* REQUEST_STARTED */
        , {
          requestIndex: context.requestIndex,
          url: context.url
        });
        break;

      case 'complete':
        tracer.clearTracingIfNeeded(context);
        lifeCycle.notify(6
        /* REQUEST_COMPLETED */
        , {
          duration: context.duration,
          method: context.method,
          requestIndex: context.requestIndex,
          responseType: context.responseType,
          spanId: context.spanId,
          startClocks: context.startClocks,
          status: context.status,
          traceId: context.traceId,
          traceSampled: context.traceSampled,
          type: "fetch"
          /* FETCH */
          ,
          url: context.url,
          response: context.response,
          init: context.init,
          input: context.input
        });
        break;
    }
  });
  return {
    stop: function stop() {
      return subscription.unsubscribe();
    }
  };
}

exports.trackFetch = trackFetch;

function getNextRequestIndex() {
  var result = nextRequestIndex;
  nextRequestIndex += 1;
  return result;
}

},{"./rumEventsCollection/resource/resourceUtils":84,"./tracing/tracer":92,"@datadog/browser-core":32}],71:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startActionCollection = void 0;

var browser_core_1 = require("@datadog/browser-core");

var trackClickActions_1 = require("./trackClickActions");

function startActionCollection(lifeCycle, domMutationObservable, configuration, foregroundContexts) {
  lifeCycle.subscribe(1
  /* AUTO_ACTION_COMPLETED */
  , function (action) {
    return lifeCycle.notify(10
    /* RAW_RUM_EVENT_COLLECTED */
    , processAction(action, foregroundContexts));
  });
  var actionContexts = {
    findActionId: browser_core_1.noop
  };

  if (configuration.trackInteractions) {
    actionContexts = (0, trackClickActions_1.trackClickActions)(lifeCycle, domMutationObservable, configuration).actionContexts;
  }

  return {
    addAction: function addAction(action, savedCommonContext) {
      lifeCycle.notify(10
      /* RAW_RUM_EVENT_COLLECTED */
      , (0, browser_core_1.assign)({
        savedCommonContext: savedCommonContext
      }, processAction(action, foregroundContexts)));
    },
    actionContexts: actionContexts
  };
}

exports.startActionCollection = startActionCollection;

function processAction(action, foregroundContexts) {
  var autoActionProperties = isAutoAction(action) ? {
    action: {
      id: action.id,
      loading_time: (0, browser_core_1.toServerDuration)(action.duration),
      frustration: {
        type: action.frustrationTypes
      },
      error: {
        count: action.counts.errorCount
      },
      long_task: {
        count: action.counts.longTaskCount
      },
      resource: {
        count: action.counts.resourceCount
      }
    },
    _dd: {
      action: {
        target: action.target,
        position: action.position
      }
    }
  } : undefined;
  var customerContext = !isAutoAction(action) ? action.context : undefined;
  var actionEvent = (0, browser_core_1.combine)({
    action: {
      id: (0, browser_core_1.generateUUID)(),
      target: {
        name: action.name
      },
      type: action.type
    },
    date: action.startClocks.timeStamp,
    type: "action"
    /* ACTION */

  }, autoActionProperties);
  var inForeground = foregroundContexts.isInForegroundAt(action.startClocks.relative);

  if (inForeground !== undefined) {
    actionEvent.view = {
      in_foreground: inForeground
    };
  }

  return {
    customerContext: customerContext,
    rawRumEvent: actionEvent,
    startTime: action.startClocks.relative,
    domainContext: isAutoAction(action) ? {
      event: action.event,
      events: action.events
    } : {}
  };
}

function isAutoAction(action) {
  return action.type !== "custom"
  /* CUSTOM */
  ;
}

},{"./trackClickActions":77,"@datadog/browser-core":32}],72:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClickChain = exports.MAX_DISTANCE_BETWEEN_CLICKS = exports.MAX_DURATION_BETWEEN_CLICKS = void 0;

var browser_core_1 = require("@datadog/browser-core");

exports.MAX_DURATION_BETWEEN_CLICKS = browser_core_1.ONE_SECOND;
exports.MAX_DISTANCE_BETWEEN_CLICKS = 100;

function createClickChain(firstClick, onFinalize) {
  var bufferedClicks = [];
  var status = 0
  /* WaitingForMoreClicks */
  ;
  var maxDurationBetweenClicksTimeout;
  appendClick(firstClick);

  function appendClick(click) {
    click.stopObservable.subscribe(tryFinalize);
    bufferedClicks.push(click);
    clearTimeout(maxDurationBetweenClicksTimeout);
    maxDurationBetweenClicksTimeout = setTimeout((0, browser_core_1.monitor)(dontAcceptMoreClick), exports.MAX_DURATION_BETWEEN_CLICKS);
  }

  function tryFinalize() {
    if (status === 1
    /* WaitingForClicksToStop */
    && bufferedClicks.every(function (click) {
      return click.isStopped();
    })) {
      status = 2
      /* Finalized */
      ;
      onFinalize(bufferedClicks);
    }
  }

  function dontAcceptMoreClick() {
    clearTimeout(maxDurationBetweenClicksTimeout);

    if (status === 0
    /* WaitingForMoreClicks */
    ) {
        status = 1
        /* WaitingForClicksToStop */
        ;
        tryFinalize();
      }
  }

  return {
    tryAppend: function tryAppend(click) {
      if (status !== 0
      /* WaitingForMoreClicks */
      ) {
          return false;
        }

      if (bufferedClicks.length > 0 && !areEventsSimilar(bufferedClicks[bufferedClicks.length - 1].event, click.event)) {
        dontAcceptMoreClick();
        return false;
      }

      appendClick(click);
      return true;
    },
    stop: function stop() {
      dontAcceptMoreClick();
    }
  };
}

exports.createClickChain = createClickChain;
/**
 * Checks whether two events are similar by comparing their target, position and timestamp
 */

function areEventsSimilar(first, second) {
  return first.target === second.target && mouseEventDistance(first, second) <= exports.MAX_DISTANCE_BETWEEN_CLICKS && first.timeStamp - second.timeStamp <= exports.MAX_DURATION_BETWEEN_CLICKS;
}

function mouseEventDistance(origin, other) {
  return Math.sqrt(Math.pow(origin.clientX - other.clientX, 2) + Math.pow(origin.clientY - other.clientY, 2));
}

},{"@datadog/browser-core":32}],73:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDead = exports.isRage = exports.computeFrustration = void 0;

var browser_core_1 = require("@datadog/browser-core");

var MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE = 3;

function computeFrustration(clicks, rageClick) {
  if (isRage(clicks)) {
    rageClick.addFrustration("rage_click"
    /* RAGE_CLICK */
    );

    if (clicks.some(isDead)) {
      rageClick.addFrustration("dead_click"
      /* DEAD_CLICK */
      );
    }

    if (rageClick.hasError) {
      rageClick.addFrustration("error_click"
      /* ERROR_CLICK */
      );
    }

    return {
      isRage: true
    };
  }

  var hasSelectionChanged = clicks.some(function (click) {
    return click.getUserActivity().selection;
  });
  clicks.forEach(function (click) {
    if (click.hasError) {
      click.addFrustration("error_click"
      /* ERROR_CLICK */
      );
    }

    if (isDead(click) && // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
    !hasSelectionChanged) {
      click.addFrustration("dead_click"
      /* DEAD_CLICK */
      );
    }
  });
  return {
    isRage: false
  };
}

exports.computeFrustration = computeFrustration;

function isRage(clicks) {
  if (clicks.some(function (click) {
    return click.getUserActivity().selection;
  })) {
    return false;
  }

  for (var i = 0; i < clicks.length - (MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1); i += 1) {
    if (clicks[i + MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1].event.timeStamp - clicks[i].event.timeStamp <= browser_core_1.ONE_SECOND) {
      return true;
    }
  }

  return false;
}

exports.isRage = isRage;
var DEAD_CLICK_EXCLUDE_SELECTOR = // inputs that don't trigger a meaningful event like "input" when clicked, including textual
// inputs (using a negative selector is shorter here)
'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),' + 'textarea,' + 'select,' + // canvas, as there is no good way to detect activity occurring on them
'canvas,' + // links that are interactive (have an href attribute) or any of their descendants, as they can
// open a new tab or navigate to a hash without triggering a meaningful event
'a[href],' + 'a[href] *';

function isDead(click) {
  if (click.hasPageActivity || click.getUserActivity().input) {
    return false;
  }

  return !(0, browser_core_1.elementMatches)(click.event.target, DEAD_CLICK_EXCLUDE_SELECTOR);
}

exports.isDead = isDead;

},{"@datadog/browser-core":32}],74:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActionNameFromElement = exports.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = void 0;

var browser_core_1 = require("@datadog/browser-core");
/**
 * Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
 * It can also be retrieved from a user defined attribute.
 */


exports.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = 'data-dd-action-name';

function getActionNameFromElement(element, userProgrammaticAttribute) {
  // Proceed to get the action name in two steps:
  // * first, get the name programmatically, explicitly defined by the user.
  // * then, use strategies that are known to return good results. Those strategies will be used on
  //   the element and a few parents, but it's likely that they won't succeed at all.
  // * if no name is found this way, use strategies returning less accurate names as a fallback.
  //   Those are much likely to succeed.
  return getActionNameFromElementProgrammatically(element, exports.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE) || userProgrammaticAttribute && getActionNameFromElementProgrammatically(element, userProgrammaticAttribute) || getActionNameFromElementForStrategies(element, userProgrammaticAttribute, priorityStrategies) || getActionNameFromElementForStrategies(element, userProgrammaticAttribute, fallbackStrategies) || '';
}

exports.getActionNameFromElement = getActionNameFromElement;

function getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
  var elementWithAttribute; // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
  // without limit. It is up to the user to declare a relevant naming strategy.
  // If available, use element.closest() to match get the attribute from the element or any of its
  // parent.  Else fallback to a more traditional implementation.

  if (supportsElementClosest()) {
    elementWithAttribute = targetElement.closest("[".concat(programmaticAttribute, "]"));
  } else {
    var element = targetElement;

    while (element) {
      if (element.hasAttribute(programmaticAttribute)) {
        elementWithAttribute = element;
        break;
      }

      element = element.parentElement;
    }
  }

  if (!elementWithAttribute) {
    return;
  }

  var name = elementWithAttribute.getAttribute(programmaticAttribute);
  return truncate(normalizeWhitespace(name.trim()));
}

var priorityStrategies = [// associated LABEL text
function (element, userProgrammaticAttribute) {
  // IE does not support element.labels, so we fallback to a CSS selector based on the element id
  // instead
  if (supportsLabelProperty()) {
    if ('labels' in element && element.labels && element.labels.length > 0) {
      return getTextualContent(element.labels[0], userProgrammaticAttribute);
    }
  } else if (element.id) {
    var label = element.ownerDocument && (0, browser_core_1.find)(element.ownerDocument.querySelectorAll('label'), function (label) {
      return label.htmlFor === element.id;
    });
    return label && getTextualContent(label, userProgrammaticAttribute);
  }
}, // INPUT button (and associated) value
function (element) {
  if (element.nodeName === 'INPUT') {
    var input = element;
    var type = input.getAttribute('type');

    if (type === 'button' || type === 'submit' || type === 'reset') {
      return input.value;
    }
  }
}, // BUTTON, LABEL or button-like element text
function (element, userProgrammaticAttribute) {
  if (element.nodeName === 'BUTTON' || element.nodeName === 'LABEL' || element.getAttribute('role') === 'button') {
    return getTextualContent(element, userProgrammaticAttribute);
  }
}, function (element) {
  return element.getAttribute('aria-label');
}, // associated element text designated by the aria-labelledby attribute
function (element, userProgrammaticAttribute) {
  var labelledByAttribute = element.getAttribute('aria-labelledby');

  if (labelledByAttribute) {
    return labelledByAttribute.split(/\s+/).map(function (id) {
      return getElementById(element, id);
    }).filter(function (label) {
      return Boolean(label);
    }).map(function (element) {
      return getTextualContent(element, userProgrammaticAttribute);
    }).join(' ');
  }
}, function (element) {
  return element.getAttribute('alt');
}, function (element) {
  return element.getAttribute('name');
}, function (element) {
  return element.getAttribute('title');
}, function (element) {
  return element.getAttribute('placeholder');
}, // SELECT first OPTION text
function (element, userProgrammaticAttribute) {
  if ('options' in element && element.options.length > 0) {
    return getTextualContent(element.options[0], userProgrammaticAttribute);
  }
}];
var fallbackStrategies = [function (element, userProgrammaticAttribute) {
  return getTextualContent(element, userProgrammaticAttribute);
}];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */

var MAX_PARENTS_TO_CONSIDER = 10;

function getActionNameFromElementForStrategies(targetElement, userProgrammaticAttribute, strategies) {
  var element = targetElement;
  var recursionCounter = 0;

  while (recursionCounter <= MAX_PARENTS_TO_CONSIDER && element && element.nodeName !== 'BODY' && element.nodeName !== 'HTML' && element.nodeName !== 'HEAD') {
    for (var _i = 0, strategies_1 = strategies; _i < strategies_1.length; _i++) {
      var strategy = strategies_1[_i];
      var name_1 = strategy(element, userProgrammaticAttribute);

      if (typeof name_1 === 'string') {
        var trimmedName = name_1.trim();

        if (trimmedName) {
          return truncate(normalizeWhitespace(trimmedName));
        }
      }
    } // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
    // be reconsidered in the future.


    if (element.nodeName === 'FORM') {
      break;
    }

    element = element.parentElement;
    recursionCounter += 1;
  }
}

function normalizeWhitespace(s) {
  return s.replace(/\s+/g, ' ');
}

function truncate(s) {
  return s.length > 100 ? "".concat((0, browser_core_1.safeTruncate)(s, 100), " [...]") : s;
}

function getElementById(refElement, id) {
  // Use the element ownerDocument here, because tests are executed in an iframe, so
  // document.getElementById won't work.
  return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}

function getTextualContent(element, userProgrammaticAttribute) {
  if (element.isContentEditable) {
    return;
  }

  if ('innerText' in element) {
    var text_1 = element.innerText;

    var removeTextFromElements = function removeTextFromElements(query) {
      var list = element.querySelectorAll(query);

      for (var index = 0; index < list.length; index += 1) {
        var element_1 = list[index];

        if ('innerText' in element_1) {
          var textToReplace = element_1.innerText;

          if (textToReplace && textToReplace.trim().length > 0) {
            text_1 = text_1.replace(textToReplace, '');
          }
        }
      }
    };

    if (!supportsInnerTextScriptAndStyleRemoval()) {
      // remove the inner text of SCRIPT and STYLES from the result. This is a bit dirty, but should
      // be relatively fast and work in most cases.
      removeTextFromElements('script, style');
    } // remove the text of elements with programmatic attribute value


    removeTextFromElements("[".concat(exports.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE, "]"));

    if (userProgrammaticAttribute) {
      removeTextFromElements("[".concat(userProgrammaticAttribute, "]"));
    }

    return text_1;
  }

  return element.textContent;
}
/**
 * Returns true if element.innerText excludes the text from inline SCRIPT and STYLE element. This
 * should be the case everywhere except on Internet Explorer 10 and 11 (see [1])
 *
 * The innerText property relies on what is actually rendered to compute its output, so to check if
 * it actually excludes SCRIPT and STYLE content, a solution would be to create a style element, set
 * its content to '*', inject it in the document body, and check if the style element innerText
 * property returns '*'. Using a new `document` instance won't work as it is not rendered.
 *
 * This solution requires specific CSP rules (see [2]) to be set by the customer. We want to avoid
 * this, so instead we rely on browser detection. In case of false negative, the impact should be
 * low, since we rely on this result to remove the SCRIPT and STYLE innerText (which will be empty)
 * from a parent element innerText.
 *
 * [1]: https://web.archive.org/web/20210602165716/http://perfectionkills.com/the-poor-misunderstood-innerText/#diff-with-textContent
 * [2]: https://github.com/DataDog/browser-sdk/issues/1084
 */


function supportsInnerTextScriptAndStyleRemoval() {
  return !(0, browser_core_1.isIE)();
}
/**
 * Returns true if the browser supports the element.labels property.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */


var supportsLabelPropertyResult;

function supportsLabelProperty() {
  if (supportsLabelPropertyResult === undefined) {
    supportsLabelPropertyResult = 'labels' in HTMLInputElement.prototype;
  }

  return supportsLabelPropertyResult;
}
/**
 * Returns true if the browser supports the element.closest method.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */


var supportsElementClosestResult;

function supportsElementClosest() {
  if (supportsElementClosestResult === undefined) {
    supportsElementClosestResult = 'closest' in HTMLElement.prototype;
  }

  return supportsElementClosestResult;
}

},{"@datadog/browser-core":32}],75:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectorsFromElement = void 0;

var browser_core_1 = require("@datadog/browser-core");
/**
 * Stable attributes are attributes that are commonly used to identify parts of a UI (ex:
 * component). Those attribute values should not be generated randomly (hardcoded most of the time)
 * and stay the same across deploys. They are not necessarily unique across the document.
 */


var STABLE_ATTRIBUTES = ['data-dd-action-name', // Common test attributes (list provided by google recorder)
'data-testid', 'data-test', 'data-qa', 'data-cy', 'data-test-id', 'data-qa-id', 'data-testing', // FullStory decorator attributes:
'data-component', 'data-element', 'data-source-file'];

function getSelectorsFromElement(element, actionNameAttribute) {
  var attributeSelectors = getStableAttributeSelectors();

  if (actionNameAttribute) {
    attributeSelectors = [function (element) {
      return getAttributeSelector(actionNameAttribute, element);
    }].concat(attributeSelectors);
  }

  return {
    selector: getSelectorFromElement(element, attributeSelectors.concat(getIDSelector), attributeSelectors.concat(getClassSelector))
  };
}

exports.getSelectorsFromElement = getSelectorsFromElement;

function isGeneratedValue(value) {
  // To compute the "URL path group", the backend replaces every URL path parts as a question mark
  // if it thinks the part is an identifier. The condition it uses is to checks whether a digit is
  // present.
  //
  // Here, we use the same strategy: if a the value contains a digit, we consider it generated. This
  // strategy might be a bit naive and fail in some cases, but there are many fallbacks to generate
  // CSS selectors so it should be fine most of the time. We might want to allow customers to
  // provide their own `isGeneratedValue` at some point.
  return /[0-9]/.test(value);
}

function getSelectorFromElement(targetElement, globallyUniqueSelectorStrategies, uniqueAmongChildrenSelectorStrategies) {
  var targetElementSelector = [];
  var element = targetElement;

  while (element && element.nodeName !== 'HTML') {
    var globallyUniqueSelector = findSelector(element, globallyUniqueSelectorStrategies, isSelectorUniqueGlobally);

    if (globallyUniqueSelector) {
      targetElementSelector.unshift(globallyUniqueSelector);
      break;
    }

    var uniqueSelectorAmongChildren = findSelector(element, uniqueAmongChildrenSelectorStrategies, isSelectorUniqueAmongChildren);

    if (uniqueSelectorAmongChildren) {
      targetElementSelector.unshift(uniqueSelectorAmongChildren);
    } else {
      targetElementSelector.unshift(getPositionSelector(element));
    }

    element = element.parentElement;
  }

  return targetElementSelector.join('>');
}

function getIDSelector(element) {
  if (element.id && !isGeneratedValue(element.id)) {
    return "#".concat((0, browser_core_1.cssEscape)(element.id));
  }
}

function getClassSelector(element) {
  if (element.tagName === 'BODY') {
    return;
  }

  if (element.classList.length > 0) {
    for (var i = 0; i < element.classList.length; i += 1) {
      var className = element.classList[i];

      if (isGeneratedValue(className)) {
        continue;
      }

      return "".concat(element.tagName, ".").concat((0, browser_core_1.cssEscape)(className));
    }
  }
}

var stableAttributeSelectorsCache;

function getStableAttributeSelectors() {
  if (!stableAttributeSelectorsCache) {
    stableAttributeSelectorsCache = STABLE_ATTRIBUTES.map(function (attribute) {
      return function (element) {
        return getAttributeSelector(attribute, element);
      };
    });
  }

  return stableAttributeSelectorsCache;
}

function getAttributeSelector(attributeName, element) {
  if (element.hasAttribute(attributeName)) {
    return "".concat(element.tagName, "[").concat(attributeName, "=\"").concat((0, browser_core_1.cssEscape)(element.getAttribute(attributeName)), "\"]");
  }
}

function getPositionSelector(element) {
  var parent = element.parentElement;
  var sibling = parent.firstElementChild;
  var currentIndex = 0;
  var elementIndex;

  while (sibling) {
    if (sibling.tagName === element.tagName) {
      currentIndex += 1;

      if (sibling === element) {
        elementIndex = currentIndex;
      }

      if (elementIndex !== undefined && currentIndex > 1) {
        // Performance improvement: avoid iterating over all children, stop as soon as we are sure
        // the element is not alone
        break;
      }
    }

    sibling = sibling.nextElementSibling;
  }

  return currentIndex === 1 ? element.tagName : "".concat(element.tagName, ":nth-of-type(").concat(elementIndex, ")");
}

function findSelector(element, selectorGetters, predicate) {
  for (var _i = 0, selectorGetters_1 = selectorGetters; _i < selectorGetters_1.length; _i++) {
    var selectorGetter = selectorGetters_1[_i];
    var selector = selectorGetter(element);

    if (selector && predicate(element, selector)) {
      return selector;
    }
  }
}

function isSelectorUniqueGlobally(element, selector) {
  return element.ownerDocument.body.querySelectorAll(selector).length === 1;
}

function isSelectorUniqueAmongChildren(element, selector) {
  for (var i = 0; i < element.parentElement.children.length; i++) {
    var sibling = element.parentElement.children[i];

    if (sibling !== element && (0, browser_core_1.elementMatches)(sibling, selector)) {
      return false;
    }
  }

  return true;
}

},{"@datadog/browser-core":32}],76:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listenActionEvents = void 0;

var browser_core_1 = require("@datadog/browser-core");

function listenActionEvents(_a) {
  var onPointerDown = _a.onPointerDown,
      onClick = _a.onClick;
  var hasSelectionChanged = false;
  var selectionEmptyAtPointerDown;
  var hasInputChanged = false;
  var clickContext;
  var listeners = [(0, browser_core_1.addEventListener)(window, "pointerdown"
  /* POINTER_DOWN */
  , function (event) {
    hasSelectionChanged = false;
    selectionEmptyAtPointerDown = isSelectionEmpty();

    if (isMouseEventOnElement(event)) {
      clickContext = onPointerDown(event);
    }
  }, {
    capture: true
  }), (0, browser_core_1.addEventListener)(window, "selectionchange"
  /* SELECTION_CHANGE */
  , function () {
    if (!selectionEmptyAtPointerDown || !isSelectionEmpty()) {
      hasSelectionChanged = true;
    }
  }, {
    capture: true
  }), (0, browser_core_1.addEventListener)(window, "click"
  /* CLICK */
  , function (clickEvent) {
    if (isMouseEventOnElement(clickEvent) && clickContext) {
      // Use a scoped variable to make sure the value is not changed by other clicks
      var userActivity_1 = {
        selection: hasSelectionChanged,
        input: hasInputChanged
      };

      if (!hasInputChanged) {
        setTimeout((0, browser_core_1.monitor)(function () {
          userActivity_1.input = hasInputChanged;
        }));
      }

      onClick(clickContext, clickEvent, function () {
        return userActivity_1;
      });
      clickContext = undefined;
    }
  }, {
    capture: true
  }), (0, browser_core_1.addEventListener)(window, "input"
  /* INPUT */
  , function () {
    hasInputChanged = true;
  }, {
    capture: true
  })];
  return {
    stop: function stop() {
      listeners.forEach(function (listener) {
        return listener.stop();
      });
    }
  };
}

exports.listenActionEvents = listenActionEvents;

function isSelectionEmpty() {
  var selection = window.getSelection();
  return !selection || selection.isCollapsed;
}

function isMouseEventOnElement(event) {
  return event.target instanceof Element;
}

},{"@datadog/browser-core":32}],77:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.finalizeClicks = exports.trackClickActions = exports.ACTION_CONTEXT_TIME_OUT_DELAY = exports.CLICK_ACTION_MAX_DURATION = void 0;

var browser_core_1 = require("@datadog/browser-core");

var trackEventCounts_1 = require("../../trackEventCounts");

var waitPageActivityEnd_1 = require("../../waitPageActivityEnd");

var clickChain_1 = require("./clickChain");

var getActionNameFromElement_1 = require("./getActionNameFromElement");

var getSelectorsFromElement_1 = require("./getSelectorsFromElement");

var listenActionEvents_1 = require("./listenActionEvents");

var computeFrustration_1 = require("./computeFrustration"); // Maximum duration for click actions


exports.CLICK_ACTION_MAX_DURATION = 10 * browser_core_1.ONE_SECOND;
exports.ACTION_CONTEXT_TIME_OUT_DELAY = 5 * browser_core_1.ONE_MINUTE; // arbitrary

function trackClickActions(lifeCycle, domMutationObservable, configuration) {
  var history = new browser_core_1.ContextHistory(exports.ACTION_CONTEXT_TIME_OUT_DELAY);
  var stopObservable = new browser_core_1.Observable();
  var currentClickChain;
  lifeCycle.subscribe(8
  /* SESSION_RENEWED */
  , function () {
    history.reset();
  });
  lifeCycle.subscribe(9
  /* BEFORE_UNLOAD */
  , stopClickChain);
  lifeCycle.subscribe(4
  /* VIEW_ENDED */
  , stopClickChain);
  var stopActionEventsListener = (0, listenActionEvents_1.listenActionEvents)({
    onPointerDown: function onPointerDown(pointerDownEvent) {
      return processPointerDown(configuration, history, pointerDownEvent);
    },
    onClick: function onClick(clickActionBase, clickEvent, getUserActivity) {
      return processClick(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, clickEvent, getUserActivity);
    }
  }).stop;
  var actionContexts = {
    findActionId: function findActionId(startTime) {
      return configuration.trackFrustrations ? history.findAll(startTime) : history.find(startTime);
    }
  };
  return {
    stop: function stop() {
      stopClickChain();
      stopObservable.notify();
      stopActionEventsListener();
    },
    actionContexts: actionContexts
  };

  function appendClickToClickChain(click) {
    if (!currentClickChain || !currentClickChain.tryAppend(click)) {
      var rageClick_1 = click.clone();
      currentClickChain = (0, clickChain_1.createClickChain)(click, function (clicks) {
        finalizeClicks(clicks, rageClick_1);
      });
    }
  }

  function stopClickChain() {
    if (currentClickChain) {
      currentClickChain.stop();
    }
  }
}

exports.trackClickActions = trackClickActions;

function processPointerDown(configuration, history, pointerDownEvent) {
  if (!configuration.trackFrustrations && history.find()) {
    // TODO: remove this in a future major version. To keep retrocompatibility, ignore any new
    // action if another one is already occurring.
    return;
  }

  var clickActionBase = computeClickActionBase(pointerDownEvent, configuration.actionNameAttribute);

  if (!configuration.trackFrustrations && !clickActionBase.name) {
    // TODO: remove this in a future major version. To keep retrocompatibility, ignore any action
    // with a blank name
    return;
  }

  return clickActionBase;
}

function processClick(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, clickEvent, getUserActivity) {
  var click = newClick(lifeCycle, history, getUserActivity, clickActionBase, clickEvent);

  if (configuration.trackFrustrations) {
    appendClickToClickChain(click);
  }

  var stopWaitPageActivityEnd = (0, waitPageActivityEnd_1.waitPageActivityEnd)(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
    if (pageActivityEndEvent.hadActivity && pageActivityEndEvent.end < click.startClocks.timeStamp) {
      // If the clock is looking weird, just discard the click
      click.discard();
    } else {
      click.stop(pageActivityEndEvent.hadActivity ? pageActivityEndEvent.end : undefined); // Validate or discard the click only if we don't track frustrations. It'll be done when
      // the click chain is finalized.

      if (!configuration.trackFrustrations) {
        if (!pageActivityEndEvent.hadActivity) {
          // If we are not tracking frustrations, we should discard the click to keep backward
          // compatibility.
          click.discard();
        } else {
          click.validate();
        }
      }
    }
  }, exports.CLICK_ACTION_MAX_DURATION).stop;
  var viewEndedSubscription = lifeCycle.subscribe(4
  /* VIEW_ENDED */
  , function (_a) {
    var endClocks = _a.endClocks;
    click.stop(endClocks.timeStamp);
  });
  var stopSubscription = stopObservable.subscribe(function () {
    click.stop();
  });
  click.stopObservable.subscribe(function () {
    viewEndedSubscription.unsubscribe();
    stopWaitPageActivityEnd();
    stopSubscription.unsubscribe();
  });
}

function computeClickActionBase(event, actionNameAttribute) {
  var target;
  var position;

  if ((0, browser_core_1.isExperimentalFeatureEnabled)('clickmap')) {
    var rect = event.target.getBoundingClientRect();
    target = (0, browser_core_1.assign)({
      width: Math.round(rect.width),
      height: Math.round(rect.height)
    }, (0, getSelectorsFromElement_1.getSelectorsFromElement)(event.target, actionNameAttribute));
    position = {
      // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
      x: Math.round(event.clientX - rect.left),
      y: Math.round(event.clientY - rect.top)
    };
  }

  return {
    type: "click"
    /* CLICK */
    ,
    target: target,
    position: position,
    name: (0, getActionNameFromElement_1.getActionNameFromElement)(event.target, actionNameAttribute)
  };
}

function newClick(lifeCycle, history, getUserActivity, clickActionBase, clickEvent) {
  var id = (0, browser_core_1.generateUUID)();
  var startClocks = (0, browser_core_1.clocksNow)();
  var historyEntry = history.add(id, startClocks.relative);
  var eventCountsSubscription = (0, trackEventCounts_1.trackEventCounts)(lifeCycle);
  var status = 0
  /* ONGOING */
  ;
  var activityEndTime;
  var frustrationTypes = [];
  var stopObservable = new browser_core_1.Observable();

  function stop(newActivityEndTime) {
    if (status !== 0
    /* ONGOING */
    ) {
        return;
      }

    activityEndTime = newActivityEndTime;
    status = 1
    /* STOPPED */
    ;

    if (activityEndTime) {
      historyEntry.close((0, browser_core_1.getRelativeTime)(activityEndTime));
    } else {
      historyEntry.remove();
    }

    eventCountsSubscription.stop();
    stopObservable.notify();
  }

  return {
    event: clickEvent,
    stop: stop,
    stopObservable: stopObservable,

    get hasError() {
      return eventCountsSubscription.eventCounts.errorCount > 0;
    },

    get hasPageActivity() {
      return activityEndTime !== undefined;
    },

    getUserActivity: getUserActivity,
    addFrustration: function addFrustration(frustrationType) {
      frustrationTypes.push(frustrationType);
    },
    startClocks: startClocks,
    isStopped: function isStopped() {
      return status === 1
      /* STOPPED */
      || status === 2
      /* FINALIZED */
      ;
    },
    clone: function clone() {
      return newClick(lifeCycle, history, getUserActivity, clickActionBase, clickEvent);
    },
    validate: function validate(domEvents) {
      stop();

      if (status !== 1
      /* STOPPED */
      ) {
          return;
        }

      var _a = eventCountsSubscription.eventCounts,
          resourceCount = _a.resourceCount,
          errorCount = _a.errorCount,
          longTaskCount = _a.longTaskCount;
      var clickAction = (0, browser_core_1.assign)({
        type: "click"
        /* CLICK */
        ,
        duration: activityEndTime && (0, browser_core_1.elapsed)(startClocks.timeStamp, activityEndTime),
        startClocks: startClocks,
        id: id,
        frustrationTypes: frustrationTypes,
        counts: {
          resourceCount: resourceCount,
          errorCount: errorCount,
          longTaskCount: longTaskCount
        },
        events: domEvents !== null && domEvents !== void 0 ? domEvents : [clickEvent],
        event: clickEvent
      }, clickActionBase);
      lifeCycle.notify(1
      /* AUTO_ACTION_COMPLETED */
      , clickAction);
      status = 2
      /* FINALIZED */
      ;
    },
    discard: function discard() {
      stop();
      status = 2
      /* FINALIZED */
      ;
    }
  };
}

function finalizeClicks(clicks, rageClick) {
  var isRage = (0, computeFrustration_1.computeFrustration)(clicks, rageClick).isRage;

  if (isRage) {
    clicks.forEach(function (click) {
      return click.discard();
    });
    rageClick.stop((0, browser_core_1.timeStampNow)());
    rageClick.validate(clicks.map(function (click) {
      return click.event;
    }));
  } else {
    rageClick.discard();
    clicks.forEach(function (click) {
      return click.validate();
    });
  }
}

exports.finalizeClicks = finalizeClicks;

},{"../../trackEventCounts":93,"../../waitPageActivityEnd":94,"./clickChain":72,"./computeFrustration":73,"./getActionNameFromElement":74,"./getSelectorsFromElement":75,"./listenActionEvents":76,"@datadog/browser-core":32}],78:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doStartErrorCollection = exports.startErrorCollection = void 0;

var browser_core_1 = require("@datadog/browser-core");

var trackConsoleError_1 = require("./trackConsoleError");

var trackReportError_1 = require("./trackReportError");

function startErrorCollection(lifeCycle, foregroundContexts) {
  var errorObservable = new browser_core_1.Observable();
  (0, trackConsoleError_1.trackConsoleError)(errorObservable);
  (0, browser_core_1.trackRuntimeError)(errorObservable);
  (0, trackReportError_1.trackReportError)(errorObservable);
  errorObservable.subscribe(function (error) {
    return lifeCycle.notify(12
    /* RAW_ERROR_COLLECTED */
    , {
      error: error
    });
  });
  return doStartErrorCollection(lifeCycle, foregroundContexts);
}

exports.startErrorCollection = startErrorCollection;

function doStartErrorCollection(lifeCycle, foregroundContexts) {
  lifeCycle.subscribe(12
  /* RAW_ERROR_COLLECTED */
  , function (_a) {
    var error = _a.error,
        customerContext = _a.customerContext,
        savedCommonContext = _a.savedCommonContext;
    lifeCycle.notify(10
    /* RAW_RUM_EVENT_COLLECTED */
    , (0, browser_core_1.assign)({
      customerContext: customerContext,
      savedCommonContext: savedCommonContext
    }, processError(error, foregroundContexts)));
  });
  return {
    addError: function addError(_a, savedCommonContext) {
      var error = _a.error,
          handlingStack = _a.handlingStack,
          startClocks = _a.startClocks,
          customerContext = _a.context;
      var stackTrace = error instanceof Error ? (0, browser_core_1.computeStackTrace)(error) : undefined;
      var rawError = (0, browser_core_1.computeRawError)({
        stackTrace: stackTrace,
        originalError: error,
        handlingStack: handlingStack,
        startClocks: startClocks,
        nonErrorPrefix: 'Provided',
        source: browser_core_1.ErrorSource.CUSTOM,
        handling: "handled"
        /* HANDLED */

      });
      lifeCycle.notify(12
      /* RAW_ERROR_COLLECTED */
      , {
        customerContext: customerContext,
        savedCommonContext: savedCommonContext,
        error: rawError
      });
    }
  };
}

exports.doStartErrorCollection = doStartErrorCollection;

function processError(error, foregroundContexts) {
  var rawRumEvent = {
    date: error.startClocks.timeStamp,
    error: {
      id: (0, browser_core_1.generateUUID)(),
      message: error.message,
      source: error.source,
      stack: error.stack,
      handling_stack: error.handlingStack,
      type: error.type,
      handling: error.handling,
      causes: error.causes,
      source_type: 'browser'
    },
    type: "error"
    /* ERROR */

  };
  var inForeground = foregroundContexts.isInForegroundAt(error.startClocks.relative);

  if (inForeground !== undefined) {
    rawRumEvent.view = {
      in_foreground: inForeground
    };
  }

  return {
    rawRumEvent: rawRumEvent,
    startTime: error.startClocks.relative,
    domainContext: {
      error: error.originalError
    }
  };
}

},{"./trackConsoleError":79,"./trackReportError":80,"@datadog/browser-core":32}],79:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackConsoleError = void 0;

var browser_core_1 = require("@datadog/browser-core");

function trackConsoleError(errorObservable) {
  var subscription = (0, browser_core_1.initConsoleObservable)([browser_core_1.ConsoleApiName.error]).subscribe(function (consoleError) {
    return errorObservable.notify({
      startClocks: (0, browser_core_1.clocksNow)(),
      message: consoleError.message,
      stack: consoleError.stack,
      source: browser_core_1.ErrorSource.CONSOLE,
      handling: "handled"
      /* HANDLED */
      ,
      handlingStack: consoleError.handlingStack
    });
  });
  return {
    stop: function stop() {
      subscription.unsubscribe();
    }
  };
}

exports.trackConsoleError = trackConsoleError;

},{"@datadog/browser-core":32}],80:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackReportError = void 0;

var browser_core_1 = require("@datadog/browser-core");

function trackReportError(errorObservable) {
  var subscription = (0, browser_core_1.initReportObservable)([browser_core_1.RawReportType.cspViolation, browser_core_1.RawReportType.intervention]).subscribe(function (reportError) {
    return errorObservable.notify({
      startClocks: (0, browser_core_1.clocksNow)(),
      message: reportError.message,
      stack: reportError.stack,
      type: reportError.subtype,
      source: browser_core_1.ErrorSource.REPORT,
      handling: "unhandled"
      /* UNHANDLED */

    });
  });
  return {
    stop: function stop() {
      subscription.unsubscribe();
    }
  };
}

exports.trackReportError = trackReportError;

},{"@datadog/browser-core":32}],81:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startLongTaskCollection = void 0;

var browser_core_1 = require("@datadog/browser-core");

function startLongTaskCollection(lifeCycle, sessionManager) {
  lifeCycle.subscribe(0
  /* PERFORMANCE_ENTRIES_COLLECTED */
  , function (entries) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
      var entry = entries_1[_i];

      if (entry.entryType !== 'longtask') {
        break;
      }

      var session = sessionManager.findTrackedSession(entry.startTime);

      if (!session || !session.longTaskAllowed) {
        break;
      }

      var startClocks = (0, browser_core_1.relativeToClocks)(entry.startTime);
      var rawRumEvent = {
        date: startClocks.timeStamp,
        long_task: {
          id: (0, browser_core_1.generateUUID)(),
          duration: (0, browser_core_1.toServerDuration)(entry.duration)
        },
        type: "long_task"
        /* LONG_TASK */
        ,
        _dd: {
          discarded: false
        }
      };
      lifeCycle.notify(10
      /* RAW_RUM_EVENT_COLLECTED */
      , {
        rawRumEvent: rawRumEvent,
        startTime: startClocks.relative,
        domainContext: {
          performanceEntry: entry.toJSON()
        }
      });
    }
  });
}

exports.startLongTaskCollection = startLongTaskCollection;

},{"@datadog/browser-core":32}],82:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchRequestTiming = void 0;

var browser_core_1 = require("@datadog/browser-core");

var resourceUtils_1 = require("./resourceUtils");
/**
 * Look for corresponding timing in resource timing buffer
 *
 * Observations:
 * - Timing (start, end) are nested inside the request (start, end)
 * - Some timing can be not exactly nested, being off by < 1 ms
 * - Browsers generate a timing entry for OPTIONS request
 *
 * Strategy:
 * - from valid nested entries (with 1 ms error margin)
 * - if a single timing match, return the timing
 * - if two following timings match (OPTIONS request), return the timing for the actual request
 * - otherwise we can't decide, return undefined
 */


function matchRequestTiming(request) {
  if (!performance || !('getEntriesByName' in performance)) {
    return;
  }

  var sameNameEntries = performance.getEntriesByName(request.url, 'resource');

  if (!sameNameEntries.length || !('toJSON' in sameNameEntries[0])) {
    return;
  }

  var candidates = sameNameEntries.map(function (entry) {
    return entry.toJSON();
  }).filter(resourceUtils_1.toValidEntry).filter(function (entry) {
    return isBetween(entry, request.startClocks.relative, endTime({
      startTime: request.startClocks.relative,
      duration: request.duration
    }));
  });

  if (candidates.length === 1) {
    return candidates[0];
  }

  if (candidates.length === 2 && firstCanBeOptionRequest(candidates)) {
    return candidates[1];
  }

  return;
}

exports.matchRequestTiming = matchRequestTiming;

function firstCanBeOptionRequest(correspondingEntries) {
  return endTime(correspondingEntries[0]) <= correspondingEntries[1].startTime;
}

function endTime(timing) {
  return (0, browser_core_1.addDuration)(timing.startTime, timing.duration);
}

function isBetween(timing, start, end) {
  var errorMargin = 1;
  return timing.startTime >= start - errorMargin && endTime(timing) <= (0, browser_core_1.addDuration)(end, errorMargin);
}

},{"./resourceUtils":84,"@datadog/browser-core":32}],83:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startResourceCollection = void 0;

var browser_core_1 = require("@datadog/browser-core");

var matchRequestTiming_1 = require("./matchRequestTiming");

var resourceUtils_1 = require("./resourceUtils");

function startResourceCollection(lifeCycle, configuration, sessionManager) {
  lifeCycle.subscribe(6
  /* REQUEST_COMPLETED */
  , function (request) {
    lifeCycle.notify(10
    /* RAW_RUM_EVENT_COLLECTED */
    , processRequest(request, configuration, sessionManager));
  });
  lifeCycle.subscribe(0
  /* PERFORMANCE_ENTRIES_COLLECTED */
  , function (entries) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
      var entry = entries_1[_i];

      if (entry.entryType === 'resource' && !(0, resourceUtils_1.isRequestKind)(entry)) {
        lifeCycle.notify(10
        /* RAW_RUM_EVENT_COLLECTED */
        , processResourceEntry(entry, configuration, sessionManager));
      }
    }
  });
}

exports.startResourceCollection = startResourceCollection;

function processRequest(request, configuration, sessionManager) {
  var type = request.type === "xhr"
  /* XHR */
  ? "xhr"
  /* XHR */
  : "fetch"
  /* FETCH */
  ;
  var matchingTiming = (0, matchRequestTiming_1.matchRequestTiming)(request);
  var startClocks = matchingTiming ? (0, browser_core_1.relativeToClocks)(matchingTiming.startTime) : request.startClocks;
  var correspondingTimingOverrides = matchingTiming ? computePerformanceEntryMetrics(matchingTiming) : undefined;
  var tracingInfo = computeRequestTracingInfo(request, configuration);
  var indexingInfo = computeIndexingInfo(sessionManager, startClocks);
  var resourceEvent = (0, browser_core_1.combine)({
    date: startClocks.timeStamp,
    resource: {
      id: (0, browser_core_1.generateUUID)(),
      type: type,
      duration: (0, browser_core_1.toServerDuration)(request.duration),
      method: request.method,
      status_code: request.status,
      url: request.url
    },
    type: "resource"
    /* RESOURCE */

  }, tracingInfo, correspondingTimingOverrides, indexingInfo);
  return {
    startTime: startClocks.relative,
    rawRumEvent: resourceEvent,
    domainContext: {
      performanceEntry: matchingTiming && toPerformanceEntryRepresentation(matchingTiming),
      xhr: request.xhr,
      response: request.response,
      requestInput: request.input,
      requestInit: request.init,
      error: request.error
    }
  };
}

function processResourceEntry(entry, configuration, sessionManager) {
  var type = (0, resourceUtils_1.computeResourceKind)(entry);
  var entryMetrics = computePerformanceEntryMetrics(entry);
  var startClocks = (0, browser_core_1.relativeToClocks)(entry.startTime);
  var tracingInfo = computeEntryTracingInfo(entry, configuration);
  var indexingInfo = computeIndexingInfo(sessionManager, startClocks);
  var resourceEvent = (0, browser_core_1.combine)({
    date: startClocks.timeStamp,
    resource: {
      id: (0, browser_core_1.generateUUID)(),
      type: type,
      url: entry.name
    },
    type: "resource"
    /* RESOURCE */

  }, tracingInfo, entryMetrics, indexingInfo);
  return {
    startTime: startClocks.relative,
    rawRumEvent: resourceEvent,
    domainContext: {
      performanceEntry: toPerformanceEntryRepresentation(entry)
    }
  };
}

function computePerformanceEntryMetrics(timing) {
  return {
    resource: (0, browser_core_1.assign)({
      duration: (0, resourceUtils_1.computePerformanceResourceDuration)(timing),
      size: (0, resourceUtils_1.computeSize)(timing)
    }, (0, resourceUtils_1.computePerformanceResourceDetails)(timing))
  };
}

function computeRequestTracingInfo(request, configuration) {
  var hasBeenTraced = request.traceSampled && request.traceId && request.spanId;

  if (!hasBeenTraced) {
    return undefined;
  }

  return {
    _dd: {
      span_id: request.spanId.toDecimalString(),
      trace_id: request.traceId.toDecimalString(),
      rule_psr: getRulePsr(configuration)
    }
  };
}

function computeEntryTracingInfo(entry, configuration) {
  var hasBeenTraced = entry.traceId;

  if (!hasBeenTraced) {
    return undefined;
  }

  return {
    _dd: {
      trace_id: entry.traceId,
      rule_psr: getRulePsr(configuration)
    }
  };
} // TODO next major: use directly PerformanceEntry type in domain context


function toPerformanceEntryRepresentation(entry) {
  return entry;
}
/**
 * @returns number between 0 and 1 which represents tracing sample rate
 */


function getRulePsr(configuration) {
  return (0, browser_core_1.isNumber)(configuration.tracingSampleRate) ? configuration.tracingSampleRate / 100 : undefined;
}

function computeIndexingInfo(sessionManager, resourceStart) {
  var session = sessionManager.findTrackedSession(resourceStart.relative);
  return {
    _dd: {
      discarded: !session || !session.resourceAllowed
    }
  };
}

},{"./matchRequestTiming":82,"./resourceUtils":84,"@datadog/browser-core":32}],84:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAllowedRequestUrl = exports.computeSize = exports.toValidEntry = exports.computePerformanceResourceDetails = exports.computePerformanceResourceDuration = exports.isRequestKind = exports.computeResourceKind = exports.FAKE_INITIAL_DOCUMENT = void 0;

var browser_core_1 = require("@datadog/browser-core");

exports.FAKE_INITIAL_DOCUMENT = 'initial_document';
var RESOURCE_TYPES = [["document"
/* DOCUMENT */
, function (initiatorType) {
  return exports.FAKE_INITIAL_DOCUMENT === initiatorType;
}], ["xhr"
/* XHR */
, function (initiatorType) {
  return 'xmlhttprequest' === initiatorType;
}], ["fetch"
/* FETCH */
, function (initiatorType) {
  return 'fetch' === initiatorType;
}], ["beacon"
/* BEACON */
, function (initiatorType) {
  return 'beacon' === initiatorType;
}], ["css"
/* CSS */
, function (_, path) {
  return /\.css$/i.test(path);
}], ["js"
/* JS */
, function (_, path) {
  return /\.js$/i.test(path);
}], ["image"
/* IMAGE */
, function (initiatorType, path) {
  return (0, browser_core_1.includes)(['image', 'img', 'icon'], initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null;
}], ["font"
/* FONT */
, function (_, path) {
  return /\.(woff|eot|woff2|ttf)$/i.exec(path) !== null;
}], ["media"
/* MEDIA */
, function (initiatorType, path) {
  return (0, browser_core_1.includes)(['audio', 'video'], initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null;
}]];

function computeResourceKind(timing) {
  var url = timing.name;

  if (!(0, browser_core_1.isValidUrl)(url)) {
    (0, browser_core_1.addTelemetryDebug)("Failed to construct URL for \"".concat(timing.name, "\""));
    return "other"
    /* OTHER */
    ;
  }

  var path = (0, browser_core_1.getPathName)(url);

  for (var _i = 0, RESOURCE_TYPES_1 = RESOURCE_TYPES; _i < RESOURCE_TYPES_1.length; _i++) {
    var _a = RESOURCE_TYPES_1[_i],
        type = _a[0],
        isType = _a[1];

    if (isType(timing.initiatorType, path)) {
      return type;
    }
  }

  return "other"
  /* OTHER */
  ;
}

exports.computeResourceKind = computeResourceKind;

function areInOrder() {
  var numbers = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    numbers[_i] = arguments[_i];
  }

  for (var i = 1; i < numbers.length; i += 1) {
    if (numbers[i - 1] > numbers[i]) {
      return false;
    }
  }

  return true;
}

function isRequestKind(timing) {
  return timing.initiatorType === 'xmlhttprequest' || timing.initiatorType === 'fetch';
}

exports.isRequestKind = isRequestKind;

function computePerformanceResourceDuration(entry) {
  var duration = entry.duration,
      startTime = entry.startTime,
      responseEnd = entry.responseEnd; // Safari duration is always 0 on timings blocked by cross origin policies.

  if (duration === 0 && startTime < responseEnd) {
    return (0, browser_core_1.toServerDuration)((0, browser_core_1.elapsed)(startTime, responseEnd));
  }

  return (0, browser_core_1.toServerDuration)(duration);
}

exports.computePerformanceResourceDuration = computePerformanceResourceDuration;

function computePerformanceResourceDetails(entry) {
  var validEntry = toValidEntry(entry);

  if (!validEntry) {
    return undefined;
  }

  var startTime = validEntry.startTime,
      fetchStart = validEntry.fetchStart,
      redirectStart = validEntry.redirectStart,
      redirectEnd = validEntry.redirectEnd,
      domainLookupStart = validEntry.domainLookupStart,
      domainLookupEnd = validEntry.domainLookupEnd,
      connectStart = validEntry.connectStart,
      secureConnectionStart = validEntry.secureConnectionStart,
      connectEnd = validEntry.connectEnd,
      requestStart = validEntry.requestStart,
      responseStart = validEntry.responseStart,
      responseEnd = validEntry.responseEnd;
  var details = {
    download: formatTiming(startTime, responseStart, responseEnd),
    first_byte: formatTiming(startTime, requestStart, responseStart)
  }; // Make sure a connection occurred

  if (connectEnd !== fetchStart) {
    details.connect = formatTiming(startTime, connectStart, connectEnd); // Make sure a secure connection occurred

    if (areInOrder(connectStart, secureConnectionStart, connectEnd)) {
      details.ssl = formatTiming(startTime, secureConnectionStart, connectEnd);
    }
  } // Make sure a domain lookup occurred


  if (domainLookupEnd !== fetchStart) {
    details.dns = formatTiming(startTime, domainLookupStart, domainLookupEnd);
  }

  if (hasRedirection(entry)) {
    details.redirect = formatTiming(startTime, redirectStart, redirectEnd);
  }

  return details;
}

exports.computePerformanceResourceDetails = computePerformanceResourceDetails;

function toValidEntry(entry) {
  // Ensure timings are in the right order. On top of filtering out potential invalid
  // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
  // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
  // it.
  if (!areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd)) {
    return undefined;
  }

  if (!hasRedirection(entry)) {
    return entry;
  }

  var redirectStart = entry.redirectStart,
      redirectEnd = entry.redirectEnd; // Firefox doesn't provide redirect timings on cross origin requests.
  // Provide a default for those.

  if (redirectStart < entry.startTime) {
    redirectStart = entry.startTime;
  }

  if (redirectEnd < entry.startTime) {
    redirectEnd = entry.fetchStart;
  } // Make sure redirect timings are in order


  if (!areInOrder(entry.startTime, redirectStart, redirectEnd, entry.fetchStart)) {
    return undefined;
  }

  return (0, browser_core_1.assign)({}, entry, {
    redirectEnd: redirectEnd,
    redirectStart: redirectStart
  });
}

exports.toValidEntry = toValidEntry;

function hasRedirection(entry) {
  // The only time fetchStart is different than startTime is if a redirection occurred.
  return entry.fetchStart !== entry.startTime;
}

function formatTiming(origin, start, end) {
  return {
    duration: (0, browser_core_1.toServerDuration)((0, browser_core_1.elapsed)(start, end)),
    start: (0, browser_core_1.toServerDuration)((0, browser_core_1.elapsed)(origin, start))
  };
}

function computeSize(entry) {
  // Make sure a request actually occurred
  if (entry.startTime < entry.responseStart) {
    return entry.decodedBodySize;
  }

  return undefined;
}

exports.computeSize = computeSize;

function isAllowedRequestUrl(configuration, url) {
  return url && !configuration.isIntakeUrl(url);
}

exports.isAllowedRequestUrl = isAllowedRequestUrl;

},{"@datadog/browser-core":32}],85:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetFirstHidden = exports.trackFirstHidden = void 0;

var browser_core_1 = require("@datadog/browser-core");

var trackFirstHiddenSingleton;
var stopListeners;

function trackFirstHidden(emitter) {
  if (emitter === void 0) {
    emitter = window;
  }

  if (!trackFirstHiddenSingleton) {
    if (document.visibilityState === 'hidden') {
      trackFirstHiddenSingleton = {
        timeStamp: 0
      };
    } else {
      trackFirstHiddenSingleton = {
        timeStamp: Infinity
      };
      stopListeners = (0, browser_core_1.addEventListeners)(emitter, ["pagehide"
      /* PAGE_HIDE */
      , "visibilitychange"
      /* VISIBILITY_CHANGE */
      ], function (event) {
        if (event.type === 'pagehide' || document.visibilityState === 'hidden') {
          trackFirstHiddenSingleton.timeStamp = event.timeStamp;
          stopListeners();
        }
      }, {
        capture: true
      }).stop;
    }
  }

  return trackFirstHiddenSingleton;
}

exports.trackFirstHidden = trackFirstHidden;

function resetFirstHidden() {
  if (stopListeners) {
    stopListeners();
  }

  trackFirstHiddenSingleton = undefined;
}

exports.resetFirstHidden = resetFirstHidden;

},{"@datadog/browser-core":32}],86:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackFirstInputTimings = exports.trackLargestContentfulPaintTiming = exports.trackFirstContentfulPaintTiming = exports.trackNavigationTimings = exports.trackInitialViewTimings = exports.TIMING_MAXIMUM_DELAY = void 0;

var browser_core_1 = require("@datadog/browser-core");

var trackFirstHidden_1 = require("./trackFirstHidden"); // Discard LCP and FCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations


exports.TIMING_MAXIMUM_DELAY = 10 * browser_core_1.ONE_MINUTE;

function trackInitialViewTimings(lifeCycle, callback) {
  var timings = {};

  function setTimings(newTimings) {
    (0, browser_core_1.assign)(timings, newTimings);
    callback(timings);
  }

  var stopNavigationTracking = trackNavigationTimings(lifeCycle, setTimings).stop;
  var stopFCPTracking = trackFirstContentfulPaintTiming(lifeCycle, function (firstContentfulPaint) {
    return setTimings({
      firstContentfulPaint: firstContentfulPaint
    });
  }).stop;
  var stopLCPTracking = trackLargestContentfulPaintTiming(lifeCycle, window, function (largestContentfulPaint) {
    setTimings({
      largestContentfulPaint: largestContentfulPaint
    });
  }).stop;
  var stopFIDTracking = trackFirstInputTimings(lifeCycle, function (_a) {
    var firstInputDelay = _a.firstInputDelay,
        firstInputTime = _a.firstInputTime;
    setTimings({
      firstInputDelay: firstInputDelay,
      firstInputTime: firstInputTime
    });
  }).stop;
  return {
    stop: function stop() {
      stopNavigationTracking();
      stopFCPTracking();
      stopLCPTracking();
      stopFIDTracking();
    }
  };
}

exports.trackInitialViewTimings = trackInitialViewTimings;

function trackNavigationTimings(lifeCycle, callback) {
  var stop = lifeCycle.subscribe(0
  /* PERFORMANCE_ENTRIES_COLLECTED */
  , function (entries) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
      var entry = entries_1[_i];

      if (entry.entryType === 'navigation') {
        callback({
          domComplete: entry.domComplete,
          domContentLoaded: entry.domContentLoadedEventEnd,
          domInteractive: entry.domInteractive,
          loadEvent: entry.loadEventEnd,
          // In some cases the value reported is negative or is larger
          // than the current page time. Ignore these cases:
          // https://github.com/GoogleChrome/web-vitals/issues/137
          // https://github.com/GoogleChrome/web-vitals/issues/162
          firstByte: entry.responseStart >= 0 && entry.responseStart <= (0, browser_core_1.relativeNow)() ? entry.responseStart : undefined
        });
      }
    }
  }).unsubscribe;
  return {
    stop: stop
  };
}

exports.trackNavigationTimings = trackNavigationTimings;

function trackFirstContentfulPaintTiming(lifeCycle, callback) {
  var firstHidden = (0, trackFirstHidden_1.trackFirstHidden)();
  var stop = lifeCycle.subscribe(0
  /* PERFORMANCE_ENTRIES_COLLECTED */
  , function (entries) {
    var fcpEntry = (0, browser_core_1.find)(entries, function (entry) {
      return entry.entryType === 'paint' && entry.name === 'first-contentful-paint' && entry.startTime < firstHidden.timeStamp && entry.startTime < exports.TIMING_MAXIMUM_DELAY;
    });

    if (fcpEntry) {
      callback(fcpEntry.startTime);
    }
  }).unsubscribe;
  return {
    stop: stop
  };
}

exports.trackFirstContentfulPaintTiming = trackFirstContentfulPaintTiming;
/**
 * Track the largest contentful paint (LCP) occurring during the initial View.  This can yield
 * multiple values, only the most recent one should be used.
 * Documentation: https://web.dev/lcp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getLCP.ts
 */

function trackLargestContentfulPaintTiming(lifeCycle, emitter, callback) {
  var firstHidden = (0, trackFirstHidden_1.trackFirstHidden)(); // Ignore entries that come after the first user interaction.  According to the documentation, the
  // browser should not send largest-contentful-paint entries after a user interact with the page,
  // but the web-vitals reference implementation uses this as a safeguard.

  var firstInteractionTimestamp = Infinity;
  var stopEventListener = (0, browser_core_1.addEventListeners)(emitter, ["pointerdown"
  /* POINTER_DOWN */
  , "keydown"
  /* KEY_DOWN */
  ], function (event) {
    firstInteractionTimestamp = event.timeStamp;
  }, {
    capture: true,
    once: true
  }).stop;
  var unsubscribeLifeCycle = lifeCycle.subscribe(0
  /* PERFORMANCE_ENTRIES_COLLECTED */
  , function (entries) {
    var lcpEntry = (0, browser_core_1.findLast)(entries, function (entry) {
      return entry.entryType === 'largest-contentful-paint' && entry.startTime < firstInteractionTimestamp && entry.startTime < firstHidden.timeStamp && entry.startTime < exports.TIMING_MAXIMUM_DELAY;
    });

    if (lcpEntry) {
      callback(lcpEntry.startTime);
    }
  }).unsubscribe;
  return {
    stop: function stop() {
      stopEventListener();
      unsubscribeLifeCycle();
    }
  };
}

exports.trackLargestContentfulPaintTiming = trackLargestContentfulPaintTiming;
/**
 * Track the first input occurring during the initial View to return:
 * - First Input Delay
 * - First Input Time
 * Callback is called at most one time.
 * Documentation: https://web.dev/fid/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getFID.ts
 */

function trackFirstInputTimings(lifeCycle, callback) {
  var firstHidden = (0, trackFirstHidden_1.trackFirstHidden)();
  var stop = lifeCycle.subscribe(0
  /* PERFORMANCE_ENTRIES_COLLECTED */
  , function (entries) {
    var firstInputEntry = (0, browser_core_1.find)(entries, function (entry) {
      return entry.entryType === 'first-input' && entry.startTime < firstHidden.timeStamp;
    });

    if (firstInputEntry) {
      var firstInputDelay = (0, browser_core_1.elapsed)(firstInputEntry.startTime, firstInputEntry.processingStart);
      callback({
        // Ensure firstInputDelay to be positive, see
        // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
        firstInputDelay: firstInputDelay >= 0 ? firstInputDelay : 0,
        firstInputTime: firstInputEntry.startTime
      });
    }
  }).unsubscribe;
  return {
    stop: stop
  };
}

exports.trackFirstInputTimings = trackFirstInputTimings;

},{"./trackFirstHidden":85,"@datadog/browser-core":32}],87:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackViewMetrics = void 0;

var browser_core_1 = require("@datadog/browser-core");

var performanceCollection_1 = require("../../../browser/performanceCollection");

var trackEventCounts_1 = require("../../trackEventCounts");

var waitPageActivityEnd_1 = require("../../waitPageActivityEnd");

function trackViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
  var viewMetrics = {
    eventCounts: {
      errorCount: 0,
      longTaskCount: 0,
      resourceCount: 0,
      actionCount: 0,
      frustrationCount: 0
    }
  };
  var stopEventCountsTracking = (0, trackEventCounts_1.trackEventCounts)(lifeCycle, function (newEventCounts) {
    viewMetrics.eventCounts = newEventCounts;
    scheduleViewUpdate();
  }).stop;

  var _a = trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadingType, viewStart, function (newLoadingTime) {
    viewMetrics.loadingTime = newLoadingTime;
    scheduleViewUpdate();
  }),
      stopLoadingTimeTracking = _a.stop,
      setLoadEvent = _a.setLoadEvent;

  var stopCLSTracking;

  if (isLayoutShiftSupported()) {
    viewMetrics.cumulativeLayoutShift = 0;
    stopCLSTracking = trackCumulativeLayoutShift(lifeCycle, function (cumulativeLayoutShift) {
      viewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
      scheduleViewUpdate();
    }).stop;
  } else {
    stopCLSTracking = browser_core_1.noop;
  }

  return {
    stop: function stop() {
      stopEventCountsTracking();
      stopLoadingTimeTracking();
      stopCLSTracking();
    },
    setLoadEvent: setLoadEvent,
    viewMetrics: viewMetrics
  };
}

exports.trackViewMetrics = trackViewMetrics;

function trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadType, viewStart, callback) {
  var isWaitingForLoadEvent = loadType === "initial_load"
  /* INITIAL_LOAD */
  ;
  var isWaitingForActivityLoadingTime = true;
  var loadingTimeCandidates = [];

  function invokeCallbackIfAllCandidatesAreReceived() {
    if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
      callback(Math.max.apply(Math, loadingTimeCandidates));
    }
  }

  var stop = (0, waitPageActivityEnd_1.waitPageActivityEnd)(lifeCycle, domMutationObservable, configuration, function (event) {
    if (isWaitingForActivityLoadingTime) {
      isWaitingForActivityLoadingTime = false;

      if (event.hadActivity) {
        loadingTimeCandidates.push((0, browser_core_1.elapsed)(viewStart.timeStamp, event.end));
      }

      invokeCallbackIfAllCandidatesAreReceived();
    }
  }).stop;
  return {
    stop: stop,
    setLoadEvent: function setLoadEvent(loadEvent) {
      if (isWaitingForLoadEvent) {
        isWaitingForLoadEvent = false;
        loadingTimeCandidates.push(loadEvent);
        invokeCallbackIfAllCandidatesAreReceived();
      }
    }
  };
}
/**
 * Track the cumulative layout shifts (CLS).
 * Layout shifts are grouped into session windows.
 * The minimum gap between session windows is 1 second.
 * The maximum duration of a session window is 5 second.
 * The session window layout shift value is the sum of layout shifts inside it.
 * The CLS value is the max of session windows values.
 *
 * This yields a new value whenever the CLS value is updated (a higher session window value is computed).
 *
 * See isLayoutShiftSupported to check for browser support.
 *
 * Documentation:
 * https://web.dev/cls/
 * https://web.dev/evolving-cls/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getCLS.ts
 */


function trackCumulativeLayoutShift(lifeCycle, callback) {
  var maxClsValue = 0;
  var window = slidingSessionWindow();
  var stop = lifeCycle.subscribe(0
  /* PERFORMANCE_ENTRIES_COLLECTED */
  , function (entries) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
      var entry = entries_1[_i];

      if (entry.entryType === 'layout-shift' && !entry.hadRecentInput) {
        window.update(entry);

        if (window.value() > maxClsValue) {
          maxClsValue = window.value();
          callback((0, browser_core_1.round)(maxClsValue, 4));
        }
      }
    }
  }).unsubscribe;
  return {
    stop: stop
  };
}

function slidingSessionWindow() {
  var _value = 0;
  var startTime;
  var endTime;
  return {
    update: function update(entry) {
      var shouldCreateNewWindow = startTime === undefined || entry.startTime - endTime >= browser_core_1.ONE_SECOND || entry.startTime - startTime >= 5 * browser_core_1.ONE_SECOND;

      if (shouldCreateNewWindow) {
        startTime = endTime = entry.startTime;
        _value = entry.value;
      } else {
        _value += entry.value;
        endTime = entry.startTime;
      }
    },
    value: function value() {
      return _value;
    }
  };
}
/**
 * Check whether `layout-shift` is supported by the browser.
 */


function isLayoutShiftSupported() {
  return (0, performanceCollection_1.supportPerformanceTimingEvent)('layout-shift');
}

},{"../../../browser/performanceCollection":58,"../../trackEventCounts":93,"../../waitPageActivityEnd":94,"@datadog/browser-core":32}],88:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackViews = exports.SESSION_KEEP_ALIVE_INTERVAL = exports.THROTTLE_VIEW_UPDATE_PERIOD = void 0;

var browser_core_1 = require("@datadog/browser-core");

var trackInitialViewTimings_1 = require("./trackInitialViewTimings");

var trackViewMetrics_1 = require("./trackViewMetrics");

exports.THROTTLE_VIEW_UPDATE_PERIOD = 3000;
exports.SESSION_KEEP_ALIVE_INTERVAL = 5 * browser_core_1.ONE_MINUTE;

function trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
  var _a = trackInitialView(initialViewOptions),
      stopInitialViewTracking = _a.stop,
      initialView = _a.initialView;

  var currentView = initialView;
  var stopViewLifeCycle = startViewLifeCycle().stop;
  var locationChangeSubscription;

  if (areViewsTrackedAutomatically) {
    locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
  }

  function trackInitialView(options) {
    var initialView = newView(lifeCycle, domMutationObservable, configuration, location, "initial_load"
    /* INITIAL_LOAD */
    , (0, browser_core_1.clocksOrigin)(), options);
    var stop = (0, trackInitialViewTimings_1.trackInitialViewTimings)(lifeCycle, function (timings) {
      initialView.updateTimings(timings);
      initialView.scheduleUpdate();
    }).stop;
    return {
      initialView: initialView,
      stop: stop
    };
  }

  function trackViewChange(startClocks, viewOptions) {
    return newView(lifeCycle, domMutationObservable, configuration, location, "route_change"
    /* ROUTE_CHANGE */
    , startClocks, viewOptions);
  }

  function startViewLifeCycle() {
    lifeCycle.subscribe(8
    /* SESSION_RENEWED */
    , function () {
      // do not trigger view update to avoid wrong data
      currentView.end(); // Renew view on session renewal

      currentView = trackViewChange(undefined, {
        name: currentView.name,
        service: currentView.service,
        version: currentView.version
      });
    }); // End the current view on page unload

    lifeCycle.subscribe(9
    /* BEFORE_UNLOAD */
    , function () {
      currentView.end();
      currentView.triggerUpdate();
    }); // Session keep alive

    var keepAliveInterval = window.setInterval((0, browser_core_1.monitor)(function () {
      currentView.triggerUpdate();
    }), exports.SESSION_KEEP_ALIVE_INTERVAL);
    return {
      stop: function stop() {
        clearInterval(keepAliveInterval);
      }
    };
  }

  function renewViewOnLocationChange(locationChangeObservable) {
    return locationChangeObservable.subscribe(function (_a) {
      var oldLocation = _a.oldLocation,
          newLocation = _a.newLocation;

      if (areDifferentLocation(oldLocation, newLocation)) {
        currentView.end();
        currentView.triggerUpdate();
        currentView = trackViewChange();
        return;
      }
    });
  }

  return {
    addTiming: function addTiming(name, time) {
      if (time === void 0) {
        time = (0, browser_core_1.timeStampNow)();
      }

      currentView.addTiming(name, time);
      currentView.scheduleUpdate();
    },
    startView: function startView(options, startClocks) {
      currentView.end(startClocks);
      currentView.triggerUpdate();
      currentView = trackViewChange(startClocks, options);
    },
    stop: function stop() {
      locationChangeSubscription === null || locationChangeSubscription === void 0 ? void 0 : locationChangeSubscription.unsubscribe();
      stopInitialViewTracking();
      stopViewLifeCycle();
      currentView.end();
    }
  };
}

exports.trackViews = trackViews;

function newView(lifeCycle, domMutationObservable, configuration, initialLocation, loadingType, startClocks, viewOptions) {
  if (startClocks === void 0) {
    startClocks = (0, browser_core_1.clocksNow)();
  } // Setup initial values


  var id = (0, browser_core_1.generateUUID)();
  var timings = {};
  var customTimings = {};
  var documentVersion = 0;
  var endClocks;
  var location = (0, browser_core_1.shallowClone)(initialLocation);
  var name;
  var service;
  var version;

  if (viewOptions) {
    name = viewOptions.name;
    service = viewOptions.service;
    version = viewOptions.version;
  }

  lifeCycle.notify(2
  /* VIEW_CREATED */
  , {
    id: id,
    name: name,
    startClocks: startClocks,
    service: service,
    version: version
  }); // Update the view every time the measures are changing

  var _a = (0, browser_core_1.throttle)((0, browser_core_1.monitor)(triggerViewUpdate), exports.THROTTLE_VIEW_UPDATE_PERIOD, {
    leading: false
  }),
      scheduleViewUpdate = _a.throttled,
      cancelScheduleViewUpdate = _a.cancel;

  var _b = (0, trackViewMetrics_1.trackViewMetrics)(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, startClocks),
      setLoadEvent = _b.setLoadEvent,
      stopViewMetricsTracking = _b.stop,
      viewMetrics = _b.viewMetrics; // Initial view update


  triggerViewUpdate();

  function triggerViewUpdate() {
    documentVersion += 1;
    var currentEnd = endClocks === undefined ? (0, browser_core_1.timeStampNow)() : endClocks.timeStamp;
    lifeCycle.notify(3
    /* VIEW_UPDATED */
    , (0, browser_core_1.assign)({
      customTimings: customTimings,
      documentVersion: documentVersion,
      id: id,
      name: name,
      service: service,
      version: version,
      loadingType: loadingType,
      location: location,
      startClocks: startClocks,
      timings: timings,
      duration: (0, browser_core_1.elapsed)(startClocks.timeStamp, currentEnd),
      isActive: endClocks === undefined
    }, viewMetrics));
  }

  return {
    name: name,
    service: service,
    version: version,
    scheduleUpdate: scheduleViewUpdate,
    end: function end(clocks) {
      if (clocks === void 0) {
        clocks = (0, browser_core_1.clocksNow)();
      }

      endClocks = clocks;
      lifeCycle.notify(4
      /* VIEW_ENDED */
      , {
        endClocks: endClocks
      });
      stopViewMetricsTracking();
    },
    triggerUpdate: function triggerUpdate() {
      // cancel any pending view updates execution
      cancelScheduleViewUpdate();
      triggerViewUpdate();
    },
    updateTimings: function updateTimings(newTimings) {
      timings = newTimings;

      if (newTimings.loadEvent !== undefined) {
        setLoadEvent(newTimings.loadEvent);
      }
    },
    addTiming: function addTiming(name, time) {
      var relativeTime = (0, browser_core_1.looksLikeRelativeTime)(time) ? time : (0, browser_core_1.elapsed)(startClocks.timeStamp, time);
      customTimings[sanitizeTiming(name)] = relativeTime;
    }
  };
}
/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 */


function sanitizeTiming(name) {
  var sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, '_');

  if (sanitized !== name) {
    browser_core_1.display.warn("Invalid timing name: ".concat(name, ", sanitized to: ").concat(sanitized));
  }

  return sanitized;
}

function areDifferentLocation(currentLocation, otherLocation) {
  return currentLocation.pathname !== otherLocation.pathname || !isHashAnAnchor(otherLocation.hash) && getPathFromHash(otherLocation.hash) !== getPathFromHash(currentLocation.hash);
}

function isHashAnAnchor(hash) {
  var correspondingId = hash.substr(1);
  return !!document.getElementById(correspondingId);
}

function getPathFromHash(hash) {
  var index = hash.indexOf('?');
  return index < 0 ? hash : hash.slice(0, index);
}

},{"./trackInitialViewTimings":86,"./trackViewMetrics":87,"@datadog/browser-core":32}],89:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startViewCollection = void 0;

var browser_core_1 = require("@datadog/browser-core");

var trackViews_1 = require("./trackViews");

function startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, foregroundContexts, recorderApi, initialViewOptions) {
  lifeCycle.subscribe(3
  /* VIEW_UPDATED */
  , function (view) {
    return lifeCycle.notify(10
    /* RAW_RUM_EVENT_COLLECTED */
    , processViewUpdate(view, foregroundContexts, recorderApi));
  });
  return (0, trackViews_1.trackViews)(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
}

exports.startViewCollection = startViewCollection;

function processViewUpdate(view, foregroundContexts, recorderApi) {
  var replayStats = recorderApi.getReplayStats(view.id);
  var viewEvent = {
    _dd: {
      document_version: view.documentVersion,
      replay_stats: replayStats
    },
    date: view.startClocks.timeStamp,
    type: "view"
    /* VIEW */
    ,
    view: {
      action: {
        count: view.eventCounts.actionCount
      },
      frustration: {
        count: view.eventCounts.frustrationCount
      },
      cumulative_layout_shift: view.cumulativeLayoutShift,
      first_byte: (0, browser_core_1.toServerDuration)(view.timings.firstByte),
      dom_complete: (0, browser_core_1.toServerDuration)(view.timings.domComplete),
      dom_content_loaded: (0, browser_core_1.toServerDuration)(view.timings.domContentLoaded),
      dom_interactive: (0, browser_core_1.toServerDuration)(view.timings.domInteractive),
      error: {
        count: view.eventCounts.errorCount
      },
      first_contentful_paint: (0, browser_core_1.toServerDuration)(view.timings.firstContentfulPaint),
      first_input_delay: (0, browser_core_1.toServerDuration)(view.timings.firstInputDelay),
      first_input_time: (0, browser_core_1.toServerDuration)(view.timings.firstInputTime),
      is_active: view.isActive,
      name: view.name,
      largest_contentful_paint: (0, browser_core_1.toServerDuration)(view.timings.largestContentfulPaint),
      load_event: (0, browser_core_1.toServerDuration)(view.timings.loadEvent),
      loading_time: discardNegativeDuration((0, browser_core_1.toServerDuration)(view.loadingTime)),
      loading_type: view.loadingType,
      long_task: {
        count: view.eventCounts.longTaskCount
      },
      resource: {
        count: view.eventCounts.resourceCount
      },
      time_spent: (0, browser_core_1.toServerDuration)(view.duration),
      in_foreground_periods: foregroundContexts.selectInForegroundPeriodsFor(view.startClocks.relative, view.duration)
    },
    session: {
      has_replay: replayStats ? true : undefined
    }
  };

  if (!(0, browser_core_1.isEmptyObject)(view.customTimings)) {
    viewEvent.view.custom_timings = (0, browser_core_1.mapValues)(view.customTimings, browser_core_1.toServerDuration);
  }

  return {
    rawRumEvent: viewEvent,
    startTime: view.startClocks.relative,
    domainContext: {
      location: view.location
    }
  };
}

function discardNegativeDuration(duration) {
  return (0, browser_core_1.isNumber)(duration) && duration < 0 ? undefined : duration;
}

},{"./trackViews":88,"@datadog/browser-core":32}],90:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startRumSessionManagerStub = exports.startRumSessionManager = exports.RUM_SESSION_KEY = void 0;

var browser_core_1 = require("@datadog/browser-core");

exports.RUM_SESSION_KEY = 'rum';

function startRumSessionManager(configuration, lifeCycle) {
  var sessionManager = (0, browser_core_1.startSessionManager)(configuration.cookieOptions, exports.RUM_SESSION_KEY, function (rawTrackingType) {
    return computeSessionState(configuration, rawTrackingType);
  });
  sessionManager.expireObservable.subscribe(function () {
    lifeCycle.notify(7
    /* SESSION_EXPIRED */
    );
  });
  sessionManager.renewObservable.subscribe(function () {
    lifeCycle.notify(8
    /* SESSION_RENEWED */
    );
  });
  return {
    findTrackedSession: function findTrackedSession(startTime) {
      var session = sessionManager.findActiveSession(startTime);

      if (!session || !isTypeTracked(session.trackingType)) {
        return;
      }

      var plan = session.trackingType === "1"
      /* TRACKED_WITH_SESSION_REPLAY */
      ? 2
      /* WITH_SESSION_REPLAY */
      : 1
      /* WITHOUT_SESSION_REPLAY */
      ;
      return {
        id: session.id,
        plan: plan,
        sessionReplayAllowed: plan === 2
        /* WITH_SESSION_REPLAY */
        ,
        longTaskAllowed: configuration.trackLongTasks !== undefined ? configuration.trackLongTasks : configuration.oldPlansBehavior && plan === 2
        /* WITH_SESSION_REPLAY */
        ,
        resourceAllowed: configuration.trackResources !== undefined ? configuration.trackResources : configuration.oldPlansBehavior && plan === 2
        /* WITH_SESSION_REPLAY */

      };
    }
  };
}

exports.startRumSessionManager = startRumSessionManager;
/**
 * Start a tracked replay session stub
 */

function startRumSessionManagerStub() {
  var session = {
    id: '00000000-aaaa-0000-aaaa-000000000000',
    plan: 1
    /* WITHOUT_SESSION_REPLAY */
    ,
    sessionReplayAllowed: false,
    longTaskAllowed: true,
    resourceAllowed: true
  };
  return {
    findTrackedSession: function findTrackedSession() {
      return session;
    }
  };
}

exports.startRumSessionManagerStub = startRumSessionManagerStub;

function computeSessionState(configuration, rawTrackingType) {
  var trackingType;

  if (hasValidRumSession(rawTrackingType)) {
    trackingType = rawTrackingType;
  } else if (!(0, browser_core_1.performDraw)(configuration.sampleRate)) {
    trackingType = "0"
    /* NOT_TRACKED */
    ;
  } else if (!(0, browser_core_1.performDraw)(configuration.sessionReplaySampleRate)) {
    trackingType = "2"
    /* TRACKED_WITHOUT_SESSION_REPLAY */
    ;
  } else {
    trackingType = "1"
    /* TRACKED_WITH_SESSION_REPLAY */
    ;
  }

  return {
    trackingType: trackingType,
    isTracked: isTypeTracked(trackingType)
  };
}

function hasValidRumSession(trackingType) {
  return trackingType === "0"
  /* NOT_TRACKED */
  || trackingType === "1"
  /* TRACKED_WITH_SESSION_REPLAY */
  || trackingType === "2"
  /* TRACKED_WITHOUT_SESSION_REPLAY */
  ;
}

function isTypeTracked(rumSessionType) {
  return rumSessionType === "2"
  /* TRACKED_WITHOUT_SESSION_REPLAY */
  || rumSessionType === "1"
  /* TRACKED_WITH_SESSION_REPLAY */
  ;
}

},{"@datadog/browser-core":32}],91:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findTraceComment = exports.createDocumentTraceData = exports.getDocumentTraceDataFromComment = exports.getDocumentTraceDataFromMeta = exports.getDocumentTraceId = exports.INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD = void 0;

var browser_core_1 = require("@datadog/browser-core");

exports.INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD = 2 * browser_core_1.ONE_MINUTE;

function getDocumentTraceId(document) {
  var data = getDocumentTraceDataFromMeta(document) || getDocumentTraceDataFromComment(document);

  if (!data || data.traceTime <= (0, browser_core_1.dateNow)() - exports.INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD) {
    return undefined;
  }

  return data.traceId;
}

exports.getDocumentTraceId = getDocumentTraceId;

function getDocumentTraceDataFromMeta(document) {
  var traceIdMeta = document.querySelector('meta[name=dd-trace-id]');
  var traceTimeMeta = document.querySelector('meta[name=dd-trace-time]');
  return createDocumentTraceData(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}

exports.getDocumentTraceDataFromMeta = getDocumentTraceDataFromMeta;

function getDocumentTraceDataFromComment(document) {
  var comment = findTraceComment(document);

  if (!comment) {
    return undefined;
  }

  return createDocumentTraceData((0, browser_core_1.findCommaSeparatedValue)(comment, 'trace-id'), (0, browser_core_1.findCommaSeparatedValue)(comment, 'trace-time'));
}

exports.getDocumentTraceDataFromComment = getDocumentTraceDataFromComment;

function createDocumentTraceData(traceId, rawTraceTime) {
  var traceTime = rawTraceTime && Number(rawTraceTime);

  if (!traceId || !traceTime) {
    return undefined;
  }

  return {
    traceId: traceId,
    traceTime: traceTime
  };
}

exports.createDocumentTraceData = createDocumentTraceData;

function findTraceComment(document) {
  // 1. Try to find the comment as a direct child of the document
  // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
  // value is not an array or string (here, a NodeList).
  for (var i = 0; i < document.childNodes.length; i += 1) {
    var comment = getTraceCommentFromNode(document.childNodes[i]);

    if (comment) {
      return comment;
    }
  } // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
  // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
  // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
  // reverse order, stopping if we come across a non-text node.


  if (document.body) {
    for (var i = document.body.childNodes.length - 1; i >= 0; i -= 1) {
      var node = document.body.childNodes[i];
      var comment = getTraceCommentFromNode(node);

      if (comment) {
        return comment;
      }

      if (!isTextNode(node)) {
        break;
      }
    }
  }
}

exports.findTraceComment = findTraceComment;

function getTraceCommentFromNode(node) {
  if (node && isCommentNode(node)) {
    var match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);

    if (match) {
      return match[1];
    }
  }
}

function isCommentNode(node) {
  return node.nodeName === '#comment';
}

function isTextNode(node) {
  return node.nodeName === '#text';
}

},{"@datadog/browser-core":32}],92:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TraceIdentifier = exports.isTracingSupported = exports.startTracer = exports.clearTracingIfNeeded = void 0;

var browser_core_1 = require("@datadog/browser-core");
/**
 * Clear tracing information to avoid incomplete traces. Ideally, we should do it when the
 * request did not reach the server, but the browser does not expose this. So, we clear tracing
 * information if the request ended with status 0 without being aborted by the application.
 *
 * Reasoning:
 *
 * * Applications are usually aborting requests after a bit of time, for example when the user is
 * typing (autocompletion) or navigating away (in a SPA). With a performant device and good
 * network conditions, the request is likely to reach the server before being canceled.
 *
 * * Requests aborted otherwise (ex: lack of internet, CORS issue, blocked by a privacy extension)
 * are likely to finish quickly and without reaching the server.
 *
 * Of course, it might not be the case every time, but it should limit having incomplete traces a
 * bit.
 * */


function clearTracingIfNeeded(context) {
  if (context.status === 0 && !context.isAborted) {
    context.traceId = undefined;
    context.spanId = undefined;
    context.traceSampled = undefined;
  }
}

exports.clearTracingIfNeeded = clearTracingIfNeeded;

function startTracer(configuration, sessionManager) {
  return {
    clearTracingIfNeeded: clearTracingIfNeeded,
    traceFetch: function traceFetch(context) {
      return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
        var _a;

        if (context.input instanceof Request && !((_a = context.init) === null || _a === void 0 ? void 0 : _a.headers)) {
          context.input = new Request(context.input);
          Object.keys(tracingHeaders).forEach(function (key) {
            ;
            context.input.headers.append(key, tracingHeaders[key]);
          });
        } else {
          context.init = (0, browser_core_1.shallowClone)(context.init);
          var headers_1 = [];

          if (context.init.headers instanceof Headers) {
            context.init.headers.forEach(function (value, key) {
              headers_1.push([key, value]);
            });
          } else if (Array.isArray(context.init.headers)) {
            context.init.headers.forEach(function (header) {
              headers_1.push(header);
            });
          } else if (context.init.headers) {
            Object.keys(context.init.headers).forEach(function (key) {
              headers_1.push([key, context.init.headers[key]]);
            });
          }

          context.init.headers = headers_1.concat((0, browser_core_1.objectEntries)(tracingHeaders));
        }
      });
    },
    traceXhr: function traceXhr(context, xhr) {
      return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
        Object.keys(tracingHeaders).forEach(function (name) {
          xhr.setRequestHeader(name, tracingHeaders[name]);
        });
      });
    }
  };
}

exports.startTracer = startTracer;

function injectHeadersIfTracingAllowed(configuration, context, sessionManager, inject) {
  if (!isTracingSupported() || !isAllowedUrl(configuration, context.url) || !sessionManager.findTrackedSession()) {
    return;
  }

  context.traceId = new TraceIdentifier();
  context.spanId = new TraceIdentifier();
  context.traceSampled = !(0, browser_core_1.isNumber)(configuration.tracingSampleRate) || (0, browser_core_1.performDraw)(configuration.tracingSampleRate);
  inject(makeTracingHeaders(context.traceId, context.spanId, context.traceSampled));
}

function isAllowedUrl(configuration, requestUrl) {
  return (0, browser_core_1.matchList)(configuration.allowedTracingOrigins, (0, browser_core_1.getOrigin)(requestUrl));
}

function isTracingSupported() {
  return getCrypto() !== undefined;
}

exports.isTracingSupported = isTracingSupported;

function getCrypto() {
  return window.crypto || window.msCrypto;
}
/**
 * When trace is not sampled, set priority to '0' instead of not adding the tracing headers
 * to prepare the implementation for sampling delegation.
 */


function makeTracingHeaders(traceId, spanId, traceSampled) {
  return {
    'x-datadog-origin': 'rum',
    'x-datadog-parent-id': spanId.toDecimalString(),
    'x-datadog-sampling-priority': traceSampled ? '1' : '0',
    'x-datadog-trace-id': traceId.toDecimalString()
  };
}
/* eslint-disable no-bitwise */


var TraceIdentifier =
/** @class */
function () {
  function TraceIdentifier() {
    this.buffer = new Uint8Array(8);
    getCrypto().getRandomValues(this.buffer);
    this.buffer[0] = this.buffer[0] & 0x7f; // force 63-bit
  }

  TraceIdentifier.prototype.toString = function (radix) {
    var high = this.readInt32(0);
    var low = this.readInt32(4);
    var str = '';

    do {
      var mod = high % radix * 4294967296 + low;
      high = Math.floor(high / radix);
      low = Math.floor(mod / radix);
      str = (mod % radix).toString(radix) + str;
    } while (high || low);

    return str;
  };
  /**
   * Format used everywhere except the trace intake
   */


  TraceIdentifier.prototype.toDecimalString = function () {
    return this.toString(10);
  };

  TraceIdentifier.prototype.readInt32 = function (offset) {
    return this.buffer[offset] * 16777216 + (this.buffer[offset + 1] << 16) + (this.buffer[offset + 2] << 8) + this.buffer[offset + 3];
  };

  return TraceIdentifier;
}();

exports.TraceIdentifier = TraceIdentifier;
/* eslint-enable no-bitwise */

},{"@datadog/browser-core":32}],93:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackEventCounts = void 0;

var browser_core_1 = require("@datadog/browser-core");

function trackEventCounts(lifeCycle, callback) {
  if (callback === void 0) {
    callback = browser_core_1.noop;
  }

  var eventCounts = {
    errorCount: 0,
    longTaskCount: 0,
    resourceCount: 0,
    actionCount: 0,
    frustrationCount: 0
  };
  var subscription = lifeCycle.subscribe(11
  /* RUM_EVENT_COLLECTED */
  , function (event) {
    switch (event.type) {
      case "error"
      /* ERROR */
      :
        eventCounts.errorCount += 1;
        callback(eventCounts);
        break;

      case "action"
      /* ACTION */
      :
        eventCounts.actionCount += 1;

        if (event.action.frustration) {
          eventCounts.frustrationCount += event.action.frustration.type.length;
        }

        callback(eventCounts);
        break;

      case "long_task"
      /* LONG_TASK */
      :
        eventCounts.longTaskCount += 1;
        callback(eventCounts);
        break;

      case "resource"
      /* RESOURCE */
      :
        eventCounts.resourceCount += 1;
        callback(eventCounts);
        break;
    }
  });
  return {
    stop: function stop() {
      subscription.unsubscribe();
    },
    eventCounts: eventCounts
  };
}

exports.trackEventCounts = trackEventCounts;

},{"@datadog/browser-core":32}],94:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPageActivityObservable = exports.doWaitPageActivityEnd = exports.waitPageActivityEnd = exports.PAGE_ACTIVITY_END_DELAY = exports.PAGE_ACTIVITY_VALIDATION_DELAY = void 0;

var browser_core_1 = require("@datadog/browser-core"); // Delay to wait for a page activity to validate the tracking process


exports.PAGE_ACTIVITY_VALIDATION_DELAY = 100; // Delay to wait after a page activity to end the tracking process

exports.PAGE_ACTIVITY_END_DELAY = 100;
/**
 * Wait for the page activity end
 *
 * Detection lifecycle:
 * ```
 *                        Wait page activity end
 *              .-------------------'--------------------.
 *              v                                        v
 *     [Wait for a page activity ]          [Wait for a maximum duration]
 *     [timeout: VALIDATION_DELAY]          [  timeout: maxDuration     ]
 *          /                  \                           |
 *         v                    v                          |
 *  [No page activity]   [Page activity]                   |
 *         |                   |,----------------------.   |
 *         v                   v                       |   |
 *     (Discard)     [Wait for a page activity]        |   |
 *                   [   timeout: END_DELAY   ]        |   |
 *                       /                \            |   |
 *                      v                  v           |   |
 *             [No page activity]    [Page activity]   |   |
 *                      |                 |            |   |
 *                      |                 '------------'   |
 *                      '-----------. ,--------------------'
 *                                   v
 *                                 (End)
 * ```
 *
 * Note: by assuming that maxDuration is greater than VALIDATION_DELAY, we are sure that if the
 * process is still alive after maxDuration, it has been validated.
 */

function waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, pageActivityEndCallback, maxDuration) {
  var pageActivityObservable = createPageActivityObservable(lifeCycle, domMutationObservable, configuration);
  return doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration);
}

exports.waitPageActivityEnd = waitPageActivityEnd;

function doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration) {
  var pageActivityEndTimeoutId;
  var hasCompleted = false;
  var validationTimeoutId = setTimeout((0, browser_core_1.monitor)(function () {
    return complete({
      hadActivity: false
    });
  }), exports.PAGE_ACTIVITY_VALIDATION_DELAY);
  var maxDurationTimeoutId = maxDuration && setTimeout((0, browser_core_1.monitor)(function () {
    return complete({
      hadActivity: true,
      end: (0, browser_core_1.timeStampNow)()
    });
  }), maxDuration);
  var pageActivitySubscription = pageActivityObservable.subscribe(function (_a) {
    var isBusy = _a.isBusy;
    clearTimeout(validationTimeoutId);
    clearTimeout(pageActivityEndTimeoutId);
    var lastChangeTime = (0, browser_core_1.timeStampNow)();

    if (!isBusy) {
      pageActivityEndTimeoutId = setTimeout((0, browser_core_1.monitor)(function () {
        return complete({
          hadActivity: true,
          end: lastChangeTime
        });
      }), exports.PAGE_ACTIVITY_END_DELAY);
    }
  });

  var stop = function stop() {
    hasCompleted = true;
    clearTimeout(validationTimeoutId);
    clearTimeout(pageActivityEndTimeoutId);
    clearTimeout(maxDurationTimeoutId);
    pageActivitySubscription.unsubscribe();
  };

  function complete(event) {
    if (hasCompleted) {
      return;
    }

    stop();
    pageActivityEndCallback(event);
  }

  return {
    stop: stop
  };
}

exports.doWaitPageActivityEnd = doWaitPageActivityEnd;

function createPageActivityObservable(lifeCycle, domMutationObservable, configuration) {
  var observable = new browser_core_1.Observable(function () {
    var subscriptions = [];
    var firstRequestIndex;
    var pendingRequestsCount = 0;
    subscriptions.push(domMutationObservable.subscribe(notifyPageActivity), lifeCycle.subscribe(0
    /* PERFORMANCE_ENTRIES_COLLECTED */
    , function (entries) {
      if (entries.some(function (entry) {
        return entry.entryType === 'resource' && !isExcludedUrl(configuration, entry.name);
      })) {
        notifyPageActivity();
      }
    }), lifeCycle.subscribe(5
    /* REQUEST_STARTED */
    , function (startEvent) {
      if (isExcludedUrl(configuration, startEvent.url)) {
        return;
      }

      if (firstRequestIndex === undefined) {
        firstRequestIndex = startEvent.requestIndex;
      }

      pendingRequestsCount += 1;
      notifyPageActivity();
    }), lifeCycle.subscribe(6
    /* REQUEST_COMPLETED */
    , function (request) {
      if (isExcludedUrl(configuration, request.url) || firstRequestIndex === undefined || // If the request started before the tracking start, ignore it
      request.requestIndex < firstRequestIndex) {
        return;
      }

      pendingRequestsCount -= 1;
      notifyPageActivity();
    }));
    var stopTrackingWindowOpen = trackWindowOpen(notifyPageActivity).stop;
    return function () {
      stopTrackingWindowOpen();
      subscriptions.forEach(function (s) {
        return s.unsubscribe();
      });
    };

    function notifyPageActivity() {
      observable.notify({
        isBusy: pendingRequestsCount > 0
      });
    }
  });
  return observable;
}

exports.createPageActivityObservable = createPageActivityObservable;

function isExcludedUrl(configuration, requestUrl) {
  return (0, browser_core_1.matchList)(configuration.excludedActivityUrls, requestUrl);
}

function trackWindowOpen(callback) {
  return (0, browser_core_1.instrumentMethodAndCallOriginal)(window, 'open', {
    before: callback
  });
}

},{"@datadog/browser-core":32}],95:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = exports.getViewportDimension = exports.initViewportObservable = exports.getMutationObserverConstructor = exports.LifeCycle = exports.startRum = exports.makeRumPublicApi = void 0;

var rumPublicApi_1 = require("./boot/rumPublicApi");

Object.defineProperty(exports, "makeRumPublicApi", {
  enumerable: true,
  get: function get() {
    return rumPublicApi_1.makeRumPublicApi;
  }
});

var startRum_1 = require("./boot/startRum");

Object.defineProperty(exports, "startRum", {
  enumerable: true,
  get: function get() {
    return startRum_1.startRum;
  }
});

var lifeCycle_1 = require("./domain/lifeCycle");

Object.defineProperty(exports, "LifeCycle", {
  enumerable: true,
  get: function get() {
    return lifeCycle_1.LifeCycle;
  }
});

var domMutationObservable_1 = require("./browser/domMutationObservable");

Object.defineProperty(exports, "getMutationObserverConstructor", {
  enumerable: true,
  get: function get() {
    return domMutationObservable_1.getMutationObserverConstructor;
  }
});

var viewportObservable_1 = require("./browser/viewportObservable");

Object.defineProperty(exports, "initViewportObservable", {
  enumerable: true,
  get: function get() {
    return viewportObservable_1.initViewportObservable;
  }
});
Object.defineProperty(exports, "getViewportDimension", {
  enumerable: true,
  get: function get() {
    return viewportObservable_1.getViewportDimension;
  }
});

var getActionNameFromElement_1 = require("./domain/rumEventsCollection/action/getActionNameFromElement");

Object.defineProperty(exports, "DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE", {
  enumerable: true,
  get: function get() {
    return getActionNameFromElement_1.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE;
  }
});

},{"./boot/rumPublicApi":54,"./boot/startRum":55,"./browser/domMutationObservable":56,"./browser/viewportObservable":59,"./domain/lifeCycle":69,"./domain/rumEventsCollection/action/getActionNameFromElement":74}],96:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startRumBatch = void 0;

var browser_core_1 = require("@datadog/browser-core");

function startRumBatch(configuration, lifeCycle, telemetryEventObservable, reportError) {
  var batch = makeRumBatch(configuration, lifeCycle, reportError);
  lifeCycle.subscribe(11
  /* RUM_EVENT_COLLECTED */
  , function (serverRumEvent) {
    if (serverRumEvent.type === "view"
    /* VIEW */
    ) {
        batch.upsert(serverRumEvent, serverRumEvent.view.id);
      } else {
      batch.add(serverRumEvent);
    }
  });
  telemetryEventObservable.subscribe(function (event) {
    return batch.add(event, (0, browser_core_1.isTelemetryReplicationAllowed)(configuration));
  });
}

exports.startRumBatch = startRumBatch;

function makeRumBatch(configuration, lifeCycle, reportError) {
  var primaryBatch = createRumBatch(configuration.rumEndpointBuilder, true, function () {
    return lifeCycle.notify(9
    /* BEFORE_UNLOAD */
    );
  });
  var replicaBatch;
  var replica = configuration.replica;

  if (replica !== undefined) {
    replicaBatch = createRumBatch(replica.rumEndpointBuilder, false);
  }

  function createRumBatch(endpointBuilder, toPrimaryEndpoint, unloadCallback) {
    return new browser_core_1.Batch((0, browser_core_1.createHttpRequest)(endpointBuilder, configuration.batchBytesLimit, reportError, toPrimaryEndpoint), configuration.batchMessagesLimit, configuration.batchBytesLimit, configuration.messageBytesLimit, configuration.flushTimeout, unloadCallback);
  }

  function withReplicaApplicationId(message) {
    return (0, browser_core_1.combine)(message, {
      application: {
        id: replica.applicationId
      }
    });
  }

  return {
    add: function add(message, replicated) {
      if (replicated === void 0) {
        replicated = true;
      }

      primaryBatch.add(message);

      if (replicaBatch && replicated) {
        replicaBatch.add(withReplicaApplicationId(message));
      }
    },
    upsert: function upsert(message, key) {
      primaryBatch.upsert(message, key);

      if (replicaBatch) {
        replicaBatch.upsert(withReplicaApplicationId(message), key);
      }
    }
  };
}

},{"@datadog/browser-core":32}],97:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startRumEventBridge = void 0;

var browser_core_1 = require("@datadog/browser-core");

function startRumEventBridge(lifeCycle) {
  var bridge = (0, browser_core_1.getEventBridge)();
  lifeCycle.subscribe(11
  /* RUM_EVENT_COLLECTED */
  , function (serverRumEvent) {
    bridge.send('rum', serverRumEvent);
  });
}

exports.startRumEventBridge = startRumEventBridge;

},{"@datadog/browser-core":32}],98:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeRecorderApi = void 0;

var browser_core_1 = require("@datadog/browser-core");

var replayStats_1 = require("../domain/replayStats");

var segmentCollection_1 = require("../domain/segmentCollection");

function makeRecorderApi(startRecordingImpl, startDeflateWorkerImpl) {
  if (startDeflateWorkerImpl === void 0) {
    startDeflateWorkerImpl = segmentCollection_1.startDeflateWorker;
  }

  if ((0, browser_core_1.canUseEventBridge)() || !isBrowserSupported()) {
    return {
      start: browser_core_1.noop,
      stop: browser_core_1.noop,
      getReplayStats: function getReplayStats() {
        return undefined;
      },
      onRumStart: browser_core_1.noop,
      isRecording: function isRecording() {
        return false;
      }
    };
  }

  var state = {
    status: 0
    /* Stopped */

  };

  var startStrategy = function startStrategy() {
    state = {
      status: 1
      /* IntentToStart */

    };
  };

  var stopStrategy = function stopStrategy() {
    state = {
      status: 0
      /* Stopped */

    };
  };

  return {
    start: function start() {
      return startStrategy();
    },
    stop: function stop() {
      return stopStrategy();
    },
    getReplayStats: replayStats_1.getReplayStats,
    onRumStart: function onRumStart(lifeCycle, configuration, sessionManager, viewContexts) {
      lifeCycle.subscribe(7
      /* SESSION_EXPIRED */
      , function () {
        if (state.status === 2
        /* Starting */
        || state.status === 3
        /* Started */
        ) {
            stopStrategy();
            state = {
              status: 1
              /* IntentToStart */

            };
          }
      });
      lifeCycle.subscribe(8
      /* SESSION_RENEWED */
      , function () {
        if (state.status === 1
        /* IntentToStart */
        ) {
            startStrategy();
          }
      });

      startStrategy = function startStrategy() {
        var session = sessionManager.findTrackedSession();

        if (!session || !session.sessionReplayAllowed) {
          state = {
            status: 1
            /* IntentToStart */

          };
          return;
        }

        if (state.status === 2
        /* Starting */
        || state.status === 3
        /* Started */
        ) {
            return;
          }

        state = {
          status: 2
          /* Starting */

        };
        (0, browser_core_1.runOnReadyState)('interactive', function () {
          if (state.status !== 2
          /* Starting */
          ) {
              return;
            }

          startDeflateWorkerImpl(function (worker) {
            if (state.status !== 2
            /* Starting */
            ) {
                return;
              }

            if (!worker) {
              state = {
                status: 0
                /* Stopped */

              };
              return;
            }

            var stopRecording = startRecordingImpl(lifeCycle, configuration, sessionManager, viewContexts, worker).stop;
            state = {
              status: 3
              /* Started */
              ,
              stopRecording: stopRecording
            };
          });
        });
      };

      stopStrategy = function stopStrategy() {
        if (state.status === 0
        /* Stopped */
        ) {
            return;
          }

        if (state.status === 3
        /* Started */
        ) {
            state.stopRecording();
          }

        state = {
          status: 0
          /* Stopped */

        };
      };

      if (state.status === 1
      /* IntentToStart */
      ) {
          startStrategy();
        }
    },
    isRecording: function isRecording() {
      return state.status === 3
      /* Started */
      ;
    }
  };
}

exports.makeRecorderApi = makeRecorderApi;
/**
 * Test for Browser features used while recording
 */

function isBrowserSupported() {
  return (// Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from === 'function' && typeof CSSSupportsRule === 'function'
  );
}

},{"../domain/replayStats":112,"../domain/segmentCollection":114,"@datadog/browser-core":32}],99:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startRecording = void 0;

var browser_core_1 = require("@datadog/browser-core");

var record_1 = require("../domain/record");

var segmentCollection_1 = require("../domain/segmentCollection");

var send_1 = require("../transport/send");

var types_1 = require("../types");

function startRecording(lifeCycle, configuration, sessionManager, viewContexts, worker, httpRequest) {
  var reportError = function reportError(error) {
    lifeCycle.notify(12
    /* RAW_ERROR_COLLECTED */
    , {
      error: error
    });
  };

  var replayRequest = httpRequest || (0, browser_core_1.createHttpRequest)(configuration.sessionReplayEndpointBuilder, segmentCollection_1.SEGMENT_BYTES_LIMIT, reportError, true);

  var _a = (0, segmentCollection_1.startSegmentCollection)(lifeCycle, configuration.applicationId, sessionManager, viewContexts, function (data, metadata, rawSegmentBytesCount) {
    return (0, send_1.send)(replayRequest, data, metadata, rawSegmentBytesCount);
  }, worker),
      addRecord = _a.addRecord,
      stopSegmentCollection = _a.stop;

  var _b = (0, record_1.record)({
    emit: addRecord,
    configuration: configuration,
    lifeCycle: lifeCycle
  }),
      stopRecording = _b.stop,
      takeSubsequentFullSnapshot = _b.takeSubsequentFullSnapshot,
      flushMutations = _b.flushMutations;

  var unsubscribeViewEnded = lifeCycle.subscribe(4
  /* VIEW_ENDED */
  , function () {
    flushMutations();
    addRecord({
      timestamp: (0, browser_core_1.timeStampNow)(),
      type: types_1.RecordType.ViewEnd
    });
  }).unsubscribe;
  var unsubscribeViewCreated = lifeCycle.subscribe(2
  /* VIEW_CREATED */
  , function (view) {
    takeSubsequentFullSnapshot(view.startClocks.timeStamp);
  }).unsubscribe;
  return {
    stop: function stop() {
      unsubscribeViewEnded();
      unsubscribeViewCreated();
      stopRecording();
      stopSegmentCollection();
    }
  };
}

exports.startRecording = startRecording;

},{"../domain/record":102,"../domain/segmentCollection":114,"../transport/send":119,"../types":120,"@datadog/browser-core":32}],100:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FORM_PRIVATE_TAG_NAMES = exports.CENSORED_IMG_MARK = exports.CENSORED_STRING_MARK = exports.PRIVACY_CLASS_HIDDEN = exports.PRIVACY_CLASS_MASK_USER_INPUT = exports.PRIVACY_CLASS_MASK = exports.PRIVACY_CLASS_ALLOW = exports.PRIVACY_ATTR_VALUE_HIDDEN = exports.PRIVACY_ATTR_VALUE_MASK_USER_INPUT = exports.PRIVACY_ATTR_VALUE_MASK = exports.PRIVACY_ATTR_VALUE_ALLOW = exports.PRIVACY_ATTR_NAME = exports.NodePrivacyLevel = void 0;

var browser_core_1 = require("@datadog/browser-core");

exports.NodePrivacyLevel = {
  IGNORE: 'ignore',
  HIDDEN: 'hidden',
  ALLOW: browser_core_1.DefaultPrivacyLevel.ALLOW,
  MASK: browser_core_1.DefaultPrivacyLevel.MASK,
  MASK_USER_INPUT: browser_core_1.DefaultPrivacyLevel.MASK_USER_INPUT
};
exports.PRIVACY_ATTR_NAME = 'data-dd-privacy'; // Privacy Attrs

exports.PRIVACY_ATTR_VALUE_ALLOW = 'allow';
exports.PRIVACY_ATTR_VALUE_MASK = 'mask';
exports.PRIVACY_ATTR_VALUE_MASK_USER_INPUT = 'mask-user-input';
exports.PRIVACY_ATTR_VALUE_HIDDEN = 'hidden'; // Privacy Classes - not all customers can set plain HTML attributes, so support classes too

exports.PRIVACY_CLASS_ALLOW = 'dd-privacy-allow';
exports.PRIVACY_CLASS_MASK = 'dd-privacy-mask';
exports.PRIVACY_CLASS_MASK_USER_INPUT = 'dd-privacy-mask-user-input';
exports.PRIVACY_CLASS_HIDDEN = 'dd-privacy-hidden'; // Private Replacement Templates

exports.CENSORED_STRING_MARK = '***';
exports.CENSORED_IMG_MARK = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
exports.FORM_PRIVATE_TAG_NAMES = {
  INPUT: true,
  OUTPUT: true,
  TEXTAREA: true,
  SELECT: true,
  OPTION: true,
  DATALIST: true,
  OPTGROUP: true
};

},{"@datadog/browser-core":32}],101:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createElementsScrollPositions = void 0;

function createElementsScrollPositions() {
  var scrollPositionsByElement = new WeakMap();
  return {
    set: function set(element, scrollPositions) {
      if (element === document && !document.scrollingElement) {
        // cf https://drafts.csswg.org/cssom-view/#dom-document-scrollingelement,
        // in some cases scrolling elements can not be defined, we don't support those for now
        return;
      }

      scrollPositionsByElement.set(element === document ? document.scrollingElement : element, scrollPositions);
    },
    get: function get(element) {
      return scrollPositionsByElement.get(element);
    },
    has: function has(element) {
      return scrollPositionsByElement.has(element);
    }
  };
}

exports.createElementsScrollPositions = createElementsScrollPositions;

},{}],102:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createElementsScrollPositions = exports.serializeDocument = exports.serializeNodeWithId = exports.record = void 0;

var record_1 = require("./record");

Object.defineProperty(exports, "record", {
  enumerable: true,
  get: function get() {
    return record_1.record;
  }
});

var serialize_1 = require("./serialize");

Object.defineProperty(exports, "serializeNodeWithId", {
  enumerable: true,
  get: function get() {
    return serialize_1.serializeNodeWithId;
  }
});
Object.defineProperty(exports, "serializeDocument", {
  enumerable: true,
  get: function get() {
    return serialize_1.serializeDocument;
  }
});

var elementsScrollPositions_1 = require("./elementsScrollPositions");

Object.defineProperty(exports, "createElementsScrollPositions", {
  enumerable: true,
  get: function get() {
    return elementsScrollPositions_1.createElementsScrollPositions;
  }
});

},{"./elementsScrollPositions":101,"./record":107,"./serialize":109}],103:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMutationBatch = void 0;

var browser_core_1 = require("@datadog/browser-core");
/**
 * Maximum duration to wait before processing mutations. If the browser is idle, mutations will be
 * processed more quickly. If the browser is busy executing small tasks (ex: rendering frames), the
 * mutations will wait MUTATION_PROCESS_MAX_DELAY milliseconds before being processed. If the
 * browser is busy executing a longer task, mutations will be processed after this task.
 */


var MUTATION_PROCESS_MAX_DELAY = 100;

function createMutationBatch(processMutationBatch) {
  var cancelScheduledFlush = browser_core_1.noop;
  var pendingMutations = [];

  function flush() {
    cancelScheduledFlush();
    processMutationBatch(pendingMutations);
    pendingMutations = [];
  }

  return {
    addMutations: function addMutations(mutations) {
      if (pendingMutations.length === 0) {
        cancelScheduledFlush = (0, browser_core_1.requestIdleCallback)(flush, {
          timeout: MUTATION_PROCESS_MAX_DELAY
        });
      }

      pendingMutations.push.apply(pendingMutations, mutations);
    },
    flush: flush,
    stop: function stop() {
      cancelScheduledFlush();
    }
  };
}

exports.createMutationBatch = createMutationBatch;

},{"@datadog/browser-core":32}],104:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortAddedAndMovedNodes = exports.MutationController = exports.startMutationObserver = void 0;

var browser_core_1 = require("@datadog/browser-core");

var browser_rum_core_1 = require("@datadog/browser-rum-core");

var constants_1 = require("../../constants");

var privacy_1 = require("./privacy");

var serializationUtils_1 = require("./serializationUtils");

var serialize_1 = require("./serialize");

var utils_1 = require("./utils");

var mutationBatch_1 = require("./mutationBatch");
/**
 * Buffers and aggregate mutations generated by a MutationObserver into MutationPayload
 */


function startMutationObserver(controller, mutationCallback, configuration) {
  var MutationObserver = (0, browser_rum_core_1.getMutationObserverConstructor)();

  if (!MutationObserver) {
    return {
      stop: browser_core_1.noop
    };
  }

  var mutationBatch = (0, mutationBatch_1.createMutationBatch)(function (mutations) {
    processMutations(mutations.concat(observer.takeRecords()), mutationCallback, configuration);
  });
  var observer = new MutationObserver((0, browser_core_1.monitor)(mutationBatch.addMutations));
  observer.observe(document, {
    attributeOldValue: true,
    attributes: true,
    characterData: true,
    characterDataOldValue: true,
    childList: true,
    subtree: true
  });
  controller.onFlush(mutationBatch.flush);
  return {
    stop: function stop() {
      observer.disconnect();
      mutationBatch.stop();
    }
  };
}

exports.startMutationObserver = startMutationObserver;
/**
 * Controls how mutations are processed, allowing to flush pending mutations.
 */

var MutationController =
/** @class */
function () {
  function MutationController() {}

  MutationController.prototype.flush = function () {
    var _a;

    (_a = this.flushListener) === null || _a === void 0 ? void 0 : _a.call(this);
  };

  MutationController.prototype.onFlush = function (listener) {
    this.flushListener = listener;
  };

  return MutationController;
}();

exports.MutationController = MutationController;

function processMutations(mutations, mutationCallback, configuration) {
  // Discard any mutation with a 'target' node that:
  // * isn't injected in the current document or isn't known/serialized yet: those nodes are likely
  // part of a mutation occurring in a parent Node
  // * should be hidden or ignored
  var filteredMutations = mutations.filter(function (mutation) {
    return document.contains(mutation.target) && (0, serializationUtils_1.nodeAndAncestorsHaveSerializedNode)(mutation.target) && (0, privacy_1.getNodePrivacyLevel)(mutation.target, configuration.defaultPrivacyLevel) !== constants_1.NodePrivacyLevel.HIDDEN;
  });

  var _a = processChildListMutations(filteredMutations.filter(function (mutation) {
    return mutation.type === 'childList';
  }), configuration),
      adds = _a.adds,
      removes = _a.removes,
      hasBeenSerialized = _a.hasBeenSerialized;

  var texts = processCharacterDataMutations(filteredMutations.filter(function (mutation) {
    return mutation.type === 'characterData' && !hasBeenSerialized(mutation.target);
  }), configuration);
  var attributes = processAttributesMutations(filteredMutations.filter(function (mutation) {
    return mutation.type === 'attributes' && !hasBeenSerialized(mutation.target);
  }), configuration);

  if (!texts.length && !attributes.length && !removes.length && !adds.length) {
    return;
  }

  mutationCallback({
    adds: adds,
    removes: removes,
    texts: texts,
    attributes: attributes
  });
}

function processChildListMutations(mutations, configuration) {
  // First, we iterate over mutations to collect:
  //
  // * nodes that have been added in the document and not removed by a subsequent mutation
  // * nodes that have been removed from the document but were not added in a previous mutation
  //
  // For this second category, we also collect their previous parent (mutation.target) because we'll
  // need it to emit a 'remove' mutation.
  //
  // Those two categories may overlap: if a node moved from a position to another, it is reported as
  // two mutation records, one with a "removedNodes" and the other with "addedNodes". In this case,
  // the node will be in both sets.
  var addedAndMovedNodes = new Set();
  var removedNodes = new Map();

  var _loop_1 = function _loop_1(mutation) {
    (0, utils_1.forEach)(mutation.addedNodes, function (node) {
      addedAndMovedNodes.add(node);
    });
    (0, utils_1.forEach)(mutation.removedNodes, function (node) {
      if (!addedAndMovedNodes.has(node)) {
        removedNodes.set(node, mutation.target);
      }

      addedAndMovedNodes["delete"](node);
    });
  };

  for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
    var mutation = mutations_1[_i];

    _loop_1(mutation);
  } // Then, we sort nodes that are still in the document by topological order, for two reasons:
  //
  // * We will serialize each added nodes with their descendants. We don't want to serialize a node
  // twice, so we need to iterate over the parent nodes first and skip any node that is contained in
  // a precedent node.
  //
  // * To emit "add" mutations, we need references to the parent and potential next sibling of each
  // added node. So we need to iterate over the parent nodes first, and when multiple nodes are
  // siblings, we want to iterate from last to first. This will ensure that any "next" node is
  // already serialized and have an id.


  var sortedAddedAndMovedNodes = Array.from(addedAndMovedNodes);
  sortAddedAndMovedNodes(sortedAddedAndMovedNodes); // Then, we iterate over our sorted node sets to emit mutations. We collect the newly serialized
  // node ids in a set to be able to skip subsequent related mutations.

  var serializedNodeIds = new Set();
  var addedNodeMutations = [];

  for (var _a = 0, sortedAddedAndMovedNodes_1 = sortedAddedAndMovedNodes; _a < sortedAddedAndMovedNodes_1.length; _a++) {
    var node = sortedAddedAndMovedNodes_1[_a];

    if (hasBeenSerialized(node)) {
      continue;
    }

    var parentNodePrivacyLevel = (0, privacy_1.getNodePrivacyLevel)(node.parentNode, configuration.defaultPrivacyLevel);

    if (parentNodePrivacyLevel === constants_1.NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === constants_1.NodePrivacyLevel.IGNORE) {
      continue;
    }

    var serializedNode = (0, serialize_1.serializeNodeWithId)(node, {
      serializedNodeIds: serializedNodeIds,
      parentNodePrivacyLevel: parentNodePrivacyLevel,
      serializationContext: {
        status: 2
        /* MUTATION */

      },
      configuration: configuration
    });

    if (!serializedNode) {
      continue;
    }

    addedNodeMutations.push({
      nextId: getNextSibling(node),
      parentId: (0, serializationUtils_1.getSerializedNodeId)(node.parentNode),
      node: serializedNode
    });
  } // Finally, we emit remove mutations.


  var removedNodeMutations = [];
  removedNodes.forEach(function (parent, node) {
    if ((0, serializationUtils_1.hasSerializedNode)(node)) {
      removedNodeMutations.push({
        parentId: (0, serializationUtils_1.getSerializedNodeId)(parent),
        id: (0, serializationUtils_1.getSerializedNodeId)(node)
      });
    }
  });
  return {
    adds: addedNodeMutations,
    removes: removedNodeMutations,
    hasBeenSerialized: hasBeenSerialized
  };

  function hasBeenSerialized(node) {
    return (0, serializationUtils_1.hasSerializedNode)(node) && serializedNodeIds.has((0, serializationUtils_1.getSerializedNodeId)(node));
  }

  function getNextSibling(node) {
    var nextSibling = node.nextSibling;

    while (nextSibling) {
      if ((0, serializationUtils_1.hasSerializedNode)(nextSibling)) {
        return (0, serializationUtils_1.getSerializedNodeId)(nextSibling);
      }

      nextSibling = nextSibling.nextSibling;
    }

    return null;
  }
}

function processCharacterDataMutations(mutations, configuration) {
  var _a;

  var textMutations = []; // Deduplicate mutations based on their target node

  var handledNodes = new Set();
  var filteredMutations = mutations.filter(function (mutation) {
    if (handledNodes.has(mutation.target)) {
      return false;
    }

    handledNodes.add(mutation.target);
    return true;
  }); // Emit mutations

  for (var _i = 0, filteredMutations_1 = filteredMutations; _i < filteredMutations_1.length; _i++) {
    var mutation = filteredMutations_1[_i];
    var value = mutation.target.textContent;

    if (value === mutation.oldValue) {
      continue;
    }

    var parentNodePrivacyLevel = (0, privacy_1.getNodePrivacyLevel)(mutation.target.parentNode, configuration.defaultPrivacyLevel);

    if (parentNodePrivacyLevel === constants_1.NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === constants_1.NodePrivacyLevel.IGNORE) {
      continue;
    }

    textMutations.push({
      id: (0, serializationUtils_1.getSerializedNodeId)(mutation.target),
      // TODO: pass a valid "ignoreWhiteSpace" argument
      value: (_a = (0, privacy_1.getTextContent)(mutation.target, false, parentNodePrivacyLevel)) !== null && _a !== void 0 ? _a : null
    });
  }

  return textMutations;
}

function processAttributesMutations(mutations, configuration) {
  var attributeMutations = []; // Deduplicate mutations based on their target node and changed attribute

  var handledElements = new Map();
  var filteredMutations = mutations.filter(function (mutation) {
    var handledAttributes = handledElements.get(mutation.target);

    if (handledAttributes === null || handledAttributes === void 0 ? void 0 : handledAttributes.has(mutation.attributeName)) {
      return false;
    }

    if (!handledAttributes) {
      handledElements.set(mutation.target, new Set([mutation.attributeName]));
    } else {
      handledAttributes.add(mutation.attributeName);
    }

    return true;
  }); // Emit mutations

  var emittedMutations = new Map();

  for (var _i = 0, filteredMutations_2 = filteredMutations; _i < filteredMutations_2.length; _i++) {
    var mutation = filteredMutations_2[_i];
    var uncensoredValue = mutation.target.getAttribute(mutation.attributeName);

    if (uncensoredValue === mutation.oldValue) {
      continue;
    }

    var privacyLevel = (0, privacy_1.getNodePrivacyLevel)(mutation.target, configuration.defaultPrivacyLevel);
    var attributeValue = (0, serialize_1.serializeAttribute)(mutation.target, privacyLevel, mutation.attributeName, configuration);
    var transformedValue = void 0;

    if (mutation.attributeName === 'value') {
      var inputValue = (0, serializationUtils_1.getElementInputValue)(mutation.target, privacyLevel);

      if (inputValue === undefined) {
        continue;
      }

      transformedValue = inputValue;
    } else if (typeof attributeValue === 'string') {
      transformedValue = attributeValue;
    } else {
      transformedValue = null;
    }

    var emittedMutation = emittedMutations.get(mutation.target);

    if (!emittedMutation) {
      emittedMutation = {
        id: (0, serializationUtils_1.getSerializedNodeId)(mutation.target),
        attributes: {}
      };
      attributeMutations.push(emittedMutation);
      emittedMutations.set(mutation.target, emittedMutation);
    }

    emittedMutation.attributes[mutation.attributeName] = transformedValue;
  }

  return attributeMutations;
}

function sortAddedAndMovedNodes(nodes) {
  nodes.sort(function (a, b) {
    var position = a.compareDocumentPosition(b);
    /* eslint-disable no-bitwise */

    if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
      return -1;
    } else if (position & Node.DOCUMENT_POSITION_CONTAINS) {
      return 1;
    } else if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
      return 1;
    } else if (position & Node.DOCUMENT_POSITION_PRECEDING) {
      return -1;
    }
    /* eslint-enable no-bitwise */


    return 0;
  });
}

exports.sortAddedAndMovedNodes = sortAddedAndMovedNodes;

},{"../../constants":100,"./mutationBatch":103,"./privacy":106,"./serializationUtils":108,"./serialize":109,"./utils":110,"@datadog/browser-core":32,"@datadog/browser-rum-core":95}],105:[function(require,module,exports){
"use strict";

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initFrustrationObserver = exports.initStyleSheetObserver = exports.initInputObserver = exports.initObservers = void 0;

var browser_core_1 = require("@datadog/browser-core");

var browser_rum_core_1 = require("@datadog/browser-rum-core");

var constants_1 = require("../../constants");

var types_1 = require("../../types");

var privacy_1 = require("./privacy");

var serializationUtils_1 = require("./serializationUtils");

var utils_1 = require("./utils");

var mutationObserver_1 = require("./mutationObserver");

var viewports_1 = require("./viewports");

var MOUSE_MOVE_OBSERVER_THRESHOLD = 50;
var SCROLL_OBSERVER_THRESHOLD = 100;
var VISUAL_VIEWPORT_OBSERVER_THRESHOLD = 200;
var recordIds = new WeakMap();
var nextId = 1;

function getRecordIdForEvent(event) {
  if (!recordIds.has(event)) {
    recordIds.set(event, nextId++);
  }

  return recordIds.get(event);
}

function initObservers(o) {
  var mutationHandler = initMutationObserver(o.mutationController, o.mutationCb, o.configuration);
  var mousemoveHandler = initMoveObserver(o.mousemoveCb);
  var mouseInteractionHandler = initMouseInteractionObserver(o.mouseInteractionCb, o.configuration.defaultPrivacyLevel);
  var scrollHandler = initScrollObserver(o.scrollCb, o.configuration.defaultPrivacyLevel, o.elementsScrollPositions);
  var viewportResizeHandler = initViewportResizeObserver(o.viewportResizeCb);
  var inputHandler = initInputObserver(o.inputCb, o.configuration.defaultPrivacyLevel);
  var mediaInteractionHandler = initMediaInteractionObserver(o.mediaInteractionCb, o.configuration.defaultPrivacyLevel);
  var styleSheetObserver = initStyleSheetObserver(o.styleSheetCb);
  var focusHandler = initFocusObserver(o.focusCb);
  var visualViewportResizeHandler = initVisualViewportResizeObserver(o.visualViewportResizeCb);
  var frustrationHandler = initFrustrationObserver(o.lifeCycle, o.frustrationCb);
  return function () {
    mutationHandler();
    mousemoveHandler();
    mouseInteractionHandler();
    scrollHandler();
    viewportResizeHandler();
    inputHandler();
    mediaInteractionHandler();
    styleSheetObserver();
    focusHandler();
    visualViewportResizeHandler();
    frustrationHandler();
  };
}

exports.initObservers = initObservers;

function initMutationObserver(mutationController, cb, configuration) {
  return (0, mutationObserver_1.startMutationObserver)(mutationController, cb, configuration).stop;
}

function initMoveObserver(cb) {
  var updatePosition = (0, browser_core_1.throttle)((0, browser_core_1.monitor)(function (event) {
    var target = event.target;

    if ((0, serializationUtils_1.hasSerializedNode)(target)) {
      var _a = (0, utils_1.isTouchEvent)(event) ? event.changedTouches[0] : event,
          clientX = _a.clientX,
          clientY = _a.clientY;

      var position = {
        id: (0, serializationUtils_1.getSerializedNodeId)(target),
        timeOffset: 0,
        x: clientX,
        y: clientY
      };

      if (window.visualViewport) {
        var _b = (0, viewports_1.convertMouseEventToLayoutCoordinates)(clientX, clientY),
            visualViewportX = _b.visualViewportX,
            visualViewportY = _b.visualViewportY;

        position.x = visualViewportX;
        position.y = visualViewportY;
      }

      cb([position], (0, utils_1.isTouchEvent)(event) ? types_1.IncrementalSource.TouchMove : types_1.IncrementalSource.MouseMove);
    }
  }), MOUSE_MOVE_OBSERVER_THRESHOLD, {
    trailing: false
  }).throttled;
  return (0, browser_core_1.addEventListeners)(document, ["mousemove"
  /* MOUSE_MOVE */
  , "touchmove"
  /* TOUCH_MOVE */
  ], updatePosition, {
    capture: true,
    passive: true
  }).stop;
}

var eventTypeToMouseInteraction = (_a = {}, _a["mouseup"
/* MOUSE_UP */
] = types_1.MouseInteractionType.MouseUp, _a["mousedown"
/* MOUSE_DOWN */
] = types_1.MouseInteractionType.MouseDown, _a["click"
/* CLICK */
] = types_1.MouseInteractionType.Click, _a["contextmenu"
/* CONTEXT_MENU */
] = types_1.MouseInteractionType.ContextMenu, _a["dblclick"
/* DBL_CLICK */
] = types_1.MouseInteractionType.DblClick, _a["focus"
/* FOCUS */
] = types_1.MouseInteractionType.Focus, _a["blur"
/* BLUR */
] = types_1.MouseInteractionType.Blur, _a["touchstart"
/* TOUCH_START */
] = types_1.MouseInteractionType.TouchStart, _a["touchend"
/* TOUCH_END */
] = types_1.MouseInteractionType.TouchEnd, _a);

function initMouseInteractionObserver(cb, defaultPrivacyLevel) {
  var handler = function handler(event) {
    var target = event.target;

    if ((0, privacy_1.getNodePrivacyLevel)(target, defaultPrivacyLevel) === constants_1.NodePrivacyLevel.HIDDEN || !(0, serializationUtils_1.hasSerializedNode)(target)) {
      return;
    }

    var _a = (0, utils_1.isTouchEvent)(event) ? event.changedTouches[0] : event,
        clientX = _a.clientX,
        clientY = _a.clientY;

    var position = {
      id: (0, serializationUtils_1.getSerializedNodeId)(target),
      type: eventTypeToMouseInteraction[event.type],
      x: clientX,
      y: clientY
    };

    if (window.visualViewport) {
      var _b = (0, viewports_1.convertMouseEventToLayoutCoordinates)(clientX, clientY),
          visualViewportX = _b.visualViewportX,
          visualViewportY = _b.visualViewportY;

      position.x = visualViewportX;
      position.y = visualViewportY;
    }

    var record = (0, browser_core_1.assign)({
      id: getRecordIdForEvent(event)
    }, (0, utils_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.MouseInteraction, position));
    cb(record);
  };

  return (0, browser_core_1.addEventListeners)(document, Object.keys(eventTypeToMouseInteraction), handler, {
    capture: true,
    passive: true
  }).stop;
}

function initScrollObserver(cb, defaultPrivacyLevel, elementsScrollPositions) {
  var updatePosition = (0, browser_core_1.throttle)((0, browser_core_1.monitor)(function (event) {
    var target = event.target;

    if (!target || (0, privacy_1.getNodePrivacyLevel)(target, defaultPrivacyLevel) === constants_1.NodePrivacyLevel.HIDDEN || !(0, serializationUtils_1.hasSerializedNode)(target)) {
      return;
    }

    var id = (0, serializationUtils_1.getSerializedNodeId)(target);
    var scrollPositions = target === document ? {
      scrollTop: (0, viewports_1.getScrollY)(),
      scrollLeft: (0, viewports_1.getScrollX)()
    } : {
      scrollTop: Math.round(target.scrollTop),
      scrollLeft: Math.round(target.scrollLeft)
    };
    elementsScrollPositions.set(target, scrollPositions);
    cb({
      id: id,
      x: scrollPositions.scrollLeft,
      y: scrollPositions.scrollTop
    });
  }), SCROLL_OBSERVER_THRESHOLD).throttled;
  return (0, browser_core_1.addEventListener)(document, "scroll"
  /* SCROLL */
  , updatePosition, {
    capture: true,
    passive: true
  }).stop;
}

function initViewportResizeObserver(cb) {
  return (0, browser_rum_core_1.initViewportObservable)().subscribe(cb).unsubscribe;
}

function initInputObserver(cb, defaultPrivacyLevel) {
  var lastInputStateMap = new WeakMap();

  function onElementChange(target) {
    var nodePrivacyLevel = (0, privacy_1.getNodePrivacyLevel)(target, defaultPrivacyLevel);

    if (nodePrivacyLevel === constants_1.NodePrivacyLevel.HIDDEN) {
      return;
    }

    var type = target.type;
    var inputState;

    if (type === 'radio' || type === 'checkbox') {
      if ((0, privacy_1.shouldMaskNode)(target, nodePrivacyLevel)) {
        return;
      }

      inputState = {
        isChecked: target.checked
      };
    } else {
      var value = (0, serializationUtils_1.getElementInputValue)(target, nodePrivacyLevel);

      if (value === undefined) {
        return;
      }

      inputState = {
        text: value
      };
    } // Can be multiple changes on the same node within the same batched mutation observation.


    cbWithDedup(target, inputState); // If a radio was checked, other radios with the same name attribute will be unchecked.

    var name = target.name;

    if (type === 'radio' && name && target.checked) {
      (0, utils_1.forEach)(document.querySelectorAll("input[type=\"radio\"][name=\"".concat(name, "\"]")), function (el) {
        if (el !== target) {
          // TODO: Consider the privacy implications for various differing input privacy levels
          cbWithDedup(el, {
            isChecked: false
          });
        }
      });
    }
  }
  /**
   * There can be multiple changes on the same node within the same batched mutation observation.
   */


  function cbWithDedup(target, inputState) {
    if (!(0, serializationUtils_1.hasSerializedNode)(target)) {
      return;
    }

    var lastInputState = lastInputStateMap.get(target);

    if (!lastInputState || lastInputState.text !== inputState.text || lastInputState.isChecked !== inputState.isChecked) {
      lastInputStateMap.set(target, inputState);
      cb((0, browser_core_1.assign)({
        id: (0, serializationUtils_1.getSerializedNodeId)(target)
      }, inputState));
    }
  }

  var stopEventListeners = (0, browser_core_1.addEventListeners)(document, ["input"
  /* INPUT */
  , "change"
  /* CHANGE */
  ], function (event) {
    if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement || event.target instanceof HTMLSelectElement) {
      onElementChange(event.target);
    }
  }, {
    capture: true,
    passive: true
  }).stop;
  var instrumentationStoppers = [(0, browser_core_1.instrumentSetter)(HTMLInputElement.prototype, 'value', onElementChange), (0, browser_core_1.instrumentSetter)(HTMLInputElement.prototype, 'checked', onElementChange), (0, browser_core_1.instrumentSetter)(HTMLSelectElement.prototype, 'value', onElementChange), (0, browser_core_1.instrumentSetter)(HTMLTextAreaElement.prototype, 'value', onElementChange), (0, browser_core_1.instrumentSetter)(HTMLSelectElement.prototype, 'selectedIndex', onElementChange)];
  return function () {
    instrumentationStoppers.forEach(function (stopper) {
      return stopper.stop();
    });
    stopEventListeners();
  };
}

exports.initInputObserver = initInputObserver;

function initStyleSheetObserver(cb) {
  function checkStyleSheetAndCallback(styleSheet, callback) {
    if (styleSheet && (0, serializationUtils_1.hasSerializedNode)(styleSheet.ownerNode)) {
      callback((0, serializationUtils_1.getSerializedNodeId)(styleSheet.ownerNode));
    }
  }

  var instrumentationStoppers = [(0, browser_core_1.instrumentMethodAndCallOriginal)(CSSStyleSheet.prototype, 'insertRule', {
    before: function before(rule, index) {
      checkStyleSheetAndCallback(this, function (id) {
        return cb({
          id: id,
          adds: [{
            rule: rule,
            index: index
          }]
        });
      });
    }
  }), (0, browser_core_1.instrumentMethodAndCallOriginal)(CSSStyleSheet.prototype, 'deleteRule', {
    before: function before(index) {
      checkStyleSheetAndCallback(this, function (id) {
        return cb({
          id: id,
          removes: [{
            index: index
          }]
        });
      });
    }
  })];

  if (typeof CSSGroupingRule !== 'undefined') {
    instrumentGroupingCSSRuleClass(CSSGroupingRule);
  } else {
    instrumentGroupingCSSRuleClass(CSSMediaRule);
    instrumentGroupingCSSRuleClass(CSSSupportsRule);
  }

  function instrumentGroupingCSSRuleClass(cls) {
    instrumentationStoppers.push((0, browser_core_1.instrumentMethodAndCallOriginal)(cls.prototype, 'insertRule', {
      before: function before(rule, index) {
        var _this = this;

        checkStyleSheetAndCallback(this.parentStyleSheet, function (id) {
          var path = (0, utils_1.getPathToNestedCSSRule)(_this);

          if (path) {
            path.push(index || 0);
            cb({
              id: id,
              adds: [{
                rule: rule,
                index: path
              }]
            });
          }
        });
      }
    }), (0, browser_core_1.instrumentMethodAndCallOriginal)(cls.prototype, 'deleteRule', {
      before: function before(index) {
        var _this = this;

        checkStyleSheetAndCallback(this.parentStyleSheet, function (id) {
          var path = (0, utils_1.getPathToNestedCSSRule)(_this);

          if (path) {
            path.push(index);
            cb({
              id: id,
              removes: [{
                index: path
              }]
            });
          }
        });
      }
    }));
  }

  return function () {
    return instrumentationStoppers.forEach(function (stopper) {
      return stopper.stop();
    });
  };
}

exports.initStyleSheetObserver = initStyleSheetObserver;

function initMediaInteractionObserver(mediaInteractionCb, defaultPrivacyLevel) {
  var handler = function handler(event) {
    var target = event.target;

    if (!target || (0, privacy_1.getNodePrivacyLevel)(target, defaultPrivacyLevel) === constants_1.NodePrivacyLevel.HIDDEN || !(0, serializationUtils_1.hasSerializedNode)(target)) {
      return;
    }

    mediaInteractionCb({
      id: (0, serializationUtils_1.getSerializedNodeId)(target),
      type: event.type === "play"
      /* PLAY */
      ? types_1.MediaInteractionType.Play : types_1.MediaInteractionType.Pause
    });
  };

  return (0, browser_core_1.addEventListeners)(document, ["play"
  /* PLAY */
  , "pause"
  /* PAUSE */
  ], handler, {
    capture: true,
    passive: true
  }).stop;
}

function initFocusObserver(focusCb) {
  return (0, browser_core_1.addEventListeners)(window, ["focus"
  /* FOCUS */
  , "blur"
  /* BLUR */
  ], function () {
    focusCb({
      has_focus: document.hasFocus()
    });
  }).stop;
}

function initVisualViewportResizeObserver(cb) {
  if (!window.visualViewport) {
    return browser_core_1.noop;
  }

  var _a = (0, browser_core_1.throttle)((0, browser_core_1.monitor)(function () {
    cb((0, viewports_1.getVisualViewport)());
  }), VISUAL_VIEWPORT_OBSERVER_THRESHOLD, {
    trailing: false
  }),
      updateDimension = _a.throttled,
      cancelThrottle = _a.cancel;

  var removeListener = (0, browser_core_1.addEventListeners)(window.visualViewport, ["resize"
  /* RESIZE */
  , "scroll"
  /* SCROLL */
  ], updateDimension, {
    capture: true,
    passive: true
  }).stop;
  return function stop() {
    removeListener();
    cancelThrottle();
  };
}

function initFrustrationObserver(lifeCycle, frustrationCb) {
  return lifeCycle.subscribe(10
  /* RAW_RUM_EVENT_COLLECTED */
  , function (data) {
    var _a, _b, _c;

    if (data.rawRumEvent.type === "action"
    /* ACTION */
    && data.rawRumEvent.action.type === "click"
    /* CLICK */
    && ((_b = (_a = data.rawRumEvent.action.frustration) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.length) && 'events' in data.domainContext && ((_c = data.domainContext.events) === null || _c === void 0 ? void 0 : _c.length)) {
      frustrationCb({
        timestamp: data.rawRumEvent.date,
        type: types_1.RecordType.FrustrationRecord,
        data: {
          frustrationTypes: data.rawRumEvent.action.frustration.type,
          recordIds: data.domainContext.events.map(function (e) {
            return getRecordIdForEvent(e);
          })
        }
      });
    }
  }).unsubscribe;
}

exports.initFrustrationObserver = initFrustrationObserver;

},{"../../constants":100,"../../types":120,"./mutationObserver":104,"./privacy":106,"./serializationUtils":108,"./utils":110,"./viewports":111,"@datadog/browser-core":32,"@datadog/browser-rum-core":95}],106:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldIgnoreElement = exports.getTextContent = exports.censorText = exports.shouldMaskNode = exports.getNodeSelfPrivacyLevel = exports.reducePrivacyLevel = exports.getNodePrivacyLevel = exports.MAX_ATTRIBUTE_VALUE_CHAR_LENGTH = void 0;

var constants_1 = require("../../constants");

exports.MAX_ATTRIBUTE_VALUE_CHAR_LENGTH = 100000;
var TEXT_MASKING_CHAR = 'x';
/**
 * Get node privacy level by iterating over its ancestors. When the direct parent privacy level is
 * know, it is best to use something like:
 *
 * derivePrivacyLevelGivenParent(getNodeSelfPrivacyLevel(node), parentNodePrivacyLevel)
 */

function getNodePrivacyLevel(node, defaultPrivacyLevel) {
  var parentNodePrivacyLevel = node.parentNode ? getNodePrivacyLevel(node.parentNode, defaultPrivacyLevel) : defaultPrivacyLevel;
  var selfNodePrivacyLevel = getNodeSelfPrivacyLevel(node);
  return reducePrivacyLevel(selfNodePrivacyLevel, parentNodePrivacyLevel);
}

exports.getNodePrivacyLevel = getNodePrivacyLevel;
/**
 * Reduces the next privacy level based on self + parent privacy levels
 */

function reducePrivacyLevel(childPrivacyLevel, parentNodePrivacyLevel) {
  switch (parentNodePrivacyLevel) {
    // These values cannot be overridden
    case constants_1.NodePrivacyLevel.HIDDEN:
    case constants_1.NodePrivacyLevel.IGNORE:
      return parentNodePrivacyLevel;
  }

  switch (childPrivacyLevel) {
    case constants_1.NodePrivacyLevel.ALLOW:
    case constants_1.NodePrivacyLevel.MASK:
    case constants_1.NodePrivacyLevel.MASK_USER_INPUT:
    case constants_1.NodePrivacyLevel.HIDDEN:
    case constants_1.NodePrivacyLevel.IGNORE:
      return childPrivacyLevel;

    default:
      return parentNodePrivacyLevel;
  }
}

exports.reducePrivacyLevel = reducePrivacyLevel;
/**
 * Determines the node's own privacy level without checking for ancestors.
 */

function getNodeSelfPrivacyLevel(node) {
  // Only Element types can have a privacy level set
  if (!isElement(node)) {
    return;
  }

  var privAttr = node.getAttribute(constants_1.PRIVACY_ATTR_NAME); // Overrules for replay purpose

  if (node.tagName === 'BASE') {
    return constants_1.NodePrivacyLevel.ALLOW;
  } // Overrules to enforce end-user protection


  if (node.tagName === 'INPUT') {
    var inputElement = node;

    if (inputElement.type === 'password' || inputElement.type === 'email' || inputElement.type === 'tel') {
      return constants_1.NodePrivacyLevel.MASK;
    }

    if (inputElement.type === 'hidden') {
      return constants_1.NodePrivacyLevel.MASK;
    }

    var autocomplete = inputElement.getAttribute('autocomplete'); // Handle input[autocomplete=cc-number/cc-csc/cc-exp/cc-exp-month/cc-exp-year]

    if (autocomplete && autocomplete.indexOf('cc-') === 0) {
      return constants_1.NodePrivacyLevel.MASK;
    }
  } // Check HTML privacy attributes and classes


  if (privAttr === constants_1.PRIVACY_ATTR_VALUE_HIDDEN || node.classList.contains(constants_1.PRIVACY_CLASS_HIDDEN)) {
    return constants_1.NodePrivacyLevel.HIDDEN;
  }

  if (privAttr === constants_1.PRIVACY_ATTR_VALUE_MASK || node.classList.contains(constants_1.PRIVACY_CLASS_MASK)) {
    return constants_1.NodePrivacyLevel.MASK;
  }

  if (privAttr === constants_1.PRIVACY_ATTR_VALUE_MASK_USER_INPUT || node.classList.contains(constants_1.PRIVACY_CLASS_MASK_USER_INPUT)) {
    return constants_1.NodePrivacyLevel.MASK_USER_INPUT;
  }

  if (privAttr === constants_1.PRIVACY_ATTR_VALUE_ALLOW || node.classList.contains(constants_1.PRIVACY_CLASS_ALLOW)) {
    return constants_1.NodePrivacyLevel.ALLOW;
  }

  if (shouldIgnoreElement(node)) {
    return constants_1.NodePrivacyLevel.IGNORE;
  }
}

exports.getNodeSelfPrivacyLevel = getNodeSelfPrivacyLevel;
/**
 * Helper aiming to unify `mask` and `mask-user-input` privacy levels:
 *
 * In the `mask` case, it is trivial: we should mask the element.
 *
 * In the `mask-user-input` case, we should mask the element only if it is a "form" element or the
 * direct parent is a form element for text nodes).
 *
 * Other `shouldMaskNode` cases are edge cases that should not matter too much (ex: should we mask a
 * node if it is ignored or hidden? it doesn't matter since it won't be serialized).
 */

function shouldMaskNode(node, privacyLevel) {
  switch (privacyLevel) {
    case constants_1.NodePrivacyLevel.MASK:
    case constants_1.NodePrivacyLevel.HIDDEN:
    case constants_1.NodePrivacyLevel.IGNORE:
      return true;

    case constants_1.NodePrivacyLevel.MASK_USER_INPUT:
      return isTextNode(node) ? isFormElement(node.parentNode) : isFormElement(node);

    default:
      return false;
  }
}

exports.shouldMaskNode = shouldMaskNode;

function isElement(node) {
  return node.nodeType === node.ELEMENT_NODE;
}

function isTextNode(node) {
  return node.nodeType === node.TEXT_NODE;
}

function isFormElement(node) {
  if (!node || node.nodeType !== node.ELEMENT_NODE) {
    return false;
  }

  var element = node;

  if (element.tagName === 'INPUT') {
    switch (element.type) {
      case 'button':
      case 'color':
      case 'reset':
      case 'submit':
        return false;
    }
  }

  return !!constants_1.FORM_PRIVATE_TAG_NAMES[element.tagName];
}
/**
 * Text censoring non-destructively maintains whitespace characters in order to preserve text shape
 * during replay.
 */


var censorText = function censorText(text) {
  return text.replace(/\S/g, TEXT_MASKING_CHAR);
};

exports.censorText = censorText;

function getTextContent(textNode, ignoreWhiteSpace, parentNodePrivacyLevel) {
  var _a; // The parent node may not be a html element which has a tagName attribute.
  // So just let it be undefined which is ok in this use case.


  var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
  var textContent = textNode.textContent || '';

  if (ignoreWhiteSpace && !textContent.trim()) {
    return;
  }

  var nodePrivacyLevel = parentNodePrivacyLevel;
  var isStyle = parentTagName === 'STYLE' ? true : undefined;
  var isScript = parentTagName === 'SCRIPT';

  if (isScript) {
    // For perf reasons, we don't record script (heuristic)
    textContent = constants_1.CENSORED_STRING_MARK;
  } else if (nodePrivacyLevel === constants_1.NodePrivacyLevel.HIDDEN) {
    // Should never occur, but just in case, we set to CENSORED_MARK.
    textContent = constants_1.CENSORED_STRING_MARK;
  } else if (shouldMaskNode(textNode, nodePrivacyLevel) && // Style tags are `overruled` (Use `hide` to enforce privacy)
  !isStyle) {
    if ( // Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
    parentTagName === 'DATALIST' || parentTagName === 'SELECT' || parentTagName === 'OPTGROUP') {
      if (!textContent.trim()) {
        return;
      }
    } else if (parentTagName === 'OPTION') {
      // <Option> has low entropy in charset + text length, so use `CENSORED_STRING_MARK` when masked
      textContent = constants_1.CENSORED_STRING_MARK;
    } else {
      textContent = (0, exports.censorText)(textContent);
    }
  }

  return textContent;
}

exports.getTextContent = getTextContent;
/**
 * TODO: Preserve CSS element order, and record the presence of the tag, just don't render
 * We don't need this logic on the recorder side.
 * For security related meta's, customer can mask themmanually given they
 * are easy to identify in the HEAD tag.
 */

function shouldIgnoreElement(element) {
  if (element.nodeName === 'SCRIPT') {
    return true;
  }

  if (element.nodeName === 'LINK') {
    var relAttribute = getLowerCaseAttribute('rel');
    return (// Scripts
      relAttribute === 'preload' && getLowerCaseAttribute('as') === 'script' || // Favicons
      relAttribute === 'shortcut icon' || relAttribute === 'icon'
    );
  }

  if (element.nodeName === 'META') {
    var nameAttribute = getLowerCaseAttribute('name');
    var relAttribute = getLowerCaseAttribute('rel');
    var propertyAttribute = getLowerCaseAttribute('property');
    return (// Favicons
      /^msapplication-tile(image|color)$/.test(nameAttribute) || nameAttribute === 'application-name' || relAttribute === 'icon' || relAttribute === 'apple-touch-icon' || relAttribute === 'shortcut icon' || // Description
      nameAttribute === 'keywords' || nameAttribute === 'description' || // Social
      /^(og|twitter|fb):/.test(propertyAttribute) || /^(og|twitter):/.test(nameAttribute) || nameAttribute === 'pinterest' || // Robots
      nameAttribute === 'robots' || nameAttribute === 'googlebot' || nameAttribute === 'bingbot' || // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
      // X-Translated-By
      element.hasAttribute('http-equiv') || // Authorship
      nameAttribute === 'author' || nameAttribute === 'generator' || nameAttribute === 'framework' || nameAttribute === 'publisher' || nameAttribute === 'progid' || /^article:/.test(propertyAttribute) || /^product:/.test(propertyAttribute) || // Verification
      nameAttribute === 'google-site-verification' || nameAttribute === 'yandex-verification' || nameAttribute === 'csrf-token' || nameAttribute === 'p:domain_verify' || nameAttribute === 'verify-v1' || nameAttribute === 'verification' || nameAttribute === 'shopify-checkout-api-token'
    );
  }

  function getLowerCaseAttribute(name) {
    return (element.getAttribute(name) || '').toLowerCase();
  }

  return false;
}

exports.shouldIgnoreElement = shouldIgnoreElement;

},{"../../constants":100}],107:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.record = void 0;

var browser_core_1 = require("@datadog/browser-core");

var browser_rum_core_1 = require("@datadog/browser-rum-core");

var types_1 = require("../../types");

var serialize_1 = require("./serialize");

var observers_1 = require("./observers");

var mutationObserver_1 = require("./mutationObserver");

var viewports_1 = require("./viewports");

var utils_1 = require("./utils");

var elementsScrollPositions_1 = require("./elementsScrollPositions");

function record(options) {
  var emit = options.emit; // runtime checks for user options

  if (!emit) {
    throw new Error('emit function is required');
  }

  var mutationController = new mutationObserver_1.MutationController();
  var elementsScrollPositions = (0, elementsScrollPositions_1.createElementsScrollPositions)();

  var takeFullSnapshot = function takeFullSnapshot(timestamp, serializationContext) {
    if (timestamp === void 0) {
      timestamp = (0, browser_core_1.timeStampNow)();
    }

    if (serializationContext === void 0) {
      serializationContext = {
        status: 0
        /* INITIAL_FULL_SNAPSHOT */
        ,
        elementsScrollPositions: elementsScrollPositions
      };
    }

    mutationController.flush(); // process any pending mutation before taking a full snapshot

    var _a = (0, browser_rum_core_1.getViewportDimension)(),
        width = _a.width,
        height = _a.height;

    emit({
      data: {
        height: height,
        href: window.location.href,
        width: width
      },
      type: types_1.RecordType.Meta,
      timestamp: timestamp
    });
    emit({
      data: {
        has_focus: document.hasFocus()
      },
      type: types_1.RecordType.Focus,
      timestamp: timestamp
    });
    emit({
      data: {
        node: (0, serialize_1.serializeDocument)(document, options.configuration, serializationContext),
        initialOffset: {
          left: (0, viewports_1.getScrollX)(),
          top: (0, viewports_1.getScrollY)()
        }
      },
      type: types_1.RecordType.FullSnapshot,
      timestamp: timestamp
    });

    if (window.visualViewport) {
      emit({
        data: (0, viewports_1.getVisualViewport)(),
        type: types_1.RecordType.VisualViewport,
        timestamp: timestamp
      });
    }
  };

  takeFullSnapshot();
  var stopObservers = (0, observers_1.initObservers)({
    lifeCycle: options.lifeCycle,
    configuration: options.configuration,
    mutationController: mutationController,
    elementsScrollPositions: elementsScrollPositions,
    inputCb: function inputCb(v) {
      return emit((0, utils_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.Input, v));
    },
    mediaInteractionCb: function mediaInteractionCb(p) {
      return emit((0, utils_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.MediaInteraction, p));
    },
    mouseInteractionCb: function mouseInteractionCb(mouseInteractionRecord) {
      return emit(mouseInteractionRecord);
    },
    mousemoveCb: function mousemoveCb(positions, source) {
      return emit((0, utils_1.assembleIncrementalSnapshot)(source, {
        positions: positions
      }));
    },
    mutationCb: function mutationCb(m) {
      return emit((0, utils_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.Mutation, m));
    },
    scrollCb: function scrollCb(p) {
      return emit((0, utils_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.Scroll, p));
    },
    styleSheetCb: function styleSheetCb(r) {
      return emit((0, utils_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.StyleSheetRule, r));
    },
    viewportResizeCb: function viewportResizeCb(d) {
      return emit((0, utils_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.ViewportResize, d));
    },
    frustrationCb: function frustrationCb(frustrationRecord) {
      return emit(frustrationRecord);
    },
    focusCb: function focusCb(data) {
      return emit({
        data: data,
        type: types_1.RecordType.Focus,
        timestamp: (0, browser_core_1.timeStampNow)()
      });
    },
    visualViewportResizeCb: function visualViewportResizeCb(data) {
      emit({
        data: data,
        type: types_1.RecordType.VisualViewport,
        timestamp: (0, browser_core_1.timeStampNow)()
      });
    }
  });
  return {
    stop: stopObservers,
    takeSubsequentFullSnapshot: function takeSubsequentFullSnapshot(timestamp) {
      return takeFullSnapshot(timestamp, {
        status: 1
        /* SUBSEQUENT_FULL_SNAPSHOT */
        ,
        elementsScrollPositions: elementsScrollPositions
      });
    },
    flushMutations: function flushMutations() {
      return mutationController.flush();
    }
  };
}

exports.record = record;

},{"../../types":120,"./elementsScrollPositions":101,"./mutationObserver":104,"./observers":105,"./serialize":109,"./utils":110,"./viewports":111,"@datadog/browser-core":32,"@datadog/browser-rum-core":95}],108:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getElementInputValue = exports.setSerializedNodeId = exports.getSerializedNodeId = exports.nodeAndAncestorsHaveSerializedNode = exports.hasSerializedNode = void 0;

var constants_1 = require("../../constants");

var privacy_1 = require("./privacy");

var serializedNodeIds = new WeakMap();

function hasSerializedNode(node) {
  return serializedNodeIds.has(node);
}

exports.hasSerializedNode = hasSerializedNode;

function nodeAndAncestorsHaveSerializedNode(node) {
  var current = node;

  while (current) {
    if (!hasSerializedNode(current)) {
      return false;
    }

    current = current.parentNode;
  }

  return true;
}

exports.nodeAndAncestorsHaveSerializedNode = nodeAndAncestorsHaveSerializedNode;

function getSerializedNodeId(node) {
  return serializedNodeIds.get(node);
}

exports.getSerializedNodeId = getSerializedNodeId;

function setSerializedNodeId(node, serializeNodeId) {
  serializedNodeIds.set(node, serializeNodeId);
}

exports.setSerializedNodeId = setSerializedNodeId;
/**
 * Get the element "value" to be serialized as an attribute or an input update record. It respects
 * the input privacy mode of the element.
 * PERFROMANCE OPTIMIZATION: Assumes that privacy level `HIDDEN` is never encountered because of earlier checks.
 */

function getElementInputValue(element, nodePrivacyLevel) {
  /*
   BROWSER SPEC NOTE: <input>, <select>
   For some <input> elements, the `value` is an exceptional property/attribute that has the
   value synced between el.value and el.getAttribute()
   input[type=button,checkbox,hidden,image,radio,reset,submit]
   */
  var tagName = element.tagName;
  var value = element.value;

  if ((0, privacy_1.shouldMaskNode)(element, nodePrivacyLevel)) {
    var type = element.type;

    if (tagName === 'INPUT' && (type === 'button' || type === 'submit' || type === 'reset')) {
      // Overrule `MASK` privacy level for button-like element values, as they are used during replay
      // to display their label. They can still be hidden via the "hidden" privacy attribute or class name.
      return value;
    } else if (!value || tagName === 'OPTION') {
      // <Option> value provides no benefit
      return;
    }

    return constants_1.CENSORED_STRING_MARK;
  }

  if (tagName === 'OPTION' || tagName === 'SELECT') {
    return element.value;
  }

  if (tagName !== 'INPUT' && tagName !== 'TEXTAREA') {
    return;
  }

  return value;
}

exports.getElementInputValue = getElementInputValue;

},{"../../constants":100,"./privacy":106}],109:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serializeAttribute = exports.serializeChildNodes = exports.serializeElementNode = exports.serializeDocumentNode = exports.serializeNodeWithId = exports.serializeDocument = void 0;

var browser_core_1 = require("@datadog/browser-core");

var browser_rum_core_1 = require("@datadog/browser-rum-core");

var constants_1 = require("../../constants");

var types_1 = require("../../types");

var privacy_1 = require("./privacy");

var serializationUtils_1 = require("./serializationUtils");

var utils_1 = require("./utils");

function serializeDocument(document, configuration, serializationContext) {
  // We are sure that Documents are never ignored, so this function never returns null
  return serializeNodeWithId(document, {
    serializationContext: serializationContext,
    parentNodePrivacyLevel: configuration.defaultPrivacyLevel,
    configuration: configuration
  });
}

exports.serializeDocument = serializeDocument;

function serializeNodeWithId(node, options) {
  var serializedNode = serializeNode(node, options);

  if (!serializedNode) {
    return null;
  } // Try to reuse the previous id


  var id = (0, serializationUtils_1.getSerializedNodeId)(node) || generateNextId();
  var serializedNodeWithId = serializedNode;
  serializedNodeWithId.id = id;
  (0, serializationUtils_1.setSerializedNodeId)(node, id);

  if (options.serializedNodeIds) {
    options.serializedNodeIds.add(id);
  }

  return serializedNodeWithId;
}

exports.serializeNodeWithId = serializeNodeWithId;

function serializeNode(node, options) {
  switch (node.nodeType) {
    case node.DOCUMENT_NODE:
      return serializeDocumentNode(node, options);

    case node.DOCUMENT_TYPE_NODE:
      return serializeDocumentTypeNode(node);

    case node.ELEMENT_NODE:
      return serializeElementNode(node, options);

    case node.TEXT_NODE:
      return serializeTextNode(node, options);

    case node.CDATA_SECTION_NODE:
      return serializeCDataNode();
  }
}

function serializeDocumentNode(document, options) {
  return {
    type: types_1.NodeType.Document,
    childNodes: serializeChildNodes(document, options)
  };
}

exports.serializeDocumentNode = serializeDocumentNode;

function serializeDocumentTypeNode(documentType) {
  return {
    type: types_1.NodeType.DocumentType,
    name: documentType.name,
    publicId: documentType.publicId,
    systemId: documentType.systemId
  };
}
/**
 * Serializing Element nodes involves capturing:
 * 1. HTML ATTRIBUTES:
 * 2. JS STATE:
 * - scroll offsets
 * - Form fields (input value, checkbox checked, otpion selection, range)
 * - Canvas state,
 * - Media (video/audio) play mode + currentTime
 * - iframe contents
 * - webcomponents
 * 3. CUSTOM PROPERTIES:
 * - height+width for when `hidden` to cover the element
 * 4. EXCLUDED INTERACTION STATE:
 * - focus (possible, but not worth perf impact)
 * - hover (tracked only via mouse activity)
 * - fullscreen mode
 */


function serializeElementNode(element, options) {
  var _a;

  var tagName = getValidTagName(element.tagName);
  var isSVG = isSVGElement(element) || undefined; // For performance reason, we don't use getNodePrivacyLevel directly: we leverage the
  // parentNodePrivacyLevel option to avoid iterating over all parents

  var nodePrivacyLevel = (0, privacy_1.reducePrivacyLevel)((0, privacy_1.getNodeSelfPrivacyLevel)(element), options.parentNodePrivacyLevel);

  if (nodePrivacyLevel === constants_1.NodePrivacyLevel.HIDDEN) {
    var _b = element.getBoundingClientRect(),
        width = _b.width,
        height = _b.height;

    return {
      type: types_1.NodeType.Element,
      tagName: tagName,
      attributes: (_a = {
        rr_width: "".concat(width, "px"),
        rr_height: "".concat(height, "px")
      }, _a[constants_1.PRIVACY_ATTR_NAME] = constants_1.PRIVACY_ATTR_VALUE_HIDDEN, _a),
      childNodes: [],
      isSVG: isSVG
    };
  } // Ignore Elements like Script and some Link, Metas


  if (nodePrivacyLevel === constants_1.NodePrivacyLevel.IGNORE) {
    return;
  }

  var attributes = getAttributesForPrivacyLevel(element, nodePrivacyLevel, options);
  var childNodes = [];

  if (element.childNodes.length) {
    // OBJECT POOLING OPTIMIZATION:
    // We should not create a new object systematically as it could impact performances. Try to reuse
    // the same object as much as possible, and clone it only if we need to.
    var childNodesSerializationOptions = void 0;

    if (options.parentNodePrivacyLevel === nodePrivacyLevel && options.ignoreWhiteSpace === (tagName === 'head')) {
      childNodesSerializationOptions = options;
    } else {
      childNodesSerializationOptions = (0, browser_core_1.assign)({}, options, {
        parentNodePrivacyLevel: nodePrivacyLevel,
        ignoreWhiteSpace: tagName === 'head'
      });
    }

    childNodes = serializeChildNodes(element, childNodesSerializationOptions);
  }

  return {
    type: types_1.NodeType.Element,
    tagName: tagName,
    attributes: attributes,
    childNodes: childNodes,
    isSVG: isSVG
  };
}

exports.serializeElementNode = serializeElementNode;
/**
 * Text Nodes are dependant on Element nodes
 * Privacy levels are set on elements so we check the parentElement of a text node
 * for privacy level.
 */

function serializeTextNode(textNode, options) {
  var _a; // The parent node may not be a html element which has a tagName attribute.
  // So just let it be undefined which is ok in this use case.


  var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
  var textContent = (0, privacy_1.getTextContent)(textNode, options.ignoreWhiteSpace || false, options.parentNodePrivacyLevel);

  if (!textContent) {
    return;
  }

  return {
    type: types_1.NodeType.Text,
    textContent: textContent,
    isStyle: parentTagName === 'STYLE' ? true : undefined
  };
}

function serializeCDataNode() {
  return {
    type: types_1.NodeType.CDATA,
    textContent: ''
  };
}

function serializeChildNodes(node, options) {
  var result = [];
  (0, utils_1.forEach)(node.childNodes, function (childNode) {
    var serializedChildNode = serializeNodeWithId(childNode, options);

    if (serializedChildNode) {
      result.push(serializedChildNode);
    }
  });
  return result;
}

exports.serializeChildNodes = serializeChildNodes;

function serializeAttribute(element, nodePrivacyLevel, attributeName, configuration) {
  if (nodePrivacyLevel === constants_1.NodePrivacyLevel.HIDDEN) {
    // dup condition for direct access case
    return null;
  }

  var attributeValue = element.getAttribute(attributeName);

  if (nodePrivacyLevel === constants_1.NodePrivacyLevel.MASK && attributeName !== constants_1.PRIVACY_ATTR_NAME && attributeName !== browser_rum_core_1.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE && attributeName !== configuration.actionNameAttribute) {
    var tagName = element.tagName;

    switch (attributeName) {
      // Mask Attribute text content
      case 'title':
      case 'alt':
      case 'placeholder':
        return constants_1.CENSORED_STRING_MARK;
    } // mask image URLs


    if (tagName === 'IMG' || tagName === 'SOURCE') {
      if (attributeName === 'src' || attributeName === 'srcset') {
        return constants_1.CENSORED_IMG_MARK;
      }
    } // mask <a> URLs


    if (tagName === 'A' && attributeName === 'href') {
      return constants_1.CENSORED_STRING_MARK;
    } // mask data-* attributes


    if (attributeValue && (0, browser_core_1.startsWith)(attributeName, 'data-')) {
      // Exception: it's safe to reveal the `${PRIVACY_ATTR_NAME}` attr
      return constants_1.CENSORED_STRING_MARK;
    }
  }

  if (!attributeValue || typeof attributeValue !== 'string') {
    return attributeValue;
  } // Minimum Fix for customer.


  if (attributeValue.length > privacy_1.MAX_ATTRIBUTE_VALUE_CHAR_LENGTH && attributeValue.slice(0, 5) === 'data:') {
    return 'data:truncated';
  }

  return attributeValue;
}

exports.serializeAttribute = serializeAttribute;
var _nextId = 1;

function generateNextId() {
  return _nextId++;
}

var TAG_NAME_REGEX = /[^a-z1-6-_]/;

function getValidTagName(tagName) {
  var processedTagName = tagName.toLowerCase().trim();

  if (TAG_NAME_REGEX.test(processedTagName)) {
    // if the tag name is odd and we cannot extract
    // anything from the string, then we return a
    // generic div
    return 'div';
  }

  return processedTagName;
}

function getCssRulesString(s) {
  try {
    var rules = s.rules || s.cssRules;
    return rules ? Array.from(rules).map(getCssRuleString).join('') : null;
  } catch (error) {
    return null;
  }
}

function getCssRuleString(rule) {
  return isCSSImportRule(rule) ? getCssRulesString(rule.styleSheet) || '' : rule.cssText;
}

function isCSSImportRule(rule) {
  return 'styleSheet' in rule;
}

function isSVGElement(el) {
  return el.tagName === 'svg' || el instanceof SVGElement;
}

function getAttributesForPrivacyLevel(element, nodePrivacyLevel, options) {
  var _a;

  if (nodePrivacyLevel === constants_1.NodePrivacyLevel.HIDDEN) {
    return {};
  }

  var safeAttrs = {};
  var tagName = getValidTagName(element.tagName);
  var doc = element.ownerDocument;

  for (var i = 0; i < element.attributes.length; i += 1) {
    var attribute = element.attributes.item(i);
    var attributeName = attribute.name;
    var attributeValue = serializeAttribute(element, nodePrivacyLevel, attributeName, options.configuration);

    if (attributeValue !== null) {
      safeAttrs[attributeName] = attributeValue;
    }
  }

  if (element.value && (tagName === 'textarea' || tagName === 'select' || tagName === 'option' || tagName === 'input')) {
    var formValue = (0, serializationUtils_1.getElementInputValue)(element, nodePrivacyLevel);

    if (formValue !== undefined) {
      safeAttrs.value = formValue;
    }
  }
  /**
   * <Option> can be selected, which occurs if its `value` matches ancestor `<Select>.value`
   */


  if (tagName === 'option' && nodePrivacyLevel === constants_1.NodePrivacyLevel.ALLOW) {
    // For privacy=`MASK`, all the values would be the same, so skip.
    var optionElement = element;

    if (optionElement.selected) {
      safeAttrs.selected = optionElement.selected;
    }
  } // remote css


  if (tagName === 'link') {
    var stylesheet = Array.from(doc.styleSheets).find(function (s) {
      return s.href === element.href;
    });
    var cssText = getCssRulesString(stylesheet);

    if (cssText && stylesheet) {
      delete safeAttrs.rel;
      delete safeAttrs.href;
      safeAttrs._cssText = cssText;
    }
  } // dynamic stylesheet


  if (tagName === 'style' && element.sheet && // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
  !(element.innerText || element.textContent || '').trim().length) {
    var cssText = getCssRulesString(element.sheet);

    if (cssText) {
      safeAttrs._cssText = cssText;
    }
  }
  /**
   * Forms: input[type=checkbox,radio]
   * The `checked` property for <input> is a little bit special:
   * 1. el.checked is a setter that returns if truthy.
   * 2. getAttribute returns the string value
   * getAttribute('checked') does not sync with `Element.checked`, so use JS property
   * NOTE: `checked` property exists on `HTMLInputElement`. For serializer assumptions, we check for type=radio|check.
   */


  var inputElement = element;

  if (tagName === 'input' && (inputElement.type === 'radio' || inputElement.type === 'checkbox')) {
    if (nodePrivacyLevel === constants_1.NodePrivacyLevel.ALLOW) {
      safeAttrs.checked = !!inputElement.checked;
    } else if ((0, privacy_1.shouldMaskNode)(inputElement, nodePrivacyLevel)) {
      safeAttrs.checked = constants_1.CENSORED_STRING_MARK;
    }
  }
  /**
   * Serialize the media playback state
   */


  if (tagName === 'audio' || tagName === 'video') {
    var mediaElement = element;
    safeAttrs.rr_mediaState = mediaElement.paused ? 'paused' : 'played';
  }
  /**
   * Serialize the scroll state for each element only for full snapshot
   */


  var scrollTop;
  var scrollLeft;
  var serializationContext = options.serializationContext;

  switch (serializationContext.status) {
    case 0
    /* INITIAL_FULL_SNAPSHOT */
    :
      scrollTop = Math.round(element.scrollTop);
      scrollLeft = Math.round(element.scrollLeft);

      if (scrollTop || scrollLeft) {
        serializationContext.elementsScrollPositions.set(element, {
          scrollTop: scrollTop,
          scrollLeft: scrollLeft
        });
      }

      break;

    case 1
    /* SUBSEQUENT_FULL_SNAPSHOT */
    :
      if (serializationContext.elementsScrollPositions.has(element)) {
        ;
        _a = serializationContext.elementsScrollPositions.get(element), scrollTop = _a.scrollTop, scrollLeft = _a.scrollLeft;
      }

      break;
  }

  if (scrollLeft) {
    safeAttrs.rr_scrollLeft = scrollLeft;
  }

  if (scrollTop) {
    safeAttrs.rr_scrollTop = scrollTop;
  }

  return safeAttrs;
}

},{"../../constants":100,"../../types":120,"./privacy":106,"./serializationUtils":108,"./utils":110,"@datadog/browser-core":32,"@datadog/browser-rum-core":95}],110:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPathToNestedCSSRule = exports.assembleIncrementalSnapshot = exports.forEach = exports.isTouchEvent = void 0;

var browser_core_1 = require("@datadog/browser-core");

var types_1 = require("../../types");

function isTouchEvent(event) {
  return Boolean(event.changedTouches);
}

exports.isTouchEvent = isTouchEvent;

function forEach(list, callback) {
  Array.prototype.forEach.call(list, callback);
}

exports.forEach = forEach;

function assembleIncrementalSnapshot(source, data) {
  return {
    data: (0, browser_core_1.assign)({
      source: source
    }, data),
    type: types_1.RecordType.IncrementalSnapshot,
    timestamp: (0, browser_core_1.timeStampNow)()
  };
}

exports.assembleIncrementalSnapshot = assembleIncrementalSnapshot;

function getPathToNestedCSSRule(rule) {
  var path = [];
  var currentRule = rule;

  while (currentRule.parentRule) {
    var rules_1 = Array.from(currentRule.parentRule.cssRules);
    var index_1 = rules_1.indexOf(currentRule);
    path.unshift(index_1);
    currentRule = currentRule.parentRule;
  } // A rule may not be attached to a stylesheet


  if (!currentRule.parentStyleSheet) {
    return;
  }

  var rules = Array.from(currentRule.parentStyleSheet.cssRules);
  var index = rules.indexOf(currentRule);
  path.unshift(index);
  return path;
}

exports.getPathToNestedCSSRule = getPathToNestedCSSRule;

},{"../../types":120,"@datadog/browser-core":32}],111:[function(require,module,exports){
"use strict";
/**
 * Browsers have not standardized various dimension properties. Mobile devices typically report
 * dimensions in reference to the visual viewport, while desktop uses the layout viewport. For example,
 * Mobile Chrome will change innerWidth when a pinch zoom takes place, while Chrome Desktop (mac) will not.
 *
 * With the new Viewport API, we now calculate and normalize dimension properties to the layout viewport.
 * If the VisualViewport API is not supported by a browser, it isn't reasonably possible to detect or normalize
 * which viewport is being measured. Therefore these exported functions will fallback to assuming that the layout
 * viewport is being measured by the browser
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScrollY = exports.getScrollX = exports.getVisualViewport = exports.convertMouseEventToLayoutCoordinates = void 0; // Scrollbar widths vary across properties on different devices and browsers

var TOLERANCE = 25;
/**
 * Use the Visual Viewport API's properties to measure scrollX/Y in reference to the layout viewport
 * in order to determine if window.scrollX/Y is measuring the layout or visual viewport.
 * This finding corresponds to which viewport mouseEvent.clientX/Y and window.innerWidth/Height measures.
 */

function isVisualViewportFactoredIn() {
  var visual = window.visualViewport;
  return Math.abs(visual.pageTop - visual.offsetTop - window.scrollY) > TOLERANCE || Math.abs(visual.pageLeft - visual.offsetLeft - window.scrollX) > TOLERANCE;
}

var convertMouseEventToLayoutCoordinates = function convertMouseEventToLayoutCoordinates(clientX, clientY) {
  var visual = window.visualViewport;
  var normalised = {
    layoutViewportX: clientX,
    layoutViewportY: clientY,
    visualViewportX: clientX,
    visualViewportY: clientY
  };

  if (!visual) {
    // On old browsers, we cannot normalise, so fallback to clientX/Y
    return normalised;
  } else if (isVisualViewportFactoredIn()) {
    // Typically Mobile Devices
    normalised.layoutViewportX = Math.round(clientX + visual.offsetLeft);
    normalised.layoutViewportY = Math.round(clientY + visual.offsetTop);
  } else {
    // Typically Desktop Devices
    normalised.visualViewportX = Math.round(clientX - visual.offsetLeft);
    normalised.visualViewportY = Math.round(clientY - visual.offsetTop);
  }

  return normalised;
};

exports.convertMouseEventToLayoutCoordinates = convertMouseEventToLayoutCoordinates;

var getVisualViewport = function getVisualViewport() {
  var visual = window.visualViewport;
  return {
    scale: visual.scale,
    offsetLeft: visual.offsetLeft,
    offsetTop: visual.offsetTop,
    pageLeft: visual.pageLeft,
    pageTop: visual.pageTop,
    height: visual.height,
    width: visual.width
  };
};

exports.getVisualViewport = getVisualViewport;

function getScrollX() {
  var scrollX;
  var visual = window.visualViewport;

  if (visual) {
    scrollX = visual.pageLeft - visual.offsetLeft;
  } else if (window.scrollX !== undefined) {
    scrollX = window.scrollX;
  } else {
    scrollX = window.pageXOffset || 0;
  }

  return Math.round(scrollX);
}

exports.getScrollX = getScrollX;

function getScrollY() {
  var scrollY;
  var visual = window.visualViewport;

  if (visual) {
    scrollY = visual.pageTop - visual.offsetTop;
  } else if (window.scrollY !== undefined) {
    scrollY = window.scrollY;
  } else {
    scrollY = window.pageYOffset || 0;
  }

  return Math.round(scrollY);
}

exports.getScrollY = getScrollY;

},{}],112:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetReplayStats = exports.getReplayStats = exports.addWroteData = exports.addRecord = exports.addSegment = exports.getSegmentsCount = exports.MAX_STATS_HISTORY = void 0;
exports.MAX_STATS_HISTORY = 10;
var statsPerView;

function getSegmentsCount(viewId) {
  return getOrCreateReplayStats(viewId).segments_count;
}

exports.getSegmentsCount = getSegmentsCount;

function addSegment(viewId) {
  getOrCreateReplayStats(viewId).segments_count += 1;
}

exports.addSegment = addSegment;

function addRecord(viewId) {
  getOrCreateReplayStats(viewId).records_count += 1;
}

exports.addRecord = addRecord;

function addWroteData(viewId, additionalBytesCount) {
  getOrCreateReplayStats(viewId).segments_total_raw_size += additionalBytesCount;
}

exports.addWroteData = addWroteData;

function getReplayStats(viewId) {
  return statsPerView === null || statsPerView === void 0 ? void 0 : statsPerView.get(viewId);
}

exports.getReplayStats = getReplayStats;

function resetReplayStats() {
  statsPerView = undefined;
}

exports.resetReplayStats = resetReplayStats;

function getOrCreateReplayStats(viewId) {
  if (!statsPerView) {
    statsPerView = new Map();
  }

  var replayStats;

  if (statsPerView.has(viewId)) {
    replayStats = statsPerView.get(viewId);
  } else {
    replayStats = {
      records_count: 0,
      segments_count: 0,
      segments_total_raw_size: 0
    };
    statsPerView.set(viewId, replayStats);

    if (statsPerView.size > exports.MAX_STATS_HISTORY) {
      deleteOldestStats();
    }
  }

  return replayStats;
}

function deleteOldestStats() {
  if (!statsPerView) {
    return;
  }

  if (statsPerView.keys) {
    statsPerView["delete"](statsPerView.keys().next().value);
  } else {
    // IE11 doesn't support map.keys
    var isFirst_1 = true;
    statsPerView.forEach(function (_value, key) {
      if (isFirst_1) {
        statsPerView["delete"](key);
        isFirst_1 = false;
      }
    });
  }
}

},{}],113:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDeflateWorker = void 0;
var workerURL;

function createDeflateWorker() {
  // Lazily compute the worker URL to allow importing the SDK in NodeJS
  if (!workerURL) {
    workerURL = URL.createObjectURL(new Blob(["(".concat(workerCodeFn, ")(self)")]));
  }

  return new Worker(workerURL);
}

exports.createDeflateWorker = createDeflateWorker;

function workerCodeFn() {
  monitor(function () {
    var _a = makePakoDeflate(),
        Deflate = _a.Deflate,
        constants = _a.constants,
        string2buf = _a.string2buf;

    var deflate = new Deflate();
    var rawBytesCount = 0;
    self.addEventListener('message', monitor(function (event) {
      var data = event.data;

      switch (data.action) {
        case 'init':
          self.postMessage({
            type: 'initialized'
          });
          break;

        case 'write':
          {
            var additionalBytesCount = pushData(data.data);
            self.postMessage({
              type: 'wrote',
              id: data.id,
              compressedBytesCount: deflate.chunks.reduce(function (total, chunk) {
                return total + chunk.length;
              }, 0),
              additionalBytesCount: additionalBytesCount
            });
            break;
          }

        case 'flush':
          {
            var additionalBytesCount = data.data ? pushData(data.data) : 0;
            deflate.push('', constants.Z_FINISH);
            self.postMessage({
              type: 'flushed',
              id: data.id,
              result: deflate.result,
              additionalBytesCount: additionalBytesCount,
              rawBytesCount: rawBytesCount
            });
            deflate = new Deflate();
            rawBytesCount = 0;
            break;
          }
      }
    }));

    function pushData(data) {
      // TextEncoder is not supported on old browser version like Edge 18, therefore we use string2buf
      var binaryData = string2buf(data);
      deflate.push(binaryData, constants.Z_SYNC_FLUSH);
      rawBytesCount += binaryData.length;
      return binaryData.length;
    }
  })();

  function monitor(fn) {
    return function () {
      try {
        return fn.apply(this, arguments);
      } catch (e) {
        try {
          self.postMessage({
            type: 'errored',
            error: e
          });
        } catch (_) {
          // DATA_CLONE_ERR, cf https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm
          self.postMessage({
            type: 'errored',
            error: "".concat(e)
          });
        }
      }
    };
  } // https://github.com/nodeca/pako/blob/034669ba0f1a4c0590e45f7c2820128200f972b3/dist/pako_deflate.es5.js


  function makePakoDeflate() {
    /* eslint-disable camelcase, no-bitwise */
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    /* Public constants ========================================================== */

    /* =========================================================================== */
    // const Z_FILTERED          = 1;
    // const Z_HUFFMAN_ONLY      = 2;
    // const Z_RLE               = 3;
    var Z_FIXED = 4; // const Z_DEFAULT_STRATEGY  = 0;

    /* Possible values of the data_type field (though see inflate()) */

    var Z_BINARY = 0;
    var Z_TEXT = 1; // const Z_ASCII             = 1; // = Z_TEXT

    var Z_UNKNOWN = 2;
    /* ============================================================================ */

    function zero(buf) {
      var len = buf.length;

      while (--len >= 0) {
        buf[len] = 0;
      }
    } // From zutil.h


    var STORED_BLOCK = 0;
    var STATIC_TREES = 1;
    var DYN_TREES = 2;
    /* The three kinds of block type */

    var MIN_MATCH = 3;
    var MAX_MATCH = 258;
    /* The minimum and maximum match lengths */
    // From deflate.h

    /* ===========================================================================
     * Internal compression state.
     */

    var LENGTH_CODES = 29;
    /* number of length codes, not counting the special END_BLOCK code */

    var LITERALS = 256;
    /* number of literal bytes 0..255 */

    var L_CODES = LITERALS + 1 + LENGTH_CODES;
    /* number of Literal or Length codes, including the END_BLOCK code */

    var D_CODES = 30;
    /* number of distance codes */

    var BL_CODES = 19;
    /* number of codes used to transfer the bit lengths */

    var HEAP_SIZE = 2 * L_CODES + 1;
    /* maximum heap size */

    var MAX_BITS = 15;
    /* All codes must not exceed MAX_BITS bits */

    var Buf_size = 16;
    /* size of bit buffer in bi_buf */

    /* ===========================================================================
     * Constants
     */

    var MAX_BL_BITS = 7;
    /* Bit length codes must not exceed MAX_BL_BITS bits */

    var END_BLOCK = 256;
    /* end of block literal code */

    var REP_3_6 = 16;
    /* repeat previous bit length 3-6 times (2 bits of repeat count) */

    var REPZ_3_10 = 17;
    /* repeat a zero length 3-10 times  (3 bits of repeat count) */

    var REPZ_11_138 = 18;
    /* repeat a zero length 11-138 times  (7 bits of repeat count) */

    var extra_lbits =
    /* extra bits for each length code */
    new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]);
    var extra_dbits =
    /* extra bits for each distance code */
    new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]);
    var extra_blbits =
    /* extra bits for each bit length code */
    new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]);
    var bl_order = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
    /* eslint-enable comma-spacing,array-bracket-spacing */

    /* The lengths of the bit length codes are sent in order of decreasing
     * probability, to avoid transmitting the lengths for unused bit length codes.
     */

    /* ===========================================================================
     * Local data. These are initialized only once.
     */
    // We pre-fill arrays with 0 to avoid uninitialized gaps

    var DIST_CODE_LEN = 512;
    /* see definition of array dist_code below */
    // !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1

    var static_ltree = new Array((L_CODES + 2) * 2);
    zero(static_ltree);
    /* The static literal tree. Since the bit lengths are imposed, there is no
     * need for the L_CODES extra codes used during heap construction. However
     * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
     * below).
     */

    var static_dtree = new Array(D_CODES * 2);
    zero(static_dtree);
    /* The static distance tree. (Actually a trivial tree since all codes use
     * 5 bits.)
     */

    var _dist_code = new Array(DIST_CODE_LEN);

    zero(_dist_code);
    /* Distance codes. The first 256 values correspond to the distances
     * 3 .. 258, the last 256 values correspond to the top 8 bits of
     * the 15 bit distances.
     */

    var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);

    zero(_length_code);
    /* length code for each normalized match length (0 == MIN_MATCH) */

    var base_length = new Array(LENGTH_CODES);
    zero(base_length);
    /* First normalized length for each code (0 = MIN_MATCH) */

    var base_dist = new Array(D_CODES);
    zero(base_dist);
    /* First normalized distance for each code (0 = distance of 1) */

    function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
      this.static_tree = static_tree;
      /* static tree or NULL */

      this.extra_bits = extra_bits;
      /* extra bits for each code or NULL */

      this.extra_base = extra_base;
      /* base index for extra_bits */

      this.elems = elems;
      /* max number of elements in the tree */

      this.max_length = max_length;
      /* max bit length for the codes */
      // show if `static_tree` has data or dummy - needed for monomorphic objects

      this.has_stree = static_tree && static_tree.length;
    }

    var static_l_desc;
    var static_d_desc;
    var static_bl_desc;

    function TreeDesc(dyn_tree, stat_desc) {
      this.dyn_tree = dyn_tree;
      /* the dynamic tree */

      this.max_code = 0;
      /* largest code with non zero frequency */

      this.stat_desc = stat_desc;
      /* the corresponding static tree */
    }

    var d_code = function d_code(dist) {
      return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
    };
    /* ===========================================================================
     * Output a short LSB first on the stream.
     * IN assertion: there is enough room in pendingBuf.
     */


    var put_short = function put_short(s, w) {
      //    put_byte(s, (uch)((w) & 0xff));
      //    put_byte(s, (uch)((ush)(w) >> 8));
      s.pending_buf[s.pending++] = w & 0xff;
      s.pending_buf[s.pending++] = w >>> 8 & 0xff;
    };
    /* ===========================================================================
     * Send a value on a given number of bits.
     * IN assertion: length <= 16 and value fits in length bits.
     */


    var send_bits = function send_bits(s, value, length) {
      if (s.bi_valid > Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        put_short(s, s.bi_buf);
        s.bi_buf = value >> Buf_size - s.bi_valid;
        s.bi_valid += length - Buf_size;
      } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
      }
    };

    var send_code = function send_code(s, c, tree) {
      send_bits(s, tree[c * 2],
      /* .Code */
      tree[c * 2 + 1]
      /* .Len */
      );
    };
    /* ===========================================================================
     * Reverse the first len bits of a code, using straightforward code (a faster
     * method would use a table)
     * IN assertion: 1 <= len <= 15
     */


    var bi_reverse = function bi_reverse(code, len) {
      var res = 0;

      do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
      } while (--len > 0);

      return res >>> 1;
    };
    /* ===========================================================================
     * Flush the bit buffer, keeping at most 7 bits in it.
     */


    var bi_flush = function bi_flush(s) {
      if (s.bi_valid === 16) {
        put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
      } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
      }
    };
    /* ===========================================================================
     * Compute the optimal bit lengths for a tree and update the total bit length
     * for the current block.
     * IN assertion: the fields freq and dad are set, heap[heap_max] and
     *    above are the tree nodes sorted by increasing frequency.
     * OUT assertions: the field len is set to the optimal bit length, the
     *     array bl_count contains the frequencies for each bit length.
     *     The length opt_len is updated; static_len is also updated if stree is
     *     not null.
     */


    var gen_bitlen = function gen_bitlen(s, desc //    deflate_state *s; //    tree_desc *desc;    /* the tree descriptor */
    ) {
      var tree = desc.dyn_tree;
      var max_code = desc.max_code;
      var stree = desc.stat_desc.static_tree;
      var has_stree = desc.stat_desc.has_stree;
      var extra = desc.stat_desc.extra_bits;
      var base = desc.stat_desc.extra_base;
      var max_length = desc.stat_desc.max_length;
      var h;
      /* heap index */

      var n;
      var m;
      /* iterate over the tree elements */

      var bits;
      /* bit length */

      var xbits;
      /* extra bits */

      var f;
      /* frequency */

      var overflow = 0;
      /* number of elements with bit length too large */

      for (bits = 0; bits <= MAX_BITS; bits++) {
        s.bl_count[bits] = 0;
      }
      /* In a first pass, compute the optimal bit lengths (which may
       * overflow in the case of the bit length tree).
       */


      tree[s.heap[s.heap_max] * 2 + 1] =
      /* .Len */
      0;
      /* root of the heap */

      for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] *
        /* .Dad */
        2 + 1] +
        /* .Len */
        1;

        if (bits > max_length) {
          bits = max_length;
          overflow++;
        }

        tree[n * 2 + 1] =
        /* .Len */
        bits;
        /* We overwrite tree[n].Dad which is no longer needed */

        if (n > max_code) {
          continue;
        }
        /* not a leaf node */


        s.bl_count[bits]++;
        xbits = 0;

        if (n >= base) {
          xbits = extra[n - base];
        }

        f = tree[n * 2];
        /* .Freq */

        s.opt_len += f * (bits + xbits);

        if (has_stree) {
          s.static_len += f * (stree[n * 2 + 1] +
          /* .Len */
          xbits);
        }
      }

      if (overflow === 0) {
        return;
      } // Trace((stderr,"\nbit length overflow\n"));

      /* This happens for example on obj2 and pic of the Calgary corpus */

      /* Find the first bit length which could increase: */


      do {
        bits = max_length - 1;

        while (s.bl_count[bits] === 0) {
          bits--;
        }

        s.bl_count[bits]--;
        /* move one leaf down the tree */

        s.bl_count[bits + 1] += 2;
        /* move one overflow item as its brother */

        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
         * but this does not affect bl_count[max_length]
         */

        overflow -= 2;
      } while (overflow > 0);
      /* Now recompute all bit lengths, scanning in increasing frequency.
       * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
       * lengths instead of fixing only the wrong ones. This idea is taken
       * from 'ar' written by Haruhiko Okumura.)
       */


      for (bits = max_length; bits !== 0; bits--) {
        n = s.bl_count[bits];

        while (n !== 0) {
          m = s.heap[--h];

          if (m > max_code) {
            continue;
          }

          if (tree[m * 2 + 1] !==
          /* .Len */
          bits) {
            // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
            s.opt_len += (bits - tree[m * 2 + 1]) *
            /* .Len */
            tree[m * 2];
            /* .Freq */

            tree[m * 2 + 1] =
            /* .Len */
            bits;
          }

          n--;
        }
      }
    };
    /* ===========================================================================
     * Generate the codes for a given tree and bit counts (which need not be
     * optimal).
     * IN assertion: the array bl_count contains the bit length statistics for
     * the given tree and the field len is set for all tree elements.
     * OUT assertion: the field code is set for all tree elements of non
     *     zero code length.
     */


    var gen_codes = function gen_codes(tree, max_code, bl_count //    ct_data *tree;             /* the tree to decorate */
    //    int max_code;              /* largest code with non zero frequency */
    //    ushf *bl_count;            /* number of codes at each bit length */
    ) {
      var next_code = new Array(MAX_BITS + 1);
      /* next code value for each bit length */

      var code = 0;
      /* running code value */

      var bits;
      /* bit index */

      var n;
      /* code index */

      /* The distribution counts are first used to generate the code values
       * without bit reversal.
       */

      for (bits = 1; bits <= MAX_BITS; bits++) {
        next_code[bits] = code = code + bl_count[bits - 1] << 1;
      }
      /* Check that the bit counts in bl_count are consistent. The last code
       * must be all ones.
       */
      // Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
      //        "inconsistent bit counts");
      // Tracev((stderr,"\ngen_codes: max_code %d ", max_code));


      for (n = 0; n <= max_code; n++) {
        var len = tree[n * 2 + 1];
        /* .Len */

        if (len === 0) {
          continue;
        }
        /* Now reverse the bits */


        tree[n * 2] =
        /* .Code */
        bi_reverse(next_code[len]++, len); // Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
        //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
      }
    };
    /* ===========================================================================
     * Initialize the various 'constant' tables.
     */


    var tr_static_init = function tr_static_init() {
      var n;
      /* iterates over tree elements */

      var bits;
      /* bit counter */

      var length;
      /* length value */

      var code;
      /* code value */

      var dist;
      /* distance index */

      var bl_count = new Array(MAX_BITS + 1);
      /* number of codes at each bit length for an optimal tree */
      // do check in _tr_init()
      // if (static_init_done) return;

      /* For some embedded targets, global variables are not initialized: */

      /* #ifdef NO_INIT_GLOBAL_POINTERS
      static_l_desc.static_tree = static_ltree;
      static_l_desc.extra_bits = extra_lbits;
      static_d_desc.static_tree = static_dtree;
      static_d_desc.extra_bits = extra_dbits;
      static_bl_desc.extra_bits = extra_blbits;
      #endif */

      /* Initialize the mapping length (0..255) -> length code (0..28) */

      length = 0;

      for (code = 0; code < LENGTH_CODES - 1; code++) {
        base_length[code] = length;

        for (n = 0; n < 1 << extra_lbits[code]; n++) {
          _length_code[length++] = code;
        }
      } // Assert (length == 256, "tr_static_init: length != 256");

      /* Note that the length 255 (match length 258) can be represented
       * in two different ways: code 284 + 5 bits or code 285, so we
       * overwrite length_code[255] to use the best encoding:
       */


      _length_code[length - 1] = code;
      /* Initialize the mapping dist (0..32K) -> dist code (0..29) */

      dist = 0;

      for (code = 0; code < 16; code++) {
        base_dist[code] = dist;

        for (n = 0; n < 1 << extra_dbits[code]; n++) {
          _dist_code[dist++] = code;
        }
      } // Assert (dist == 256, "tr_static_init: dist != 256");


      dist >>= 7;
      /* from now on, all distances are divided by 128 */

      for (; code < D_CODES; code++) {
        base_dist[code] = dist << 7;

        for (n = 0; n < 1 << extra_dbits[code] - 7; n++) {
          _dist_code[256 + dist++] = code;
        }
      } // Assert (dist == 256, "tr_static_init: 256+dist != 512");

      /* Construct the codes of the static literal tree */


      for (bits = 0; bits <= MAX_BITS; bits++) {
        bl_count[bits] = 0;
      }

      n = 0;

      while (n <= 143) {
        static_ltree[n * 2 + 1] =
        /* .Len */
        8;
        n++;
        bl_count[8]++;
      }

      while (n <= 255) {
        static_ltree[n * 2 + 1] =
        /* .Len */
        9;
        n++;
        bl_count[9]++;
      }

      while (n <= 279) {
        static_ltree[n * 2 + 1] =
        /* .Len */
        7;
        n++;
        bl_count[7]++;
      }

      while (n <= 287) {
        static_ltree[n * 2 + 1] =
        /* .Len */
        8;
        n++;
        bl_count[8]++;
      }
      /* Codes 286 and 287 do not exist, but we must include them in the
       * tree construction to get a canonical Huffman tree (longest code
       * all ones)
       */


      gen_codes(static_ltree, L_CODES + 1, bl_count);
      /* The static distance tree is trivial: */

      for (n = 0; n < D_CODES; n++) {
        static_dtree[n * 2 + 1] =
        /* .Len */
        5;
        static_dtree[n * 2] =
        /* .Code */
        bi_reverse(n, 5);
      } // Now data ready and we can init static trees


      static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
      static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
      static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS); // static_init_done = true;
    };
    /* ===========================================================================
     * Initialize a new block.
     */


    var init_block = function init_block(s) {
      var n;
      /* iterates over tree elements */

      /* Initialize the trees. */

      for (n = 0; n < L_CODES; n++) {
        s.dyn_ltree[n * 2] =
        /* .Freq */
        0;
      }

      for (n = 0; n < D_CODES; n++) {
        s.dyn_dtree[n * 2] =
        /* .Freq */
        0;
      }

      for (n = 0; n < BL_CODES; n++) {
        s.bl_tree[n * 2] =
        /* .Freq */
        0;
      }

      s.dyn_ltree[END_BLOCK * 2] =
      /* .Freq */
      1;
      s.opt_len = s.static_len = 0;
      s.last_lit = s.matches = 0;
    };
    /* ===========================================================================
     * Flush the bit buffer and align the output on a byte boundary
     */


    var bi_windup = function bi_windup(s) {
      if (s.bi_valid > 8) {
        put_short(s, s.bi_buf);
      } else if (s.bi_valid > 0) {
        // put_byte(s, (Byte)s->bi_buf);
        s.pending_buf[s.pending++] = s.bi_buf;
      }

      s.bi_buf = 0;
      s.bi_valid = 0;
    };
    /* ===========================================================================
     * Copy a stored block, storing first the length and its
     * one's complement if requested.
     */


    var copy_block = function copy_block(s, buf, len, header // DeflateState *s;
    // charf    *buf;    /* the input data */
    // unsigned len;     /* its length */
    // int      header;  /* true if block header must be written */
    ) {
      bi_windup(s);
      /* align on byte boundary */

      if (header) {
        put_short(s, len);
        put_short(s, ~len);
      } //  while (len--) {
      //    put_byte(s, *buf++);
      //  }


      s.pending_buf.set(s.window.subarray(buf, buf + len), s.pending);
      s.pending += len;
    };
    /* ===========================================================================
     * Compares to subtrees, using the tree depth as tie breaker when
     * the subtrees have equal frequency. This minimizes the worst case length.
     */


    var smaller = function smaller(tree, n, m, depth) {
      var _n2 = n * 2;

      var _m2 = m * 2;

      return tree[_n2] <
      /* .Freq */
      tree[_m2] ||
      /* .Freq */
      tree[_n2] ===
      /* .Freq */
      tree[_m2] &&
      /* .Freq */
      depth[n] <= depth[m];
    };
    /* ===========================================================================
     * Restore the heap property by moving down the tree starting at node k,
     * exchanging a node with the smallest of its two sons if necessary, stopping
     * when the heap property is re-established (each father smaller than its
     * two sons).
     */


    var pqdownheap = function pqdownheap(s, tree, k //    deflate_state *s;
    //    ct_data *tree;  /* the tree to restore */
    //    int k;               /* node to move down */
    ) {
      var v = s.heap[k];
      var j = k << 1;
      /* left son of k */

      while (j <= s.heap_len) {
        /* Set j to the smallest of the two sons: */
        if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
          j++;
        }
        /* Exit if v is smaller than both sons */


        if (smaller(tree, v, s.heap[j], s.depth)) {
          break;
        }
        /* Exchange v with the smallest son */


        s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */

        j <<= 1;
      }

      s.heap[k] = v;
    }; // inlined manually
    // const SMALLEST = 1;

    /* ===========================================================================
     * Send the block data compressed using the given Huffman trees
     */


    var compress_block = function compress_block(s, ltree, dtree //    deflate_state *s;
    //    const ct_data *ltree; /* literal tree */
    //    const ct_data *dtree; /* distance tree */
    ) {
      var dist;
      /* distance of matched string */

      var lc;
      /* match length or unmatched char (if dist == 0) */

      var lx = 0;
      /* running index in l_buf */

      var code;
      /* the code to send */

      var extra;
      /* number of extra bits to send */

      if (s.last_lit !== 0) {
        do {
          dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
          lc = s.pending_buf[s.l_buf + lx];
          lx++;

          if (dist === 0) {
            send_code(s, lc, ltree);
            /* send a literal byte */
            // Tracecv(isgraph(lc), (stderr," '%c' ", lc));
          } else {
            /* Here, lc is the match length - MIN_MATCH */
            code = _length_code[lc];
            send_code(s, code + LITERALS + 1, ltree);
            /* send the length code */

            extra = extra_lbits[code];

            if (extra !== 0) {
              lc -= base_length[code];
              send_bits(s, lc, extra);
              /* send the extra length bits */
            }

            dist--;
            /* dist is now the match distance - 1 */

            code = d_code(dist); // Assert (code < D_CODES, "bad d_code");

            send_code(s, code, dtree);
            /* send the distance code */

            extra = extra_dbits[code];

            if (extra !== 0) {
              dist -= base_dist[code];
              send_bits(s, dist, extra);
              /* send the extra distance bits */
            }
          }
          /* literal or match pair ? */

          /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
          // Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
          //       "pendingBuf overflow");

        } while (lx < s.last_lit);
      }

      send_code(s, END_BLOCK, ltree);
    };
    /* ===========================================================================
     * Construct one Huffman tree and assigns the code bit strings and lengths.
     * Update the total bit length for the current block.
     * IN assertion: the field freq is set for all tree elements.
     * OUT assertions: the fields len and code are set to the optimal bit length
     *     and corresponding code. The length opt_len is updated; static_len is
     *     also updated if stree is not null. The field max_code is set.
     */


    var build_tree = function build_tree(s, desc //    deflate_state *s; //    tree_desc *desc; /* the tree descriptor */
    ) {
      var tree = desc.dyn_tree;
      var stree = desc.stat_desc.static_tree;
      var has_stree = desc.stat_desc.has_stree;
      var elems = desc.stat_desc.elems;
      var n;
      var m;
      /* iterate over heap elements */

      var max_code = -1;
      /* largest code with non zero frequency */

      var node;
      /* new node being created */

      /* Construct the initial heap, with least frequent element in
       * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
       * heap[0] is not used.
       */

      s.heap_len = 0;
      s.heap_max = HEAP_SIZE;

      for (n = 0; n < elems; n++) {
        if (tree[n * 2] !==
        /* .Freq */
        0) {
          s.heap[++s.heap_len] = max_code = n;
          s.depth[n] = 0;
        } else {
          tree[n * 2 + 1] =
          /* .Len */
          0;
        }
      }
      /* The pkzip format requires that at least one distance code exists,
       * and that at least one bit should be sent even if there is only one
       * possible code. So to avoid special checks later on we force at least
       * two codes of non zero frequency.
       */


      while (s.heap_len < 2) {
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] =
        /* .Freq */
        1;
        s.depth[node] = 0;
        s.opt_len--;

        if (has_stree) {
          s.static_len -= stree[node * 2 + 1];
          /* .Len */
        }
        /* node is 0 or 1 so it does not have extra bits */

      }

      desc.max_code = max_code;
      /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
       * establish sub-heaps of increasing lengths:
       */

      for (n = s.heap_len >> 1;
      /* int /2 */
      n >= 1; n--) {
        pqdownheap(s, tree, n);
      }
      /* Construct the Huffman tree by repeatedly combining the least two
       * frequent nodes.
       */


      node = elems;
      /* next internal node of the tree */

      do {
        // pqremove(s, tree, n);  /* n = node of least frequency */

        /** * pqremove ** */
        n = s.heap[1];
        /* SMALLEST */

        s.heap[1] = s.heap[s.heap_len--];
        /* SMALLEST */

        pqdownheap(s, tree, 1
        /* SMALLEST */
        );
        /***/

        m = s.heap[1];
        /* SMALLEST */

        /* m = node of next least frequency */

        s.heap[--s.heap_max] = n;
        /* keep the nodes sorted by frequency */

        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */

        tree[node * 2] =
        /* .Freq */
        tree[n * 2] +
        /* .Freq */
        tree[m * 2];
        /* .Freq */

        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] =
        /* .Dad */
        tree[m * 2 + 1] =
        /* .Dad */
        node;
        /* and insert the new node in the heap */

        s.heap[1] = node++;
        /* SMALLEST */

        pqdownheap(s, tree, 1
        /* SMALLEST */
        );
      } while (s.heap_len >= 2);

      s.heap[--s.heap_max] = s.heap[1];
      /* SMALLEST */

      /* At this point, the fields freq and dad are set. We can now
       * generate the bit lengths.
       */

      gen_bitlen(s, desc);
      /* The field len is now set, we can generate the bit codes */

      gen_codes(tree, max_code, s.bl_count);
    };
    /* ===========================================================================
     * Scan a literal or distance tree to determine the frequencies of the codes
     * in the bit length tree.
     */


    var scan_tree = function scan_tree(s, tree, max_code //    deflate_state *s;
    //    ct_data *tree;   /* the tree to be scanned */
    //    int max_code;    /* and its largest code of non zero frequency */
    ) {
      var n;
      /* iterates over all tree elements */

      var prevlen = -1;
      /* last emitted length */

      var curlen;
      /* length of current code */

      var nextlen = tree[0 * 2 + 1];
      /* .Len */

      /* length of next code */

      var count = 0;
      /* repeat count of the current code */

      var max_count = 7;
      /* max repeat count */

      var min_count = 4;
      /* min repeat count */

      if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
      }

      tree[(max_code + 1) * 2 + 1] =
      /* .Len */
      0xffff;
      /* guard */

      for (n = 0; n <= max_code; n++) {
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1];
        /* .Len */

        if (++count < max_count && curlen === nextlen) {
          continue;
        } else if (count < min_count) {
          s.bl_tree[curlen * 2] +=
          /* .Freq */
          count;
        } else if (curlen !== 0) {
          if (curlen !== prevlen) {
            s.bl_tree[curlen * 2] /* .Freq */++;
          }

          s.bl_tree[REP_3_6 * 2] /* .Freq */++;
        } else if (count <= 10) {
          s.bl_tree[REPZ_3_10 * 2] /* .Freq */++;
        } else {
          s.bl_tree[REPZ_11_138 * 2] /* .Freq */++;
        }

        count = 0;
        prevlen = curlen;

        if (nextlen === 0) {
          max_count = 138;
          min_count = 3;
        } else if (curlen === nextlen) {
          max_count = 6;
          min_count = 3;
        } else {
          max_count = 7;
          min_count = 4;
        }
      }
    };
    /* ===========================================================================
     * Send a literal or distance tree in compressed form, using the codes in
     * bl_tree.
     */


    var send_tree = function send_tree(s, tree, max_code //    deflate_state *s;
    //    ct_data *tree; /* the tree to be scanned */
    //    int max_code;       /* and its largest code of non zero frequency */
    ) {
      var n;
      /* iterates over all tree elements */

      var prevlen = -1;
      /* last emitted length */

      var curlen;
      /* length of current code */

      var nextlen = tree[0 * 2 + 1];
      /* .Len */

      /* length of next code */

      var count = 0;
      /* repeat count of the current code */

      var max_count = 7;
      /* max repeat count */

      var min_count = 4;
      /* min repeat count */

      /* tree[max_code+1].Len = -1; */

      /* guard already set */

      if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
      }

      for (n = 0; n <= max_code; n++) {
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1];
        /* .Len */

        if (++count < max_count && curlen === nextlen) {
          continue;
        } else if (count < min_count) {
          do {
            send_code(s, curlen, s.bl_tree);
          } while (--count !== 0);
        } else if (curlen !== 0) {
          if (curlen !== prevlen) {
            send_code(s, curlen, s.bl_tree);
            count--;
          } // Assert(count >= 3 && count <= 6, " 3_6?");


          send_code(s, REP_3_6, s.bl_tree);
          send_bits(s, count - 3, 2);
        } else if (count <= 10) {
          send_code(s, REPZ_3_10, s.bl_tree);
          send_bits(s, count - 3, 3);
        } else {
          send_code(s, REPZ_11_138, s.bl_tree);
          send_bits(s, count - 11, 7);
        }

        count = 0;
        prevlen = curlen;

        if (nextlen === 0) {
          max_count = 138;
          min_count = 3;
        } else if (curlen === nextlen) {
          max_count = 6;
          min_count = 3;
        } else {
          max_count = 7;
          min_count = 4;
        }
      }
    };
    /* ===========================================================================
     * Construct the Huffman tree for the bit lengths and return the index in
     * bl_order of the last bit length code to send.
     */


    var build_bl_tree = function build_bl_tree(s) {
      var max_blindex;
      /* index of last bit length code of non zero freq */

      /* Determine the bit length frequencies for literal and distance trees */

      scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
      scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
      /* Build the bit length tree: */

      build_tree(s, s.bl_desc);
      /* opt_len now includes the length of the tree representations, except
       * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
       */

      /* Determine the number of bit length codes to send. The pkzip format
       * requires that at least 4 bit length codes be sent. (appnote.txt says
       * 3 but the actual value used is 4.)
       */

      for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
        if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !==
        /* .Len */
        0) {
          break;
        }
      }
      /* Update opt_len to include the bit length tree and counts */


      s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4; // Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
      //        s->opt_len, s->static_len));

      return max_blindex;
    };
    /* ===========================================================================
     * Send the header for a block using dynamic Huffman trees: the counts, the
     * lengths of the bit length codes, the literal tree and the distance tree.
     * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
     */


    var send_all_trees = function send_all_trees(s, lcodes, dcodes, blcodes //    deflate_state *s; //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
    ) {
      var rank;
      /* index in bl_order */
      // Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
      // Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
      //        "too many codes");
      // Tracev((stderr, "\nbl counts: "));

      send_bits(s, lcodes - 257, 5);
      /* not +255 as stated in appnote.txt */

      send_bits(s, dcodes - 1, 5);
      send_bits(s, blcodes - 4, 4);
      /* not -3 as stated in appnote.txt */

      for (rank = 0; rank < blcodes; rank++) {
        // Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
        send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1],
        /* .Len */
        3);
      } // Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));


      send_tree(s, s.dyn_ltree, lcodes - 1);
      /* literal tree */
      // Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

      send_tree(s, s.dyn_dtree, dcodes - 1);
      /* distance tree */
      // Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
    };
    /* ===========================================================================
     * Check if the data type is TEXT or BINARY, using the following algorithm:
     * - TEXT if the two conditions below are satisfied:
     *    a) There are no non-portable control characters belonging to the
     *       "black list" (0..6, 14..25, 28..31).
     *    b) There is at least one printable character belonging to the
     *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
     * - BINARY otherwise.
     * - The following partially-portable control characters form a
     *   "gray list" that is ignored in this detection algorithm:
     *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
     * IN assertion: the fields Freq of dyn_ltree are set.
     */


    var detect_data_type = function detect_data_type(s) {
      /* black_mask is the bit mask of black-listed bytes
       * set bits 0..6, 14..25, and 28..31
       * 0xf3ffc07f = binary 11110011111111111100000001111111
       */
      var black_mask = 0xf3ffc07f;
      var n;
      /* Check for non-textual ("black-listed") bytes. */

      for (n = 0; n <= 31; n++, black_mask >>>= 1) {
        if (black_mask & 1 && s.dyn_ltree[n * 2] !==
        /* .Freq */
        0) {
          return Z_BINARY;
        }
      }
      /* Check for textual ("white-listed") bytes. */


      if (s.dyn_ltree[9 * 2] !==
      /* .Freq */
      0 || s.dyn_ltree[10 * 2] !==
      /* .Freq */
      0 || s.dyn_ltree[13 * 2] !==
      /* .Freq */
      0) {
        return Z_TEXT;
      }

      for (n = 32; n < LITERALS; n++) {
        if (s.dyn_ltree[n * 2] !==
        /* .Freq */
        0) {
          return Z_TEXT;
        }
      }
      /* There are no "black-listed" or "white-listed" bytes:
       * this stream either is empty or has tolerated ("gray-listed") bytes only.
       */


      return Z_BINARY;
    };

    var static_init_done = false;
    /* ===========================================================================
     * Initialize the tree data structures for a new zlib stream.
     */

    var _tr_init = function _tr_init(s) {
      if (!static_init_done) {
        tr_static_init();
        static_init_done = true;
      }

      s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
      s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
      s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
      s.bi_buf = 0;
      s.bi_valid = 0;
      /* Initialize the first block of the first file: */

      init_block(s);
    };
    /* ===========================================================================
     * Send a stored block
     */


    var _tr_stored_block = function _tr_stored_block(s, buf, stored_len, last // DeflateState *s;
    // charf *buf;       /* input block */
    // ulg stored_len;   /* length of input block */
    // int last;         /* one if this is the last block for a file */
    ) {
      send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);
      /* send block type */

      copy_block(s, buf, stored_len, true);
      /* with header */
    };
    /* ===========================================================================
     * Send one empty static block to give enough lookahead for inflate.
     * This takes 10 bits, of which 7 may remain in the bit buffer.
     */


    var _tr_align = function _tr_align(s) {
      send_bits(s, STATIC_TREES << 1, 3);
      send_code(s, END_BLOCK, static_ltree);
      bi_flush(s);
    };
    /* ===========================================================================
     * Determine the best encoding for the current block: dynamic trees, static
     * trees or store, and output the encoded block to the zip file.
     */


    var _tr_flush_block = function _tr_flush_block(s, buf, stored_len, last // DeflateState *s;
    // charf *buf;       /* input block, or NULL if too old */
    // ulg stored_len;   /* length of input block */
    // int last;         /* one if this is the last block for a file */
    ) {
      var opt_lenb;
      var static_lenb;
      /* opt_len and static_len in bytes */

      var max_blindex = 0;
      /* index of last bit length code of non zero freq */

      /* Build the Huffman trees unless a stored block is forced */

      if (s.level > 0) {
        /* Check if the file is binary or text */
        if (s.strm.data_type === Z_UNKNOWN) {
          s.strm.data_type = detect_data_type(s);
        }
        /* Construct the literal and distance trees */


        build_tree(s, s.l_desc); // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));

        build_tree(s, s.d_desc); // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));

        /* At this point, opt_len and static_len are the total bit lengths of
         * the compressed block data, excluding the tree representations.
         */

        /* Build the bit length tree for the above two trees, and get the index
         * in bl_order of the last bit length code to send.
         */

        max_blindex = build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */

        opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3; // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));

        if (static_lenb <= opt_lenb) {
          opt_lenb = static_lenb;
        }
      } else {
        // Assert(buf != (char*)0, "lost buf");
        opt_lenb = static_lenb = stored_len + 5;
        /* force a stored block */
      }

      if (stored_len + 4 <= opt_lenb && buf !== -1) {
        /* 4: two words for the lengths */

        /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
         * Otherwise we can't have processed more than WSIZE input bytes since
         * the last block flush, because compression would have been
         * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
         * transform a block into a stored block.
         */
        _tr_stored_block(s, buf, stored_len, last);
      } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
        send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
        compress_block(s, static_ltree, static_dtree);
      } else {
        send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
        send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        compress_block(s, s.dyn_ltree, s.dyn_dtree);
      } // Assert (s->compressed_len == s->bits_sent, "bad compressed size");

      /* The above check is made mod 2^32, for files larger than 512 MB
       * and uLong implemented on 32 bits.
       */


      init_block(s);

      if (last) {
        bi_windup(s);
      } // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
      //       s->compressed_len-7*last));

    };
    /* ===========================================================================
     * Save the match info and tally the frequency counts. Return true if
     * the current block must be flushed.
     */


    var _tr_tally = function _tr_tally(s, dist, lc //    deflate_state *s;
    //    unsigned dist;  /* distance of matched string */
    //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
    ) {
      // let out_length, in_length, dcode;
      s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
      s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
      s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
      s.last_lit++;

      if (dist === 0) {
        /* lc is the unmatched char */
        s.dyn_ltree[lc * 2] /* .Freq */++;
      } else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */

        dist--;
        /* dist = match distance - 1 */
        // Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

        s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2] /* .Freq */++;
        s.dyn_dtree[d_code(dist) * 2] /* .Freq */++;
      } // (!) This block is disabled in zlib defaults,
      // don't enable it for binary compatibility
      // #ifdef TRUNCATE_BLOCK
      //  /* Try to guess if it is profitable to stop the current block here */
      //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
      //    /* Compute an upper bound for the compressed length */
      //    out_length = s.last_lit*8;
      //    in_length = s.strstart - s.block_start;
      //
      //    for (dcode = 0; dcode < D_CODES; dcode++) {
      //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
      //    }
      //    out_length >>>= 3;
      //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
      //    //       s->last_lit, in_length, out_length,
      //    //       100L - out_length*100L/in_length));
      //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
      //      return true;
      //    }
      //  }
      // #endif


      return s.last_lit === s.lit_bufsize - 1;
      /* We avoid equality with lit_bufsize because of wraparound at 64K
       * on 16 bit machines and because stored blocks are restricted to
       * 64K-1 bytes.
       */
    };

    var _tr_init_1 = _tr_init;
    var _tr_stored_block_1 = _tr_stored_block;
    var _tr_flush_block_1 = _tr_flush_block;
    var _tr_tally_1 = _tr_tally;
    var _tr_align_1 = _tr_align;
    var trees = {
      _tr_init: _tr_init_1,
      _tr_stored_block: _tr_stored_block_1,
      _tr_flush_block: _tr_flush_block_1,
      _tr_tally: _tr_tally_1,
      _tr_align: _tr_align_1
    }; // It isn't worth it to make additional optimizations as in original.
    // Small size is preferable.
    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    var adler32 = function adler32(adler, buf, len, pos) {
      var s1 = adler & 0xffff | 0;
      var s2 = adler >>> 16 & 0xffff | 0;
      var n = 0;

      while (len !== 0) {
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;

        do {
          s1 = s1 + buf[pos++] | 0;
          s2 = s2 + s1 | 0;
        } while (--n);

        s1 %= 65521;
        s2 %= 65521;
      }

      return s1 | s2 << 16 | 0;
    };

    var adler32_1 = adler32; // So write code to minimize size - no pregenerated tables
    // and array tools dependencies.
    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.
    // Use ordinary array, since untyped makes no boost here

    var makeTable = function makeTable() {
      var c;
      var table = [];

      for (var n = 0; n < 256; n++) {
        c = n;

        for (var k = 0; k < 8; k++) {
          c = c & 1 ? 0xedb88320 ^ c >>> 1 : c >>> 1;
        }

        table[n] = c;
      }

      return table;
    }; // Create table on load. Just 255 signed longs. Not a problem.


    var crcTable = new Uint32Array(makeTable());

    var crc32 = function crc32(crc, buf, len, pos) {
      var t = crcTable;
      var end = pos + len;
      crc ^= -1;

      for (var i = pos; i < end; i++) {
        crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xff];
      }

      return crc ^ -1; // >>> 0;
    };

    var crc32_1 = crc32; // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    var messages = {
      2: 'need dictionary',

      /* Z_NEED_DICT       2  */
      1: 'stream end',

      /* Z_STREAM_END      1  */
      0: '',

      /* Z_OK              0  */
      '-1': 'file error',

      /* Z_ERRNO         (-1) */
      '-2': 'stream error',

      /* Z_STREAM_ERROR  (-2) */
      '-3': 'data error',

      /* Z_DATA_ERROR    (-3) */
      '-4': 'insufficient memory',

      /* Z_MEM_ERROR     (-4) */
      '-5': 'buffer error',

      /* Z_BUF_ERROR     (-5) */
      '-6': 'incompatible version'
      /* Z_VERSION_ERROR (-6) */

    }; // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    var constants = {
      /* Allowed flush values; see deflate() and inflate() below for details */
      Z_NO_FLUSH: 0,
      Z_PARTIAL_FLUSH: 1,
      Z_SYNC_FLUSH: 2,
      Z_FULL_FLUSH: 3,
      Z_FINISH: 4,
      Z_BLOCK: 5,
      Z_TREES: 6,

      /* Return codes for the compression/decompression functions. Negative values
       * are errors, positive values are used for special but normal events.
       */
      Z_OK: 0,
      Z_STREAM_END: 1,
      Z_NEED_DICT: 2,
      Z_ERRNO: -1,
      Z_STREAM_ERROR: -2,
      Z_DATA_ERROR: -3,
      Z_MEM_ERROR: -4,
      Z_BUF_ERROR: -5,
      // Z_VERSION_ERROR: -6,

      /* compression levels */
      Z_NO_COMPRESSION: 0,
      Z_BEST_SPEED: 1,
      Z_BEST_COMPRESSION: 9,
      Z_DEFAULT_COMPRESSION: -1,
      Z_FILTERED: 1,
      Z_HUFFMAN_ONLY: 2,
      Z_RLE: 3,
      Z_FIXED: 4,
      Z_DEFAULT_STRATEGY: 0,

      /* Possible values of the data_type field (though see inflate()) */
      Z_BINARY: 0,
      Z_TEXT: 1,
      // Z_ASCII:                1, // = Z_TEXT (deprecated)
      Z_UNKNOWN: 2,

      /* The deflate compression method */
      Z_DEFLATED: 8 // Z_NULL:                 null // Use -1 or null inline, depending on var type

    }; // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    var _tr_init$1 = trees._tr_init;
    var _tr_stored_block$1 = trees._tr_stored_block;
    var _tr_flush_block$1 = trees._tr_flush_block;
    var _tr_tally$1 = trees._tr_tally;
    var _tr_align$1 = trees._tr_align;
    /* Public constants ========================================================== */

    /* =========================================================================== */

    var Z_NO_FLUSH = constants.Z_NO_FLUSH;
    var Z_PARTIAL_FLUSH = constants.Z_PARTIAL_FLUSH;
    var Z_FULL_FLUSH = constants.Z_FULL_FLUSH;
    var Z_FINISH = constants.Z_FINISH;
    var Z_BLOCK = constants.Z_BLOCK;
    var Z_OK = constants.Z_OK;
    var Z_STREAM_END = constants.Z_STREAM_END;
    var Z_STREAM_ERROR = constants.Z_STREAM_ERROR;
    var Z_DATA_ERROR = constants.Z_DATA_ERROR;
    var Z_BUF_ERROR = constants.Z_BUF_ERROR;
    var Z_DEFAULT_COMPRESSION = constants.Z_DEFAULT_COMPRESSION;
    var Z_FILTERED = constants.Z_FILTERED;
    var Z_HUFFMAN_ONLY = constants.Z_HUFFMAN_ONLY;
    var Z_RLE = constants.Z_RLE;
    var Z_FIXED$1 = constants.Z_FIXED;
    var Z_DEFAULT_STRATEGY = constants.Z_DEFAULT_STRATEGY;
    var Z_UNKNOWN$1 = constants.Z_UNKNOWN;
    var Z_DEFLATED = constants.Z_DEFLATED;
    /* ============================================================================ */

    var MAX_MEM_LEVEL = 9;
    /* Maximum value for memLevel in deflateInit2 */

    var MAX_WBITS = 15;
    /* 32K LZ77 window */

    var DEF_MEM_LEVEL = 8;
    var LENGTH_CODES$1 = 29;
    /* number of length codes, not counting the special END_BLOCK code */

    var LITERALS$1 = 256;
    /* number of literal bytes 0..255 */

    var L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1;
    /* number of Literal or Length codes, including the END_BLOCK code */

    var D_CODES$1 = 30;
    /* number of distance codes */

    var BL_CODES$1 = 19;
    /* number of codes used to transfer the bit lengths */

    var HEAP_SIZE$1 = 2 * L_CODES$1 + 1;
    /* maximum heap size */

    var MAX_BITS$1 = 15;
    /* All codes must not exceed MAX_BITS bits */

    var MIN_MATCH$1 = 3;
    var MAX_MATCH$1 = 258;
    var MIN_LOOKAHEAD = MAX_MATCH$1 + MIN_MATCH$1 + 1;
    var PRESET_DICT = 0x20;
    var INIT_STATE = 42;
    var EXTRA_STATE = 69;
    var NAME_STATE = 73;
    var COMMENT_STATE = 91;
    var HCRC_STATE = 103;
    var BUSY_STATE = 113;
    var FINISH_STATE = 666;
    var BS_NEED_MORE = 1;
    /* block not completed, need more input or more output */

    var BS_BLOCK_DONE = 2;
    /* block flush performed */

    var BS_FINISH_STARTED = 3;
    /* finish started, need only more output at next deflate */

    var BS_FINISH_DONE = 4;
    /* finish done, accept no more input or output */

    var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

    var err = function err(strm, errorCode) {
      strm.msg = messages[errorCode];
      return errorCode;
    };

    var rank = function rank(f) {
      return (f << 1) - (f > 4 ? 9 : 0);
    };

    var zero$1 = function zero(buf) {
      var len = buf.length;

      while (--len >= 0) {
        buf[len] = 0;
      }
    };

    var HASH_ZLIB = function HASH_ZLIB(s, prev, data) {
      return (prev << s.hash_shift ^ data) & s.hash_mask;
    }; // This hash causes less collisions, https://github.com/nodeca/pako/issues/135
    // But breaks binary compatibility
    // let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;


    var HASH = HASH_ZLIB;
    /* =========================================================================
     * Flush as much pending output as possible. All deflate() output goes
     * through this function so some applications may wish to modify it
     * to avoid allocating a large strm->output buffer and copying into it.
     * (See also read_buf()).
     */

    var flush_pending = function flush_pending(strm) {
      var s = strm.state; // _tr_flush_bits(s);

      var len = s.pending;

      if (len > strm.avail_out) {
        len = strm.avail_out;
      }

      if (len === 0) {
        return;
      }

      strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
      strm.next_out += len;
      s.pending_out += len;
      strm.total_out += len;
      strm.avail_out -= len;
      s.pending -= len;

      if (s.pending === 0) {
        s.pending_out = 0;
      }
    };

    var flush_block_only = function flush_block_only(s, last) {
      _tr_flush_block$1(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);

      s.block_start = s.strstart;
      flush_pending(s.strm);
    };

    var put_byte = function put_byte(s, b) {
      s.pending_buf[s.pending++] = b;
    };
    /* =========================================================================
     * Put a short in the pending buffer. The 16-bit value is put in MSB order.
     * IN assertion: the stream state is correct and there is enough room in
     * pending_buf.
     */


    var putShortMSB = function putShortMSB(s, b) {
      //  put_byte(s, (Byte)(b >> 8));
      //  put_byte(s, (Byte)(b & 0xff));
      s.pending_buf[s.pending++] = b >>> 8 & 0xff;
      s.pending_buf[s.pending++] = b & 0xff;
    };
    /* ===========================================================================
     * Read a new buffer from the current input stream, update the adler32
     * and total number of bytes read.  All deflate() input goes through
     * this function so some applications may wish to modify it to avoid
     * allocating a large strm->input buffer and copying from it.
     * (See also flush_pending()).
     */


    var read_buf = function read_buf(strm, buf, start, size) {
      var len = strm.avail_in;

      if (len > size) {
        len = size;
      }

      if (len === 0) {
        return 0;
      }

      strm.avail_in -= len; // zmemcpy(buf, strm->next_in, len);

      buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);

      if (strm.state.wrap === 1) {
        strm.adler = adler32_1(strm.adler, buf, len, start);
      } else if (strm.state.wrap === 2) {
        strm.adler = crc32_1(strm.adler, buf, len, start);
      }

      strm.next_in += len;
      strm.total_in += len;
      return len;
    };
    /* ===========================================================================
     * Set match_start to the longest match starting at the given string and
     * return its length. Matches shorter or equal to prev_length are discarded,
     * in which case the result is equal to prev_length and match_start is
     * garbage.
     * IN assertions: cur_match is the head of the hash chain for the current
     *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
     * OUT assertion: the match length is not greater than s->lookahead.
     */


    var longest_match = function longest_match(s, cur_match) {
      var chain_length = s.max_chain_length;
      /* max hash chain length */

      var scan = s.strstart;
      /* current string */

      var match;
      /* matched string */

      var len;
      /* length of current match */

      var best_len = s.prev_length;
      /* best match length so far */

      var nice_match = s.nice_match;
      /* stop if match long enough */

      var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0;
      /* NIL */

      var _win = s.window; // shortcut

      var wmask = s.w_mask;
      var prev = s.prev;
      /* Stop when cur_match becomes <= limit. To simplify the code,
       * we prevent matches with the string of window index 0.
       */

      var strend = s.strstart + MAX_MATCH$1;
      var scan_end1 = _win[scan + best_len - 1];
      var scan_end = _win[scan + best_len];
      /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
       * It is easy to get rid of this optimization if necessary.
       */
      // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

      /* Do not waste too much time if we already have a good match: */

      if (s.prev_length >= s.good_match) {
        chain_length >>= 2;
      }
      /* Do not look for matches beyond the end of the input. This is necessary
       * to make deflate deterministic.
       */


      if (nice_match > s.lookahead) {
        nice_match = s.lookahead;
      } // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");


      do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
         * or if the match length is less than 2.  Note that the checks below
         * for insufficient lookahead only occur occasionally for performance
         * reasons.  Therefore uninitialized memory will be accessed, and
         * conditional jumps will be made that depend on those values.
         * However the length of the match is limited to the lookahead, so
         * the output of deflate is not affected by the uninitialized values.
         */

        if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) {
          continue;
        }
        /* The check at best_len-1 can be removed because it will be made
         * again later. (This heuristic is not always a win.)
         * It is not necessary to compare scan[2] and match[2] since they
         * are always equal when the other bytes match, given that
         * the hash keys are equal and that HASH_BITS >= 8.
         */


        scan += 2;
        match++; // Assert(*scan == *match, "match[2]?");

        /* We check for insufficient lookahead only every 8th comparison;
         * the 256th check will be made at strstart+258.
         */

        do {
          /* jshint noempty:false */
        } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend); // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");


        len = MAX_MATCH$1 - (strend - scan);
        scan = strend - MAX_MATCH$1;

        if (len > best_len) {
          s.match_start = cur_match;
          best_len = len;

          if (len >= nice_match) {
            break;
          }

          scan_end1 = _win[scan + best_len - 1];
          scan_end = _win[scan + best_len];
        }
      } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

      if (best_len <= s.lookahead) {
        return best_len;
      }

      return s.lookahead;
    };
    /* ===========================================================================
     * Fill the window when the lookahead becomes insufficient.
     * Updates strstart and lookahead.
     *
     * IN assertion: lookahead < MIN_LOOKAHEAD
     * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
     *    At least one byte has been read, or avail_in == 0; reads are
     *    performed for at least two bytes (required for the zip translate_eol
     *    option -- not supported here).
     */


    var fill_window = function fill_window(s) {
      var _w_size = s.w_size;
      var p;
      var n;
      var m;
      var more;
      var str; // Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

      do {
        more = s.window_size - s.lookahead - s.strstart; // JS ints have 32 bit, block below not needed

        /* Deal with !@#$% 64K limit: */
        // if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        // }

        /* If the window is almost full and there is insufficient lookahead,
         * move the upper half to the lower one to make room in the upper half.
         */

        if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
          s.window.set(s.window.subarray(_w_size, _w_size + _w_size), 0);
          s.match_start -= _w_size;
          s.strstart -= _w_size;
          /* we now have strstart >= MAX_DIST */

          s.block_start -= _w_size;
          /* Slide the hash table (could be avoided with 32 bit values
          at the expense of memory usage). We slide even when level == 0
          to keep the hash table consistent if we switch back to level > 0
          later. (Using level 0 permanently is not an optimal usage of
          zlib, so we don't care about this pathological case.)
          */

          n = s.hash_size;
          p = n;

          do {
            m = s.head[--p];
            s.head[p] = m >= _w_size ? m - _w_size : 0;
          } while (--n);

          n = _w_size;
          p = n;

          do {
            m = s.prev[--p];
            s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
             * its value will never be used.
             */
          } while (--n);

          more += _w_size;
        }

        if (s.strm.avail_in === 0) {
          break;
        }
        /* If there was no sliding:
         *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
         *    more == window_size - lookahead - strstart
         * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
         * => more >= window_size - 2*WSIZE + 2
         * In the BIG_MEM or MMAP case (not yet supported),
         *   window_size == input_size + MIN_LOOKAHEAD  &&
         *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
         * Otherwise, window_size == 2*WSIZE so more >= 2.
         * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
         */
        // Assert(more >= 2, "more < 2");


        n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */

        if (s.lookahead + s.insert >= MIN_MATCH$1) {
          str = s.strstart - s.insert;
          s.ins_h = s.window[str];
          /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */

          s.ins_h = HASH(s, s.ins_h, s.window[str + 1]); // #if MIN_MATCH != 3
          //        Call update_hash() MIN_MATCH-3 more times
          // #endif

          while (s.insert) {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
            s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH$1 - 1]);
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
            s.insert--;

            if (s.lookahead + s.insert < MIN_MATCH$1) {
              break;
            }
          }
        }
        /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
         * but this is not important since only literal bytes will be emitted.
         */

      } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
      /* If the WIN_INIT bytes after the end of the current data have never been
       * written, then zero those bytes in order to avoid memory check reports of
       * the use of uninitialized (or uninitialised as Julian writes) bytes by
       * the longest match routines.  Update the high water mark for the next
       * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
       * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
       */
      //  if (s.high_water < s.window_size) {
      //    const curr = s.strstart + s.lookahead;
      //    let init = 0;
      //
      //    if (s.high_water < curr) {
      //      /* Previous high water mark below current data -- zero WIN_INIT
      //       * bytes or up to end of window, whichever is less.
      //       */
      //      init = s.window_size - curr;
      //      if (init > WIN_INIT)
      //        init = WIN_INIT;
      //      zmemzero(s->window + curr, (unsigned)init);
      //      s->high_water = curr + init;
      //    }
      //    else if (s->high_water < (ulg)curr + WIN_INIT) {
      //      /* High water mark at or above current data, but below current data
      //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
      //       * to end of window, whichever is less.
      //       */
      //      init = (ulg)curr + WIN_INIT - s->high_water;
      //      if (init > s->window_size - s->high_water)
      //        init = s->window_size - s->high_water;
      //      zmemzero(s->window + s->high_water, (unsigned)init);
      //      s->high_water += init;
      //    }
      //  }
      //
      //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
      //    "not enough room for search");

    };
    /* ===========================================================================
     * Copy without compression as much as possible from the input stream, return
     * the current block state.
     * This function does not insert new strings in the dictionary since
     * uncompressible data is probably not useful. This function is used
     * only for the level=0 compression option.
     * NOTE: this function should be optimized to avoid extra copying from
     * window to pending_buf.
     */


    var deflate_stored = function deflate_stored(s, flush) {
      /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
       * to pending_buf_size, and each stored block has a 5 byte header:
       */
      var max_block_size = 0xffff;

      if (max_block_size > s.pending_buf_size - 5) {
        max_block_size = s.pending_buf_size - 5;
      }
      /* Copy as much as possible from input to output: */


      for (;;) {
        /* Fill the window as much as possible: */
        if (s.lookahead <= 1) {
          // Assert(s->strstart < s->w_size+MAX_DIST(s) ||
          //  s->block_start >= (long)s->w_size, "slide too late");
          //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
          //        s.block_start >= s.w_size)) {
          //        throw  new Error("slide too late");
          //      }
          fill_window(s);

          if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
            return BS_NEED_MORE;
          }

          if (s.lookahead === 0) {
            break;
          }
          /* flush the current block */

        } // Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");


        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */

        var max_start = s.block_start + max_block_size;

        if (s.strstart === 0 || s.strstart >= max_start) {
          /* strstart == 0 is possible when wraparound on 16-bit machine */
          s.lookahead = s.strstart - max_start;
          s.strstart = max_start;
          /** * FLUSH_BLOCK(s, 0); ** */

          flush_block_only(s, false);

          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/

        }
        /* Flush if we may have to slide, otherwise block_start may become
         * negative and the data will be gone:
         */


        if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
          /** * FLUSH_BLOCK(s, 0); ** */
          flush_block_only(s, false);

          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/

        }
      }

      s.insert = 0;

      if (flush === Z_FINISH) {
        /** * FLUSH_BLOCK(s, 1); ** */
        flush_block_only(s, true);

        if (s.strm.avail_out === 0) {
          return BS_FINISH_STARTED;
        }
        /***/


        return BS_FINISH_DONE;
      }

      if (s.strstart > s.block_start) {
        /** * FLUSH_BLOCK(s, 0); ** */
        flush_block_only(s, false);

        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/

      }

      return BS_NEED_MORE;
    };
    /* ===========================================================================
     * Compress as much as possible from the input stream, return the current
     * block state.
     * This function does not perform lazy evaluation of matches and inserts
     * new strings in the dictionary only for unmatched strings or for short
     * matches. It is used only for the fast compression options.
     */


    var deflate_fast = function deflate_fast(s, flush) {
      var hash_head;
      /* head of the hash chain */

      var bflush;
      /* set if current block must be flushed */

      for (;;) {
        /* Make sure that we always have enough lookahead, except
         * at the end of the input file. We need MAX_MATCH bytes
         * for the next match, plus MIN_MATCH bytes to insert the
         * string following the next match.
         */
        if (s.lookahead < MIN_LOOKAHEAD) {
          fill_window(s);

          if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
            return BS_NEED_MORE;
          }

          if (s.lookahead === 0) {
            break;
            /* flush the current block */
          }
        }
        /* Insert the string window[strstart .. strstart+2] in the
         * dictionary, and set hash_head to the head of the hash chain:
         */


        hash_head = 0;
        /* NIL */

        if (s.lookahead >= MIN_MATCH$1) {
          /** * INSERT_STRING(s, s.strstart, hash_head); ** */
          s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
        /* Find the longest match, discarding those <= prev_length.
         * At this point we have always match_length < MIN_MATCH
         */


        if (hash_head !== 0 &&
        /* NIL */
        s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
          /* To simplify the code, we prevent matches with the string
           * of window index 0 (in particular we have to avoid a match
           * of the string with itself at the start of the input file).
           */
          s.match_length = longest_match(s, hash_head);
          /* longest_match() sets match_start */
        }

        if (s.match_length >= MIN_MATCH$1) {
          // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

          /** * _tr_tally_dist(s, s.strstart - s.match_start,
                       s.match_length - MIN_MATCH, bflush); ** */
          bflush = _tr_tally$1(s, s.strstart - s.match_start, s.match_length - MIN_MATCH$1);
          s.lookahead -= s.match_length;
          /* Insert new strings in the hash table only if the match length
           * is not too large. This saves time but degrades compression.
           */

          if (s.match_length <= s.max_lazy_match &&
          /* max_insert_length */
          s.lookahead >= MIN_MATCH$1) {
            s.match_length--;
            /* string at strstart already in table */

            do {
              s.strstart++;
              /** * INSERT_STRING(s, s.strstart, hash_head); ** */

              s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
              hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
              s.head[s.ins_h] = s.strstart;
              /***/

              /* strstart never exceeds WSIZE-MAX_MATCH, so there are
               * always MIN_MATCH bytes ahead.
               */
            } while (--s.match_length !== 0);

            s.strstart++;
          } else {
            s.strstart += s.match_length;
            s.match_length = 0;
            s.ins_h = s.window[s.strstart];
            /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */

            s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + 1]); // #if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            // #endif

            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
             * matter since it will be recomputed at next deflate call.
             */
          }
        } else {
          /* No match, output a literal byte */
          // Tracevv((stderr,"%c", s.window[s.strstart]));

          /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
          bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
          s.lookahead--;
          s.strstart++;
        }

        if (bflush) {
          /** * FLUSH_BLOCK(s, 0); ** */
          flush_block_only(s, false);

          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/

        }
      }

      s.insert = s.strstart < MIN_MATCH$1 - 1 ? s.strstart : MIN_MATCH$1 - 1;

      if (flush === Z_FINISH) {
        /** * FLUSH_BLOCK(s, 1); ** */
        flush_block_only(s, true);

        if (s.strm.avail_out === 0) {
          return BS_FINISH_STARTED;
        }
        /***/


        return BS_FINISH_DONE;
      }

      if (s.last_lit) {
        /** * FLUSH_BLOCK(s, 0); ** */
        flush_block_only(s, false);

        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/

      }

      return BS_BLOCK_DONE;
    };
    /* ===========================================================================
     * Same as above, but achieves better compression. We use a lazy
     * evaluation for matches: a match is finally adopted only if there is
     * no better match at the next window position.
     */


    var deflate_slow = function deflate_slow(s, flush) {
      var hash_head;
      /* head of hash chain */

      var bflush;
      /* set if current block must be flushed */

      var max_insert;
      /* Process the input block. */

      for (;;) {
        /* Make sure that we always have enough lookahead, except
         * at the end of the input file. We need MAX_MATCH bytes
         * for the next match, plus MIN_MATCH bytes to insert the
         * string following the next match.
         */
        if (s.lookahead < MIN_LOOKAHEAD) {
          fill_window(s);

          if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
            return BS_NEED_MORE;
          }

          if (s.lookahead === 0) {
            break;
          }
          /* flush the current block */

        }
        /* Insert the string window[strstart .. strstart+2] in the
         * dictionary, and set hash_head to the head of the hash chain:
         */


        hash_head = 0;
        /* NIL */

        if (s.lookahead >= MIN_MATCH$1) {
          /** * INSERT_STRING(s, s.strstart, hash_head); ** */
          s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
        /* Find the longest match, discarding those <= prev_length.
         */


        s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = MIN_MATCH$1 - 1;

        if (hash_head !== 0 &&
        /* NIL */
        s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD
        /* MAX_DIST(s) */
        ) {
            /* To simplify the code, we prevent matches with the string
             * of window index 0 (in particular we have to avoid a match
             * of the string with itself at the start of the input file).
             */
            s.match_length = longest_match(s, hash_head);
            /* longest_match() sets match_start */

            if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH$1 && s.strstart - s.match_start > 4096)
            /* TOO_FAR */
            ) {
                /* If prev_match is also MIN_MATCH, match_start is garbage
                 * but we will ignore the current match anyway.
                 */
                s.match_length = MIN_MATCH$1 - 1;
              }
          }
        /* If there was a match at the previous step and the current
         * match is not better, output the previous match:
         */


        if (s.prev_length >= MIN_MATCH$1 && s.match_length <= s.prev_length) {
          max_insert = s.strstart + s.lookahead - MIN_MATCH$1;
          /* Do not insert strings in hash table beyond this. */
          // check_match(s, s.strstart-1, s.prev_match, s.prev_length);

          /** *_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                       s.prev_length - MIN_MATCH, bflush);** */

          bflush = _tr_tally$1(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH$1);
          /* Insert in hash table all strings up to the end of the match.
           * strstart-1 and strstart are already inserted. If there is not
           * enough lookahead, the last two strings are not inserted in
           * the hash table.
           */

          s.lookahead -= s.prev_length - 1;
          s.prev_length -= 2;

          do {
            if (++s.strstart <= max_insert) {
              /** * INSERT_STRING(s, s.strstart, hash_head); ** */
              s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
              hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
              s.head[s.ins_h] = s.strstart;
              /***/
            }
          } while (--s.prev_length !== 0);

          s.match_available = 0;
          s.match_length = MIN_MATCH$1 - 1;
          s.strstart++;

          if (bflush) {
            /** * FLUSH_BLOCK(s, 0); ** */
            flush_block_only(s, false);

            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/

          }
        } else if (s.match_available) {
          /* If there was no match at the previous position, output a
           * single literal. If there was a match but the current match
           * is longer, truncate the previous match to a single literal.
           */
          // Tracevv((stderr,"%c", s->window[s->strstart-1]));

          /** * _tr_tally_lit(s, s.window[s.strstart-1], bflush); ** */
          bflush = _tr_tally$1(s, 0, s.window[s.strstart - 1]);

          if (bflush) {
            /** * FLUSH_BLOCK_ONLY(s, 0) ** */
            flush_block_only(s, false);
            /***/
          }

          s.strstart++;
          s.lookahead--;

          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
        } else {
          /* There is no previous match to compare with, wait for
           * the next step to decide.
           */
          s.match_available = 1;
          s.strstart++;
          s.lookahead--;
        }
      } // Assert (flush != Z_NO_FLUSH, "no flush?");


      if (s.match_available) {
        // Tracevv((stderr,"%c", s->window[s->strstart-1]));

        /** * _tr_tally_lit(s, s.window[s.strstart-1], bflush); ** */
        bflush = _tr_tally$1(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
      }

      s.insert = s.strstart < MIN_MATCH$1 - 1 ? s.strstart : MIN_MATCH$1 - 1;

      if (flush === Z_FINISH) {
        /** * FLUSH_BLOCK(s, 1); ** */
        flush_block_only(s, true);

        if (s.strm.avail_out === 0) {
          return BS_FINISH_STARTED;
        }
        /***/


        return BS_FINISH_DONE;
      }

      if (s.last_lit) {
        /** * FLUSH_BLOCK(s, 0); ** */
        flush_block_only(s, false);

        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/

      }

      return BS_BLOCK_DONE;
    };
    /* ===========================================================================
     * For Z_RLE, simply look for runs of bytes, generate matches only of distance
     * one.  Do not maintain a hash table.  (It will be regenerated if this run of
     * deflate switches away from Z_RLE.)
     */


    var deflate_rle = function deflate_rle(s, flush) {
      var bflush;
      /* set if current block must be flushed */

      var prev;
      /* byte at distance one to match */

      var scan;
      var strend;
      /* scan goes up to strend for length of run */

      var _win = s.window;

      for (;;) {
        /* Make sure that we always have enough lookahead, except
         * at the end of the input file. We need MAX_MATCH bytes
         * for the longest run, plus one for the unrolled loop.
         */
        if (s.lookahead <= MAX_MATCH$1) {
          fill_window(s);

          if (s.lookahead <= MAX_MATCH$1 && flush === Z_NO_FLUSH) {
            return BS_NEED_MORE;
          }

          if (s.lookahead === 0) {
            break;
          }
          /* flush the current block */

        }
        /* See how many times the previous byte repeats */


        s.match_length = 0;

        if (s.lookahead >= MIN_MATCH$1 && s.strstart > 0) {
          scan = s.strstart - 1;
          prev = _win[scan];

          if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
            strend = s.strstart + MAX_MATCH$1;

            do {
              /* jshint noempty:false */
            } while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);

            s.match_length = MAX_MATCH$1 - (strend - scan);

            if (s.match_length > s.lookahead) {
              s.match_length = s.lookahead;
            }
          } // Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");

        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */


        if (s.match_length >= MIN_MATCH$1) {
          // check_match(s, s.strstart, s.strstart - 1, s.match_length);

          /** * _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ** */
          bflush = _tr_tally$1(s, 1, s.match_length - MIN_MATCH$1);
          s.lookahead -= s.match_length;
          s.strstart += s.match_length;
          s.match_length = 0;
        } else {
          /* No match, output a literal byte */
          // Tracevv((stderr,"%c", s->window[s->strstart]));

          /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
          bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
          s.lookahead--;
          s.strstart++;
        }

        if (bflush) {
          /** * FLUSH_BLOCK(s, 0); ** */
          flush_block_only(s, false);

          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/

        }
      }

      s.insert = 0;

      if (flush === Z_FINISH) {
        /** * FLUSH_BLOCK(s, 1); ** */
        flush_block_only(s, true);

        if (s.strm.avail_out === 0) {
          return BS_FINISH_STARTED;
        }
        /***/


        return BS_FINISH_DONE;
      }

      if (s.last_lit) {
        /** * FLUSH_BLOCK(s, 0); ** */
        flush_block_only(s, false);

        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/

      }

      return BS_BLOCK_DONE;
    };
    /* ===========================================================================
     * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
     * (It will be regenerated if this run of deflate switches away from Huffman.)
     */


    var deflate_huff = function deflate_huff(s, flush) {
      var bflush;
      /* set if current block must be flushed */

      for (;;) {
        /* Make sure that we have a literal to write. */
        if (s.lookahead === 0) {
          fill_window(s);

          if (s.lookahead === 0) {
            if (flush === Z_NO_FLUSH) {
              return BS_NEED_MORE;
            }

            break;
            /* flush the current block */
          }
        }
        /* Output a literal byte */


        s.match_length = 0; // Tracevv((stderr,"%c", s->window[s->strstart]));

        /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */

        bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;

        if (bflush) {
          /** * FLUSH_BLOCK(s, 0); ** */
          flush_block_only(s, false);

          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/

        }
      }

      s.insert = 0;

      if (flush === Z_FINISH) {
        /** * FLUSH_BLOCK(s, 1); ** */
        flush_block_only(s, true);

        if (s.strm.avail_out === 0) {
          return BS_FINISH_STARTED;
        }
        /***/


        return BS_FINISH_DONE;
      }

      if (s.last_lit) {
        /** * FLUSH_BLOCK(s, 0); ** */
        flush_block_only(s, false);

        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/

      }

      return BS_BLOCK_DONE;
    };
    /* Values for max_lazy_match, good_match and max_chain_length, depending on
     * the desired pack level (0..9). The values given below have been tuned to
     * exclude worst case performance for pathological files. Better values may be
     * found for specific files.
     */


    function Config(good_length, max_lazy, nice_length, max_chain, func) {
      this.good_length = good_length;
      this.max_lazy = max_lazy;
      this.nice_length = nice_length;
      this.max_chain = max_chain;
      this.func = func;
    }

    var configuration_table = [
    /*      good lazy nice chain */
    new Config(0, 0, 0, 0, deflate_stored),
    /* 0 store only */
    new Config(4, 4, 8, 4, deflate_fast),
    /* 1 max speed, no lazy matches */
    new Config(4, 5, 16, 8, deflate_fast),
    /* 2 */
    new Config(4, 6, 32, 32, deflate_fast),
    /* 3 */
    new Config(4, 4, 16, 16, deflate_slow),
    /* 4 lazy matches */
    new Config(8, 16, 32, 32, deflate_slow),
    /* 5 */
    new Config(8, 16, 128, 128, deflate_slow),
    /* 6 */
    new Config(8, 32, 128, 256, deflate_slow),
    /* 7 */
    new Config(32, 128, 258, 1024, deflate_slow),
    /* 8 */
    new Config(32, 258, 258, 4096, deflate_slow)
    /* 9 max compression */
    ];
    /* ===========================================================================
     * Initialize the "longest match" routines for a new zlib stream
     */

    var lm_init = function lm_init(s) {
      s.window_size = 2 * s.w_size;
      /** * CLEAR_HASH(s); ** */

      zero$1(s.head); // Fill with NIL (= 0);

      /* Set the default configuration parameters:
       */

      s.max_lazy_match = configuration_table[s.level].max_lazy;
      s.good_match = configuration_table[s.level].good_length;
      s.nice_match = configuration_table[s.level].nice_length;
      s.max_chain_length = configuration_table[s.level].max_chain;
      s.strstart = 0;
      s.block_start = 0;
      s.lookahead = 0;
      s.insert = 0;
      s.match_length = s.prev_length = MIN_MATCH$1 - 1;
      s.match_available = 0;
      s.ins_h = 0;
    };

    function DeflateState() {
      this.strm = null;
      /* pointer back to this zlib stream */

      this.status = 0;
      /* as the name implies */

      this.pending_buf = null;
      /* output still pending */

      this.pending_buf_size = 0;
      /* size of pending_buf */

      this.pending_out = 0;
      /* next pending byte to output to the stream */

      this.pending = 0;
      /* nb of bytes in the pending buffer */

      this.wrap = 0;
      /* bit 0 true for zlib, bit 1 true for gzip */

      this.gzhead = null;
      /* gzip header information to write */

      this.gzindex = 0;
      /* where in extra, name, or comment */

      this.method = Z_DEFLATED;
      /* can only be DEFLATED */

      this.last_flush = -1;
      /* value of flush param for previous deflate call */

      this.w_size = 0;
      /* LZ77 window size (32K by default) */

      this.w_bits = 0;
      /* log2(w_size)  (8..16) */

      this.w_mask = 0;
      /* w_size - 1 */

      this.window = null;
      /* Sliding window. Input bytes are read into the second half of the window,
       * and move to the first half later to keep a dictionary of at least wSize
       * bytes. With this organization, matches are limited to a distance of
       * wSize-MAX_MATCH bytes, but this ensures that IO is always
       * performed with a length multiple of the block size.
       */

      this.window_size = 0;
      /* Actual size of window: 2*wSize, except when the user input buffer
       * is directly used as sliding window.
       */

      this.prev = null;
      /* Link to older string with same hash index. To limit the size of this
       * array to 64K, this link is maintained only for the last 32K strings.
       * An index in this array is thus a window index modulo 32K.
       */

      this.head = null;
      /* Heads of the hash chains or NIL. */

      this.ins_h = 0;
      /* hash index of string to be inserted */

      this.hash_size = 0;
      /* number of elements in hash table */

      this.hash_bits = 0;
      /* log2(hash_size) */

      this.hash_mask = 0;
      /* hash_size-1 */

      this.hash_shift = 0;
      /* Number of bits by which ins_h must be shifted at each input
       * step. It must be such that after MIN_MATCH steps, the oldest
       * byte no longer takes part in the hash key, that is:
       *   hash_shift * MIN_MATCH >= hash_bits
       */

      this.block_start = 0;
      /* Window position at the beginning of the current output block. Gets
       * negative when the window is moved backwards.
       */

      this.match_length = 0;
      /* length of best match */

      this.prev_match = 0;
      /* previous match */

      this.match_available = 0;
      /* set if previous match exists */

      this.strstart = 0;
      /* start of string to insert */

      this.match_start = 0;
      /* start of matching string */

      this.lookahead = 0;
      /* number of valid bytes ahead in window */

      this.prev_length = 0;
      /* Length of the best match at previous step. Matches not greater than this
       * are discarded. This is used in the lazy match evaluation.
       */

      this.max_chain_length = 0;
      /* To speed up deflation, hash chains are never searched beyond this
       * length.  A higher limit improves compression ratio but degrades the
       * speed.
       */

      this.max_lazy_match = 0;
      /* Attempt to find a better match only when the current match is strictly
       * smaller than this value. This mechanism is used only for compression
       * levels >= 4.
       */
      // That's alias to max_lazy_match, don't use directly
      // this.max_insert_length = 0;

      /* Insert new strings in the hash table only if the match length is not
       * greater than this length. This saves time but degrades compression.
       * max_insert_length is used only for compression levels <= 3.
       */

      this.level = 0;
      /* compression level (1..9) */

      this.strategy = 0;
      /* favor or force Huffman coding */

      this.good_match = 0;
      /* Use a faster search when the previous match is longer than this */

      this.nice_match = 0;
      /* Stop searching when current match exceeds this */

      /* used by trees.c: */

      /* Didn't use ct_data typedef below to suppress compiler warning */
      // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
      // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
      // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
      // Use flat array of DOUBLE size, with interleaved fata,
      // because JS does not support effective

      this.dyn_ltree = new Uint16Array(HEAP_SIZE$1 * 2);
      this.dyn_dtree = new Uint16Array((2 * D_CODES$1 + 1) * 2);
      this.bl_tree = new Uint16Array((2 * BL_CODES$1 + 1) * 2);
      zero$1(this.dyn_ltree);
      zero$1(this.dyn_dtree);
      zero$1(this.bl_tree);
      this.l_desc = null;
      /* desc. for literal tree */

      this.d_desc = null;
      /* desc. for distance tree */

      this.bl_desc = null;
      /* desc. for bit length tree */
      // ush bl_count[MAX_BITS+1];

      this.bl_count = new Uint16Array(MAX_BITS$1 + 1);
      /* number of codes at each bit length for an optimal tree */
      // int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */

      this.heap = new Uint16Array(2 * L_CODES$1 + 1);
      /* heap used to build the Huffman trees */

      zero$1(this.heap);
      this.heap_len = 0;
      /* number of elements in the heap */

      this.heap_max = 0;
      /* element of largest frequency */

      /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
       * The same heap array is used to build all trees.
       */

      this.depth = new Uint16Array(2 * L_CODES$1 + 1); // uch depth[2*L_CODES+1];

      zero$1(this.depth);
      /* Depth of each subtree used as tie breaker for trees of equal frequency
       */

      this.l_buf = 0;
      /* buffer index for literals or lengths */

      this.lit_bufsize = 0;
      /* Size of match buffer for literals/lengths.  There are 4 reasons for
       * limiting lit_bufsize to 64K:
       *   - frequencies can be kept in 16 bit counters
       *   - if compression is not successful for the first block, all input
       *     data is still in the window so we can still emit a stored block even
       *     when input comes from standard input.  (This can also be done for
       *     all blocks if lit_bufsize is not greater than 32K.)
       *   - if compression is not successful for a file smaller than 64K, we can
       *     even emit a stored file instead of a stored block (saving 5 bytes).
       *     This is applicable only for zip (not gzip or zlib).
       *   - creating new Huffman trees less frequently may not provide fast
       *     adaptation to changes in the input data statistics. (Take for
       *     example a binary file with poorly compressible code followed by
       *     a highly compressible string table.) Smaller buffer sizes give
       *     fast adaptation but have of course the overhead of transmitting
       *     trees more frequently.
       *   - I can't count above 4
       */

      this.last_lit = 0;
      /* running index in l_buf */

      this.d_buf = 0;
      /* Buffer index for distances. To simplify the code, d_buf and l_buf have
       * the same number of elements. To use different lengths, an extra flag
       * array would be necessary.
       */

      this.opt_len = 0;
      /* bit length of current block with optimal trees */

      this.static_len = 0;
      /* bit length of current block with static trees */

      this.matches = 0;
      /* number of string matches in current block */

      this.insert = 0;
      /* bytes at end of window left to insert */

      this.bi_buf = 0;
      /* Output buffer. bits are inserted starting at the bottom (least
       * significant bits).
       */

      this.bi_valid = 0;
      /* Number of valid bits in bi_buf.  All bits above the last valid bit
       * are always zero.
       */
      // Used for window memory init. We safely ignore it for JS. That makes
      // sense only for pointers and memory check tools.
      // this.high_water = 0;

      /* High water mark offset in window for initialized bytes -- bytes above
       * this are set to zero in order to avoid memory check warnings when
       * longest match routines access bytes past the input.  This is then
       * updated to the new high water mark.
       */
    }

    var deflateResetKeep = function deflateResetKeep(strm) {
      if (!strm || !strm.state) {
        return err(strm, Z_STREAM_ERROR);
      }

      strm.total_in = strm.total_out = 0;
      strm.data_type = Z_UNKNOWN$1;
      var s = strm.state;
      s.pending = 0;
      s.pending_out = 0;

      if (s.wrap < 0) {
        s.wrap = -s.wrap;
        /* was made negative by deflate(..., Z_FINISH); */
      }

      s.status = s.wrap ? INIT_STATE : BUSY_STATE;
      strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
      : 1; // adler32(0, Z_NULL, 0)

      s.last_flush = Z_NO_FLUSH;

      _tr_init$1(s);

      return Z_OK;
    };

    var deflateReset = function deflateReset(strm) {
      var ret = deflateResetKeep(strm);

      if (ret === Z_OK) {
        lm_init(strm.state);
      }

      return ret;
    };

    var deflateSetHeader = function deflateSetHeader(strm, head) {
      if (!strm || !strm.state) {
        return Z_STREAM_ERROR;
      }

      if (strm.state.wrap !== 2) {
        return Z_STREAM_ERROR;
      }

      strm.state.gzhead = head;
      return Z_OK;
    };

    var deflateInit2 = function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
      if (!strm) {
        // === Z_NULL
        return Z_STREAM_ERROR;
      }

      var wrap = 1;

      if (level === Z_DEFAULT_COMPRESSION) {
        level = 6;
      }

      if (windowBits < 0) {
        /* suppress zlib wrapper */
        wrap = 0;
        windowBits = -windowBits;
      } else if (windowBits > 15) {
        wrap = 2;
        /* write gzip wrapper instead */

        windowBits -= 16;
      }

      if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED$1) {
        return err(strm, Z_STREAM_ERROR);
      }

      if (windowBits === 8) {
        windowBits = 9;
      }
      /* until 256-byte window bug fixed */


      var s = new DeflateState();
      strm.state = s;
      s.strm = strm;
      s.wrap = wrap;
      s.gzhead = null;
      s.w_bits = windowBits;
      s.w_size = 1 << s.w_bits;
      s.w_mask = s.w_size - 1;
      s.hash_bits = memLevel + 7;
      s.hash_size = 1 << s.hash_bits;
      s.hash_mask = s.hash_size - 1;
      s.hash_shift = ~~((s.hash_bits + MIN_MATCH$1 - 1) / MIN_MATCH$1);
      s.window = new Uint8Array(s.w_size * 2);
      s.head = new Uint16Array(s.hash_size);
      s.prev = new Uint16Array(s.w_size); // Don't need mem init magic for JS.
      // s.high_water = 0;  /* nothing written to s->window yet */

      s.lit_bufsize = 1 << memLevel + 6;
      /* 16K elements by default */

      s.pending_buf_size = s.lit_bufsize * 4; // overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
      // s->pending_buf = (uchf *) overlay;
      // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)

      s.pending_buf = new Uint8Array(s.pending_buf_size); // s->d_buf = overlay + s->lit_bufsize/sizeof(ush);

      s.d_buf = 1 * s.lit_bufsize; // s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;

      s.l_buf = (1 + 2) * s.lit_bufsize;
      s.level = level;
      s.strategy = strategy;
      s.method = method;
      return deflateReset(strm);
    };

    var deflateInit = function deflateInit(strm, level) {
      return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
    };

    var deflate = function deflate(strm, flush) {
      var beg;
      var val; // for gzip header write only

      if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) {
        return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
      }

      var s = strm.state;

      if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === FINISH_STATE && flush !== Z_FINISH) {
        return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
      }

      s.strm = strm;
      /* just in case */

      var old_flush = s.last_flush;
      s.last_flush = flush;
      /* Write the header */

      if (s.status === INIT_STATE) {
        if (s.wrap === 2) {
          // GZIP header
          strm.adler = 0; // crc32(0L, Z_NULL, 0);

          put_byte(s, 31);
          put_byte(s, 139);
          put_byte(s, 8);

          if (!s.gzhead) {
            // s->gzhead == Z_NULL
            put_byte(s, 0);
            put_byte(s, 0);
            put_byte(s, 0);
            put_byte(s, 0);
            put_byte(s, 0);
            put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            put_byte(s, OS_CODE);
            s.status = BUSY_STATE;
          } else {
            put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
            put_byte(s, s.gzhead.time & 0xff);
            put_byte(s, s.gzhead.time >> 8 & 0xff);
            put_byte(s, s.gzhead.time >> 16 & 0xff);
            put_byte(s, s.gzhead.time >> 24 & 0xff);
            put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            put_byte(s, s.gzhead.os & 0xff);

            if (s.gzhead.extra && s.gzhead.extra.length) {
              put_byte(s, s.gzhead.extra.length & 0xff);
              put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
            }

            if (s.gzhead.hcrc) {
              strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending, 0);
            }

            s.gzindex = 0;
            s.status = EXTRA_STATE;
          }
        } // DEFLATE header
        else {
            var header = Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;

            if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
              level_flags = 0;
            } else if (s.level < 6) {
              level_flags = 1;
            } else if (s.level === 6) {
              level_flags = 2;
            } else {
              level_flags = 3;
            }

            header |= level_flags << 6;

            if (s.strstart !== 0) {
              header |= PRESET_DICT;
            }

            header += 31 - header % 31;
            s.status = BUSY_STATE;
            putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */

            if (s.strstart !== 0) {
              putShortMSB(s, strm.adler >>> 16);
              putShortMSB(s, strm.adler & 0xffff);
            }

            strm.adler = 1; // adler32(0L, Z_NULL, 0);
          }
      } // #ifdef GZIP


      if (s.status === EXTRA_STATE) {
        if (s.gzhead.extra
        /* != Z_NULL */
        ) {
            beg = s.pending;
            /* start of bytes to update crc */

            while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
              if (s.pending === s.pending_buf_size) {
                if (s.gzhead.hcrc && s.pending > beg) {
                  strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                }

                flush_pending(strm);
                beg = s.pending;

                if (s.pending === s.pending_buf_size) {
                  break;
                }
              }

              put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
              s.gzindex++;
            }

            if (s.gzhead.hcrc && s.pending > beg) {
              strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            }

            if (s.gzindex === s.gzhead.extra.length) {
              s.gzindex = 0;
              s.status = NAME_STATE;
            }
          } else {
          s.status = NAME_STATE;
        }
      }

      if (s.status === NAME_STATE) {
        if (s.gzhead.name
        /* != Z_NULL */
        ) {
            beg = s.pending;
            /* start of bytes to update crc */
            // int val;

            do {
              if (s.pending === s.pending_buf_size) {
                if (s.gzhead.hcrc && s.pending > beg) {
                  strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                }

                flush_pending(strm);
                beg = s.pending;

                if (s.pending === s.pending_buf_size) {
                  val = 1;
                  break;
                }
              } // JS specific: little magic to add zero terminator to end of string


              if (s.gzindex < s.gzhead.name.length) {
                val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
              } else {
                val = 0;
              }

              put_byte(s, val);
            } while (val !== 0);

            if (s.gzhead.hcrc && s.pending > beg) {
              strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            }

            if (val === 0) {
              s.gzindex = 0;
              s.status = COMMENT_STATE;
            }
          } else {
          s.status = COMMENT_STATE;
        }
      }

      if (s.status === COMMENT_STATE) {
        if (s.gzhead.comment
        /* != Z_NULL */
        ) {
            beg = s.pending;
            /* start of bytes to update crc */
            // int val;

            do {
              if (s.pending === s.pending_buf_size) {
                if (s.gzhead.hcrc && s.pending > beg) {
                  strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                }

                flush_pending(strm);
                beg = s.pending;

                if (s.pending === s.pending_buf_size) {
                  val = 1;
                  break;
                }
              } // JS specific: little magic to add zero terminator to end of string


              if (s.gzindex < s.gzhead.comment.length) {
                val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
              } else {
                val = 0;
              }

              put_byte(s, val);
            } while (val !== 0);

            if (s.gzhead.hcrc && s.pending > beg) {
              strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            }

            if (val === 0) {
              s.status = HCRC_STATE;
            }
          } else {
          s.status = HCRC_STATE;
        }
      }

      if (s.status === HCRC_STATE) {
        if (s.gzhead.hcrc) {
          if (s.pending + 2 > s.pending_buf_size) {
            flush_pending(strm);
          }

          if (s.pending + 2 <= s.pending_buf_size) {
            put_byte(s, strm.adler & 0xff);
            put_byte(s, strm.adler >> 8 & 0xff);
            strm.adler = 0; // crc32(0L, Z_NULL, 0);

            s.status = BUSY_STATE;
          }
        } else {
          s.status = BUSY_STATE;
        }
      } // #endif

      /* Flush as much pending output as possible */


      if (s.pending !== 0) {
        flush_pending(strm);

        if (strm.avail_out === 0) {
          /* Since avail_out is 0, deflate will be called again with
           * more output space, but possibly with both pending and
           * avail_in equal to zero. There won't be anything to do,
           * but this is not an error situation so make sure we
           * return OK instead of BUF_ERROR at next call of deflate:
           */
          s.last_flush = -1;
          return Z_OK;
        }
        /* Make sure there is something to do and avoid duplicate consecutive
         * flushes. For repeated and useless calls with Z_FINISH, we keep
         * returning Z_STREAM_END instead of Z_BUF_ERROR.
         */

      } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) {
        return err(strm, Z_BUF_ERROR);
      }
      /* User must not provide more input after the first FINISH: */


      if (s.status === FINISH_STATE && strm.avail_in !== 0) {
        return err(strm, Z_BUF_ERROR);
      }
      /* Start a new block or continue the current one.
       */


      if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH && s.status !== FINISH_STATE) {
        var bstate = s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);

        if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
          s.status = FINISH_STATE;
        }

        if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
          if (strm.avail_out === 0) {
            s.last_flush = -1;
            /* avoid BUF_ERROR next call, see above */
          }

          return Z_OK;
          /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
           * of deflate should use the same flush parameter to make sure
           * that the flush is complete. So we don't have to output an
           * empty block here, this will be done at next call. This also
           * ensures that for a very small output buffer, we emit at most
           * one empty block.
           */
        }

        if (bstate === BS_BLOCK_DONE) {
          if (flush === Z_PARTIAL_FLUSH) {
            _tr_align$1(s);
          } else if (flush !== Z_BLOCK) {
            /* FULL_FLUSH or SYNC_FLUSH */
            _tr_stored_block$1(s, 0, 0, false);
            /* For a full flush, this empty block will be recognized
             * as a special marker by inflate_sync().
             */


            if (flush === Z_FULL_FLUSH) {
              /** * CLEAR_HASH(s); ** */

              /* forget history */
              zero$1(s.head); // Fill with NIL (= 0);

              if (s.lookahead === 0) {
                s.strstart = 0;
                s.block_start = 0;
                s.insert = 0;
              }
            }
          }

          flush_pending(strm);

          if (strm.avail_out === 0) {
            s.last_flush = -1;
            /* avoid BUF_ERROR at next call, see above */

            return Z_OK;
          }
        }
      } // Assert(strm->avail_out > 0, "bug2");
      // if (strm.avail_out <= 0) { throw new Error("bug2");}


      if (flush !== Z_FINISH) {
        return Z_OK;
      }

      if (s.wrap <= 0) {
        return Z_STREAM_END;
      }
      /* Write the trailer */


      if (s.wrap === 2) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, strm.adler >> 8 & 0xff);
        put_byte(s, strm.adler >> 16 & 0xff);
        put_byte(s, strm.adler >> 24 & 0xff);
        put_byte(s, strm.total_in & 0xff);
        put_byte(s, strm.total_in >> 8 & 0xff);
        put_byte(s, strm.total_in >> 16 & 0xff);
        put_byte(s, strm.total_in >> 24 & 0xff);
      } else {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }

      flush_pending(strm);
      /* If avail_out is zero, the application will call deflate again
       * to flush the rest.
       */

      if (s.wrap > 0) {
        s.wrap = -s.wrap;
      }
      /* write the trailer only once! */


      return s.pending !== 0 ? Z_OK : Z_STREAM_END;
    };

    var deflateEnd = function deflateEnd(strm) {
      if (!strm ||
      /* == Z_NULL */
      !strm.state
      /* == Z_NULL */
      ) {
          return Z_STREAM_ERROR;
        }

      var status = strm.state.status;

      if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) {
        return err(strm, Z_STREAM_ERROR);
      }

      strm.state = null;
      return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
    };
    /* =========================================================================
     * Initializes the compression dictionary from the given byte
     * sequence without producing any compressed output.
     */


    var deflateSetDictionary = function deflateSetDictionary(strm, dictionary) {
      var dictLength = dictionary.length;

      if (!strm ||
      /* == Z_NULL */
      !strm.state
      /* == Z_NULL */
      ) {
          return Z_STREAM_ERROR;
        }

      var s = strm.state;
      var wrap = s.wrap;

      if (wrap === 2 || wrap === 1 && s.status !== INIT_STATE || s.lookahead) {
        return Z_STREAM_ERROR;
      }
      /* when using zlib wrappers, compute Adler-32 for provided dictionary */


      if (wrap === 1) {
        /* adler32(strm->adler, dictionary, dictLength); */
        strm.adler = adler32_1(strm.adler, dictionary, dictLength, 0);
      }

      s.wrap = 0;
      /* avoid computing Adler-32 in read_buf */

      /* if dictionary would fill window, just replace the history */

      if (dictLength >= s.w_size) {
        if (wrap === 0) {
          /* already empty otherwise */

          /** * CLEAR_HASH(s); ** */
          zero$1(s.head); // Fill with NIL (= 0);

          s.strstart = 0;
          s.block_start = 0;
          s.insert = 0;
        }
        /* use the tail */
        // dictionary = dictionary.slice(dictLength - s.w_size);


        var tmpDict = new Uint8Array(s.w_size);
        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
      }
      /* insert dictionary into window and hash */


      var avail = strm.avail_in;
      var next = strm.next_in;
      var input = strm.input;
      strm.avail_in = dictLength;
      strm.next_in = 0;
      strm.input = dictionary;
      fill_window(s);

      while (s.lookahead >= MIN_MATCH$1) {
        var str = s.strstart;
        var n = s.lookahead - (MIN_MATCH$1 - 1);

        do {
          /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
          s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH$1 - 1]);
          s.prev[str & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = str;
          str++;
        } while (--n);

        s.strstart = str;
        s.lookahead = MIN_MATCH$1 - 1;
        fill_window(s);
      }

      s.strstart += s.lookahead;
      s.block_start = s.strstart;
      s.insert = s.lookahead;
      s.lookahead = 0;
      s.match_length = s.prev_length = MIN_MATCH$1 - 1;
      s.match_available = 0;
      strm.next_in = next;
      strm.input = input;
      strm.avail_in = avail;
      s.wrap = wrap;
      return Z_OK;
    };

    var deflateInit_1 = deflateInit;
    var deflateInit2_1 = deflateInit2;
    var deflateReset_1 = deflateReset;
    var deflateResetKeep_1 = deflateResetKeep;
    var deflateSetHeader_1 = deflateSetHeader;
    var deflate_2 = deflate;
    var deflateEnd_1 = deflateEnd;
    var deflateSetDictionary_1 = deflateSetDictionary;
    var deflateInfo = 'pako deflate (from Nodeca project)';
    /* Not implemented
    module.exports.deflateBound = deflateBound;
    module.exports.deflateCopy = deflateCopy;
    module.exports.deflateParams = deflateParams;
    module.exports.deflatePending = deflatePending;
    module.exports.deflatePrime = deflatePrime;
    module.exports.deflateTune = deflateTune;
    */

    var deflate_1 = {
      deflateInit: deflateInit_1,
      deflateInit2: deflateInit2_1,
      deflateReset: deflateReset_1,
      deflateResetKeep: deflateResetKeep_1,
      deflateSetHeader: deflateSetHeader_1,
      deflate: deflate_2,
      deflateEnd: deflateEnd_1,
      deflateSetDictionary: deflateSetDictionary_1,
      deflateInfo: deflateInfo
    }; // Join array of chunks to single array.

    function flattenChunks(chunks) {
      // calculate data length
      var len = 0;

      for (var i = 0, l = chunks.length; i < l; i++) {
        len += chunks[i].length;
      } // join chunks


      var result = new Uint8Array(len);

      for (var _i = 0, pos = 0, _l = chunks.length; _i < _l; _i++) {
        var chunk = chunks[_i];
        result.set(chunk, pos);
        pos += chunk.length;
      }

      return result;
    } // String encode/decode helpers
    //
    // - apply(Array) can fail on Android 2.2
    // - apply(Uint8Array) can fail on iOS 5.1 Safari
    //
    // Table with utf8 lengths (calculated by first byte of sequence)
    // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
    // because max possible codepoint is 0x10ffff


    var _utf8len = new Uint8Array(256);

    for (var q = 0; q < 256; q++) {
      _utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
    }

    _utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
    // convert string to array (typed, when possible)
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    function ZStream() {
      /* next input byte */
      this.input = null; // JS specific, because we have no pointers

      this.next_in = 0;
      /* number of bytes available at input */

      this.avail_in = 0;
      /* total number of input bytes read so far */

      this.total_in = 0;
      /* next output byte should be put there */

      this.output = null; // JS specific, because we have no pointers

      this.next_out = 0;
      /* remaining free space at output */

      this.avail_out = 0;
      /* total number of bytes output so far */

      this.total_out = 0;
      /* last error message, NULL if no error */

      this.msg = '';
      /* Z_NULL */

      /* not visible by applications */

      this.state = null;
      /* best guess about the data type: binary or text */

      this.data_type = 2;
      /* Z_UNKNOWN */

      /* adler32 value of the uncompressed data */

      this.adler = 0;
    }

    var zstream = ZStream; // eslint-disable-next-line @typescript-eslint/unbound-method

    var toString = Object.prototype.toString;
    /* Public constants ========================================================== */

    /* =========================================================================== */

    var Z_NO_FLUSH$1 = constants.Z_NO_FLUSH;
    var Z_SYNC_FLUSH = constants.Z_SYNC_FLUSH;
    var Z_FULL_FLUSH$1 = constants.Z_FULL_FLUSH;
    var Z_FINISH$1 = constants.Z_FINISH;
    var Z_OK$1 = constants.Z_OK;
    var Z_STREAM_END$1 = constants.Z_STREAM_END;
    var Z_DEFAULT_COMPRESSION$1 = constants.Z_DEFAULT_COMPRESSION;
    var Z_DEFAULT_STRATEGY$1 = constants.Z_DEFAULT_STRATEGY;
    var Z_DEFLATED$1 = constants.Z_DEFLATED;
    /* =========================================================================== */

    /**
     * class Deflate
     *
     * Generic JS-style wrapper for zlib calls. If you don't need
     * streaming behaviour - use more simple functions: [[deflate]],
     * [[deflateRaw]] and [[gzip]].
     * */

    /* internal
     * Deflate.chunks -> Array
     *
     * Chunks of output data, if [[Deflate#onData]] not overridden.
     * */

    /**
     * Deflate.result -> Uint8Array
     *
     * Compressed result, generated by default [[Deflate#onData]]
     * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
     * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
     * */

    /**
     * Deflate.err -> Number
     *
     * Error code after deflate finished. 0 (Z_OK) on success.
     * You will not need it in real life, because deflate errors
     * are possible only on wrong options or bad `onData` / `onEnd`
     * custom handlers.
     * */

    /**
     * Deflate.msg -> String
     *
     * Error message, if [[Deflate.err]] != 0
     * */

    /**
     * new Deflate(options)
     * - options (Object): zlib deflate options.
     *
     * Creates new deflator instance with specified params. Throws exception
     * on bad params. Supported options:
     *
     * - `level`
     * - `windowBits`
     * - `memLevel`
     * - `strategy`
     * - `dictionary`
     *
     * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
     * for more information on these.
     *
     * Additional options, for internal needs:
     *
     * * `chunkSize` - size of generated data chunks (16K by default)
     * * `raw` (Boolean) - do raw deflate
     * * `gzip` (Boolean) - create gzip wrapper
     * * `header` (Object) - custom header for gzip
     * ** `text` (Boolean) - true if compressed data believed to be text
     * ** `time` (Number) - modification time, unix timestamp
     * ** `os` (Number) - operation system code
     * ** `extra` (Array) - array of bytes with extra data (max 65536)
     * ** `name` (String) - file name (binary string)
     * ** `comment` (String) - comment (binary string)
     * ** `hcrc` (Boolean) - true if header crc should be added
     *
     * ##### Example:
     *
     * ```javascript
     * const pako = require('pako')
     *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
     *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
     *
     * const deflate = new pako.Deflate({ level: 3});
     *
     * deflate.push(chunk1, false);
     * deflate.push(chunk2, true);  // true -> last chunk
     *
     * if (deflate.err) { throw new Error(deflate.err); }
     *
     * console.log(deflate.result);
     * ```
     * */

    function Deflate() {
      this.options = {
        level: Z_DEFAULT_COMPRESSION$1,
        method: Z_DEFLATED$1,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: Z_DEFAULT_STRATEGY$1
      };
      var opt = this.options;

      if (opt.raw && opt.windowBits > 0) {
        opt.windowBits = -opt.windowBits;
      } else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) {
        opt.windowBits += 16;
      }

      this.err = 0; // error code, if happens (0 = Z_OK)

      this.msg = ''; // error message

      this.ended = false; // used to avoid multiple onEnd() calls

      this.chunks = []; // chunks of compressed data

      this.strm = new zstream();
      this.strm.avail_out = 0;
      var status = deflate_1.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);

      if (status !== Z_OK$1) {
        throw new Error(messages[status]);
      }

      if (opt.header) {
        deflate_1.deflateSetHeader(this.strm, opt.header);
      }

      if (opt.dictionary) {
        var dict; // Convert data if needed

        if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
          dict = new Uint8Array(opt.dictionary);
        } else {
          dict = opt.dictionary;
        }

        status = deflate_1.deflateSetDictionary(this.strm, dict);

        if (status !== Z_OK$1) {
          throw new Error(messages[status]);
        }

        this._dict_set = true;
      }
    }
    /**
     * Deflate#push(data[, flush_mode]) -> Boolean
     * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
     * converted to utf8 byte sequence.
     * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
     * See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
     *
     * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
     * new compressed chunks. Returns `true` on success. The last data block must
     * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
     * buffers and call [[Deflate#onEnd]].
     *
     * On fail call [[Deflate#onEnd]] with error code and return false.
     *
     * ##### Example
     *
     * ```javascript
     * push(chunk, false); // push one of data chunks
     * ...
     * push(chunk, true);  // push last chunk
     * ```
     * */


    Deflate.prototype.push = function (data, flush_mode) {
      var strm = this.strm;
      var chunkSize = this.options.chunkSize;
      var status;

      var _flush_mode;

      if (this.ended) {
        return false;
      }

      if (flush_mode === ~~flush_mode) {
        _flush_mode = flush_mode;
      } else {
        _flush_mode = flush_mode === true ? Z_FINISH$1 : Z_NO_FLUSH$1;
      } // Convert data if needed


      if (toString.call(data) === '[object ArrayBuffer]') {
        strm.input = new Uint8Array(data);
      } else {
        strm.input = data;
      }

      strm.next_in = 0;
      strm.avail_in = strm.input.length;

      for (;;) {
        if (strm.avail_out === 0) {
          strm.output = new Uint8Array(chunkSize);
          strm.next_out = 0;
          strm.avail_out = chunkSize;
        } // Make sure avail_out > 6 to avoid repeating markers


        if ((_flush_mode === Z_SYNC_FLUSH || _flush_mode === Z_FULL_FLUSH$1) && strm.avail_out <= 6) {
          this.onData(strm.output.subarray(0, strm.next_out));
          strm.avail_out = 0;
          continue;
        }

        status = deflate_1.deflate(strm, _flush_mode); // Ended => flush and finish

        if (status === Z_STREAM_END$1) {
          if (strm.next_out > 0) {
            this.onData(strm.output.subarray(0, strm.next_out));
          }

          status = deflate_1.deflateEnd(this.strm);
          this.onEnd(status);
          this.ended = true;
          return status === Z_OK$1;
        } // Flush if out buffer full


        if (strm.avail_out === 0) {
          this.onData(strm.output);
          continue;
        } // Flush if requested and has data


        if (_flush_mode > 0 && strm.next_out > 0) {
          this.onData(strm.output.subarray(0, strm.next_out));
          strm.avail_out = 0;
          continue;
        }

        if (strm.avail_in === 0) {
          break;
        }
      }

      return true;
    };
    /**
     * Deflate#onData(chunk) -> Void
     * - chunk (Uint8Array): output data.
     *
     * By default, stores data blocks in `chunks[]` property and glue
     * those in `onEnd`. Override this handler, if you need another behaviour.
     * */


    Deflate.prototype.onData = function (chunk) {
      this.chunks.push(chunk);
    };
    /**
     * Deflate#onEnd(status) -> Void
     * - status (Number): deflate status. 0 (Z_OK) on success,
     * other if not.
     *
     * Called once after you tell deflate that the input stream is
     * complete (Z_FINISH). By default - join collected chunks,
     * free memory and fill `results` / `err` properties.
     * */


    Deflate.prototype.onEnd = function (status) {
      // On success - join
      if (status === Z_OK$1) {
        this.result = flattenChunks(this.chunks);
      }

      this.chunks = [];
      this.err = status;
      this.msg = this.strm.msg;
    }; // https://github.com/nodeca/pako/blob/26dff4fb3472c5532b3bd8856421146d35ab7592/lib/utils/strings.js#L26


    function string2buf(str) {
      if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) {
        return new TextEncoder().encode(str);
      }

      var buf;
      var c;
      var c2;
      var m_pos;
      var i;
      var str_len = str.length;
      var buf_len = 0; // count binary size

      for (m_pos = 0; m_pos < str_len; m_pos++) {
        c = str.charCodeAt(m_pos);

        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
          c2 = str.charCodeAt(m_pos + 1);

          if ((c2 & 0xfc00) === 0xdc00) {
            c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
            m_pos++;
          }
        }

        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
      } // allocate buffer


      buf = new Uint8Array(buf_len); // convert

      for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
        c = str.charCodeAt(m_pos);

        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
          c2 = str.charCodeAt(m_pos + 1);

          if ((c2 & 0xfc00) === 0xdc00) {
            c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
            m_pos++;
          }
        }

        if (c < 0x80) {
          /* one byte */
          buf[i++] = c;
        } else if (c < 0x800) {
          /* two bytes */
          buf[i++] = 0xc0 | c >>> 6;
          buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
          /* three bytes */
          buf[i++] = 0xe0 | c >>> 12;
          buf[i++] = 0x80 | c >>> 6 & 0x3f;
          buf[i++] = 0x80 | c & 0x3f;
        } else {
          /* four bytes */
          buf[i++] = 0xf0 | c >>> 18;
          buf[i++] = 0x80 | c >>> 12 & 0x3f;
          buf[i++] = 0x80 | c >>> 6 & 0x3f;
          buf[i++] = 0x80 | c & 0x3f;
        }
      }

      return buf;
    }

    return {
      Deflate: Deflate,
      constants: constants,
      string2buf: string2buf
    };
  }
}

},{}],114:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEGMENT_BYTES_LIMIT = exports.startDeflateWorker = exports.setSegmentBytesLimit = exports.startSegmentCollection = void 0;

var segmentCollection_1 = require("./segmentCollection");

Object.defineProperty(exports, "startSegmentCollection", {
  enumerable: true,
  get: function get() {
    return segmentCollection_1.startSegmentCollection;
  }
});
Object.defineProperty(exports, "setSegmentBytesLimit", {
  enumerable: true,
  get: function get() {
    return segmentCollection_1.setSegmentBytesLimit;
  }
});

var startDeflateWorker_1 = require("./startDeflateWorker");

Object.defineProperty(exports, "startDeflateWorker", {
  enumerable: true,
  get: function get() {
    return startDeflateWorker_1.startDeflateWorker;
  }
});

var segmentCollection_2 = require("./segmentCollection");

Object.defineProperty(exports, "SEGMENT_BYTES_LIMIT", {
  enumerable: true,
  get: function get() {
    return segmentCollection_2.SEGMENT_BYTES_LIMIT;
  }
});

},{"./segmentCollection":116,"./startDeflateWorker":117}],115:[function(require,module,exports){
"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Segment = void 0;

var browser_core_1 = require("@datadog/browser-core");

var types_1 = require("../../types");

var replayStats = __importStar(require("../replayStats"));

var nextId = 0;

var Segment =
/** @class */
function () {
  function Segment(worker, context, creationReason, initialRecord, onWrote, onFlushed) {
    var _this = this;

    this.worker = worker;
    this.isFlushed = false;
    this.id = nextId++;
    var viewId = context.view.id;
    this.metadata = (0, browser_core_1.assign)({
      start: initialRecord.timestamp,
      end: initialRecord.timestamp,
      creation_reason: creationReason,
      records_count: 1,
      has_full_snapshot: initialRecord.type === types_1.RecordType.FullSnapshot,
      index_in_view: replayStats.getSegmentsCount(viewId),
      source: 'browser'
    }, context);
    replayStats.addSegment(viewId);
    replayStats.addRecord(viewId);
    var listener = (0, browser_core_1.monitor)(function (_a) {
      var data = _a.data;

      if (data.type === 'errored' || data.type === 'initialized') {
        return;
      }

      if (data.id === _this.id) {
        replayStats.addWroteData(viewId, data.additionalBytesCount);

        if (data.type === 'flushed') {
          onFlushed(data.result, data.rawBytesCount);
          worker.removeEventListener('message', listener);
        } else {
          onWrote(data.compressedBytesCount);
        }
      } else if (data.id > _this.id) {
        // Messages should be received in the same order as they are sent, so if we receive a
        // message with an id superior to this Segment instance id, we know that another, more
        // recent Segment instance is being used.
        //
        // In theory, a "flush" response should have been received at this point, so the listener
        // should already have been removed. But if something goes wrong and we didn't receive a
        // "flush" response, remove the listener to avoid any leak, and send a monitor message to
        // help investigate the issue.
        worker.removeEventListener('message', listener);
        (0, browser_core_1.addTelemetryDebug)("Segment did not receive a 'flush' response before being replaced.");
      }
    });
    worker.addEventListener('message', listener);
    this.worker.postMessage({
      data: "{\"records\":[".concat(JSON.stringify(initialRecord)),
      id: this.id,
      action: 'write'
    });
  }

  Segment.prototype.addRecord = function (record) {
    var _a;

    this.metadata.start = Math.min(this.metadata.start, record.timestamp);
    this.metadata.end = Math.max(this.metadata.end, record.timestamp);
    this.metadata.records_count += 1;
    replayStats.addRecord(this.metadata.view.id);
    (_a = this.metadata).has_full_snapshot || (_a.has_full_snapshot = record.type === types_1.RecordType.FullSnapshot);
    this.worker.postMessage({
      data: ",".concat(JSON.stringify(record)),
      id: this.id,
      action: 'write'
    });
  };

  Segment.prototype.flush = function () {
    this.worker.postMessage({
      data: "],".concat(JSON.stringify(this.metadata).slice(1), "\n"),
      id: this.id,
      action: 'flush'
    });
    this.isFlushed = true;
  };

  return Segment;
}();

exports.Segment = Segment;

},{"../../types":120,"../replayStats":112,"@datadog/browser-core":32}],116:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSegmentBytesLimit = exports.computeSegmentContext = exports.doStartSegmentCollection = exports.startSegmentCollection = exports.SEGMENT_BYTES_LIMIT = exports.SEGMENT_DURATION_LIMIT = void 0;

var browser_core_1 = require("@datadog/browser-core");

var segment_1 = require("./segment");

exports.SEGMENT_DURATION_LIMIT = 30 * browser_core_1.ONE_SECOND;
/**
 * beacon payload max queue size implementation is 64kb
 * ensure that we leave room for logs, rum and potential other users
 */

exports.SEGMENT_BYTES_LIMIT = 60000; // Segments are the main data structure for session replays. They contain context information used
// for indexing or UI needs, and a list of records (RRWeb 'events', renamed to avoid confusing
// namings). They are stored without any processing from the intake, and fetched one after the
// other while a session is being replayed. Their encoding (deflate) are carefully crafted to allow
// concatenating multiple segments together. Segments have a size overhead (metadata), so our goal is to
// build segments containing as many records as possible while complying with the various flush
// strategies to guarantee a good replay quality.
//
// When the recording starts, a segment is initially created.  The segment is flushed (finalized and
// sent) based on various events (non-exhaustive list):
//
// * the page visibility change or becomes to unload
// * the segment duration reaches a limit
// * the encoded segment bytes count reaches a limit
// * ...
//
// A segment cannot be created without its context.  If the RUM session ends and no session id is
// available when creating a new segment, records will be ignored, until the session is renewed and
// a new session id is available.
//
// Empty segments (segments with no record) aren't useful and should be ignored.
//
// To help investigate session replays issues, each segment is created with a "creation reason",
// indicating why the session has been created.

function startSegmentCollection(lifeCycle, applicationId, sessionManager, viewContexts, send, worker) {
  return doStartSegmentCollection(lifeCycle, function () {
    return computeSegmentContext(applicationId, sessionManager, viewContexts);
  }, send, worker);
}

exports.startSegmentCollection = startSegmentCollection;

function doStartSegmentCollection(lifeCycle, getSegmentContext, send, worker, emitter) {
  if (emitter === void 0) {
    emitter = window;
  }

  var state = {
    status: 0
    /* WaitingForInitialRecord */
    ,
    nextSegmentCreationReason: 'init'
  };
  var unsubscribeViewCreated = lifeCycle.subscribe(2
  /* VIEW_CREATED */
  , function () {
    flushSegment('view_change');
  }).unsubscribe;
  var unsubscribeBeforeUnload = lifeCycle.subscribe(9
  /* BEFORE_UNLOAD */
  , function () {
    flushSegment('before_unload');
  }).unsubscribe;
  var unsubscribeVisibilityChange = (0, browser_core_1.addEventListener)(emitter, "visibilitychange"
  /* VISIBILITY_CHANGE */
  , function () {
    if (document.visibilityState === 'hidden') {
      flushSegment('visibility_hidden');
    }
  }, {
    capture: true
  }).stop;

  function flushSegment(nextSegmentCreationReason) {
    if (state.status === 1
    /* SegmentPending */
    ) {
        state.segment.flush();
        clearTimeout(state.expirationTimeoutId);
      }

    if (nextSegmentCreationReason) {
      state = {
        status: 0
        /* WaitingForInitialRecord */
        ,
        nextSegmentCreationReason: nextSegmentCreationReason
      };
    } else {
      state = {
        status: 2
        /* Stopped */

      };
    }
  }

  function createNewSegment(creationReason, initialRecord) {
    var context = getSegmentContext();

    if (!context) {
      return;
    }

    var segment = new segment_1.Segment(worker, context, creationReason, initialRecord, function (compressedSegmentBytesCount) {
      if (!segment.isFlushed && compressedSegmentBytesCount > exports.SEGMENT_BYTES_LIMIT) {
        flushSegment('segment_bytes_limit');
      }
    }, function (data, rawSegmentBytesCount) {
      send(data, segment.metadata, rawSegmentBytesCount);
    });
    state = {
      status: 1
      /* SegmentPending */
      ,
      segment: segment,
      expirationTimeoutId: setTimeout((0, browser_core_1.monitor)(function () {
        flushSegment('segment_duration_limit');
      }), exports.SEGMENT_DURATION_LIMIT)
    };
  }

  return {
    addRecord: function addRecord(record) {
      switch (state.status) {
        case 0
        /* WaitingForInitialRecord */
        :
          createNewSegment(state.nextSegmentCreationReason, record);
          break;

        case 1
        /* SegmentPending */
        :
          state.segment.addRecord(record);
          break;
      }
    },
    stop: function stop() {
      flushSegment();
      unsubscribeViewCreated();
      unsubscribeBeforeUnload();
      unsubscribeVisibilityChange();
    }
  };
}

exports.doStartSegmentCollection = doStartSegmentCollection;

function computeSegmentContext(applicationId, sessionManager, viewContexts) {
  var session = sessionManager.findTrackedSession();
  var viewContext = viewContexts.findView();

  if (!session || !viewContext) {
    return undefined;
  }

  return {
    application: {
      id: applicationId
    },
    session: {
      id: session.id
    },
    view: {
      id: viewContext.id
    }
  };
}

exports.computeSegmentContext = computeSegmentContext;

function setSegmentBytesLimit(newSegmentBytesLimit) {
  if (newSegmentBytesLimit === void 0) {
    newSegmentBytesLimit = 60000;
  }

  exports.SEGMENT_BYTES_LIMIT = newSegmentBytesLimit;
}

exports.setSegmentBytesLimit = setSegmentBytesLimit;

},{"./segment":115,"@datadog/browser-core":32}],117:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doStartDeflateWorker = exports.resetDeflateWorkerState = exports.startDeflateWorker = void 0;

var browser_core_1 = require("@datadog/browser-core");

var deflateWorker_1 = require("./deflateWorker");

var state = {
  status: 0
  /* Nil */

};

function startDeflateWorker(callback, createDeflateWorkerImpl) {
  if (createDeflateWorkerImpl === void 0) {
    createDeflateWorkerImpl = deflateWorker_1.createDeflateWorker;
  }

  switch (state.status) {
    case 0
    /* Nil */
    :
      state = {
        status: 1
        /* Loading */
        ,
        callbacks: [callback]
      };
      doStartDeflateWorker(createDeflateWorkerImpl);
      break;

    case 1
    /* Loading */
    :
      state.callbacks.push(callback);
      break;

    case 2
    /* Error */
    :
      callback();
      break;

    case 3
    /* Initialized */
    :
      callback(state.worker);
      break;
  }
}

exports.startDeflateWorker = startDeflateWorker;

function resetDeflateWorkerState() {
  state = {
    status: 0
    /* Nil */

  };
}

exports.resetDeflateWorkerState = resetDeflateWorkerState;
/**
 * Starts the deflate worker and handle messages and errors
 *
 * The spec allow browsers to handle worker errors differently:
 * - Chromium throws an exception
 * - Firefox fires an error event
 *
 * more details: https://bugzilla.mozilla.org/show_bug.cgi?id=1736865#c2
 */

function doStartDeflateWorker(createDeflateWorkerImpl) {
  if (createDeflateWorkerImpl === void 0) {
    createDeflateWorkerImpl = deflateWorker_1.createDeflateWorker;
  }

  try {
    var worker_1 = createDeflateWorkerImpl();
    worker_1.addEventListener('error', (0, browser_core_1.monitor)(onError));
    worker_1.addEventListener('message', (0, browser_core_1.monitor)(function (_a) {
      var data = _a.data;

      if (data.type === 'errored') {
        onError(data.error);
      } else if (data.type === 'initialized') {
        onInitialized(worker_1);
      }
    }));
    worker_1.postMessage({
      action: 'init'
    });
    return worker_1;
  } catch (error) {
    onError(error);
  }
}

exports.doStartDeflateWorker = doStartDeflateWorker;

function onInitialized(worker) {
  if (state.status === 1
  /* Loading */
  ) {
      state.callbacks.forEach(function (callback) {
        return callback(worker);
      });
      state = {
        status: 3
        /* Initialized */
        ,
        worker: worker
      };
    }
}

function onError(error) {
  if (state.status === 1
  /* Loading */
  ) {
      browser_core_1.display.error('Session Replay recording failed to start: an error occurred while creating the Worker:', error);

      if (error instanceof Event || error instanceof Error && (0, browser_core_1.includes)(error.message, 'Content Security Policy')) {
        browser_core_1.display.error('Please make sure CSP is correctly configured ' + 'https://docs.datadoghq.com/real_user_monitoring/faq/content_security_policy');
      } else {
        (0, browser_core_1.addTelemetryError)(error);
      }

      state.callbacks.forEach(function (callback) {
        return callback();
      });
      state = {
        status: 2
        /* Error */

      };
    } else {
    (0, browser_core_1.addTelemetryError)(error);
  }
}

},{"./deflateWorker":113,"@datadog/browser-core":32}],118:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.datadogRum = exports.DefaultPrivacyLevel = void 0; // Keep the following in sync with packages/rum-slim/src/entries/main.ts

var browser_core_1 = require("@datadog/browser-core");

var browser_rum_core_1 = require("@datadog/browser-rum-core");

var startRecording_1 = require("../boot/startRecording");

var recorderApi_1 = require("../boot/recorderApi");

var browser_core_2 = require("@datadog/browser-core");

Object.defineProperty(exports, "DefaultPrivacyLevel", {
  enumerable: true,
  get: function get() {
    return browser_core_2.DefaultPrivacyLevel;
  }
});
var recorderApi = (0, recorderApi_1.makeRecorderApi)(startRecording_1.startRecording);
exports.datadogRum = (0, browser_rum_core_1.makeRumPublicApi)(browser_rum_core_1.startRum, recorderApi);
(0, browser_core_1.defineGlobal)((0, browser_core_1.getGlobalObject)(), 'DD_RUM', exports.datadogRum);

},{"../boot/recorderApi":98,"../boot/startRecording":99,"@datadog/browser-core":32,"@datadog/browser-rum-core":95}],119:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toFormEntries = exports.send = void 0;

var browser_core_1 = require("@datadog/browser-core");

function send(httpRequest, data, metadata, rawSegmentBytesCount) {
  var formData = new FormData();
  formData.append('segment', new Blob([data], {
    type: 'application/octet-stream'
  }), "".concat(metadata.session.id, "-").concat(metadata.start));
  toFormEntries(metadata, function (key, value) {
    return formData.append(key, value);
  });
  formData.append('raw_segment_size', rawSegmentBytesCount.toString());
  httpRequest.sendOnExit({
    data: formData,
    bytesCount: data.byteLength
  });
}

exports.send = send;

function toFormEntries(input, onEntry, prefix) {
  if (prefix === void 0) {
    prefix = '';
  }

  (0, browser_core_1.objectEntries)(input).forEach(function (_a) {
    var key = _a[0],
        value = _a[1];

    if (_typeof(value) === 'object' && value !== null) {
      toFormEntries(value, onEntry, "".concat(prefix).concat(key, "."));
    } else {
      onEntry("".concat(prefix).concat(key), String(value));
    }
  });
}

exports.toFormEntries = toFormEntries;

},{"@datadog/browser-core":32}],120:[function(require,module,exports){
"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = void 0 && (void 0).__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

__exportStar(require("./sessionReplay"), exports);

__exportStar(require("./sessionReplayConstants"), exports);

},{"./sessionReplay":121,"./sessionReplayConstants":122}],121:[function(require,module,exports){
"use strict";
/* eslint-disable */

/**
 * DO NOT MODIFY IT BY HAND. Run `yarn rum-events-format:sync` instead.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

},{}],122:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaInteractionType = exports.MouseInteractionType = exports.IncrementalSource = exports.NodeType = exports.RecordType = void 0;
exports.RecordType = {
  FullSnapshot: 2,
  IncrementalSnapshot: 3,
  Meta: 4,
  Focus: 6,
  ViewEnd: 7,
  VisualViewport: 8,
  FrustrationRecord: 9
};
exports.NodeType = {
  Document: 0,
  DocumentType: 1,
  Element: 2,
  Text: 3,
  CDATA: 4
};
exports.IncrementalSource = {
  Mutation: 0,
  MouseMove: 1,
  MouseInteraction: 2,
  Scroll: 3,
  ViewportResize: 4,
  Input: 5,
  TouchMove: 6,
  MediaInteraction: 7,
  StyleSheetRule: 8 // CanvasMutation : 9,
  // Font : 10,

};
exports.MouseInteractionType = {
  MouseUp: 0,
  MouseDown: 1,
  Click: 2,
  ContextMenu: 3,
  DblClick: 4,
  Focus: 5,
  Blur: 6,
  TouchStart: 7,
  TouchEnd: 9
};
exports.MediaInteractionType = {
  Play: 0,
  Pause: 1
};

},{}],123:[function(require,module,exports){
"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = void 0 && (void 0).__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

__exportStar(require("./jwt-client"), exports);

},{"./jwt-client":124}],124:[function(require,module,exports){
"use strict";

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeFetchIntercept = exports.refresh = exports.getAccessToken = exports.hasAccessToken = exports.setupFetchIntercept = exports.fetchWithJwt = exports.setTokens = exports.logout = exports.login = exports.init = void 0;
var _loginEnpoint = '';
var _refreshEndpoint = '';
var _localStorageAccessTokenKey = '___t';
var _localStorateRefreshTokenKey = '___r';

var _originalFetch = typeof window !== 'undefined' ? window['fetch'] : undefined;

function init(loginEndpoint, refreshEndpoint, localStorageAccessTokenKey, localStorageRefreshTokenKey) {
  _loginEnpoint = loginEndpoint;
  _refreshEndpoint = refreshEndpoint;

  if (localStorageAccessTokenKey) {
    _localStorageAccessTokenKey = localStorageAccessTokenKey;
  }

  if (localStorageRefreshTokenKey) {
    _localStorateRefreshTokenKey = localStorageRefreshTokenKey;
  }
}

exports.init = init;

function login(username, password) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var res, tokenData;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(_loginEnpoint, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                username: username,
                password: password
              })
            });

          case 2:
            res = _context.sent;

            if (!res.ok) {
              _context.next = 10;
              break;
            }

            _context.next = 6;
            return res.json();

          case 6:
            tokenData = _context.sent;

            if (!(!tokenData || !tokenData.access_token || !tokenData.refresh_token)) {
              _context.next = 9;
              break;
            }

            throw new Error('jwt-client: failed to get token data from login endpoint');

          case 9:
            setTokens(tokenData.access_token, tokenData.refresh_token);

          case 10:
            return _context.abrupt("return", res);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.login = login;

function logout() {
  clearTokens();
}

exports.logout = logout;

function setTokens(accessToken, refreshToken) {
  localStorage.setItem(_localStorageAccessTokenKey, accessToken);
  localStorage.setItem(_localStorateRefreshTokenKey, refreshToken);
}

exports.setTokens = setTokens;

function clearTokens() {
  localStorage.removeItem(_localStorageAccessTokenKey);
  localStorage.removeItem(_localStorateRefreshTokenKey);
}

function isLoggedIn() {
  return localStorage.getItem(_localStorageAccessTokenKey) !== null;
}

function fetchWithJwt(input, init) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var updatedInit, res, refreshResponse;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            updatedInit = init = init || {};

            if (isLoggedIn()) {
              if (updatedInit.headers instanceof Headers) {
                updatedInit.headers.set('Authorization', "Bearer ".concat(getAccessToken()));
              } else {
                updatedInit.headers = init.headers || {}; //@ts-ignore

                updatedInit.headers['Authorization'] = "Bearer ".concat(getAccessToken());
              }
            }

            _context2.next = 4;
            return _originalFetch(input, updatedInit);

          case 4:
            res = _context2.sent;

            if (!(res.status === 401 && res.headers.has('X-Token-Expired') && isLoggedIn())) {
              _context2.next = 15;
              break;
            }

            _context2.next = 8;
            return refresh();

          case 8:
            refreshResponse = _context2.sent;

            if (!refreshResponse.ok) {
              _context2.next = 13;
              break;
            }

            return _context2.abrupt("return", fetchWithJwt(input, init));

          case 13:
            clearTokens(); //delete tokens as they are now confirmed useless

            return _context2.abrupt("return", res);

          case 15:
            return _context2.abrupt("return", res);

          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

exports.fetchWithJwt = fetchWithJwt;

function isInHostsAllowList(hostsAllowList, url) {
  try {
    var parsedUrl = new URL(url); //will allow any subdmain, e.g. allowListHost 'zencastr.com' will allow any subdomain 'www.zencastr.com', 'local.zencastr.com', etc

    return hostsAllowList.some(function (allowListHost) {
      return parsedUrl.hostname.endsWith(allowListHost);
    });
  } catch (_a) {
    return false;
  }
}

function setupFetchIntercept() {
  var hostsAllowList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['zencastr.com', 'localhost'];

  window['fetch'] = function interceptedFetch(input, init) {
    if (typeof input === 'string' && !isInHostsAllowList(hostsAllowList, input) || input instanceof Request && !isInHostsAllowList(hostsAllowList, input.url)) {
      return _originalFetch(input, init);
    }

    return fetchWithJwt(input, init);
  };
}

exports.setupFetchIntercept = setupFetchIntercept;

function hasAccessToken() {
  return getAccessToken() !== null;
}

exports.hasAccessToken = hasAccessToken;

function getAccessToken() {
  return localStorage.getItem(_localStorageAccessTokenKey);
}

exports.getAccessToken = getAccessToken;

function getRefreshToken() {
  return localStorage.getItem(_localStorateRefreshTokenKey);
}

function refresh() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var fetchResponse, tokenData;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(_originalFetch === null)) {
              _context3.next = 2;
              break;
            }

            throw new Error('@zencastr/jwt-client not initialized');

          case 2:
            if (isLoggedIn()) {
              _context3.next = 4;
              break;
            }

            throw new Error('User is not logged in, no tokens to refresh');

          case 4:
            _context3.next = 6;
            return _originalFetch(_refreshEndpoint, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': "Bearer ".concat(getAccessToken()) //send expired access token

              },
              body: JSON.stringify({
                refreshToken: getRefreshToken()
              })
            });

          case 6:
            fetchResponse = _context3.sent;

            if (!fetchResponse.ok) {
              _context3.next = 12;
              break;
            }

            _context3.next = 10;
            return fetchResponse.json();

          case 10:
            tokenData = _context3.sent;
            setTokens(tokenData.access_token, tokenData.refresh_token);

          case 12:
            return _context3.abrupt("return", fetchResponse);

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}

exports.refresh = refresh;
/**
 * Removes the fetch interceptor that adds Authorization header
 * Does nothing if the interceptor wasn't added
 */

function removeFetchIntercept() {
  //calling this more than once or after not calling replace does nothing
  window['fetch'] = _originalFetch;
}

exports.removeFetchIntercept = removeFetchIntercept;

},{}],125:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._reset = exports.remove = exports.get = exports.has = exports.add = void 0;

var log_1 = require("../log");

var _pendingTransactionTimeouts = new Map();

function add(transactionId, timeoutId, deferred) {
  log_1.log.debug('STRNC: Adding transaction to tracker', {
    transactionId: transactionId,
    timeoutId: timeoutId
  });

  if (_pendingTransactionTimeouts.has(transactionId)) {
    throw new Error("transactionId should be unique, " + transactionId + " was added twice");
  }

  _pendingTransactionTimeouts.set(transactionId, {
    timeoutId: timeoutId,
    deferred: deferred
  });
}

exports.add = add;

function has(transactionId) {
  return _pendingTransactionTimeouts.has(transactionId);
}

exports.has = has;

function get(transactionId) {
  return _pendingTransactionTimeouts.get(transactionId);
}

exports.get = get;

function remove(transactionId) {
  log_1.log.debug('STRNC: Removing transaction from tracker', {
    transactionId: transactionId
  });

  _pendingTransactionTimeouts["delete"](transactionId);
}

exports.remove = remove;

function _reset() {
  _pendingTransactionTimeouts = new Map();
}

exports._reset = _reset;

},{"../log":135}],126:[function(require,module,exports){
"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = void 0 && (void 0).__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unRegisterAbortHandler = exports.registerAbortHandler = exports.unRegisterActionHandler = exports.registerActionHandler = exports.startTransaction = exports.init = exports._reset = void 0;

var recording_transaction_id_generator_1 = require("./recording-transaction-id-generator");

var transactionsTracker = __importStar(require("./client-transactions-tracker"));

var protocol_events_1 = require("../protocol-events");

var deferred_1 = require("../deferred");

var log_1 = require("../log");

var _socket = null;
var _transactionTimeout = null;

var _actionHandlers = new Map();

var _abortActionHandlers = new Map();

function _reset() {
  _socket = null;
  _transactionTimeout = null;

  transactionsTracker._reset();

  _actionHandlers = new Map();
  _abortActionHandlers = new Map();
}

exports._reset = _reset;

function init(socket, transactionTimeout) {
  if (transactionTimeout === void 0) {
    transactionTimeout = 1000;
  }

  _socket = socket;
  _transactionTimeout = transactionTimeout;
  getSocket().on(protocol_events_1.Events.TransactionCompleted, function (transactionId) {
    if (transactionsTracker.has(transactionId)) {
      var transaction = transactionsTracker.get(transactionId);
      log_1.log.info("STRNC: Completed transaction", {
        transactionId: transactionId,
        transaction: transaction
      });
      clearTimeout(transaction.timeoutId);
      transaction.deferred.resolve();
      transactionsTracker.remove(transactionId);
    } else {
      log_1.log.warn('STRNC: Tried to complete a transaction that doesn\'t exist anymore.', {
        transactionId: transactionId
      });
    }
  });
  getSocket().on(protocol_events_1.Events.TransactionAborted, function (transactionId, failureReason) {
    if (transactionsTracker.has(transactionId)) {
      var transaction = transactionsTracker.get(transactionId);
      log_1.log.warn("STRNC: Transaction aborted", {
        transactionId: transactionId,
        transaction: transaction,
        failureReason: failureReason
      });
      clearTimeout(transaction.timeoutId);
      transaction.deferred.reject(failureReason);
      transactionsTracker.remove(transactionId);
    } else {
      log_1.log.warn('STRNC: Tried to abort a transaction that doesn\'t exist anymore.', {
        transactionId: transactionId,
        failureReason: failureReason
      });
    }
  });
}

exports.init = init;

function getSocket() {
  if (!_socket) throw new Error('recording-transaction-client not ready, did you forget to call initialize');
  return _socket;
}

function startTransaction(request) {
  var transactionId = recording_transaction_id_generator_1.generateTransactionId(request);
  log_1.log.info('STRNC: Starting transaction', {
    transactionId: transactionId,
    request: request
  });
  getSocket().emit(protocol_events_1.Events.StartTransaction, __assign(__assign({}, request), {
    transactionId: transactionId
  }));
  var pendingTransactionTimeoutId = setTimeout(function () {
    if (transactionsTracker.has(transactionId)) {
      log_1.log.warn('STRNC: Transaction timed out', {
        transactionId: transactionId,
        _transactionTimeout: _transactionTimeout
      });
      var transaction = transactionsTracker.get(transactionId);
      transaction.deferred.reject({
        isInitiatorTimeout: true,
        description: 'Server took too long'
      });
      transactionsTracker.remove(transactionId);
    }
  }, _transactionTimeout);
  var deferred = new deferred_1.Deferred();
  transactionsTracker.add(transactionId, pendingTransactionTimeoutId, deferred);
  return deferred.toPromise();
}

exports.startTransaction = startTransaction;

function registerActionHandler(handlerActionType, handler) {
  var _this = this;

  log_1.log.verbose('STRNC: Registering action handler', {
    handlerActionType: handlerActionType
  });
  if (_actionHandlers.has(handlerActionType)) throw new Error("Handler for action " + handlerActionType + " already registered");
  var socket = getSocket();

  var socketListener = function socketListener(recordingId, transactionId, transactionActionType) {
    return __awaiter(_this, void 0, void 0, function () {
      var metadata, err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            metadata = {
              recordingId: recordingId,
              transactionId: transactionId,
              transactionActionType: transactionActionType
            };

            if (handlerActionType !== transactionActionType) {
              return [2
              /*return*/
              ]; //do nothing, this handler is for another type of action
            }

            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            log_1.log.verbose('STRNC: Executing action handler', metadata);
            return [4
            /*yield*/
            , handler(recordingId)];

          case 2:
            _a.sent();

            log_1.log.verbose('STRNC: Action handler completed successfully', metadata);
            socket.emit(protocol_events_1.Events.Done, transactionId);
            return [3
            /*break*/
            , 4];

          case 3:
            err_1 = _a.sent();
            socket.emit(protocol_events_1.Events.Fail, transactionId, err_1 && err_1.toString());
            log_1.log.warn('STRNC: Action handler failed', __assign(__assign({}, metadata), {
              err: err_1
            }));
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  socket.on(protocol_events_1.Events.Action, socketListener);

  _actionHandlers.set(handlerActionType, socketListener);

  log_1.log.verbose('STRNC: Action handler registered', {
    handlerActionType: handlerActionType
  });
}

exports.registerActionHandler = registerActionHandler;

function unRegisterActionHandler(handlerActionType) {
  log_1.log.verbose('STRNC: Unregistering action handler', {
    handlerActionType: handlerActionType
  });
  if (!_actionHandlers.has(handlerActionType)) throw new Error("Trying to unregister handler for action " + handlerActionType + ", but no handler found");

  var handler = _actionHandlers.get(handlerActionType);

  if (!handler) throw new Error("Unregister handler for action " + handlerActionType + " failed, handler is undefined/null");

  _actionHandlers["delete"](handlerActionType);

  getSocket().off(protocol_events_1.Events.Action, handler);
  log_1.log.verbose('STRNC: Action handler unregistered', {
    handlerActionType: handlerActionType
  });
}

exports.unRegisterActionHandler = unRegisterActionHandler;

function registerAbortHandler(handlerActionType, handler) {
  var _this = this;

  log_1.log.verbose('STRNC: Registering abort handler', {
    handlerActionType: handlerActionType
  });
  if (_abortActionHandlers.has(handlerActionType)) throw new Error("Abort handler for action " + handlerActionType + " already registered");
  var socket = getSocket();

  var socketListener = function socketListener(recordingId, transactionActionType) {
    return __awaiter(_this, void 0, void 0, function () {
      var metadata, err_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            metadata = {
              recordingId: recordingId,
              transactionActionType: transactionActionType
            };

            if (handlerActionType !== transactionActionType) {
              return [2
              /*return*/
              ]; //do nothing, this handler is for another type of action
            }

            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            log_1.log.verbose('STRNC: Executing abort handler', metadata);
            return [4
            /*yield*/
            , handler(recordingId)];

          case 2:
            _a.sent();

            log_1.log.verbose('STRNC: Abort handler completed successfully', metadata);
            return [3
            /*break*/
            , 4];

          case 3:
            err_2 = _a.sent();
            log_1.log.warn('STRNC: Abort handler failed', __assign(__assign({}, metadata), {
              err: err_2
            }));
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  socket.on(protocol_events_1.Events.Abort, socketListener);

  _abortActionHandlers.set(handlerActionType, socketListener);

  log_1.log.verbose('STRNC: Abort handler registered', {
    handlerActionType: handlerActionType
  });
}

exports.registerAbortHandler = registerAbortHandler;

function unRegisterAbortHandler(handlerActionType) {
  log_1.log.verbose('STRNC: Unregistering abort handler', {
    handlerActionType: handlerActionType
  });
  if (!_abortActionHandlers.has(handlerActionType)) throw new Error("Trying to unregister abort handler for action " + handlerActionType + ", but no handler found");

  var handler = _abortActionHandlers.get(handlerActionType);

  if (!handler) throw new Error("Unregister abort handler for action " + handlerActionType + " failed, handler is undefined/null");

  _abortActionHandlers["delete"](handlerActionType);

  getSocket().off(protocol_events_1.Events.Abort, handler);
  log_1.log.verbose('STRNC: Abort handler unregistered', {
    handlerActionType: handlerActionType
  });
}

exports.unRegisterAbortHandler = unRegisterAbortHandler;

},{"../deferred":133,"../log":135,"../protocol-events":136,"./client-transactions-tracker":125,"./recording-transaction-id-generator":127}],127:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateTransactionId = void 0;

function generateTransactionId(request) {
  return request.recordingId + "-" + request.actionType + "-" + Date.now() + "-" + Math.random().toString(36).substring(2);
}

exports.generateTransactionId = generateTransactionId;

},{}],128:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeBySocketId = exports.remove = exports.add = exports.getSocketIdByRoomMemberId = exports._reset = exports._socketIdRoomMemberMappings = exports._roomMemberSocketMappings = void 0;

var log_1 = require("../../log");

var protocol_events_1 = require("../../protocol-events");

var recording_transaction_coordinator_1 = require("../recording-transaction-coordinator");

var room_member_key_creator_1 = require("./room-member-key-creator");

exports._roomMemberSocketMappings = new Map();
exports._socketIdRoomMemberMappings = new Map();

function _reset() {
  //@ts-ignore
  exports._roomMemberSocketMappings = new Map(); //@ts-ignore

  exports._socketIdRoomMemberMappings = new Map();
}

exports._reset = _reset;

function getSocketIdByRoomMemberId(roomId, memberId) {
  var _a;

  return ((_a = exports._roomMemberSocketMappings.get(room_member_key_creator_1.createRoomMemberKey(roomId, memberId))) === null || _a === void 0 ? void 0 : _a.id) || null;
}

exports.getSocketIdByRoomMemberId = getSocketIdByRoomMemberId;

function add(roomId, memberId, socket) {
  var metadata = {
    roomId: roomId,
    memberId: memberId,
    socketId: socket === null || socket === void 0 ? void 0 : socket.id
  };

  if (!roomId) {
    log_1.log.warn('STRN: room id was not provided when adding a socket in connected sockets tracker, ignoring', metadata);
    return;
  }

  if (!memberId) {
    log_1.log.warn('STRN: member id was not provided when adding a socket in connected sockets tracker, ignoring', metadata);
    return;
  }

  if (!socket) {
    log_1.log.warn('STRN: socket was not provided when adding a socket in connected sockets tracker, ignoring', metadata);
    return;
  }

  var roomMemberKey = room_member_key_creator_1.createRoomMemberKey(roomId, memberId);

  exports._roomMemberSocketMappings.set(roomMemberKey, socket);

  exports._socketIdRoomMemberMappings.set(socket.id, roomMemberKey);

  log_1.log.info('STRN: Registering socket', metadata);
  socket.on(protocol_events_1.Events.StartTransaction, function (startTransactionRequest) {
    try {
      recording_transaction_coordinator_1.startTransaction(startTransactionRequest, memberId);
    } catch (err) {
      log_1.log.error('STRN: Start transaction failed', {
        startTransactionRequest: startTransactionRequest,
        memberId: memberId,
        err: err
      });
    }
  });
  socket.on(protocol_events_1.Events.Done, function (transactionId) {
    try {
      recording_transaction_coordinator_1.handleActionDone(transactionId, memberId);
    } catch (err) {
      log_1.log.error('STRN: Action done handler failed', {
        transactionId: transactionId,
        memberId: memberId,
        err: err
      });
    }
  });
  socket.on(protocol_events_1.Events.Fail, function (transactionId, failureReason) {
    try {
      recording_transaction_coordinator_1.handleActionFailed(transactionId, memberId, failureReason);
    } catch (err) {
      log_1.log.error('STRN: Action failed handler failed', {
        transactionId: transactionId,
        memberId: memberId,
        err: err
      });
    }
  });
}

exports.add = add;

function remove(roomId, memberId) {
  var metadata = {
    roomId: roomId,
    memberId: memberId
  };
  log_1.log.info('STRN: Removing tracked socket', metadata);

  if (!roomId) {
    log_1.log.warn('STRN: Tried to remove a room-member mapping from connected socket tracker but no roomId was provided', metadata);
    return;
  }

  if (!memberId) {
    log_1.log.warn('STRN: Tried to remove a room-member mapping from connected socket tracker but no memberId was provided', metadata);
    return;
  }

  var roomMemberKey = room_member_key_creator_1.createRoomMemberKey(roomId, memberId);
  removeByRoomMemberKey(roomMemberKey);
}

exports.remove = remove;

function removeBySocketId(socketId) {
  log_1.log.info('STRN: Removing tracked socket by socketId', {
    socketId: socketId
  });

  if (exports._socketIdRoomMemberMappings.has(socketId)) {
    var roomMemberKey = exports._socketIdRoomMemberMappings.get(socketId);

    removeByRoomMemberKey(roomMemberKey);
  } else {
    log_1.log.warn('STRN: tried to remove a socket by id that wasn\'t registered', {
      socketId: socketId
    });
  }
}

exports.removeBySocketId = removeBySocketId;

function removeByRoomMemberKey(recordingMemberKey) {
  log_1.log.info('STRN: Removing tracked socket by room and member', {
    recordingMemberKey: recordingMemberKey
  });

  var socket = exports._roomMemberSocketMappings.get(recordingMemberKey);

  if (socket !== undefined) {
    exports._socketIdRoomMemberMappings["delete"](socket.id);

    socket.removeAllListeners(protocol_events_1.Events.Done); //we should only have one, the alternative is to use off but that requires the listener function

    socket.removeAllListeners(protocol_events_1.Events.Fail);
    socket.removeAllListeners(protocol_events_1.Events.StartTransaction);
  } else {
    log_1.log.warn('STRN: tried to remove a socket by room and member that wasn\'t registered', {
      recordingMemberKey: recordingMemberKey
    });
  }

  exports._roomMemberSocketMappings["delete"](recordingMemberKey);
}

},{"../../log":135,"../../protocol-events":136,"../recording-transaction-coordinator":130,"./room-member-key-creator":129}],129:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRoomMemberKey = void 0;

function createRoomMemberKey(recordingId, memberId) {
  return recordingId + "-" + memberId;
}

exports.createRoomMemberKey = createRoomMemberKey;

},{}],130:[function(require,module,exports){
"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleActionFailed = exports.handleActionDone = exports.startTransaction = exports.getSocketServer = exports.init = exports._reset = void 0;

var server_transactions_tracker_1 = require("./server-transactions-tracker");

var connected_sockets_tracker_1 = require("./connected-sockets-tracker/connected-sockets-tracker");

var protocol_events_1 = require("../protocol-events");

var log_1 = require("../log");

var _socketServer = null;
var _timeoutInMs = null;

function _reset() {
  _socketServer = null;
  _timeoutInMs = null;

  server_transactions_tracker_1._reset();
}

exports._reset = _reset;

function init(socketServer, timeoutInMs) {
  if (timeoutInMs === void 0) {
    timeoutInMs = 1000;
  }

  _socketServer = socketServer;
  _timeoutInMs = timeoutInMs;
}

exports.init = init;

function getSocketServer() {
  if (_socketServer === null) throw new Error('socketServer not ready, did you forget to call initialize?');
  return _socketServer;
}

exports.getSocketServer = getSocketServer;

function startTransaction(startTransactionRequest, initatorMemberId) {
  if (!Array.isArray(startTransactionRequest.members) || startTransactionRequest.members.length === 0) {
    throw new Error('Received a start transaction request with no members');
  }

  if (!startTransactionRequest.recordingId) {
    throw new Error('Received a start transaction with no recordingId');
  }

  if (!startTransactionRequest.transactionId) {
    throw new Error('Received a start transaction with no transactionId');
  }

  if (!startTransactionRequest.roomId) {
    throw new Error('Received a start transaction with no roomId');
  }

  log_1.log.info('STRN: Starting transaction', {
    startTransactionRequest: startTransactionRequest
  });
  var socketServer = getSocketServer();
  socketServer.to(startTransactionRequest.roomId).emit(protocol_events_1.Events.Action, startTransactionRequest.recordingId, startTransactionRequest.transactionId, startTransactionRequest.actionType);
  var timeoutId = setTimeout(function () {
    var membersWhoDidntComplete = server_transactions_tracker_1.get(startTransactionRequest.transactionId).getMembersWhoHaventCompleted();
    var failureReason = {
      description: 'Members took too long to reply',
      isTimeout: true,
      membersWhoDidntComplete: membersWhoDidntComplete
    };
    log_1.log.warn('STRN: Transaction timed out waiting for members to respond', {
      startTransactionRequest: startTransactionRequest,
      membersWhoDidntComplete: membersWhoDidntComplete,
      failureReason: failureReason
    });
    sendTransactionAborted(startTransactionRequest.transactionId, failureReason); //this does not send a request to abort the action to participants
  }, _timeoutInMs);
  server_transactions_tracker_1.add(startTransactionRequest.transactionId, startTransactionRequest.actionType, startTransactionRequest.roomId, startTransactionRequest.recordingId, startTransactionRequest.members, initatorMemberId, timeoutId);
}

exports.startTransaction = startTransaction;

function handleActionDone(transactionId, memberId) {
  var metadata = {
    transactionId: transactionId,
    memberId: memberId
  };
  log_1.log.debug('STRN: Handling action done', metadata);

  if (!server_transactions_tracker_1.has(transactionId)) {
    log_1.log.warn('STRN: Received an action complete, ignoring because the transaction is no longer active', metadata);
    return;
  }

  var socketServer = getSocketServer();
  var transaction = server_transactions_tracker_1.get(transactionId);

  if (!transaction.isMember(memberId)) {
    log_1.log.warn('STRN: Received an action complete, ignoring because the participant was not part of the transaction\'s member list', metadata);
    return;
  }

  transaction.markComplete(memberId);

  if (transaction.isComplete()) {
    var initiatorSocketId = connected_sockets_tracker_1.getSocketIdByRoomMemberId(transaction.roomId, transaction.initiatingMemberId); //the initiator might have dropped connection, if it did, he can miss this event, the transaction will timeout on the client's end. 
    //if the client manually triggers the action it will already be fullfilled, all clients should report done trivially
    //we should show a warning on timeout in the client and log this

    if (initiatorSocketId !== null) {
      socketServer.to(initiatorSocketId).emit(protocol_events_1.Events.TransactionCompleted, transactionId);
    } else {
      log_1.log.warn('STRN: Unable to notify transaction initiator of action done', __assign(__assign({}, metadata), {
        initiatorSocketId: initiatorSocketId
      }));
    }

    server_transactions_tracker_1.remove(transactionId);
  }
}

exports.handleActionDone = handleActionDone;

function handleActionFailed(transactionId, memberId, failureReason) {
  var metadata = {
    transactionId: transactionId,
    memberId: memberId,
    failureReason: failureReason
  };
  log_1.log.debug('STRN: Handling action failed', metadata);

  if (!server_transactions_tracker_1.has(transactionId)) {
    log_1.log.warn("STRN: Received a failed action, ignoring because the transaction is no longer active", metadata);
    return;
  }

  sendAbortActionAndAbortTransaction(transactionId, {
    description: "Participant failed with: " + failureReason,
    isTimeout: false,
    failedMemberId: memberId,
    membersWhoDidntComplete: server_transactions_tracker_1.get(transactionId).getMembersWhoHaventCompleted()
  });
}

exports.handleActionFailed = handleActionFailed;

function sendAbortAction(transactionId) {
  var socketServer = getSocketServer();
  var transaction = server_transactions_tracker_1.get(transactionId);
  log_1.log.info('STRN: Sending abort action', {
    transactionId: transactionId,
    transaction: transaction
  });
  socketServer.to(transaction.roomId).emit(protocol_events_1.Events.Abort, transaction.recordingId, transaction.actionType);
}

function sendTransactionAborted(transactionId, failureReason) {
  var transaction = server_transactions_tracker_1.get(transactionId);
  var metadata = {
    transactionId: transactionId,
    transaction: transaction,
    failureReason: failureReason
  };
  log_1.log.info('STRN: Transaction aborted', metadata);
  var initiatorSocketId = connected_sockets_tracker_1.getSocketIdByRoomMemberId(transaction.roomId, transaction.initiatingMemberId); //the initiator might have dropped connection (===null), if it did, he can miss this event, the transaction will timeout on the client's end. 
  //the client is responsible for retrying
  //we should show a warning on timeout in the client and log this

  if (initiatorSocketId !== null) {
    var socketServer = getSocketServer();
    socketServer.to(initiatorSocketId).emit(protocol_events_1.Events.TransactionAborted, transactionId, failureReason);
  } else {
    log_1.log.warn('STRN: Unable to notify transaction initiator of action abort', __assign(__assign({}, metadata), {
      initiatorSocketId: initiatorSocketId
    }));
  }

  server_transactions_tracker_1.remove(transactionId);
}

function sendAbortActionAndAbortTransaction(transactionId, failureReason) {
  sendAbortAction(transactionId);
  sendTransactionAborted(transactionId, failureReason);
}

},{"../log":135,"../protocol-events":136,"./connected-sockets-tracker/connected-sockets-tracker":128,"./server-transactions-tracker":131}],131:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remove = exports.get = exports.has = exports.add = exports._reset = void 0;

var log_1 = require("../log");

var transaction_1 = require("./transaction");

var _ongoingTransactions = new Map();

function _reset() {
  _ongoingTransactions = new Map();
}

exports._reset = _reset;

function add(transactionId, actionType, roomId, recordingId, members, initiatingMemberId, timeoutId) {
  log_1.log.debug('STRN: Adding transaction to tracker', {
    transactionId: transactionId,
    actionType: actionType,
    roomId: roomId,
    recordingId: recordingId,
    members: members,
    initiatingMemberId: initiatingMemberId,
    timeoutId: timeoutId
  });

  if (has(transactionId)) {
    throw new Error("Tried to add the same transaction twice (" + transactionId + ")");
  }

  var transaction = new transaction_1.Transaction(transactionId, actionType, roomId, recordingId, members, initiatingMemberId, timeoutId);

  _ongoingTransactions.set(transactionId, transaction);
}

exports.add = add;

function has(transactionId) {
  return _ongoingTransactions.has(transactionId);
}

exports.has = has;

function get(transactionId) {
  return _ongoingTransactions.get(transactionId);
}

exports.get = get;

function remove(transactionId) {
  if (_ongoingTransactions.has(transactionId)) {
    var transaction = _ongoingTransactions.get(transactionId);

    clearTimeout(transaction.timeoutId);
    log_1.log.debug('STRN: Removing transaction from tracker', {
      transaction: transaction
    });

    _ongoingTransactions["delete"](transactionId);
  }
}

exports.remove = remove;

},{"../log":135,"./transaction":132}],132:[function(require,module,exports){
"use strict";

var __spreadArray = void 0 && (void 0).__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }

  return to;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Transaction = void 0;

var Transaction =
/** @class */
function () {
  function Transaction(transactionId, actionType, roomId, recordingId, members, initiatingMemberId, timeoutId) {
    this.transactionId = transactionId;
    this.actionType = actionType;
    this.roomId = roomId;
    this.recordingId = recordingId;
    this.members = members;
    this.initiatingMemberId = initiatingMemberId;
    this.timeoutId = timeoutId;
    this._membersWhoHaventCompleted = [];
    this._membersWhoHaventCompleted = __spreadArray([], members);
  }

  Transaction.prototype.isMember = function (memberId) {
    return this.members.some(function (id) {
      return id === memberId;
    });
  };

  Transaction.prototype.markComplete = function (memberId) {
    if (this._membersWhoHaventCompleted.includes(memberId)) {
      this._membersWhoHaventCompleted.splice(this._membersWhoHaventCompleted.indexOf(memberId), 1);
    } else {
      //assumes isMember was used to check membership first
      throw new Error("Tried to mark the same member as complete twice: memberId: " + memberId + ", recordingId: " + this.recordingId);
    }
  };

  Transaction.prototype.isComplete = function () {
    return this._membersWhoHaventCompleted.length === 0;
  };

  Transaction.prototype.getMembersWhoHaventCompleted = function () {
    return __spreadArray([], this._membersWhoHaventCompleted);
  };

  return Transaction;
}();

exports.Transaction = Transaction;

},{}],133:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Deferred = void 0;

var Deferred =
/** @class */
function () {
  function Deferred() {
    var _this = this;

    this._resolveFn = null;
    this._rejectFn = null;
    this._promise = new Promise(function (resolve, reject) {
      _this._resolveFn = resolve;
      _this._rejectFn = reject;
    });
  }

  Deferred.prototype.toPromise = function () {
    return this._promise;
  }; //calling resolve multiple time won't produce any errors but will only "resolve" the promise once
  //calling resolve and reject after that has no effect
  //same is true for a "normally" created promise


  Deferred.prototype.resolve = function (value) {
    if (this._resolveFn) {
      this._resolveFn(value);
    } else {
      throw new Error('Resolve called on deferred without a promise');
    }
  };

  Deferred.prototype.reject = function (err) {
    if (this._rejectFn) {
      this._rejectFn(err);
    } else {
      throw new Error('Reject called on deferred without a promise');
    }
  };

  return Deferred;
}();

exports.Deferred = Deferred;

},{}],134:[function(require,module,exports){
"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectedSocketsTracker = exports.recordingTransactionsCoordinator = exports.recordingTransactionsClient = void 0;
exports.recordingTransactionsClient = __importStar(require("./client/recording-transaction-client"));
exports.recordingTransactionsCoordinator = __importStar(require("./coordinator/recording-transaction-coordinator"));
exports.connectedSocketsTracker = __importStar(require("./coordinator/connected-sockets-tracker/connected-sockets-tracker"));

},{"./client/recording-transaction-client":126,"./coordinator/connected-sockets-tracker/connected-sockets-tracker":128,"./coordinator/recording-transaction-coordinator":130}],135:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.log = void 0;

var util_1 = __importDefault(require("util"));

var LogLevel;

(function (LogLevel) {
  LogLevel["Error"] = "Error";
  LogLevel["Warn"] = "Warn";
  LogLevel["Info"] = "Info";
  LogLevel["Debug"] = "Debug";
  LogLevel["Verbose"] = "Verbose";
})(LogLevel || (LogLevel = {})); // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value#examples
// Removes circular references from objects when stringifying


var getCircularReplacer = function getCircularReplacer() {
  var seen = new WeakSet();
  return function (key, value) {
    if (_typeof(value) === "object" && value !== null) {
      if (seen.has(value)) {
        return;
      }

      seen.add(value);
    }

    return value;
  };
};

var _log = function _log(level, message, metadata) {
  var output = {
    level: level,
    message: message
  };

  if (typeof metadata !== "undefined") {
    output.metadata = metadata;
  }

  try {
    // this is used both serverside and clientside
    // if we are on the client, we should just output the object
    // otherwise, we should remove the circular issues
    // @ts-ignore
    if (typeof browser === "undefined") console.log(JSON.stringify(output, getCircularReplacer()));else console.log(output);
  } catch (e) {
    // If we still fail to stringify, just log result of `util.inspect` (which may be invalid JSON), along with parseError
    var cleaned = util_1["default"].inspect(__assign(__assign({}, output), {
      parseError: e.message
    }), {
      breakLength: Infinity,
      compact: true
    });
    console.log(cleaned);
  }
};

exports.log = {
  verbose: function verbose(message, metadata) {
    return _log(LogLevel.Verbose, message, metadata);
  },
  debug: function debug(message, metadata) {
    return _log(LogLevel.Debug, message, metadata);
  },
  info: function info(message, metadata) {
    return _log(LogLevel.Info, message, metadata);
  },
  warn: function warn(message, metadata) {
    return _log(LogLevel.Warn, message, metadata);
  },
  error: function error(message, metadata) {
    return _log(LogLevel.Error, message, metadata);
  }
};

},{"util":164}],136:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Events = void 0;
exports.Events = {
  TransactionCompleted: '1pc-completed',
  TransactionAborted: '1pc-aborted',
  StartTransaction: '1pc',
  Done: '1pc-action-done',
  Fail: '1pc-action-fail',
  Action: '1pc-action',
  Abort: '1pc-abort'
};

},{}],137:[function(require,module,exports){
"use strict";

/**
 * Expose `Emitter`.
 */
if (typeof module !== 'undefined') {
  module.exports = Emitter;
}
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */


function Emitter(obj) {
  if (obj) return mixin(obj);
}

;
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }

  return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */


Emitter.prototype.on = Emitter.prototype.addEventListener = function (event, fn) {
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
  return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */


Emitter.prototype.once = function (event, fn) {
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */


Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function (event, fn) {
  this._callbacks = this._callbacks || {}; // all

  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  } // specific event


  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this; // remove all handlers

  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  } // remove specific handler


  var cb;

  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];

    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  } // Remove event specific arrays for event types that no
  // one is subscribed for to avoid memory leak.


  if (callbacks.length === 0) {
    delete this._callbacks['$' + event];
  }

  return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */


Emitter.prototype.emit = function (event) {
  this._callbacks = this._callbacks || {};
  var args = new Array(arguments.length - 1),
      callbacks = this._callbacks['$' + event];

  for (var i = 1; i < arguments.length; i++) {
    args[i - 1] = arguments[i];
  }

  if (callbacks) {
    callbacks = callbacks.slice(0);

    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */


Emitter.prototype.listeners = function (event) {
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */


Emitter.prototype.hasListeners = function (event) {
  return !!this.listeners(event).length;
};

},{}],138:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Helpers.
 */
var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {};

  var type = _typeof(val);

  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options["long"] ? fmtLong(val) : fmtShort(val);
  }

  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */


function parse(str) {
  str = String(str);

  if (str.length > 100) {
    return;
  }

  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);

  if (!match) {
    return;
  }

  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();

  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;

    case 'days':
    case 'day':
    case 'd':
      return n * d;

    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;

    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;

    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;

    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;

    default:
      return undefined;
  }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */


function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }

  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }

  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }

  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }

  return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */


function fmtLong(ms) {
  return plural(ms, d, 'day') || plural(ms, h, 'hour') || plural(ms, m, 'minute') || plural(ms, s, 'second') || ms + ' ms';
}
/**
 * Pluralization helper.
 */


function plural(ms, n, name) {
  if (ms < n) {
    return;
  }

  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }

  return Math.ceil(ms / n) + ' ' + name + 's';
}

},{}],139:[function(require,module,exports){
(function (process){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */
exports = module.exports = require('./debug');
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();
/**
 * Colors.
 */

exports.colors = ['lightseagreen', 'forestgreen', 'goldenrod', 'dodgerblue', 'darkorchid', 'crimson'];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  } // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632


  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */


exports.formatters.j = function (v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */


function formatArgs(args) {
  var useColors = this.useColors;
  args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
  if (!useColors) return;
  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit'); // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into

  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function (match) {
    if ('%%' === match) return;
    index++;

    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });
  args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */


function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === (typeof console === "undefined" ? "undefined" : _typeof(console)) && console.log && Function.prototype.apply.call(console.log, console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */


function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch (e) {}
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */


function load() {
  var r;

  try {
    r = exports.storage.debug;
  } catch (e) {} // If debug isn't set in LS, and we're in Electron, try to load $DEBUG


  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}
/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */


exports.enable(load());
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

}).call(this,require('_process'))
},{"./debug":140,"_process":154}],140:[function(require,module,exports){
"use strict";

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */
exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = require('ms');
/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];
/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};
/**
 * Previous log timestamp.
 */

var prevTime;
/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0,
      i;

  for (i in namespace) {
    hash = (hash << 5) - hash + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}
/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */


function createDebug(namespace) {
  function debug() {
    // disabled?
    if (!debug.enabled) return;
    var self = debug; // set `diff` timestamp

    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr; // turn the `arguments` into a proper Array

    var args = new Array(arguments.length);

    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    } // apply any `formatters` transformations


    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];

      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val); // now we need to remove `args[index]` since it's inlined in the `format`

        args.splice(index, 1);
        index--;
      }

      return match;
    }); // apply env-specific formatting (colors, etc.)

    exports.formatArgs.call(self, args);
    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace); // env-specific initialization logic for debug instances

  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}
/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */


function enable(namespaces) {
  exports.save(namespaces);
  exports.names = [];
  exports.skips = [];
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings

    namespaces = split[i].replace(/\*/g, '.*?');

    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}
/**
 * Disable debug output.
 *
 * @api public
 */


function disable() {
  exports.enable('');
}
/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */


function enabled(name) {
  var i, len;

  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }

  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }

  return false;
}
/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */


function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}

},{"ms":138}],141:[function(require,module,exports){
"use strict";

var request = require('superagent');

var Promise = require('es6-promise').Promise;

var getBaseURL = require('./get-base-url');

var httpHeaderSafeJson = require('./http-header-safe-json');

var buildCustomError;
var downloadRequest;
var nodeBinaryParser; // Register a handler that will instruct superagent how to parse the response

request.parse['application/octect-stream'] = function (obj) {
  return obj;
}; // This doesn't match what was spec'd in paper doc yet


buildCustomError = function buildCustomError(error, response) {
  return {
    status: error.status,
    error: (response ? response.text : null) || error.toString(),
    response: response
  };
};

nodeBinaryParser = function nodeBinaryParser(res, done) {
  res.text = '';
  res.setEncoding('binary');
  res.on('data', function (chunk) {
    res.text += chunk;
  });
  res.on('end', function () {
    done();
  });
};

downloadRequest = function downloadRequest(path, args, auth, host, accessToken, selectUser) {
  if (auth !== 'user') {
    throw new Error('Unexpected auth type: ' + auth);
  }

  var promiseFunction = function promiseFunction(resolve, reject) {
    var apiRequest;

    function success(data) {
      if (resolve) {
        resolve(data);
      }
    }

    function failure(error) {
      if (reject) {
        reject(error);
      }
    }

    function responseHandler(error, response) {
      var data;

      if (error) {
        failure(buildCustomError(error, response));
      } else {
        // In the browser, the file is passed as a blob and in node the file is
        // passed as a string of binary data.
        data = JSON.parse(response.headers['dropbox-api-result']);

        if (response.xhr) {
          data.fileBlob = response.xhr.response;
        } else {
          data.fileBinary = response.res.text;
        }

        success(data);
      }
    }

    apiRequest = request.post(getBaseURL(host) + path).set('Authorization', 'Bearer ' + accessToken).set('Dropbox-API-Arg', httpHeaderSafeJson(args)).on('request', function () {
      if (this.xhr) {
        this.xhr.responseType = 'blob';
      }
    });

    if (selectUser) {
      apiRequest = apiRequest.set('Dropbox-API-Select-User', selectUser);
    } // Apply the node binary parser to the response if executing in node


    if (typeof window === 'undefined') {
      apiRequest.buffer(true).parse(nodeBinaryParser).end(responseHandler);
    } else {
      apiRequest.end(responseHandler);
    }
  };

  return new Promise(promiseFunction);
};

module.exports = downloadRequest;

},{"./get-base-url":144,"./http-header-safe-json":145,"es6-promise":152,"superagent":157}],142:[function(require,module,exports){
"use strict";

var REQUEST_CONSTANTS = require('./request-constants');

var DropboxBase; // Polyfill Object.assign() for older browsers

require('./object-assign-polyfill');
/**
 * @private
 * @class DropboxBase
 * @classdesc The main Dropbox SDK class. This contains the methods that are
 * shared between Dropbox and DropboxTeam classes. It is marked as private so
 * that it doesn't show up in the docs because it is never used directly.
 * @arg {Object} options
 * @arg {String} [options.accessToken] - An access token for making authenticated
 * requests.
 * @arg {String} [options.clientId] - The client id fo ryour app. Used to create
 * authentication URL.
 * @arg {Number} [options.selectUser] - User is the team access token would like
 * to act as.
 */


DropboxBase = function DropboxBase(options) {
  options = options || {};
  this.accessToken = options.accessToken;
  this.clientId = options.clientId;
  this.selectUser = options.selectUser;
};
/**
 * Set the access token used to authenticate requests to the API.
 * @arg {String} accessToken - An access token
 * @returns {undefined}
 */


DropboxBase.prototype.setAccessToken = function (accessToken) {
  this.accessToken = accessToken;
};
/**
 * Get the access token
 * @returns {String} Access token
 */


DropboxBase.prototype.getAccessToken = function () {
  return this.accessToken;
};
/**
 * Set the client id, which is used to help gain an access token.
 * @arg {String} clientId - Your apps client id
 * @returns {undefined}
 */


DropboxBase.prototype.setClientId = function (clientId) {
  this.clientId = clientId;
};
/**
 * Get the client id
 * @returns {String} Client id
 */


DropboxBase.prototype.getClientId = function () {
  return this.clientId;
};
/**
 * Get a URL that can be used to authenticate users for the Dropbox API.
 * @arg {String} redirectUri - A URL to redirect the user to after
 * authenticating. This must be added to your app through the admin interface.
 * @arg {String} [state] - State that will be returned in the redirect URL to help
 * prevent cross site scripting attacks.
 * @returns {String} Url to send user to for Dropbox API authentication
 */


DropboxBase.prototype.getAuthenticationUrl = function (redirectUri, state) {
  var AUTH_BASE_URL = 'https://www.dropbox.com/oauth2/authorize';
  var clientId = this.getClientId();
  var authUrl;

  if (!clientId) {
    throw new Error('A client id is required. You can set the client id using .setClientId().');
  }

  if (!redirectUri) {
    throw new Error('A redirect uri is required.');
  }

  authUrl = AUTH_BASE_URL + '?response_type=token&client_id=' + clientId;

  if (redirectUri) {
    authUrl = authUrl + '&redirect_uri=' + redirectUri;
  }

  if (state) {
    authUrl = authUrl + '&state=' + state;
  }

  return authUrl;
};
/**
 * Called when the authentication succeed
 * @callback successCallback
 * @param {string} access_token The application's access token
 */

/**
 * Called when the authentication failed.
 * @callback errorCallback
 */

/**
 * An authentication process that works with cordova applications.
 * @param {successCallback} successCallback
 * @param {errorCallback} errorCallback 
 */


DropboxBase.prototype.authenticateWithCordova = function (successCallback, errorCallback) {
  var redirect_url = 'https://www.dropbox.com/1/oauth2/redirect_receiver';
  var url = this.getAuthenticationUrl(redirect_url);
  var browser = window.open(url, '_blank');
  var removed = false;

  var onLoadError = function onLoadError(event) {
    // Try to avoid a browser crash on browser.close().
    window.setTimeout(function () {
      browser.close();
    }, 10);
    errorCallback();
  };

  var onLoadStop = function onLoadStop(event) {
    var error_label = '&error=';
    var error_index = event.url.indexOf(error_label);

    if (error_index > -1) {
      // Try to avoid a browser crash on browser.close().
      window.setTimeout(function () {
        browser.close();
      }, 10);
      errorCallback();
    } else {
      var access_token_label = '#access_token=';
      var access_token_index = event.url.indexOf(access_token_label);
      var token_type_index = event.url.indexOf('&token_type=');

      if (access_token_index > -1) {
        access_token_index += access_token_label.length; // Try to avoid a browser crash on browser.close().

        window.setTimeout(function () {
          browser.close();
        }, 10);
        var access_token = event.url.substring(access_token_index, token_type_index);
        successCallback(access_token);
      }
    }
  };

  var onExit = function onExit(event) {
    if (removed) {
      return;
    }

    browser.removeEventListener('loaderror', onLoadError);
    browser.removeEventListener('loadstop', onLoadStop);
    browser.removeEventListener('exit', onExit);
    removed = true;
  };

  browser.addEventListener('loaderror', onLoadError);
  browser.addEventListener('loadstop', onLoadStop);
  browser.addEventListener('exit', onExit);
};

DropboxBase.prototype.request = function (path, args, auth, host, style) {
  var request = null;

  switch (style) {
    case REQUEST_CONSTANTS.RPC:
      request = this.getRpcRequest();
      break;

    case REQUEST_CONSTANTS.DOWNLOAD:
      request = this.getDownloadRequest();
      break;

    case REQUEST_CONSTANTS.UPLOAD:
      request = this.getUploadRequest();
      break;

    default:
      throw new Error('Invalid request style: ' + style);
  }

  return request(path, args, auth, host, this.getAccessToken(), this.selectUser);
};

DropboxBase.prototype.setRpcRequest = function (newRpcRequest) {
  DropboxBase.prototype.rpcRequest = newRpcRequest;
};

DropboxBase.prototype.getRpcRequest = function () {
  if (DropboxBase.prototype.rpcRequest === undefined) {
    DropboxBase.prototype.rpcRequest = require('./rpc-request');
  }

  return DropboxBase.prototype.rpcRequest;
};

DropboxBase.prototype.setDownloadRequest = function (newDownloadRequest) {
  DropboxBase.prototype.downloadRequest = newDownloadRequest;
};

DropboxBase.prototype.getDownloadRequest = function () {
  if (DropboxBase.prototype.downloadRequest === undefined) {
    DropboxBase.prototype.downloadRequest = require('./download-request');
  }

  return DropboxBase.prototype.downloadRequest;
};

DropboxBase.prototype.setUploadRequest = function (newUploadRequest) {
  DropboxBase.prototype.uploadRequest = newUploadRequest;
};

DropboxBase.prototype.getUploadRequest = function () {
  if (DropboxBase.prototype.uploadRequest === undefined) {
    DropboxBase.prototype.uploadRequest = require('./upload-request');
  }

  return DropboxBase.prototype.uploadRequest;
};

module.exports = DropboxBase;

},{"./download-request":141,"./object-assign-polyfill":147,"./request-constants":148,"./rpc-request":150,"./upload-request":151}],143:[function(require,module,exports){
"use strict";

var DropboxBase = require('./dropbox-base');

var routes = require('./routes');

var Dropbox;
/**
 * @class Dropbox
 * @extends DropboxBase
 * @classdesc The Dropbox SDK class that provides methods to read, write and
 * create files or folders in a user's Dropbox.
 * @arg {Object} options
 * @arg {String} [options.accessToken] - An access token for making authenticated
 * requests.
 * @arg {String} [options.clientId] - The client id for your app. Used to create
 * authentication URL.
 * @arg {String} [options.selectUser] - Select user is only used by DropboxTeam.
 * It specifies which user the team access token should be acting as.
 */

Dropbox = function Dropbox(options) {
  DropboxBase.call(this, options);
};

Dropbox.prototype = Object.create(DropboxBase.prototype);
Dropbox.prototype.constructor = Dropbox; // Add the user endpoint methods to the prototype

Dropbox.prototype = Object.assign(Dropbox.prototype, routes);

Dropbox.prototype.filesGetSharedLinkFile = function (arg) {
  return this.request('sharing/get_shared_link_file', arg, 'api', 'download');
};

module.exports = Dropbox;

},{"./dropbox-base":142,"./routes":149}],144:[function(require,module,exports){
"use strict";

function getBaseURL(host) {
  return 'https://' + host + '.dropboxapi.com/2/';
}

module.exports = getBaseURL;

},{}],145:[function(require,module,exports){
"use strict";

// source https://www.dropboxforum.com/t5/API-support/HTTP-header-quot-Dropbox-API-Arg-quot-could-not-decode-input-as/m-p/173823/highlight/true#M6786
var charsToEncode = /[\u007f-\uffff]/g;

function httpHeaderSafeJson(args) {
  return JSON.stringify(args).replace(charsToEncode, function (c) {
    return "\\u" + ('000' + c.charCodeAt(0).toString(16)).slice(-4);
  });
}

module.exports = httpHeaderSafeJson;

},{}],146:[function(require,module,exports){
"use strict";

var Dropbox = require('./dropbox');

module.exports = Dropbox;

},{"./dropbox":143}],147:[function(require,module,exports){
"use strict";

// Polyfill object.assign for legacy browsers
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
if (typeof Object.assign !== 'function') {
  (function () {
    Object.assign = function (target) {
      'use strict';

      var output;
      var index;
      var source;
      var nextKey;

      if (target === undefined || target === null) {
        throw new TypeError('Cannot convert undefined or null to object');
      }

      output = Object(target);

      for (index = 1; index < arguments.length; index++) {
        source = arguments[index];

        if (source !== undefined && source !== null) {
          for (nextKey in source) {
            if (source.hasOwnProperty(nextKey)) {
              output[nextKey] = source[nextKey];
            }
          }
        }
      }

      return output;
    };
  })();
}

},{}],148:[function(require,module,exports){
"use strict";

var REQUEST_CONSTANTS = {
  RPC: 'rpc',
  DOWNLOAD: 'download',
  UPLOAD: 'upload'
};
module.exports = REQUEST_CONSTANTS;

},{}],149:[function(require,module,exports){
"use strict";

// Auto-generated by Stone, do not modify.
var routes = {};
/**
 * Creates an OAuth 2.0 access token from the supplied OAuth 1.0 access token.
 * @function Dropbox#authTokenFromOauth1
 * @arg {AuthTokenFromOAuth1Arg} arg - The request parameters.
 * @returns {Promise.<AuthTokenFromOAuth1Result, Error.<AuthTokenFromOAuth1Error>>}
 */

routes.authTokenFromOauth1 = function (arg) {
  return this.request('auth/token/from_oauth1', arg, 'app', 'api', 'rpc');
};
/**
 * Disables the access token used to authenticate the call.
 * @function Dropbox#authTokenRevoke
 * @arg {void} arg - The request parameters.
 * @returns {Promise.<void, Error.<void>>}
 */


routes.authTokenRevoke = function (arg) {
  return this.request('auth/token/revoke', arg, 'user', 'api', 'rpc');
};
/**
 * Add property groups to a Dropbox file. See templates/add_for_user or
 * templates/add_for_team to create new templates.
 * @function Dropbox#filePropertiesPropertiesAdd
 * @arg {FilePropertiesAddPropertiesArg} arg - The request parameters.
 * @returns {Promise.<void, Error.<FilePropertiesAddPropertiesError>>}
 */


routes.filePropertiesPropertiesAdd = function (arg) {
  return this.request('file_properties/properties/add', arg, 'user', 'api', 'rpc');
};
/**
 * Overwrite property groups associated with a file. This endpoint should be
 * used instead of properties/update when property groups are being updated via
 * a "snapshot" instead of via a "delta". In other words, this endpoint will
 * delete all omitted fields from a property group, whereas properties/update
 * will only delete fields that are explicitly marked for deletion.
 * @function Dropbox#filePropertiesPropertiesOverwrite
 * @arg {FilePropertiesOverwritePropertyGroupArg} arg - The request parameters.
 * @returns {Promise.<void, Error.<FilePropertiesInvalidPropertyGroupError>>}
 */


routes.filePropertiesPropertiesOverwrite = function (arg) {
  return this.request('file_properties/properties/overwrite', arg, 'user', 'api', 'rpc');
};
/**
 * Permanently removes the specified property group from the file. To remove
 * specific property field key value pairs, see properties/update. To update a
 * template, see templates/update_for_user or templates/update_for_team.
 * Templates can't be removed once created.
 * @function Dropbox#filePropertiesPropertiesRemove
 * @arg {FilePropertiesRemovePropertiesArg} arg - The request parameters.
 * @returns {Promise.<void, Error.<FilePropertiesRemovePropertiesError>>}
 */


routes.filePropertiesPropertiesRemove = function (arg) {
  return this.request('file_properties/properties/remove', arg, 'user', 'api', 'rpc');
};
/**
 * Search across property templates for particular property field values.
 * @function Dropbox#filePropertiesPropertiesSearch
 * @arg {FilePropertiesPropertiesSearchArg} arg - The request parameters.
 * @returns {Promise.<FilePropertiesPropertiesSearchResult, Error.<FilePropertiesPropertiesSearchError>>}
 */


routes.filePropertiesPropertiesSearch = function (arg) {
  return this.request('file_properties/properties/search', arg, 'user', 'api', 'rpc');
};
/**
 * Once a cursor has been retrieved from properties/search, use this to paginate
 * through all search results.
 * @function Dropbox#filePropertiesPropertiesSearchContinue
 * @arg {FilePropertiesPropertiesSearchContinueArg} arg - The request parameters.
 * @returns {Promise.<FilePropertiesPropertiesSearchResult, Error.<FilePropertiesPropertiesSearchContinueError>>}
 */


routes.filePropertiesPropertiesSearchContinue = function (arg) {
  return this.request('file_properties/properties/search/continue', arg, 'user', 'api', 'rpc');
};
/**
 * Add, update or remove properties associated with the supplied file and
 * templates. This endpoint should be used instead of properties/overwrite when
 * property groups are being updated via a "delta" instead of via a "snapshot" .
 * In other words, this endpoint will not delete any omitted fields from a
 * property group, whereas properties/overwrite will delete any fields that are
 * omitted from a property group.
 * @function Dropbox#filePropertiesPropertiesUpdate
 * @arg {FilePropertiesUpdatePropertiesArg} arg - The request parameters.
 * @returns {Promise.<void, Error.<FilePropertiesUpdatePropertiesError>>}
 */


routes.filePropertiesPropertiesUpdate = function (arg) {
  return this.request('file_properties/properties/update', arg, 'user', 'api', 'rpc');
};
/**
 * Add a template associated with a team. See properties/add to add properties
 * to a file or folder. Note: this endpoint will create team-owned templates.
 * @function Dropbox#filePropertiesTemplatesAddForTeam
 * @arg {FilePropertiesAddTemplateArg} arg - The request parameters.
 * @returns {Promise.<FilePropertiesAddTemplateResult, Error.<FilePropertiesModifyTemplateError>>}
 */


routes.filePropertiesTemplatesAddForTeam = function (arg) {
  return this.request('file_properties/templates/add_for_team', arg, 'team', 'api', 'rpc');
};
/**
 * Add a template associated with a user. See properties/add to add properties
 * to a file. This endpoint can't be called on a team member or admin's behalf.
 * @function Dropbox#filePropertiesTemplatesAddForUser
 * @arg {FilePropertiesAddTemplateArg} arg - The request parameters.
 * @returns {Promise.<FilePropertiesAddTemplateResult, Error.<FilePropertiesModifyTemplateError>>}
 */


routes.filePropertiesTemplatesAddForUser = function (arg) {
  return this.request('file_properties/templates/add_for_user', arg, 'user', 'api', 'rpc');
};
/**
 * Get the schema for a specified template.
 * @function Dropbox#filePropertiesTemplatesGetForTeam
 * @arg {FilePropertiesGetTemplateArg} arg - The request parameters.
 * @returns {Promise.<FilePropertiesGetTemplateResult, Error.<FilePropertiesTemplateError>>}
 */


routes.filePropertiesTemplatesGetForTeam = function (arg) {
  return this.request('file_properties/templates/get_for_team', arg, 'team', 'api', 'rpc');
};
/**
 * Get the schema for a specified template. This endpoint can't be called on a
 * team member or admin's behalf.
 * @function Dropbox#filePropertiesTemplatesGetForUser
 * @arg {FilePropertiesGetTemplateArg} arg - The request parameters.
 * @returns {Promise.<FilePropertiesGetTemplateResult, Error.<FilePropertiesTemplateError>>}
 */


routes.filePropertiesTemplatesGetForUser = function (arg) {
  return this.request('file_properties/templates/get_for_user', arg, 'user', 'api', 'rpc');
};
/**
 * Get the template identifiers for a team. To get the schema of each template
 * use templates/get_for_team.
 * @function Dropbox#filePropertiesTemplatesListForTeam
 * @arg {void} arg - The request parameters.
 * @returns {Promise.<FilePropertiesListTemplateResult, Error.<FilePropertiesTemplateError>>}
 */


routes.filePropertiesTemplatesListForTeam = function (arg) {
  return this.request('file_properties/templates/list_for_team', arg, 'team', 'api', 'rpc');
};
/**
 * Get the template identifiers for a team. To get the schema of each template
 * use templates/get_for_user. This endpoint can't be called on a team member or
 * admin's behalf.
 * @function Dropbox#filePropertiesTemplatesListForUser
 * @arg {void} arg - The request parameters.
 * @returns {Promise.<FilePropertiesListTemplateResult, Error.<FilePropertiesTemplateError>>}
 */


routes.filePropertiesTemplatesListForUser = function (arg) {
  return this.request('file_properties/templates/list_for_user', arg, 'user', 'api', 'rpc');
};
/**
 * Permanently removes the specified template created from
 * templates/add_for_user. All properties associated with the template will also
 * be removed. This action cannot be undone.
 * @function Dropbox#filePropertiesTemplatesRemoveForTeam
 * @arg {FilePropertiesRemoveTemplateArg} arg - The request parameters.
 * @returns {Promise.<void, Error.<FilePropertiesTemplateError>>}
 */


routes.filePropertiesTemplatesRemoveForTeam = function (arg) {
  return this.request('file_properties/templates/remove_for_team', arg, 'team', 'api', 'rpc');
};
/**
 * Permanently removes the specified template created from
 * templates/add_for_user. All properties associated with the template will also
 * be removed. This action cannot be undone.
 * @function Dropbox#filePropertiesTemplatesRemoveForUser
 * @arg {FilePropertiesRemoveTemplateArg} arg - The request parameters.
 * @returns {Promise.<void, Error.<FilePropertiesTemplateError>>}
 */


routes.filePropertiesTemplatesRemoveForUser = function (arg) {
  return this.request('file_properties/templates/remove_for_user', arg, 'user', 'api', 'rpc');
};
/**
 * Update a template associated with a team. This route can update the template
 * name, the template description and add optional properties to templates.
 * @function Dropbox#filePropertiesTemplatesUpdateForTeam
 * @arg {FilePropertiesUpdateTemplateArg} arg - The request parameters.
 * @returns {Promise.<FilePropertiesUpdateTemplateResult, Error.<FilePropertiesModifyTemplateError>>}
 */


routes.filePropertiesTemplatesUpdateForTeam = function (arg) {
  return this.request('file_properties/templates/update_for_team', arg, 'team', 'api', 'rpc');
};
/**
 * Update a template associated with a user. This route can update the template
 * name, the template description and add optional properties to templates. This
 * endpoint can't be called on a team member or admin's behalf.
 * @function Dropbox#filePropertiesTemplatesUpdateForUser
 * @arg {FilePropertiesUpdateTemplateArg} arg - The request parameters.
 * @returns {Promise.<FilePropertiesUpdateTemplateResult, Error.<FilePropertiesModifyTemplateError>>}
 */


routes.filePropertiesTemplatesUpdateForUser = function (arg) {
  return this.request('file_properties/templates/update_for_user', arg, 'user', 'api', 'rpc');
};
/**
 * Creates a file request for this user.
 * @function Dropbox#fileRequestsCreate
 * @arg {FileRequestsCreateFileRequestArgs} arg - The request parameters.
 * @returns {Promise.<FileRequestsFileRequest, Error.<FileRequestsCreateFileRequestError>>}
 */


routes.fileRequestsCreate = function (arg) {
  return this.request('file_requests/create', arg, 'user', 'api', 'rpc');
};
/**
 * Returns the specified file request.
 * @function Dropbox#fileRequestsGet
 * @arg {FileRequestsGetFileRequestArgs} arg - The request parameters.
 * @returns {Promise.<FileRequestsFileRequest, Error.<FileRequestsGetFileRequestError>>}
 */


routes.fileRequestsGet = function (arg) {
  return this.request('file_requests/get', arg, 'user', 'api', 'rpc');
};
/**
 * Returns a list of file requests owned by this user. For apps with the app
 * folder permission, this will only return file requests with destinations in
 * the app folder.
 * @function Dropbox#fileRequestsList
 * @arg {void} arg - The request parameters.
 * @returns {Promise.<FileRequestsListFileRequestsResult, Error.<FileRequestsListFileRequestsError>>}
 */


routes.fileRequestsList = function (arg) {
  return this.request('file_requests/list', arg, 'user', 'api', 'rpc');
};
/**
 * Update a file request.
 * @function Dropbox#fileRequestsUpdate
 * @arg {FileRequestsUpdateFileRequestArgs} arg - The request parameters.
 * @returns {Promise.<FileRequestsFileRequest, Error.<FileRequestsUpdateFileRequestError>>}
 */


routes.fileRequestsUpdate = function (arg) {
  return this.request('file_requests/update', arg, 'user', 'api', 'rpc');
};
/**
 * Returns the metadata for a file or folder. This is an alpha endpoint
 * compatible with the properties API. Note: Metadata for the root folder is
 * unsupported.
 * @function Dropbox#filesAlphaGetMetadata
 * @deprecated
 * @arg {FilesAlphaGetMetadataArg} arg - The request parameters.
 * @returns {Promise.<(FilesFileMetadata|FilesFolderMetadata|FilesDeletedMetadata), Error.<FilesAlphaGetMetadataError>>}
 */


routes.filesAlphaGetMetadata = function (arg) {
  return this.request('files/alpha/get_metadata', arg, 'user', 'api', 'rpc');
};
/**
 * Create a new file with the contents provided in the request. Note that this
 * endpoint is part of the properties API alpha and is slightly different from
 * upload. Do not use this to upload a file larger than 150 MB. Instead, create
 * an upload session with upload_session/start.
 * @function Dropbox#filesAlphaUpload
 * @deprecated
 * @arg {FilesCommitInfoWithProperties} arg - The request parameters.
 * @returns {Promise.<FilesFileMetadata, Error.<FilesUploadErrorWithProperties>>}
 */


routes.filesAlphaUpload = function (arg) {
  return this.request('files/alpha/upload', arg, 'user', 'content', 'upload');
};
/**
 * Copy a file or folder to a different location in the user's Dropbox. If the
 * source path is a folder all its contents will be copied.
 * @function Dropbox#filesCopy
 * @deprecated
 * @arg {FilesRelocationArg} arg - The request parameters.
 * @returns {Promise.<(FilesFileMetadata|FilesFolderMetadata|FilesDeletedMetadata), Error.<FilesRelocationError>>}
 */


routes.filesCopy = function (arg) {
  return this.request('files/copy', arg, 'user', 'api', 'rpc');
};
/**
 * Copy multiple files or folders to different locations at once in the user's
 * Dropbox. If RelocationBatchArg.allow_shared_folder is false, this route is
 * atomic. If on entry failes, the whole transaction will abort. If
 * RelocationBatchArg.allow_shared_folder is true, not atomicity is guaranteed,
 * but you will be able to copy the contents of shared folders to new locations.
 * This route will return job ID immediately and do the async copy job in
 * background. Please use copy_batch/check to check the job status.
 * @function Dropbox#filesCopyBatch
 * @arg {FilesRelocationBatchArg} arg - The request parameters.
 * @returns {Promise.<FilesRelocationBatchLaunch, Error.<void>>}
 */


routes.filesCopyBatch = function (arg) {
  return this.request('files/copy_batch', arg, 'user', 'api', 'rpc');
};
/**
 * Returns the status of an asynchronous job for copy_batch. If success, it
 * returns list of results for each entry.
 * @function Dropbox#filesCopyBatchCheck
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<FilesRelocationBatchJobStatus, Error.<AsyncPollError>>}
 */


routes.filesCopyBatchCheck = function (arg) {
  return this.request('files/copy_batch/check', arg, 'user', 'api', 'rpc');
};
/**
 * Get a copy reference to a file or folder. This reference string can be used
 * to save that file or folder to another user's Dropbox by passing it to
 * copy_reference/save.
 * @function Dropbox#filesCopyReferenceGet
 * @arg {FilesGetCopyReferenceArg} arg - The request parameters.
 * @returns {Promise.<FilesGetCopyReferenceResult, Error.<FilesGetCopyReferenceError>>}
 */


routes.filesCopyReferenceGet = function (arg) {
  return this.request('files/copy_reference/get', arg, 'user', 'api', 'rpc');
};
/**
 * Save a copy reference returned by copy_reference/get to the user's Dropbox.
 * @function Dropbox#filesCopyReferenceSave
 * @arg {FilesSaveCopyReferenceArg} arg - The request parameters.
 * @returns {Promise.<FilesSaveCopyReferenceResult, Error.<FilesSaveCopyReferenceError>>}
 */


routes.filesCopyReferenceSave = function (arg) {
  return this.request('files/copy_reference/save', arg, 'user', 'api', 'rpc');
};
/**
 * Copy a file or folder to a different location in the user's Dropbox. If the
 * source path is a folder all its contents will be copied.
 * @function Dropbox#filesCopyV2
 * @arg {FilesRelocationArg} arg - The request parameters.
 * @returns {Promise.<FilesRelocationResult, Error.<FilesRelocationError>>}
 */


routes.filesCopyV2 = function (arg) {
  return this.request('files/copy_v2', arg, 'user', 'api', 'rpc');
};
/**
 * Create a folder at a given path.
 * @function Dropbox#filesCreateFolder
 * @deprecated
 * @arg {FilesCreateFolderArg} arg - The request parameters.
 * @returns {Promise.<FilesFolderMetadata, Error.<FilesCreateFolderError>>}
 */


routes.filesCreateFolder = function (arg) {
  return this.request('files/create_folder', arg, 'user', 'api', 'rpc');
};
/**
 * Create a folder at a given path.
 * @function Dropbox#filesCreateFolderV2
 * @arg {FilesCreateFolderArg} arg - The request parameters.
 * @returns {Promise.<FilesCreateFolderResult, Error.<FilesCreateFolderError>>}
 */


routes.filesCreateFolderV2 = function (arg) {
  return this.request('files/create_folder_v2', arg, 'user', 'api', 'rpc');
};
/**
 * Delete the file or folder at a given path. If the path is a folder, all its
 * contents will be deleted too. A successful response indicates that the file
 * or folder was deleted. The returned metadata will be the corresponding
 * FileMetadata or FolderMetadata for the item at time of deletion, and not a
 * DeletedMetadata object.
 * @function Dropbox#filesDelete
 * @deprecated
 * @arg {FilesDeleteArg} arg - The request parameters.
 * @returns {Promise.<(FilesFileMetadata|FilesFolderMetadata|FilesDeletedMetadata), Error.<FilesDeleteError>>}
 */


routes.filesDelete = function (arg) {
  return this.request('files/delete', arg, 'user', 'api', 'rpc');
};
/**
 * Delete multiple files/folders at once. This route is asynchronous, which
 * returns a job ID immediately and runs the delete batch asynchronously. Use
 * delete_batch/check to check the job status.
 * @function Dropbox#filesDeleteBatch
 * @arg {FilesDeleteBatchArg} arg - The request parameters.
 * @returns {Promise.<FilesDeleteBatchLaunch, Error.<void>>}
 */


routes.filesDeleteBatch = function (arg) {
  return this.request('files/delete_batch', arg, 'user', 'api', 'rpc');
};
/**
 * Returns the status of an asynchronous job for delete_batch. If success, it
 * returns list of result for each entry.
 * @function Dropbox#filesDeleteBatchCheck
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<FilesDeleteBatchJobStatus, Error.<AsyncPollError>>}
 */


routes.filesDeleteBatchCheck = function (arg) {
  return this.request('files/delete_batch/check', arg, 'user', 'api', 'rpc');
};
/**
 * Delete the file or folder at a given path. If the path is a folder, all its
 * contents will be deleted too. A successful response indicates that the file
 * or folder was deleted. The returned metadata will be the corresponding
 * FileMetadata or FolderMetadata for the item at time of deletion, and not a
 * DeletedMetadata object.
 * @function Dropbox#filesDeleteV2
 * @arg {FilesDeleteArg} arg - The request parameters.
 * @returns {Promise.<FilesDeleteResult, Error.<FilesDeleteError>>}
 */


routes.filesDeleteV2 = function (arg) {
  return this.request('files/delete_v2', arg, 'user', 'api', 'rpc');
};
/**
 * Download a file from a user's Dropbox.
 * @function Dropbox#filesDownload
 * @arg {FilesDownloadArg} arg - The request parameters.
 * @returns {Promise.<FilesFileMetadata, Error.<FilesDownloadError>>}
 */


routes.filesDownload = function (arg) {
  return this.request('files/download', arg, 'user', 'content', 'download');
};
/**
 * Download a folder from the user's Dropbox, as a zip file. The folder must be
 * less than 1 GB in size and have fewer than 10,000 total files. The input
 * cannot be a single file.
 * @function Dropbox#filesDownloadZip
 * @arg {FilesDownloadZipArg} arg - The request parameters.
 * @returns {Promise.<FilesDownloadZipResult, Error.<FilesDownloadZipError>>}
 */


routes.filesDownloadZip = function (arg) {
  return this.request('files/download_zip', arg, 'user', 'content', 'download');
};
/**
 * Returns the metadata for a file or folder. Note: Metadata for the root folder
 * is unsupported.
 * @function Dropbox#filesGetMetadata
 * @arg {FilesGetMetadataArg} arg - The request parameters.
 * @returns {Promise.<(FilesFileMetadata|FilesFolderMetadata|FilesDeletedMetadata), Error.<FilesGetMetadataError>>}
 */


routes.filesGetMetadata = function (arg) {
  return this.request('files/get_metadata', arg, 'user', 'api', 'rpc');
};
/**
 * Get a preview for a file. Currently, PDF previews are generated for files
 * with the following extensions: .ai, .doc, .docm, .docx, .eps, .odp, .odt,
 * .pps, .ppsm, .ppsx, .ppt, .pptm, .pptx, .rtf. HTML previews are generated for
 * files with the following extensions: .csv, .ods, .xls, .xlsm, .xlsx. Other
 * formats will return an unsupported extension error.
 * @function Dropbox#filesGetPreview
 * @arg {FilesPreviewArg} arg - The request parameters.
 * @returns {Promise.<FilesFileMetadata, Error.<FilesPreviewError>>}
 */


routes.filesGetPreview = function (arg) {
  return this.request('files/get_preview', arg, 'user', 'content', 'download');
};
/**
 * Get a temporary link to stream content of a file. This link will expire in
 * four hours and afterwards you will get 410 Gone. Content-Type of the link is
 * determined automatically by the file's mime type.
 * @function Dropbox#filesGetTemporaryLink
 * @arg {FilesGetTemporaryLinkArg} arg - The request parameters.
 * @returns {Promise.<FilesGetTemporaryLinkResult, Error.<FilesGetTemporaryLinkError>>}
 */


routes.filesGetTemporaryLink = function (arg) {
  return this.request('files/get_temporary_link', arg, 'user', 'api', 'rpc');
};
/**
 * Get a thumbnail for an image. This method currently supports files with the
 * following file extensions: jpg, jpeg, png, tiff, tif, gif and bmp. Photos
 * that are larger than 20MB in size won't be converted to a thumbnail.
 * @function Dropbox#filesGetThumbnail
 * @arg {FilesThumbnailArg} arg - The request parameters.
 * @returns {Promise.<FilesFileMetadata, Error.<FilesThumbnailError>>}
 */


routes.filesGetThumbnail = function (arg) {
  return this.request('files/get_thumbnail', arg, 'user', 'content', 'download');
};
/**
 * Get thumbnails for a list of images. We allow up to 25 thumbnails in a single
 * batch. This method currently supports files with the following file
 * extensions: jpg, jpeg, png, tiff, tif, gif and bmp. Photos that are larger
 * than 20MB in size won't be converted to a thumbnail.
 * @function Dropbox#filesGetThumbnailBatch
 * @arg {FilesGetThumbnailBatchArg} arg - The request parameters.
 * @returns {Promise.<FilesGetThumbnailBatchResult, Error.<FilesGetThumbnailBatchError>>}
 */


routes.filesGetThumbnailBatch = function (arg) {
  return this.request('files/get_thumbnail_batch', arg, 'user', 'content', 'rpc');
};
/**
 * Starts returning the contents of a folder. If the result's
 * ListFolderResult.has_more field is true, call list_folder/continue with the
 * returned ListFolderResult.cursor to retrieve more entries. If you're using
 * ListFolderArg.recursive set to true to keep a local cache of the contents of
 * a Dropbox account, iterate through each entry in order and process them as
 * follows to keep your local state in sync: For each FileMetadata, store the
 * new entry at the given path in your local state. If the required parent
 * folders don't exist yet, create them. If there's already something else at
 * the given path, replace it and remove all its children. For each
 * FolderMetadata, store the new entry at the given path in your local state. If
 * the required parent folders don't exist yet, create them. If there's already
 * something else at the given path, replace it but leave the children as they
 * are. Check the new entry's FolderSharingInfo.read_only and set all its
 * children's read-only statuses to match. For each DeletedMetadata, if your
 * local state has something at the given path, remove it and all its children.
 * If there's nothing at the given path, ignore this entry. Note:
 * auth.RateLimitError may be returned if multiple list_folder or
 * list_folder/continue calls with same parameters are made simultaneously by
 * same API app for same user. If your app implements retry logic, please hold
 * off the retry until the previous request finishes.
 * @function Dropbox#filesListFolder
 * @arg {FilesListFolderArg} arg - The request parameters.
 * @returns {Promise.<FilesListFolderResult, Error.<FilesListFolderError>>}
 */


routes.filesListFolder = function (arg) {
  return this.request('files/list_folder', arg, 'user', 'api', 'rpc');
};
/**
 * Once a cursor has been retrieved from list_folder, use this to paginate
 * through all files and retrieve updates to the folder, following the same
 * rules as documented for list_folder.
 * @function Dropbox#filesListFolderContinue
 * @arg {FilesListFolderContinueArg} arg - The request parameters.
 * @returns {Promise.<FilesListFolderResult, Error.<FilesListFolderContinueError>>}
 */


routes.filesListFolderContinue = function (arg) {
  return this.request('files/list_folder/continue', arg, 'user', 'api', 'rpc');
};
/**
 * A way to quickly get a cursor for the folder's state. Unlike list_folder,
 * list_folder/get_latest_cursor doesn't return any entries. This endpoint is
 * for app which only needs to know about new files and modifications and
 * doesn't need to know about files that already exist in Dropbox.
 * @function Dropbox#filesListFolderGetLatestCursor
 * @arg {FilesListFolderArg} arg - The request parameters.
 * @returns {Promise.<FilesListFolderGetLatestCursorResult, Error.<FilesListFolderError>>}
 */


routes.filesListFolderGetLatestCursor = function (arg) {
  return this.request('files/list_folder/get_latest_cursor', arg, 'user', 'api', 'rpc');
};
/**
 * A longpoll endpoint to wait for changes on an account. In conjunction with
 * list_folder/continue, this call gives you a low-latency way to monitor an
 * account for file changes. The connection will block until there are changes
 * available or a timeout occurs. This endpoint is useful mostly for client-side
 * apps. If you're looking for server-side notifications, check out our webhooks
 * documentation https://www.dropbox.com/developers/reference/webhooks.
 * @function Dropbox#filesListFolderLongpoll
 * @arg {FilesListFolderLongpollArg} arg - The request parameters.
 * @returns {Promise.<FilesListFolderLongpollResult, Error.<FilesListFolderLongpollError>>}
 */


routes.filesListFolderLongpoll = function (arg) {
  return this.request('files/list_folder/longpoll', arg, 'noauth', 'notify', 'rpc');
};
/**
 * Returns revisions for files based on a file path or a file id. The file path
 * or file id is identified from the latest file entry at the given file path or
 * id. This end point allows your app to query either by file path or file id by
 * setting the mode parameter appropriately. In the ListRevisionsMode.path
 * (default) mode, all revisions at the same file path as the latest file entry
 * are returned. If revisions with the same file id are desired, then mode must
 * be set to ListRevisionsMode.id. The ListRevisionsMode.id mode is useful to
 * retrieve revisions for a given file across moves or renames.
 * @function Dropbox#filesListRevisions
 * @arg {FilesListRevisionsArg} arg - The request parameters.
 * @returns {Promise.<FilesListRevisionsResult, Error.<FilesListRevisionsError>>}
 */


routes.filesListRevisions = function (arg) {
  return this.request('files/list_revisions', arg, 'user', 'api', 'rpc');
};
/**
 * Move a file or folder to a different location in the user's Dropbox. If the
 * source path is a folder all its contents will be moved.
 * @function Dropbox#filesMove
 * @deprecated
 * @arg {FilesRelocationArg} arg - The request parameters.
 * @returns {Promise.<(FilesFileMetadata|FilesFolderMetadata|FilesDeletedMetadata), Error.<FilesRelocationError>>}
 */


routes.filesMove = function (arg) {
  return this.request('files/move', arg, 'user', 'api', 'rpc');
};
/**
 * Move multiple files or folders to different locations at once in the user's
 * Dropbox. This route is 'all or nothing', which means if one entry fails, the
 * whole transaction will abort. This route will return job ID immediately and
 * do the async moving job in background. Please use move_batch/check to check
 * the job status.
 * @function Dropbox#filesMoveBatch
 * @arg {FilesRelocationBatchArg} arg - The request parameters.
 * @returns {Promise.<FilesRelocationBatchLaunch, Error.<void>>}
 */


routes.filesMoveBatch = function (arg) {
  return this.request('files/move_batch', arg, 'user', 'api', 'rpc');
};
/**
 * Returns the status of an asynchronous job for move_batch. If success, it
 * returns list of results for each entry.
 * @function Dropbox#filesMoveBatchCheck
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<FilesRelocationBatchJobStatus, Error.<AsyncPollError>>}
 */


routes.filesMoveBatchCheck = function (arg) {
  return this.request('files/move_batch/check', arg, 'user', 'api', 'rpc');
};
/**
 * Move a file or folder to a different location in the user's Dropbox. If the
 * source path is a folder all its contents will be moved.
 * @function Dropbox#filesMoveV2
 * @arg {FilesRelocationArg} arg - The request parameters.
 * @returns {Promise.<FilesRelocationResult, Error.<FilesRelocationError>>}
 */


routes.filesMoveV2 = function (arg) {
  return this.request('files/move_v2', arg, 'user', 'api', 'rpc');
};
/**
 * Permanently delete the file or folder at a given path (see
 * https://www.dropbox.com/en/help/40). Note: This endpoint is only available
 * for Dropbox Business apps.
 * @function Dropbox#filesPermanentlyDelete
 * @arg {FilesDeleteArg} arg - The request parameters.
 * @returns {Promise.<void, Error.<FilesDeleteError>>}
 */


routes.filesPermanentlyDelete = function (arg) {
  return this.request('files/permanently_delete', arg, 'user', 'api', 'rpc');
};
/**
 * @function Dropbox#filesPropertiesAdd
 * @deprecated
 * @arg {FilePropertiesAddPropertiesArg} arg - The request parameters.
 * @returns {Promise.<void, Error.<FilePropertiesAddPropertiesError>>}
 */


routes.filesPropertiesAdd = function (arg) {
  return this.request('files/properties/add', arg, 'user', 'api', 'rpc');
};
/**
 * @function Dropbox#filesPropertiesOverwrite
 * @deprecated
 * @arg {FilePropertiesOverwritePropertyGroupArg} arg - The request parameters.
 * @returns {Promise.<void, Error.<FilePropertiesInvalidPropertyGroupError>>}
 */


routes.filesPropertiesOverwrite = function (arg) {
  return this.request('files/properties/overwrite', arg, 'user', 'api', 'rpc');
};
/**
 * @function Dropbox#filesPropertiesRemove
 * @deprecated
 * @arg {FilePropertiesRemovePropertiesArg} arg - The request parameters.
 * @returns {Promise.<void, Error.<FilePropertiesRemovePropertiesError>>}
 */


routes.filesPropertiesRemove = function (arg) {
  return this.request('files/properties/remove', arg, 'user', 'api', 'rpc');
};
/**
 * @function Dropbox#filesPropertiesTemplateGet
 * @deprecated
 * @arg {FilePropertiesGetTemplateArg} arg - The request parameters.
 * @returns {Promise.<FilePropertiesGetTemplateResult, Error.<FilePropertiesTemplateError>>}
 */


routes.filesPropertiesTemplateGet = function (arg) {
  return this.request('files/properties/template/get', arg, 'user', 'api', 'rpc');
};
/**
 * @function Dropbox#filesPropertiesTemplateList
 * @deprecated
 * @arg {void} arg - The request parameters.
 * @returns {Promise.<FilePropertiesListTemplateResult, Error.<FilePropertiesTemplateError>>}
 */


routes.filesPropertiesTemplateList = function (arg) {
  return this.request('files/properties/template/list', arg, 'user', 'api', 'rpc');
};
/**
 * @function Dropbox#filesPropertiesUpdate
 * @deprecated
 * @arg {FilePropertiesUpdatePropertiesArg} arg - The request parameters.
 * @returns {Promise.<void, Error.<FilePropertiesUpdatePropertiesError>>}
 */


routes.filesPropertiesUpdate = function (arg) {
  return this.request('files/properties/update', arg, 'user', 'api', 'rpc');
};
/**
 * Restore a file to a specific revision.
 * @function Dropbox#filesRestore
 * @arg {FilesRestoreArg} arg - The request parameters.
 * @returns {Promise.<FilesFileMetadata, Error.<FilesRestoreError>>}
 */


routes.filesRestore = function (arg) {
  return this.request('files/restore', arg, 'user', 'api', 'rpc');
};
/**
 * Save a specified URL into a file in user's Dropbox. If the given path already
 * exists, the file will be renamed to avoid the conflict (e.g. myfile (1).txt).
 * @function Dropbox#filesSaveUrl
 * @arg {FilesSaveUrlArg} arg - The request parameters.
 * @returns {Promise.<FilesSaveUrlResult, Error.<FilesSaveUrlError>>}
 */


routes.filesSaveUrl = function (arg) {
  return this.request('files/save_url', arg, 'user', 'api', 'rpc');
};
/**
 * Check the status of a save_url job.
 * @function Dropbox#filesSaveUrlCheckJobStatus
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<FilesSaveUrlJobStatus, Error.<AsyncPollError>>}
 */


routes.filesSaveUrlCheckJobStatus = function (arg) {
  return this.request('files/save_url/check_job_status', arg, 'user', 'api', 'rpc');
};
/**
 * Searches for files and folders. Note: Recent changes may not immediately be
 * reflected in search results due to a short delay in indexing.
 * @function Dropbox#filesSearch
 * @arg {FilesSearchArg} arg - The request parameters.
 * @returns {Promise.<FilesSearchResult, Error.<FilesSearchError>>}
 */


routes.filesSearch = function (arg) {
  return this.request('files/search', arg, 'user', 'api', 'rpc');
};
/**
 * Create a new file with the contents provided in the request. Do not use this
 * to upload a file larger than 150 MB. Instead, create an upload session with
 * upload_session/start.
 * @function Dropbox#filesUpload
 * @arg {FilesCommitInfo} arg - The request parameters.
 * @returns {Promise.<FilesFileMetadata, Error.<FilesUploadError>>}
 */


routes.filesUpload = function (arg) {
  return this.request('files/upload', arg, 'user', 'content', 'upload');
};
/**
 * Append more data to an upload session. A single request should not upload
 * more than 150 MB.
 * @function Dropbox#filesUploadSessionAppend
 * @deprecated
 * @arg {FilesUploadSessionCursor} arg - The request parameters.
 * @returns {Promise.<void, Error.<FilesUploadSessionLookupError>>}
 */


routes.filesUploadSessionAppend = function (arg) {
  return this.request('files/upload_session/append', arg, 'user', 'content', 'upload');
};
/**
 * Append more data to an upload session. When the parameter close is set, this
 * call will close the session. A single request should not upload more than 150
 * MB.
 * @function Dropbox#filesUploadSessionAppendV2
 * @arg {FilesUploadSessionAppendArg} arg - The request parameters.
 * @returns {Promise.<void, Error.<FilesUploadSessionLookupError>>}
 */


routes.filesUploadSessionAppendV2 = function (arg) {
  return this.request('files/upload_session/append_v2', arg, 'user', 'content', 'upload');
};
/**
 * Finish an upload session and save the uploaded data to the given file path. A
 * single request should not upload more than 150 MB.
 * @function Dropbox#filesUploadSessionFinish
 * @arg {FilesUploadSessionFinishArg} arg - The request parameters.
 * @returns {Promise.<FilesFileMetadata, Error.<FilesUploadSessionFinishError>>}
 */


routes.filesUploadSessionFinish = function (arg) {
  return this.request('files/upload_session/finish', arg, 'user', 'content', 'upload');
};
/**
 * This route helps you commit many files at once into a user's Dropbox. Use
 * upload_session/start and upload_session/append_v2 to upload file contents. We
 * recommend uploading many files in parallel to increase throughput. Once the
 * file contents have been uploaded, rather than calling upload_session/finish,
 * use this route to finish all your upload sessions in a single request.
 * UploadSessionStartArg.close or UploadSessionAppendArg.close needs to be true
 * for the last upload_session/start or upload_session/append_v2 call. This
 * route will return a job_id immediately and do the async commit job in
 * background. Use upload_session/finish_batch/check to check the job status.
 * For the same account, this route should be executed serially. That means you
 * should not start the next job before current job finishes. We allow up to
 * 1000 entries in a single request.
 * @function Dropbox#filesUploadSessionFinishBatch
 * @arg {FilesUploadSessionFinishBatchArg} arg - The request parameters.
 * @returns {Promise.<FilesUploadSessionFinishBatchLaunch, Error.<void>>}
 */


routes.filesUploadSessionFinishBatch = function (arg) {
  return this.request('files/upload_session/finish_batch', arg, 'user', 'api', 'rpc');
};
/**
 * Returns the status of an asynchronous job for upload_session/finish_batch. If
 * success, it returns list of result for each entry.
 * @function Dropbox#filesUploadSessionFinishBatchCheck
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<FilesUploadSessionFinishBatchJobStatus, Error.<AsyncPollError>>}
 */


routes.filesUploadSessionFinishBatchCheck = function (arg) {
  return this.request('files/upload_session/finish_batch/check', arg, 'user', 'api', 'rpc');
};
/**
 * Upload sessions allow you to upload a single file in one or more requests,
 * for example where the size of the file is greater than 150 MB.  This call
 * starts a new upload session with the given data. You can then use
 * upload_session/append_v2 to add more data and upload_session/finish to save
 * all the data to a file in Dropbox. A single request should not upload more
 * than 150 MB. An upload session can be used for a maximum of 48 hours.
 * Attempting to use an UploadSessionStartResult.session_id with
 * upload_session/append_v2 or upload_session/finish more than 48 hours after
 * its creation will return a UploadSessionLookupError.not_found.
 * @function Dropbox#filesUploadSessionStart
 * @arg {FilesUploadSessionStartArg} arg - The request parameters.
 * @returns {Promise.<FilesUploadSessionStartResult, Error.<void>>}
 */


routes.filesUploadSessionStart = function (arg) {
  return this.request('files/upload_session/start', arg, 'user', 'content', 'upload');
};
/**
 * Marks the given Paper doc as archived. Note: This action can be performed or
 * undone by anyone with edit permissions to the doc.
 * @function Dropbox#paperDocsArchive
 * @arg {PaperRefPaperDoc} arg - The request parameters.
 * @returns {Promise.<void, Error.<PaperDocLookupError>>}
 */


routes.paperDocsArchive = function (arg) {
  return this.request('paper/docs/archive', arg, 'user', 'api', 'rpc');
};
/**
 * Creates a new Paper doc with the provided content.
 * @function Dropbox#paperDocsCreate
 * @arg {PaperPaperDocCreateArgs} arg - The request parameters.
 * @returns {Promise.<PaperPaperDocCreateUpdateResult, Error.<PaperPaperDocCreateError>>}
 */


routes.paperDocsCreate = function (arg) {
  return this.request('paper/docs/create', arg, 'user', 'api', 'upload');
};
/**
 * Exports and downloads Paper doc either as HTML or markdown.
 * @function Dropbox#paperDocsDownload
 * @arg {PaperPaperDocExport} arg - The request parameters.
 * @returns {Promise.<PaperPaperDocExportResult, Error.<PaperDocLookupError>>}
 */


routes.paperDocsDownload = function (arg) {
  return this.request('paper/docs/download', arg, 'user', 'api', 'download');
};
/**
 * Lists the users who are explicitly invited to the Paper folder in which the
 * Paper doc is contained. For private folders all users (including owner)
 * shared on the folder are listed and for team folders all non-team users
 * shared on the folder are returned.
 * @function Dropbox#paperDocsFolderUsersList
 * @arg {PaperListUsersOnFolderArgs} arg - The request parameters.
 * @returns {Promise.<PaperListUsersOnFolderResponse, Error.<PaperDocLookupError>>}
 */


routes.paperDocsFolderUsersList = function (arg) {
  return this.request('paper/docs/folder_users/list', arg, 'user', 'api', 'rpc');
};
/**
 * Once a cursor has been retrieved from docs/folder_users/list, use this to
 * paginate through all users on the Paper folder.
 * @function Dropbox#paperDocsFolderUsersListContinue
 * @arg {PaperListUsersOnFolderContinueArgs} arg - The request parameters.
 * @returns {Promise.<PaperListUsersOnFolderResponse, Error.<PaperListUsersCursorError>>}
 */


routes.paperDocsFolderUsersListContinue = function (arg) {
  return this.request('paper/docs/folder_users/list/continue', arg, 'user', 'api', 'rpc');
};
/**
 * Retrieves folder information for the given Paper doc. This includes:   -
 * folder sharing policy; permissions for subfolders are set by the top-level
 * folder.   - full 'filepath', i.e. the list of folders (both folderId and
 * folderName) from the root folder to the folder directly containing the Paper
 * doc.  Note: If the Paper doc is not in any folder (aka unfiled) the response
 * will be empty.
 * @function Dropbox#paperDocsGetFolderInfo
 * @arg {PaperRefPaperDoc} arg - The request parameters.
 * @returns {Promise.<PaperFoldersContainingPaperDoc, Error.<PaperDocLookupError>>}
 */


routes.paperDocsGetFolderInfo = function (arg) {
  return this.request('paper/docs/get_folder_info', arg, 'user', 'api', 'rpc');
};
/**
 * Return the list of all Paper docs according to the argument specifications.
 * To iterate over through the full pagination, pass the cursor to
 * docs/list/continue.
 * @function Dropbox#paperDocsList
 * @arg {PaperListPaperDocsArgs} arg - The request parameters.
 * @returns {Promise.<PaperListPaperDocsResponse, Error.<void>>}
 */


routes.paperDocsList = function (arg) {
  return this.request('paper/docs/list', arg, 'user', 'api', 'rpc');
};
/**
 * Once a cursor has been retrieved from docs/list, use this to paginate through
 * all Paper doc.
 * @function Dropbox#paperDocsListContinue
 * @arg {PaperListPaperDocsContinueArgs} arg - The request parameters.
 * @returns {Promise.<PaperListPaperDocsResponse, Error.<PaperListDocsCursorError>>}
 */


routes.paperDocsListContinue = function (arg) {
  return this.request('paper/docs/list/continue', arg, 'user', 'api', 'rpc');
};
/**
 * Permanently deletes the given Paper doc. This operation is final as the doc
 * cannot be recovered.  Note: This action can be performed only by the doc
 * owner.
 * @function Dropbox#paperDocsPermanentlyDelete
 * @arg {PaperRefPaperDoc} arg - The request parameters.
 * @returns {Promise.<void, Error.<PaperDocLookupError>>}
 */


routes.paperDocsPermanentlyDelete = function (arg) {
  return this.request('paper/docs/permanently_delete', arg, 'user', 'api', 'rpc');
};
/**
 * Gets the default sharing policy for the given Paper doc.
 * @function Dropbox#paperDocsSharingPolicyGet
 * @arg {PaperRefPaperDoc} arg - The request parameters.
 * @returns {Promise.<PaperSharingPolicy, Error.<PaperDocLookupError>>}
 */


routes.paperDocsSharingPolicyGet = function (arg) {
  return this.request('paper/docs/sharing_policy/get', arg, 'user', 'api', 'rpc');
};
/**
 * Sets the default sharing policy for the given Paper doc. The default
 * 'team_sharing_policy' can be changed only by teams, omit this field for
 * personal accounts.  Note: 'public_sharing_policy' cannot be set to the value
 * 'disabled' because this setting can be changed only via the team admin
 * console.
 * @function Dropbox#paperDocsSharingPolicySet
 * @arg {PaperPaperDocSharingPolicy} arg - The request parameters.
 * @returns {Promise.<void, Error.<PaperDocLookupError>>}
 */


routes.paperDocsSharingPolicySet = function (arg) {
  return this.request('paper/docs/sharing_policy/set', arg, 'user', 'api', 'rpc');
};
/**
 * Updates an existing Paper doc with the provided content.
 * @function Dropbox#paperDocsUpdate
 * @arg {PaperPaperDocUpdateArgs} arg - The request parameters.
 * @returns {Promise.<PaperPaperDocCreateUpdateResult, Error.<PaperPaperDocUpdateError>>}
 */


routes.paperDocsUpdate = function (arg) {
  return this.request('paper/docs/update', arg, 'user', 'api', 'upload');
};
/**
 * Allows an owner or editor to add users to a Paper doc or change their
 * permissions using their email address or Dropbox account ID.  Note: The Doc
 * owner's permissions cannot be changed.
 * @function Dropbox#paperDocsUsersAdd
 * @arg {PaperAddPaperDocUser} arg - The request parameters.
 * @returns {Promise.<Array.<PaperAddPaperDocUserMemberResult>, Error.<PaperDocLookupError>>}
 */


routes.paperDocsUsersAdd = function (arg) {
  return this.request('paper/docs/users/add', arg, 'user', 'api', 'rpc');
};
/**
 * Lists all users who visited the Paper doc or users with explicit access. This
 * call excludes users who have been removed. The list is sorted by the date of
 * the visit or the share date. The list will include both users, the explicitly
 * shared ones as well as those who came in using the Paper url link.
 * @function Dropbox#paperDocsUsersList
 * @arg {PaperListUsersOnPaperDocArgs} arg - The request parameters.
 * @returns {Promise.<PaperListUsersOnPaperDocResponse, Error.<PaperDocLookupError>>}
 */


routes.paperDocsUsersList = function (arg) {
  return this.request('paper/docs/users/list', arg, 'user', 'api', 'rpc');
};
/**
 * Once a cursor has been retrieved from docs/users/list, use this to paginate
 * through all users on the Paper doc.
 * @function Dropbox#paperDocsUsersListContinue
 * @arg {PaperListUsersOnPaperDocContinueArgs} arg - The request parameters.
 * @returns {Promise.<PaperListUsersOnPaperDocResponse, Error.<PaperListUsersCursorError>>}
 */


routes.paperDocsUsersListContinue = function (arg) {
  return this.request('paper/docs/users/list/continue', arg, 'user', 'api', 'rpc');
};
/**
 * Allows an owner or editor to remove users from a Paper doc using their email
 * address or Dropbox account ID.  Note: Doc owner cannot be removed.
 * @function Dropbox#paperDocsUsersRemove
 * @arg {PaperRemovePaperDocUser} arg - The request parameters.
 * @returns {Promise.<void, Error.<PaperDocLookupError>>}
 */


routes.paperDocsUsersRemove = function (arg) {
  return this.request('paper/docs/users/remove', arg, 'user', 'api', 'rpc');
};
/**
 * Adds specified members to a file.
 * @function Dropbox#sharingAddFileMember
 * @arg {SharingAddFileMemberArgs} arg - The request parameters.
 * @returns {Promise.<Array.<SharingFileMemberActionResult>, Error.<SharingAddFileMemberError>>}
 */


routes.sharingAddFileMember = function (arg) {
  return this.request('sharing/add_file_member', arg, 'user', 'api', 'rpc');
};
/**
 * Allows an owner or editor (if the ACL update policy allows) of a shared
 * folder to add another member. For the new member to get access to all the
 * functionality for this folder, you will need to call mount_folder on their
 * behalf. Apps must have full Dropbox access to use this endpoint.
 * @function Dropbox#sharingAddFolderMember
 * @arg {SharingAddFolderMemberArg} arg - The request parameters.
 * @returns {Promise.<void, Error.<SharingAddFolderMemberError>>}
 */


routes.sharingAddFolderMember = function (arg) {
  return this.request('sharing/add_folder_member', arg, 'user', 'api', 'rpc');
};
/**
 * Identical to update_file_member but with less information returned.
 * @function Dropbox#sharingChangeFileMemberAccess
 * @deprecated
 * @arg {SharingChangeFileMemberAccessArgs} arg - The request parameters.
 * @returns {Promise.<SharingFileMemberActionResult, Error.<SharingFileMemberActionError>>}
 */


routes.sharingChangeFileMemberAccess = function (arg) {
  return this.request('sharing/change_file_member_access', arg, 'user', 'api', 'rpc');
};
/**
 * Returns the status of an asynchronous job. Apps must have full Dropbox access
 * to use this endpoint.
 * @function Dropbox#sharingCheckJobStatus
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<SharingJobStatus, Error.<AsyncPollError>>}
 */


routes.sharingCheckJobStatus = function (arg) {
  return this.request('sharing/check_job_status', arg, 'user', 'api', 'rpc');
};
/**
 * Returns the status of an asynchronous job for sharing a folder. Apps must
 * have full Dropbox access to use this endpoint.
 * @function Dropbox#sharingCheckRemoveMemberJobStatus
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<SharingRemoveMemberJobStatus, Error.<AsyncPollError>>}
 */


routes.sharingCheckRemoveMemberJobStatus = function (arg) {
  return this.request('sharing/check_remove_member_job_status', arg, 'user', 'api', 'rpc');
};
/**
 * Returns the status of an asynchronous job for sharing a folder. Apps must
 * have full Dropbox access to use this endpoint.
 * @function Dropbox#sharingCheckShareJobStatus
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<SharingShareFolderJobStatus, Error.<AsyncPollError>>}
 */


routes.sharingCheckShareJobStatus = function (arg) {
  return this.request('sharing/check_share_job_status', arg, 'user', 'api', 'rpc');
};
/**
 * Create a shared link. If a shared link already exists for the given path,
 * that link is returned. Note that in the returned PathLinkMetadata, the
 * PathLinkMetadata.url field is the shortened URL if
 * CreateSharedLinkArg.short_url argument is set to true. Previously, it was
 * technically possible to break a shared link by moving or renaming the
 * corresponding file or folder. In the future, this will no longer be the case,
 * so your app shouldn't rely on this behavior. Instead, if your app needs to
 * revoke a shared link, use revoke_shared_link.
 * @function Dropbox#sharingCreateSharedLink
 * @deprecated
 * @arg {SharingCreateSharedLinkArg} arg - The request parameters.
 * @returns {Promise.<SharingPathLinkMetadata, Error.<SharingCreateSharedLinkError>>}
 */


routes.sharingCreateSharedLink = function (arg) {
  return this.request('sharing/create_shared_link', arg, 'user', 'api', 'rpc');
};
/**
 * Create a shared link with custom settings. If no settings are given then the
 * default visibility is RequestedVisibility.public (The resolved visibility,
 * though, may depend on other aspects such as team and shared folder settings).
 * @function Dropbox#sharingCreateSharedLinkWithSettings
 * @arg {SharingCreateSharedLinkWithSettingsArg} arg - The request parameters.
 * @returns {Promise.<(SharingFileLinkMetadata|SharingFolderLinkMetadata|SharingSharedLinkMetadata), Error.<SharingCreateSharedLinkWithSettingsError>>}
 */


routes.sharingCreateSharedLinkWithSettings = function (arg) {
  return this.request('sharing/create_shared_link_with_settings', arg, 'user', 'api', 'rpc');
};
/**
 * Returns shared file metadata.
 * @function Dropbox#sharingGetFileMetadata
 * @arg {SharingGetFileMetadataArg} arg - The request parameters.
 * @returns {Promise.<SharingSharedFileMetadata, Error.<SharingGetFileMetadataError>>}
 */


routes.sharingGetFileMetadata = function (arg) {
  return this.request('sharing/get_file_metadata', arg, 'user', 'api', 'rpc');
};
/**
 * Returns shared file metadata.
 * @function Dropbox#sharingGetFileMetadataBatch
 * @arg {SharingGetFileMetadataBatchArg} arg - The request parameters.
 * @returns {Promise.<Array.<SharingGetFileMetadataBatchResult>, Error.<SharingSharingUserError>>}
 */


routes.sharingGetFileMetadataBatch = function (arg) {
  return this.request('sharing/get_file_metadata/batch', arg, 'user', 'api', 'rpc');
};
/**
 * Returns shared folder metadata by its folder ID. Apps must have full Dropbox
 * access to use this endpoint.
 * @function Dropbox#sharingGetFolderMetadata
 * @arg {SharingGetMetadataArgs} arg - The request parameters.
 * @returns {Promise.<SharingSharedFolderMetadata, Error.<SharingSharedFolderAccessError>>}
 */


routes.sharingGetFolderMetadata = function (arg) {
  return this.request('sharing/get_folder_metadata', arg, 'user', 'api', 'rpc');
};
/**
 * Download the shared link's file from a user's Dropbox.
 * @function Dropbox#sharingGetSharedLinkFile
 * @arg {Object} arg - The request parameters.
 * @returns {Promise.<(SharingFileLinkMetadata|SharingFolderLinkMetadata|SharingSharedLinkMetadata), Error.<SharingGetSharedLinkFileError>>}
 */


routes.sharingGetSharedLinkFile = function (arg) {
  return this.request('sharing/get_shared_link_file', arg, 'user', 'content', 'download');
};
/**
 * Get the shared link's metadata.
 * @function Dropbox#sharingGetSharedLinkMetadata
 * @arg {SharingGetSharedLinkMetadataArg} arg - The request parameters.
 * @returns {Promise.<(SharingFileLinkMetadata|SharingFolderLinkMetadata|SharingSharedLinkMetadata), Error.<SharingSharedLinkError>>}
 */


routes.sharingGetSharedLinkMetadata = function (arg) {
  return this.request('sharing/get_shared_link_metadata', arg, 'user', 'api', 'rpc');
};
/**
 * Returns a list of LinkMetadata objects for this user, including collection
 * links. If no path is given, returns a list of all shared links for the
 * current user, including collection links, up to a maximum of 1000 links. If a
 * non-empty path is given, returns a list of all shared links that allow access
 * to the given path.  Collection links are never returned in this case. Note
 * that the url field in the response is never the shortened URL.
 * @function Dropbox#sharingGetSharedLinks
 * @deprecated
 * @arg {SharingGetSharedLinksArg} arg - The request parameters.
 * @returns {Promise.<SharingGetSharedLinksResult, Error.<SharingGetSharedLinksError>>}
 */


routes.sharingGetSharedLinks = function (arg) {
  return this.request('sharing/get_shared_links', arg, 'user', 'api', 'rpc');
};
/**
 * Use to obtain the members who have been invited to a file, both inherited and
 * uninherited members.
 * @function Dropbox#sharingListFileMembers
 * @arg {SharingListFileMembersArg} arg - The request parameters.
 * @returns {Promise.<SharingSharedFileMembers, Error.<SharingListFileMembersError>>}
 */


routes.sharingListFileMembers = function (arg) {
  return this.request('sharing/list_file_members', arg, 'user', 'api', 'rpc');
};
/**
 * Get members of multiple files at once. The arguments to this route are more
 * limited, and the limit on query result size per file is more strict. To
 * customize the results more, use the individual file endpoint. Inherited users
 * and groups are not included in the result, and permissions are not returned
 * for this endpoint.
 * @function Dropbox#sharingListFileMembersBatch
 * @arg {SharingListFileMembersBatchArg} arg - The request parameters.
 * @returns {Promise.<Array.<SharingListFileMembersBatchResult>, Error.<SharingSharingUserError>>}
 */


routes.sharingListFileMembersBatch = function (arg) {
  return this.request('sharing/list_file_members/batch', arg, 'user', 'api', 'rpc');
};
/**
 * Once a cursor has been retrieved from list_file_members or
 * list_file_members/batch, use this to paginate through all shared file
 * members.
 * @function Dropbox#sharingListFileMembersContinue
 * @arg {SharingListFileMembersContinueArg} arg - The request parameters.
 * @returns {Promise.<SharingSharedFileMembers, Error.<SharingListFileMembersContinueError>>}
 */


routes.sharingListFileMembersContinue = function (arg) {
  return this.request('sharing/list_file_members/continue', arg, 'user', 'api', 'rpc');
};
/**
 * Returns shared folder membership by its folder ID. Apps must have full
 * Dropbox access to use this endpoint.
 * @function Dropbox#sharingListFolderMembers
 * @arg {SharingListFolderMembersArgs} arg - The request parameters.
 * @returns {Promise.<SharingSharedFolderMembers, Error.<SharingSharedFolderAccessError>>}
 */


routes.sharingListFolderMembers = function (arg) {
  return this.request('sharing/list_folder_members', arg, 'user', 'api', 'rpc');
};
/**
 * Once a cursor has been retrieved from list_folder_members, use this to
 * paginate through all shared folder members. Apps must have full Dropbox
 * access to use this endpoint.
 * @function Dropbox#sharingListFolderMembersContinue
 * @arg {SharingListFolderMembersContinueArg} arg - The request parameters.
 * @returns {Promise.<SharingSharedFolderMembers, Error.<SharingListFolderMembersContinueError>>}
 */


routes.sharingListFolderMembersContinue = function (arg) {
  return this.request('sharing/list_folder_members/continue', arg, 'user', 'api', 'rpc');
};
/**
 * Return the list of all shared folders the current user has access to. Apps
 * must have full Dropbox access to use this endpoint.
 * @function Dropbox#sharingListFolders
 * @arg {SharingListFoldersArgs} arg - The request parameters.
 * @returns {Promise.<SharingListFoldersResult, Error.<void>>}
 */


routes.sharingListFolders = function (arg) {
  return this.request('sharing/list_folders', arg, 'user', 'api', 'rpc');
};
/**
 * Once a cursor has been retrieved from list_folders, use this to paginate
 * through all shared folders. The cursor must come from a previous call to
 * list_folders or list_folders/continue. Apps must have full Dropbox access to
 * use this endpoint.
 * @function Dropbox#sharingListFoldersContinue
 * @arg {SharingListFoldersContinueArg} arg - The request parameters.
 * @returns {Promise.<SharingListFoldersResult, Error.<SharingListFoldersContinueError>>}
 */


routes.sharingListFoldersContinue = function (arg) {
  return this.request('sharing/list_folders/continue', arg, 'user', 'api', 'rpc');
};
/**
 * Return the list of all shared folders the current user can mount or unmount.
 * Apps must have full Dropbox access to use this endpoint.
 * @function Dropbox#sharingListMountableFolders
 * @arg {SharingListFoldersArgs} arg - The request parameters.
 * @returns {Promise.<SharingListFoldersResult, Error.<void>>}
 */


routes.sharingListMountableFolders = function (arg) {
  return this.request('sharing/list_mountable_folders', arg, 'user', 'api', 'rpc');
};
/**
 * Once a cursor has been retrieved from list_mountable_folders, use this to
 * paginate through all mountable shared folders. The cursor must come from a
 * previous call to list_mountable_folders or list_mountable_folders/continue.
 * Apps must have full Dropbox access to use this endpoint.
 * @function Dropbox#sharingListMountableFoldersContinue
 * @arg {SharingListFoldersContinueArg} arg - The request parameters.
 * @returns {Promise.<SharingListFoldersResult, Error.<SharingListFoldersContinueError>>}
 */


routes.sharingListMountableFoldersContinue = function (arg) {
  return this.request('sharing/list_mountable_folders/continue', arg, 'user', 'api', 'rpc');
};
/**
 * Returns a list of all files shared with current user.  Does not include files
 * the user has received via shared folders, and does  not include unclaimed
 * invitations.
 * @function Dropbox#sharingListReceivedFiles
 * @arg {SharingListFilesArg} arg - The request parameters.
 * @returns {Promise.<SharingListFilesResult, Error.<SharingSharingUserError>>}
 */


routes.sharingListReceivedFiles = function (arg) {
  return this.request('sharing/list_received_files', arg, 'user', 'api', 'rpc');
};
/**
 * Get more results with a cursor from list_received_files.
 * @function Dropbox#sharingListReceivedFilesContinue
 * @arg {SharingListFilesContinueArg} arg - The request parameters.
 * @returns {Promise.<SharingListFilesResult, Error.<SharingListFilesContinueError>>}
 */


routes.sharingListReceivedFilesContinue = function (arg) {
  return this.request('sharing/list_received_files/continue', arg, 'user', 'api', 'rpc');
};
/**
 * List shared links of this user. If no path is given, returns a list of all
 * shared links for the current user. If a non-empty path is given, returns a
 * list of all shared links that allow access to the given path - direct links
 * to the given path and links to parent folders of the given path. Links to
 * parent folders can be suppressed by setting direct_only to true.
 * @function Dropbox#sharingListSharedLinks
 * @arg {SharingListSharedLinksArg} arg - The request parameters.
 * @returns {Promise.<SharingListSharedLinksResult, Error.<SharingListSharedLinksError>>}
 */


routes.sharingListSharedLinks = function (arg) {
  return this.request('sharing/list_shared_links', arg, 'user', 'api', 'rpc');
};
/**
 * Modify the shared link's settings. If the requested visibility conflict with
 * the shared links policy of the team or the shared folder (in case the linked
 * file is part of a shared folder) then the LinkPermissions.resolved_visibility
 * of the returned SharedLinkMetadata will reflect the actual visibility of the
 * shared link and the LinkPermissions.requested_visibility will reflect the
 * requested visibility.
 * @function Dropbox#sharingModifySharedLinkSettings
 * @arg {SharingModifySharedLinkSettingsArgs} arg - The request parameters.
 * @returns {Promise.<(SharingFileLinkMetadata|SharingFolderLinkMetadata|SharingSharedLinkMetadata), Error.<SharingModifySharedLinkSettingsError>>}
 */


routes.sharingModifySharedLinkSettings = function (arg) {
  return this.request('sharing/modify_shared_link_settings', arg, 'user', 'api', 'rpc');
};
/**
 * The current user mounts the designated folder. Mount a shared folder for a
 * user after they have been added as a member. Once mounted, the shared folder
 * will appear in their Dropbox. Apps must have full Dropbox access to use this
 * endpoint.
 * @function Dropbox#sharingMountFolder
 * @arg {SharingMountFolderArg} arg - The request parameters.
 * @returns {Promise.<SharingSharedFolderMetadata, Error.<SharingMountFolderError>>}
 */


routes.sharingMountFolder = function (arg) {
  return this.request('sharing/mount_folder', arg, 'user', 'api', 'rpc');
};
/**
 * The current user relinquishes their membership in the designated file. Note
 * that the current user may still have inherited access to this file through
 * the parent folder. Apps must have full Dropbox access to use this endpoint.
 * @function Dropbox#sharingRelinquishFileMembership
 * @arg {SharingRelinquishFileMembershipArg} arg - The request parameters.
 * @returns {Promise.<void, Error.<SharingRelinquishFileMembershipError>>}
 */


routes.sharingRelinquishFileMembership = function (arg) {
  return this.request('sharing/relinquish_file_membership', arg, 'user', 'api', 'rpc');
};
/**
 * The current user relinquishes their membership in the designated shared
 * folder and will no longer have access to the folder.  A folder owner cannot
 * relinquish membership in their own folder. This will run synchronously if
 * leave_a_copy is false, and asynchronously if leave_a_copy is true. Apps must
 * have full Dropbox access to use this endpoint.
 * @function Dropbox#sharingRelinquishFolderMembership
 * @arg {SharingRelinquishFolderMembershipArg} arg - The request parameters.
 * @returns {Promise.<AsyncLaunchEmptyResult, Error.<SharingRelinquishFolderMembershipError>>}
 */


routes.sharingRelinquishFolderMembership = function (arg) {
  return this.request('sharing/relinquish_folder_membership', arg, 'user', 'api', 'rpc');
};
/**
 * Identical to remove_file_member_2 but with less information returned.
 * @function Dropbox#sharingRemoveFileMember
 * @deprecated
 * @arg {SharingRemoveFileMemberArg} arg - The request parameters.
 * @returns {Promise.<SharingFileMemberActionIndividualResult, Error.<SharingRemoveFileMemberError>>}
 */


routes.sharingRemoveFileMember = function (arg) {
  return this.request('sharing/remove_file_member', arg, 'user', 'api', 'rpc');
};
/**
 * Removes a specified member from the file.
 * @function Dropbox#sharingRemoveFileMember2
 * @arg {SharingRemoveFileMemberArg} arg - The request parameters.
 * @returns {Promise.<SharingFileMemberRemoveActionResult, Error.<SharingRemoveFileMemberError>>}
 */


routes.sharingRemoveFileMember2 = function (arg) {
  return this.request('sharing/remove_file_member_2', arg, 'user', 'api', 'rpc');
};
/**
 * Allows an owner or editor (if the ACL update policy allows) of a shared
 * folder to remove another member. Apps must have full Dropbox access to use
 * this endpoint.
 * @function Dropbox#sharingRemoveFolderMember
 * @arg {SharingRemoveFolderMemberArg} arg - The request parameters.
 * @returns {Promise.<AsyncLaunchResultBase, Error.<SharingRemoveFolderMemberError>>}
 */


routes.sharingRemoveFolderMember = function (arg) {
  return this.request('sharing/remove_folder_member', arg, 'user', 'api', 'rpc');
};
/**
 * Revoke a shared link. Note that even after revoking a shared link to a file,
 * the file may be accessible if there are shared links leading to any of the
 * file parent folders. To list all shared links that enable access to a
 * specific file, you can use the list_shared_links with the file as the
 * ListSharedLinksArg.path argument.
 * @function Dropbox#sharingRevokeSharedLink
 * @arg {SharingRevokeSharedLinkArg} arg - The request parameters.
 * @returns {Promise.<void, Error.<SharingRevokeSharedLinkError>>}
 */


routes.sharingRevokeSharedLink = function (arg) {
  return this.request('sharing/revoke_shared_link', arg, 'user', 'api', 'rpc');
};
/**
 * Share a folder with collaborators. Most sharing will be completed
 * synchronously. Large folders will be completed asynchronously. To make
 * testing the async case repeatable, set `ShareFolderArg.force_async`. If a
 * ShareFolderLaunch.async_job_id is returned, you'll need to call
 * check_share_job_status until the action completes to get the metadata for the
 * folder. Apps must have full Dropbox access to use this endpoint.
 * @function Dropbox#sharingShareFolder
 * @arg {SharingShareFolderArg} arg - The request parameters.
 * @returns {Promise.<SharingShareFolderLaunch, Error.<SharingShareFolderError>>}
 */


routes.sharingShareFolder = function (arg) {
  return this.request('sharing/share_folder', arg, 'user', 'api', 'rpc');
};
/**
 * Transfer ownership of a shared folder to a member of the shared folder. User
 * must have AccessLevel.owner access to the shared folder to perform a
 * transfer. Apps must have full Dropbox access to use this endpoint.
 * @function Dropbox#sharingTransferFolder
 * @arg {SharingTransferFolderArg} arg - The request parameters.
 * @returns {Promise.<void, Error.<SharingTransferFolderError>>}
 */


routes.sharingTransferFolder = function (arg) {
  return this.request('sharing/transfer_folder', arg, 'user', 'api', 'rpc');
};
/**
 * The current user unmounts the designated folder. They can re-mount the folder
 * at a later time using mount_folder. Apps must have full Dropbox access to use
 * this endpoint.
 * @function Dropbox#sharingUnmountFolder
 * @arg {SharingUnmountFolderArg} arg - The request parameters.
 * @returns {Promise.<void, Error.<SharingUnmountFolderError>>}
 */


routes.sharingUnmountFolder = function (arg) {
  return this.request('sharing/unmount_folder', arg, 'user', 'api', 'rpc');
};
/**
 * Remove all members from this file. Does not remove inherited members.
 * @function Dropbox#sharingUnshareFile
 * @arg {SharingUnshareFileArg} arg - The request parameters.
 * @returns {Promise.<void, Error.<SharingUnshareFileError>>}
 */


routes.sharingUnshareFile = function (arg) {
  return this.request('sharing/unshare_file', arg, 'user', 'api', 'rpc');
};
/**
 * Allows a shared folder owner to unshare the folder. You'll need to call
 * check_job_status to determine if the action has completed successfully. Apps
 * must have full Dropbox access to use this endpoint.
 * @function Dropbox#sharingUnshareFolder
 * @arg {SharingUnshareFolderArg} arg - The request parameters.
 * @returns {Promise.<AsyncLaunchEmptyResult, Error.<SharingUnshareFolderError>>}
 */


routes.sharingUnshareFolder = function (arg) {
  return this.request('sharing/unshare_folder', arg, 'user', 'api', 'rpc');
};
/**
 * Changes a member's access on a shared file.
 * @function Dropbox#sharingUpdateFileMember
 * @arg {SharingUpdateFileMemberArgs} arg - The request parameters.
 * @returns {Promise.<SharingMemberAccessLevelResult, Error.<SharingFileMemberActionError>>}
 */


routes.sharingUpdateFileMember = function (arg) {
  return this.request('sharing/update_file_member', arg, 'user', 'api', 'rpc');
};
/**
 * Allows an owner or editor of a shared folder to update another member's
 * permissions. Apps must have full Dropbox access to use this endpoint.
 * @function Dropbox#sharingUpdateFolderMember
 * @arg {SharingUpdateFolderMemberArg} arg - The request parameters.
 * @returns {Promise.<SharingMemberAccessLevelResult, Error.<SharingUpdateFolderMemberError>>}
 */


routes.sharingUpdateFolderMember = function (arg) {
  return this.request('sharing/update_folder_member', arg, 'user', 'api', 'rpc');
};
/**
 * Update the sharing policies for a shared folder. User must have
 * AccessLevel.owner access to the shared folder to update its policies. Apps
 * must have full Dropbox access to use this endpoint.
 * @function Dropbox#sharingUpdateFolderPolicy
 * @arg {SharingUpdateFolderPolicyArg} arg - The request parameters.
 * @returns {Promise.<SharingSharedFolderMetadata, Error.<SharingUpdateFolderPolicyError>>}
 */


routes.sharingUpdateFolderPolicy = function (arg) {
  return this.request('sharing/update_folder_policy', arg, 'user', 'api', 'rpc');
};
/**
 * Retrieves team events. Permission : Team Auditing.
 * @function Dropbox#teamLogGetEvents
 * @arg {TeamLogGetTeamEventsArg} arg - The request parameters.
 * @returns {Promise.<TeamLogGetTeamEventsResult, Error.<TeamLogGetTeamEventsError>>}
 */


routes.teamLogGetEvents = function (arg) {
  return this.request('team_log/get_events', arg, 'team', 'api', 'rpc');
};
/**
 * Once a cursor has been retrieved from get_events, use this to paginate
 * through all events. Permission : Team Auditing.
 * @function Dropbox#teamLogGetEventsContinue
 * @arg {TeamLogGetTeamEventsContinueArg} arg - The request parameters.
 * @returns {Promise.<TeamLogGetTeamEventsResult, Error.<TeamLogGetTeamEventsContinueError>>}
 */


routes.teamLogGetEventsContinue = function (arg) {
  return this.request('team_log/get_events/continue', arg, 'team', 'api', 'rpc');
};
/**
 * Get information about a user's account.
 * @function Dropbox#usersGetAccount
 * @arg {UsersGetAccountArg} arg - The request parameters.
 * @returns {Promise.<UsersBasicAccount, Error.<UsersGetAccountError>>}
 */


routes.usersGetAccount = function (arg) {
  return this.request('users/get_account', arg, 'user', 'api', 'rpc');
};
/**
 * Get information about multiple user accounts.  At most 300 accounts may be
 * queried per request.
 * @function Dropbox#usersGetAccountBatch
 * @arg {UsersGetAccountBatchArg} arg - The request parameters.
 * @returns {Promise.<Object, Error.<UsersGetAccountBatchError>>}
 */


routes.usersGetAccountBatch = function (arg) {
  return this.request('users/get_account_batch', arg, 'user', 'api', 'rpc');
};
/**
 * Get information about the current user's account.
 * @function Dropbox#usersGetCurrentAccount
 * @arg {void} arg - The request parameters.
 * @returns {Promise.<UsersFullAccount, Error.<void>>}
 */


routes.usersGetCurrentAccount = function (arg) {
  return this.request('users/get_current_account', arg, 'user', 'api', 'rpc');
};
/**
 * Get the space usage information for the current user's account.
 * @function Dropbox#usersGetSpaceUsage
 * @arg {void} arg - The request parameters.
 * @returns {Promise.<UsersSpaceUsage, Error.<void>>}
 */


routes.usersGetSpaceUsage = function (arg) {
  return this.request('users/get_space_usage', arg, 'user', 'api', 'rpc');
};

module.exports = routes;

},{}],150:[function(require,module,exports){
"use strict";

var request = require('superagent');

var Promise = require('es6-promise').Promise;

var getBaseURL = require('./get-base-url'); // This doesn't match what was spec'd in paper doc yet


var buildCustomError = function buildCustomError(error, response) {
  var err;

  if (response) {
    try {
      err = JSON.parse(response.text);
    } catch (e) {
      err = response.text;
    }
  }

  return {
    status: error.status,
    error: err || error,
    response: response
  };
};

var rpcRequest = function rpcRequest(path, body, auth, host, accessToken, selectUser) {
  var promiseFunction = function promiseFunction(resolve, reject) {
    var apiRequest;

    function success(data) {
      if (resolve) {
        resolve(data);
      }
    }

    function failure(error) {
      if (reject) {
        reject(error);
      }
    }

    function responseHandler(error, response) {
      if (error) {
        failure(buildCustomError(error, response));
      } else {
        success(response.body);
      }
    } // The API expects null to be passed for endpoints that dont accept any
    // parameters


    if (!body) {
      body = null;
    }

    apiRequest = request.post(getBaseURL(host) + path).type('application/json');

    switch (auth) {
      case 'team':
      case 'user':
        apiRequest.set('Authorization', 'Bearer ' + accessToken);
        break;

      case 'noauth':
        break;

      default:
        throw new Error('Unhandled auth type: ' + auth);
    }

    if (selectUser) {
      apiRequest = apiRequest.set('Dropbox-API-Select-User', selectUser);
    }

    apiRequest.send(body).end(responseHandler);
  };

  return new Promise(promiseFunction);
};

module.exports = rpcRequest;

},{"./get-base-url":144,"es6-promise":152,"superagent":157}],151:[function(require,module,exports){
"use strict";

var request = require('superagent');

var Promise = require('es6-promise').Promise;

var getBaseURL = require('./get-base-url');

var httpHeaderSafeJson = require('./http-header-safe-json'); // This doesn't match what was spec'd in paper doc yet


var buildCustomError = function buildCustomError(error, response) {
  return {
    status: error.status,
    error: (response ? response.text : null) || error.toString(),
    response: response
  };
};

var uploadRequest = function uploadRequest(path, args, auth, host, accessToken, selectUser) {
  if (auth !== 'user') {
    throw new Error('Unexpected auth type: ' + auth);
  }

  var promiseFunction = function promiseFunction(resolve, reject) {
    var apiRequest; // Since args.contents is sent as the body of the request and not added to
    // the url, it needs to be remove it from args.

    var contents = args.contents;
    delete args.contents;

    function success(data) {
      if (resolve) {
        resolve(data);
      }
    }

    function failure(error) {
      if (reject) {
        reject(error);
      }
    }

    function responseHandler(error, response) {
      if (error) {
        failure(buildCustomError(error, response));
      } else {
        success(response.body);
      }
    }

    apiRequest = request.post(getBaseURL(host) + path).type('application/octet-stream').set('Authorization', 'Bearer ' + accessToken).set('Dropbox-API-Arg', httpHeaderSafeJson(args));

    if (selectUser) {
      apiRequest = apiRequest.set('Dropbox-API-Select-User', selectUser);
    }

    apiRequest.send(contents).end(responseHandler);
  };

  return new Promise(promiseFunction);
};

module.exports = uploadRequest;

},{"./get-base-url":144,"./http-header-safe-json":145,"es6-promise":152,"superagent":157}],152:[function(require,module,exports){
(function (process,global){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.ES6Promise = factory();
})(void 0, function () {
  'use strict';

  function objectOrFunction(x) {
    var type = _typeof(x);

    return x !== null && (type === 'object' || type === 'function');
  }

  function isFunction(x) {
    return typeof x === 'function';
  }

  var _isArray = void 0;

  if (Array.isArray) {
    _isArray = Array.isArray;
  } else {
    _isArray = function _isArray(x) {
      return Object.prototype.toString.call(x) === '[object Array]';
    };
  }

  var isArray = _isArray;
  var len = 0;
  var vertxNext = void 0;
  var customSchedulerFn = void 0;

  var asap = function asap(callback, arg) {
    queue[len] = callback;
    queue[len + 1] = arg;
    len += 2;

    if (len === 2) {
      // If len is 2, that means that we need to schedule an async flush.
      // If additional callbacks are queued before the queue is flushed, they
      // will be processed by this flush that we are scheduling.
      if (customSchedulerFn) {
        customSchedulerFn(flush);
      } else {
        scheduleFlush();
      }
    }
  };

  function setScheduler(scheduleFn) {
    customSchedulerFn = scheduleFn;
  }

  function setAsap(asapFn) {
    asap = asapFn;
  }

  var browserWindow = typeof window !== 'undefined' ? window : undefined;
  var browserGlobal = browserWindow || {};
  var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
  var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]'; // test for web worker but not in IE10

  var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined'; // node

  function useNextTick() {
    // node version 0.10.x displays a deprecation warning when nextTick is used recursively
    // see https://github.com/cujojs/when/issues/410 for details
    return function () {
      return process.nextTick(flush);
    };
  } // vertx


  function useVertxTimer() {
    if (typeof vertxNext !== 'undefined') {
      return function () {
        vertxNext(flush);
      };
    }

    return useSetTimeout();
  }

  function useMutationObserver() {
    var iterations = 0;
    var observer = new BrowserMutationObserver(flush);
    var node = document.createTextNode('');
    observer.observe(node, {
      characterData: true
    });
    return function () {
      node.data = iterations = ++iterations % 2;
    };
  } // web worker


  function useMessageChannel() {
    var channel = new MessageChannel();
    channel.port1.onmessage = flush;
    return function () {
      return channel.port2.postMessage(0);
    };
  }

  function useSetTimeout() {
    // Store setTimeout reference so es6-promise will be unaffected by
    // other code modifying setTimeout (like sinon.useFakeTimers())
    var globalSetTimeout = setTimeout;
    return function () {
      return globalSetTimeout(flush, 1);
    };
  }

  var queue = new Array(1000);

  function flush() {
    for (var i = 0; i < len; i += 2) {
      var callback = queue[i];
      var arg = queue[i + 1];
      callback(arg);
      queue[i] = undefined;
      queue[i + 1] = undefined;
    }

    len = 0;
  }

  function attemptVertx() {
    try {
      var vertx = Function('return this')().require('vertx');

      vertxNext = vertx.runOnLoop || vertx.runOnContext;
      return useVertxTimer();
    } catch (e) {
      return useSetTimeout();
    }
  }

  var scheduleFlush = void 0; // Decide what async method to use to triggering processing of queued callbacks:

  if (isNode) {
    scheduleFlush = useNextTick();
  } else if (BrowserMutationObserver) {
    scheduleFlush = useMutationObserver();
  } else if (isWorker) {
    scheduleFlush = useMessageChannel();
  } else if (browserWindow === undefined && typeof require === 'function') {
    scheduleFlush = attemptVertx();
  } else {
    scheduleFlush = useSetTimeout();
  }

  function then(onFulfillment, onRejection) {
    var parent = this;
    var child = new this.constructor(noop);

    if (child[PROMISE_ID] === undefined) {
      makePromise(child);
    }

    var _state = parent._state;

    if (_state) {
      var callback = arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    } else {
      subscribe(parent, child, onFulfillment, onRejection);
    }

    return child;
  }
  /**
    `Promise.resolve` returns a promise that will become resolved with the
    passed `value`. It is shorthand for the following:
  
    ```javascript
    let promise = new Promise(function(resolve, reject){
      resolve(1);
    });
  
    promise.then(function(value){
      // value === 1
    });
    ```
  
    Instead of writing the above, your code now simply becomes the following:
  
    ```javascript
    let promise = Promise.resolve(1);
  
    promise.then(function(value){
      // value === 1
    });
    ```
  
    @method resolve
    @static
    @param {Any} value value that the returned promise will be resolved with
    Useful for tooling.
    @return {Promise} a promise that will become fulfilled with the given
    `value`
  */


  function resolve$1(object) {
    /*jshint validthis:true */
    var Constructor = this;

    if (object && _typeof(object) === 'object' && object.constructor === Constructor) {
      return object;
    }

    var promise = new Constructor(noop);
    resolve(promise, object);
    return promise;
  }

  var PROMISE_ID = Math.random().toString(36).substring(2);

  function noop() {}

  var PENDING = void 0;
  var FULFILLED = 1;
  var REJECTED = 2;

  function selfFulfillment() {
    return new TypeError("You cannot resolve a promise with itself");
  }

  function cannotReturnOwn() {
    return new TypeError('A promises callback cannot return that same promise.');
  }

  function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
    try {
      then$$1.call(value, fulfillmentHandler, rejectionHandler);
    } catch (e) {
      return e;
    }
  }

  function handleForeignThenable(promise, thenable, then$$1) {
    asap(function (promise) {
      var sealed = false;
      var error = tryThen(then$$1, thenable, function (value) {
        if (sealed) {
          return;
        }

        sealed = true;

        if (thenable !== value) {
          resolve(promise, value);
        } else {
          fulfill(promise, value);
        }
      }, function (reason) {
        if (sealed) {
          return;
        }

        sealed = true;
        reject(promise, reason);
      }, 'Settle: ' + (promise._label || ' unknown promise'));

      if (!sealed && error) {
        sealed = true;
        reject(promise, error);
      }
    }, promise);
  }

  function handleOwnThenable(promise, thenable) {
    if (thenable._state === FULFILLED) {
      fulfill(promise, thenable._result);
    } else if (thenable._state === REJECTED) {
      reject(promise, thenable._result);
    } else {
      subscribe(thenable, undefined, function (value) {
        return resolve(promise, value);
      }, function (reason) {
        return reject(promise, reason);
      });
    }
  }

  function handleMaybeThenable(promise, maybeThenable, then$$1) {
    if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
      handleOwnThenable(promise, maybeThenable);
    } else {
      if (then$$1 === undefined) {
        fulfill(promise, maybeThenable);
      } else if (isFunction(then$$1)) {
        handleForeignThenable(promise, maybeThenable, then$$1);
      } else {
        fulfill(promise, maybeThenable);
      }
    }
  }

  function resolve(promise, value) {
    if (promise === value) {
      reject(promise, selfFulfillment());
    } else if (objectOrFunction(value)) {
      var then$$1 = void 0;

      try {
        then$$1 = value.then;
      } catch (error) {
        reject(promise, error);
        return;
      }

      handleMaybeThenable(promise, value, then$$1);
    } else {
      fulfill(promise, value);
    }
  }

  function publishRejection(promise) {
    if (promise._onerror) {
      promise._onerror(promise._result);
    }

    publish(promise);
  }

  function fulfill(promise, value) {
    if (promise._state !== PENDING) {
      return;
    }

    promise._result = value;
    promise._state = FULFILLED;

    if (promise._subscribers.length !== 0) {
      asap(publish, promise);
    }
  }

  function reject(promise, reason) {
    if (promise._state !== PENDING) {
      return;
    }

    promise._state = REJECTED;
    promise._result = reason;
    asap(publishRejection, promise);
  }

  function subscribe(parent, child, onFulfillment, onRejection) {
    var _subscribers = parent._subscribers;
    var length = _subscribers.length;
    parent._onerror = null;
    _subscribers[length] = child;
    _subscribers[length + FULFILLED] = onFulfillment;
    _subscribers[length + REJECTED] = onRejection;

    if (length === 0 && parent._state) {
      asap(publish, parent);
    }
  }

  function publish(promise) {
    var subscribers = promise._subscribers;
    var settled = promise._state;

    if (subscribers.length === 0) {
      return;
    }

    var child = void 0,
        callback = void 0,
        detail = promise._result;

    for (var i = 0; i < subscribers.length; i += 3) {
      child = subscribers[i];
      callback = subscribers[i + settled];

      if (child) {
        invokeCallback(settled, child, callback, detail);
      } else {
        callback(detail);
      }
    }

    promise._subscribers.length = 0;
  }

  function invokeCallback(settled, promise, callback, detail) {
    var hasCallback = isFunction(callback),
        value = void 0,
        error = void 0,
        succeeded = true;

    if (hasCallback) {
      try {
        value = callback(detail);
      } catch (e) {
        succeeded = false;
        error = e;
      }

      if (promise === value) {
        reject(promise, cannotReturnOwn());
        return;
      }
    } else {
      value = detail;
    }

    if (promise._state !== PENDING) {// noop
    } else if (hasCallback && succeeded) {
      resolve(promise, value);
    } else if (succeeded === false) {
      reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      reject(promise, value);
    }
  }

  function initializePromise(promise, resolver) {
    try {
      resolver(function resolvePromise(value) {
        resolve(promise, value);
      }, function rejectPromise(reason) {
        reject(promise, reason);
      });
    } catch (e) {
      reject(promise, e);
    }
  }

  var id = 0;

  function nextId() {
    return id++;
  }

  function makePromise(promise) {
    promise[PROMISE_ID] = id++;
    promise._state = undefined;
    promise._result = undefined;
    promise._subscribers = [];
  }

  function validationError() {
    return new Error('Array Methods must be provided an Array');
  }

  var Enumerator = function () {
    function Enumerator(Constructor, input) {
      this._instanceConstructor = Constructor;
      this.promise = new Constructor(noop);

      if (!this.promise[PROMISE_ID]) {
        makePromise(this.promise);
      }

      if (isArray(input)) {
        this.length = input.length;
        this._remaining = input.length;
        this._result = new Array(this.length);

        if (this.length === 0) {
          fulfill(this.promise, this._result);
        } else {
          this.length = this.length || 0;

          this._enumerate(input);

          if (this._remaining === 0) {
            fulfill(this.promise, this._result);
          }
        }
      } else {
        reject(this.promise, validationError());
      }
    }

    Enumerator.prototype._enumerate = function _enumerate(input) {
      for (var i = 0; this._state === PENDING && i < input.length; i++) {
        this._eachEntry(input[i], i);
      }
    };

    Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
      var c = this._instanceConstructor;
      var resolve$$1 = c.resolve;

      if (resolve$$1 === resolve$1) {
        var _then = void 0;

        var error = void 0;
        var didError = false;

        try {
          _then = entry.then;
        } catch (e) {
          didError = true;
          error = e;
        }

        if (_then === then && entry._state !== PENDING) {
          this._settledAt(entry._state, i, entry._result);
        } else if (typeof _then !== 'function') {
          this._remaining--;
          this._result[i] = entry;
        } else if (c === Promise$1) {
          var promise = new c(noop);

          if (didError) {
            reject(promise, error);
          } else {
            handleMaybeThenable(promise, entry, _then);
          }

          this._willSettleAt(promise, i);
        } else {
          this._willSettleAt(new c(function (resolve$$1) {
            return resolve$$1(entry);
          }), i);
        }
      } else {
        this._willSettleAt(resolve$$1(entry), i);
      }
    };

    Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
      var promise = this.promise;

      if (promise._state === PENDING) {
        this._remaining--;

        if (state === REJECTED) {
          reject(promise, value);
        } else {
          this._result[i] = value;
        }
      }

      if (this._remaining === 0) {
        fulfill(promise, this._result);
      }
    };

    Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
      var enumerator = this;
      subscribe(promise, undefined, function (value) {
        return enumerator._settledAt(FULFILLED, i, value);
      }, function (reason) {
        return enumerator._settledAt(REJECTED, i, reason);
      });
    };

    return Enumerator;
  }();
  /**
    `Promise.all` accepts an array of promises, and returns a new promise which
    is fulfilled with an array of fulfillment values for the passed promises, or
    rejected with the reason of the first passed promise to be rejected. It casts all
    elements of the passed iterable to promises as it runs this algorithm.
  
    Example:
  
    ```javascript
    let promise1 = resolve(1);
    let promise2 = resolve(2);
    let promise3 = resolve(3);
    let promises = [ promise1, promise2, promise3 ];
  
    Promise.all(promises).then(function(array){
      // The array here would be [ 1, 2, 3 ];
    });
    ```
  
    If any of the `promises` given to `all` are rejected, the first promise
    that is rejected will be given as an argument to the returned promises's
    rejection handler. For example:
  
    Example:
  
    ```javascript
    let promise1 = resolve(1);
    let promise2 = reject(new Error("2"));
    let promise3 = reject(new Error("3"));
    let promises = [ promise1, promise2, promise3 ];
  
    Promise.all(promises).then(function(array){
      // Code here never runs because there are rejected promises!
    }, function(error) {
      // error.message === "2"
    });
    ```
  
    @method all
    @static
    @param {Array} entries array of promises
    @param {String} label optional string for labeling the promise.
    Useful for tooling.
    @return {Promise} promise that is fulfilled when all `promises` have been
    fulfilled, or rejected if any of them become rejected.
    @static
  */


  function all(entries) {
    return new Enumerator(this, entries).promise;
  }
  /**
    `Promise.race` returns a new promise which is settled in the same way as the
    first passed promise to settle.
  
    Example:
  
    ```javascript
    let promise1 = new Promise(function(resolve, reject){
      setTimeout(function(){
        resolve('promise 1');
      }, 200);
    });
  
    let promise2 = new Promise(function(resolve, reject){
      setTimeout(function(){
        resolve('promise 2');
      }, 100);
    });
  
    Promise.race([promise1, promise2]).then(function(result){
      // result === 'promise 2' because it was resolved before promise1
      // was resolved.
    });
    ```
  
    `Promise.race` is deterministic in that only the state of the first
    settled promise matters. For example, even if other promises given to the
    `promises` array argument are resolved, but the first settled promise has
    become rejected before the other promises became fulfilled, the returned
    promise will become rejected:
  
    ```javascript
    let promise1 = new Promise(function(resolve, reject){
      setTimeout(function(){
        resolve('promise 1');
      }, 200);
    });
  
    let promise2 = new Promise(function(resolve, reject){
      setTimeout(function(){
        reject(new Error('promise 2'));
      }, 100);
    });
  
    Promise.race([promise1, promise2]).then(function(result){
      // Code here never runs
    }, function(reason){
      // reason.message === 'promise 2' because promise 2 became rejected before
      // promise 1 became fulfilled
    });
    ```
  
    An example real-world use case is implementing timeouts:
  
    ```javascript
    Promise.race([ajax('foo.json'), timeout(5000)])
    ```
  
    @method race
    @static
    @param {Array} promises array of promises to observe
    Useful for tooling.
    @return {Promise} a promise which settles in the same way as the first passed
    promise to settle.
  */


  function race(entries) {
    /*jshint validthis:true */
    var Constructor = this;

    if (!isArray(entries)) {
      return new Constructor(function (_, reject) {
        return reject(new TypeError('You must pass an array to race.'));
      });
    } else {
      return new Constructor(function (resolve, reject) {
        var length = entries.length;

        for (var i = 0; i < length; i++) {
          Constructor.resolve(entries[i]).then(resolve, reject);
        }
      });
    }
  }
  /**
    `Promise.reject` returns a promise rejected with the passed `reason`.
    It is shorthand for the following:
  
    ```javascript
    let promise = new Promise(function(resolve, reject){
      reject(new Error('WHOOPS'));
    });
  
    promise.then(function(value){
      // Code here doesn't run because the promise is rejected!
    }, function(reason){
      // reason.message === 'WHOOPS'
    });
    ```
  
    Instead of writing the above, your code now simply becomes the following:
  
    ```javascript
    let promise = Promise.reject(new Error('WHOOPS'));
  
    promise.then(function(value){
      // Code here doesn't run because the promise is rejected!
    }, function(reason){
      // reason.message === 'WHOOPS'
    });
    ```
  
    @method reject
    @static
    @param {Any} reason value that the returned promise will be rejected with.
    Useful for tooling.
    @return {Promise} a promise rejected with the given `reason`.
  */


  function reject$1(reason) {
    /*jshint validthis:true */
    var Constructor = this;
    var promise = new Constructor(noop);
    reject(promise, reason);
    return promise;
  }

  function needsResolver() {
    throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
  }

  function needsNew() {
    throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
  }
  /**
    Promise objects represent the eventual result of an asynchronous operation. The
    primary way of interacting with a promise is through its `then` method, which
    registers callbacks to receive either a promise's eventual value or the reason
    why the promise cannot be fulfilled.
  
    Terminology
    -----------
  
    - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
    - `thenable` is an object or function that defines a `then` method.
    - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
    - `exception` is a value that is thrown using the throw statement.
    - `reason` is a value that indicates why a promise was rejected.
    - `settled` the final resting state of a promise, fulfilled or rejected.
  
    A promise can be in one of three states: pending, fulfilled, or rejected.
  
    Promises that are fulfilled have a fulfillment value and are in the fulfilled
    state.  Promises that are rejected have a rejection reason and are in the
    rejected state.  A fulfillment value is never a thenable.
  
    Promises can also be said to *resolve* a value.  If this value is also a
    promise, then the original promise's settled state will match the value's
    settled state.  So a promise that *resolves* a promise that rejects will
    itself reject, and a promise that *resolves* a promise that fulfills will
    itself fulfill.
  
  
    Basic Usage:
    ------------
  
    ```js
    let promise = new Promise(function(resolve, reject) {
      // on success
      resolve(value);
  
      // on failure
      reject(reason);
    });
  
    promise.then(function(value) {
      // on fulfillment
    }, function(reason) {
      // on rejection
    });
    ```
  
    Advanced Usage:
    ---------------
  
    Promises shine when abstracting away asynchronous interactions such as
    `XMLHttpRequest`s.
  
    ```js
    function getJSON(url) {
      return new Promise(function(resolve, reject){
        let xhr = new XMLHttpRequest();
  
        xhr.open('GET', url);
        xhr.onreadystatechange = handler;
        xhr.responseType = 'json';
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.send();
  
        function handler() {
          if (this.readyState === this.DONE) {
            if (this.status === 200) {
              resolve(this.response);
            } else {
              reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
            }
          }
        };
      });
    }
  
    getJSON('/posts.json').then(function(json) {
      // on fulfillment
    }, function(reason) {
      // on rejection
    });
    ```
  
    Unlike callbacks, promises are great composable primitives.
  
    ```js
    Promise.all([
      getJSON('/posts'),
      getJSON('/comments')
    ]).then(function(values){
      values[0] // => postsJSON
      values[1] // => commentsJSON
  
      return values;
    });
    ```
  
    @class Promise
    @param {Function} resolver
    Useful for tooling.
    @constructor
  */


  var Promise$1 = function () {
    function Promise(resolver) {
      this[PROMISE_ID] = nextId();
      this._result = this._state = undefined;
      this._subscribers = [];

      if (noop !== resolver) {
        typeof resolver !== 'function' && needsResolver();
        this instanceof Promise ? initializePromise(this, resolver) : needsNew();
      }
    }
    /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
     ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
     Chaining
    --------
     The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
     ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
     findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
     ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
     Assimilation
    ------------
     Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
     ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
     If the assimliated promise rejects, then the downstream promise will also reject.
     ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
     Simple Example
    --------------
     Synchronous Example
     ```javascript
    let result;
     try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
     Errback Example
     ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
     Promise Example;
     ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
     Advanced Example
    --------------
     Synchronous Example
     ```javascript
    let author, books;
     try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
     Errback Example
     ```js
     function foundBooks(books) {
     }
     function failure(reason) {
     }
     findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
     Promise Example;
     ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
     @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
    */

    /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
    ```js
    function findAuthor(){
    throw new Error('couldn't find that author');
    }
    // synchronous
    try {
    findAuthor();
    } catch(reason) {
    // something went wrong
    }
    // async with promises
    findAuthor().catch(function(reason){
    // something went wrong
    });
    ```
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
    */


    Promise.prototype["catch"] = function _catch(onRejection) {
      return this.then(null, onRejection);
    };
    /**
      `finally` will be invoked regardless of the promise's fate just as native
      try/catch/finally behaves
    
      Synchronous example:
    
      ```js
      findAuthor() {
        if (Math.random() > 0.5) {
          throw new Error();
        }
        return new Author();
      }
    
      try {
        return findAuthor(); // succeed or fail
      } catch(error) {
        return findOtherAuther();
      } finally {
        // always runs
        // doesn't affect the return value
      }
      ```
    
      Asynchronous example:
    
      ```js
      findAuthor().catch(function(reason){
        return findOtherAuther();
      }).finally(function(){
        // author was either found, or not
      });
      ```
    
      @method finally
      @param {Function} callback
      @return {Promise}
    */


    Promise.prototype["finally"] = function _finally(callback) {
      var promise = this;
      var constructor = promise.constructor;

      if (isFunction(callback)) {
        return promise.then(function (value) {
          return constructor.resolve(callback()).then(function () {
            return value;
          });
        }, function (reason) {
          return constructor.resolve(callback()).then(function () {
            throw reason;
          });
        });
      }

      return promise.then(callback, callback);
    };

    return Promise;
  }();

  Promise$1.prototype.then = then;
  Promise$1.all = all;
  Promise$1.race = race;
  Promise$1.resolve = resolve$1;
  Promise$1.reject = reject$1;
  Promise$1._setScheduler = setScheduler;
  Promise$1._setAsap = setAsap;
  Promise$1._asap = asap;
  /*global self*/

  function polyfill() {
    var local = void 0;

    if (typeof global !== 'undefined') {
      local = global;
    } else if (typeof self !== 'undefined') {
      local = self;
    } else {
      try {
        local = Function('return this')();
      } catch (e) {
        throw new Error('polyfill failed because global object is unavailable in this environment');
      }
    }

    var P = local.Promise;

    if (P) {
      var promiseToString = null;

      try {
        promiseToString = Object.prototype.toString.call(P.resolve());
      } catch (e) {// silently ignored
      }

      if (promiseToString === '[object Promise]' && !P.cast) {
        return;
      }
    }

    local.Promise = Promise$1;
  } // Strange compat..


  Promise$1.polyfill = polyfill;
  Promise$1.Promise = Promise$1;
  return Promise$1;
});

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":154}],153:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = global || self, factory(global.idb = {}));
})(void 0, function (exports) {
  'use strict';

  function toArray(arr) {
    return Array.prototype.slice.call(arr);
  }

  function promisifyRequest(request) {
    return new Promise(function (resolve, reject) {
      request.onsuccess = function () {
        resolve(request.result);
      };

      request.onerror = function () {
        reject(request.error);
      };
    });
  }

  function promisifyRequestCall(obj, method, args) {
    var request;
    var p = new Promise(function (resolve, reject) {
      request = obj[method].apply(obj, args);
      promisifyRequest(request).then(resolve, reject);
    });
    p.request = request;
    return p;
  }

  function promisifyCursorRequestCall(obj, method, args) {
    var p = promisifyRequestCall(obj, method, args);
    return p.then(function (value) {
      if (!value) return;
      return new Cursor(value, p.request);
    });
  }

  function proxyProperties(ProxyClass, targetProp, properties) {
    properties.forEach(function (prop) {
      Object.defineProperty(ProxyClass.prototype, prop, {
        get: function get() {
          return this[targetProp][prop];
        },
        set: function set(val) {
          this[targetProp][prop] = val;
        }
      });
    });
  }

  function proxyRequestMethods(ProxyClass, targetProp, Constructor, properties) {
    properties.forEach(function (prop) {
      if (!(prop in Constructor.prototype)) return;

      ProxyClass.prototype[prop] = function () {
        return promisifyRequestCall(this[targetProp], prop, arguments);
      };
    });
  }

  function proxyMethods(ProxyClass, targetProp, Constructor, properties) {
    properties.forEach(function (prop) {
      if (!(prop in Constructor.prototype)) return;

      ProxyClass.prototype[prop] = function () {
        return this[targetProp][prop].apply(this[targetProp], arguments);
      };
    });
  }

  function proxyCursorRequestMethods(ProxyClass, targetProp, Constructor, properties) {
    properties.forEach(function (prop) {
      if (!(prop in Constructor.prototype)) return;

      ProxyClass.prototype[prop] = function () {
        return promisifyCursorRequestCall(this[targetProp], prop, arguments);
      };
    });
  }

  function Index(index) {
    this._index = index;
  }

  proxyProperties(Index, '_index', ['name', 'keyPath', 'multiEntry', 'unique']);
  proxyRequestMethods(Index, '_index', IDBIndex, ['get', 'getKey', 'getAll', 'getAllKeys', 'count']);
  proxyCursorRequestMethods(Index, '_index', IDBIndex, ['openCursor', 'openKeyCursor']);

  function Cursor(cursor, request) {
    this._cursor = cursor;
    this._request = request;
  }

  proxyProperties(Cursor, '_cursor', ['direction', 'key', 'primaryKey', 'value']);
  proxyRequestMethods(Cursor, '_cursor', IDBCursor, ['update', 'delete']); // proxy 'next' methods

  ['advance', 'continue', 'continuePrimaryKey'].forEach(function (methodName) {
    if (!(methodName in IDBCursor.prototype)) return;

    Cursor.prototype[methodName] = function () {
      var cursor = this;
      var args = arguments;
      return Promise.resolve().then(function () {
        cursor._cursor[methodName].apply(cursor._cursor, args);

        return promisifyRequest(cursor._request).then(function (value) {
          if (!value) return;
          return new Cursor(value, cursor._request);
        });
      });
    };
  });

  function ObjectStore(store) {
    this._store = store;
  }

  ObjectStore.prototype.createIndex = function () {
    return new Index(this._store.createIndex.apply(this._store, arguments));
  };

  ObjectStore.prototype.index = function () {
    return new Index(this._store.index.apply(this._store, arguments));
  };

  proxyProperties(ObjectStore, '_store', ['name', 'keyPath', 'indexNames', 'autoIncrement']);
  proxyRequestMethods(ObjectStore, '_store', IDBObjectStore, ['put', 'add', 'delete', 'clear', 'get', 'getAll', 'getKey', 'getAllKeys', 'count']);
  proxyCursorRequestMethods(ObjectStore, '_store', IDBObjectStore, ['openCursor', 'openKeyCursor']);
  proxyMethods(ObjectStore, '_store', IDBObjectStore, ['deleteIndex']);

  function Transaction(idbTransaction) {
    this._tx = idbTransaction;
    this.complete = new Promise(function (resolve, reject) {
      idbTransaction.oncomplete = function () {
        resolve();
      };

      idbTransaction.onerror = function () {
        reject(idbTransaction.error);
      };

      idbTransaction.onabort = function () {
        reject(idbTransaction.error);
      };
    });
  }

  Transaction.prototype.objectStore = function () {
    return new ObjectStore(this._tx.objectStore.apply(this._tx, arguments));
  };

  proxyProperties(Transaction, '_tx', ['objectStoreNames', 'mode']);
  proxyMethods(Transaction, '_tx', IDBTransaction, ['abort']);

  function UpgradeDB(db, oldVersion, transaction) {
    this._db = db;
    this.oldVersion = oldVersion;
    this.transaction = new Transaction(transaction);
  }

  UpgradeDB.prototype.createObjectStore = function () {
    return new ObjectStore(this._db.createObjectStore.apply(this._db, arguments));
  };

  proxyProperties(UpgradeDB, '_db', ['name', 'version', 'objectStoreNames']);
  proxyMethods(UpgradeDB, '_db', IDBDatabase, ['deleteObjectStore', 'close']);

  function DB(db) {
    this._db = db;
  }

  DB.prototype.transaction = function () {
    return new Transaction(this._db.transaction.apply(this._db, arguments));
  };

  proxyProperties(DB, '_db', ['name', 'version', 'objectStoreNames']);
  proxyMethods(DB, '_db', IDBDatabase, ['close']); // Add cursor iterators
  // TODO: remove this once browsers do the right thing with promises

  ['openCursor', 'openKeyCursor'].forEach(function (funcName) {
    [ObjectStore, Index].forEach(function (Constructor) {
      // Don't create iterateKeyCursor if openKeyCursor doesn't exist.
      if (!(funcName in Constructor.prototype)) return;

      Constructor.prototype[funcName.replace('open', 'iterate')] = function () {
        var args = toArray(arguments);
        var callback = args[args.length - 1];
        var nativeObject = this._store || this._index;
        var request = nativeObject[funcName].apply(nativeObject, args.slice(0, -1));

        request.onsuccess = function () {
          callback(request.result);
        };
      };
    });
  }); // polyfill getAll

  [Index, ObjectStore].forEach(function (Constructor) {
    if (Constructor.prototype.getAll) return;

    Constructor.prototype.getAll = function (query, count) {
      var instance = this;
      var items = [];
      return new Promise(function (resolve) {
        instance.iterateCursor(query, function (cursor) {
          if (!cursor) {
            resolve(items);
            return;
          }

          items.push(cursor.value);

          if (count !== undefined && items.length == count) {
            resolve(items);
            return;
          }

          cursor["continue"]();
        });
      });
    };
  });

  function openDb(name, version, upgradeCallback) {
    var p = promisifyRequestCall(indexedDB, 'open', [name, version]);
    var request = p.request;

    if (request) {
      request.onupgradeneeded = function (event) {
        if (upgradeCallback) {
          upgradeCallback(new UpgradeDB(request.result, event.oldVersion, request.transaction));
        }
      };
    }

    return p.then(function (db) {
      return new DB(db);
    });
  }

  function deleteDb(name) {
    return promisifyRequestCall(indexedDB, 'deleteDatabase', [name]);
  }

  exports.openDb = openDb;
  exports.deleteDb = deleteDb;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});

},{}],154:[function(require,module,exports){
"use strict";

// shim for using process in browser
var process = module.exports = {}; // cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
  throw new Error('setTimeout has not been defined');
}

function defaultClearTimeout() {
  throw new Error('clearTimeout has not been defined');
}

(function () {
  try {
    if (typeof setTimeout === 'function') {
      cachedSetTimeout = setTimeout;
    } else {
      cachedSetTimeout = defaultSetTimout;
    }
  } catch (e) {
    cachedSetTimeout = defaultSetTimout;
  }

  try {
    if (typeof clearTimeout === 'function') {
      cachedClearTimeout = clearTimeout;
    } else {
      cachedClearTimeout = defaultClearTimeout;
    }
  } catch (e) {
    cachedClearTimeout = defaultClearTimeout;
  }
})();

function runTimeout(fun) {
  if (cachedSetTimeout === setTimeout) {
    //normal enviroments in sane situations
    return setTimeout(fun, 0);
  } // if setTimeout wasn't available but was latter defined


  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
    cachedSetTimeout = setTimeout;
    return setTimeout(fun, 0);
  }

  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedSetTimeout(fun, 0);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
      return cachedSetTimeout.call(null, fun, 0);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
      return cachedSetTimeout.call(this, fun, 0);
    }
  }
}

function runClearTimeout(marker) {
  if (cachedClearTimeout === clearTimeout) {
    //normal enviroments in sane situations
    return clearTimeout(marker);
  } // if clearTimeout wasn't available but was latter defined


  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
    cachedClearTimeout = clearTimeout;
    return clearTimeout(marker);
  }

  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedClearTimeout(marker);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
      return cachedClearTimeout.call(null, marker);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
      // Some versions of I.E. have different rules for clearTimeout vs setTimeout
      return cachedClearTimeout.call(this, marker);
    }
  }
}

var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
  if (!draining || !currentQueue) {
    return;
  }

  draining = false;

  if (currentQueue.length) {
    queue = currentQueue.concat(queue);
  } else {
    queueIndex = -1;
  }

  if (queue.length) {
    drainQueue();
  }
}

function drainQueue() {
  if (draining) {
    return;
  }

  var timeout = runTimeout(cleanUpNextTick);
  draining = true;
  var len = queue.length;

  while (len) {
    currentQueue = queue;
    queue = [];

    while (++queueIndex < len) {
      if (currentQueue) {
        currentQueue[queueIndex].run();
      }
    }

    queueIndex = -1;
    len = queue.length;
  }

  currentQueue = null;
  draining = false;
  runClearTimeout(timeout);
}

process.nextTick = function (fun) {
  var args = new Array(arguments.length - 1);

  if (arguments.length > 1) {
    for (var i = 1; i < arguments.length; i++) {
      args[i - 1] = arguments[i];
    }
  }

  queue.push(new Item(fun, args));

  if (queue.length === 1 && !draining) {
    runTimeout(drainQueue);
  }
}; // v8 likes predictible objects


function Item(fun, array) {
  this.fun = fun;
  this.array = array;
}

Item.prototype.run = function () {
  this.fun.apply(null, this.array);
};

process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues

process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
  return [];
};

process.binding = function (name) {
  throw new Error('process.binding is not supported');
};

process.cwd = function () {
  return '/';
};

process.chdir = function (dir) {
  throw new Error('process.chdir is not supported');
};

process.umask = function () {
  return 0;
};

},{}],155:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var runtime = function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.

  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }

  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.

    generator._invoke = makeInvokeMethod(innerFn, self, context);
    return generator;
  }

  exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.

  var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.


  var IteratorPrototype = {};

  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };

  exports.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }

    genFun.prototype = Object.create(Gp);
    return genFun;
  }; // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.


  exports.awrap = function (arg) {
    return {
      __await: arg
    };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;

        if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function (error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    } // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).


    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);

  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };

  exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.

  exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;
    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        } // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;

        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);

          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;
        var record = tryCatch(innerFn, self, context);

        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted; // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.

          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  } // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.


  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

      context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.

      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    } // The delegate iterator is finished, so forget it and continue with
    // the outer generator.


    context.delegate = null;
    return ContinueSentinel;
  } // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.


  defineIteratorMethods(Gp);
  define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.

  Gp[iteratorSymbol] = function () {
    return this;
  };

  Gp.toString = function () {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{
      tryLoc: "root"
    }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    keys.reverse(); // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.

    return function next() {
      while (keys.length) {
        var key = keys.pop();

        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      } // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.


      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];

      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;
          return next;
        };

        return next.next = next;
      }
    } // Return an iterator with no values.


    return {
      next: doneResult
    };
  }

  exports.values = values;

  function doneResult() {
    return {
      value: undefined,
      done: true
    };
  }

  Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0; // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.

      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;
      this.method = "next";
      this.arg = undefined;
      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },
    stop: function stop() {
      this.done = true;
      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;

      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;

      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      } // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.


      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  }; // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.

  return exports;
}( // If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" ? module.exports : {});

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}

},{}],156:[function(require,module,exports){
"use strict";

function Agent() {
  this._defaults = [];
}

["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects", "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function (fn) {
  /** Default setting for all requests from this agent */
  Agent.prototype[fn] = function ()
  /*varargs*/
  {
    this._defaults.push({
      fn: fn,
      arguments: arguments
    });

    return this;
  };
});

Agent.prototype._setDefaults = function (req) {
  this._defaults.forEach(function (def) {
    req[def.fn].apply(req, def.arguments);
  });
};

module.exports = Agent;

},{}],157:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Root reference for iframes.
 */
var root;

if (typeof window !== 'undefined') {
  // Browser window
  root = window;
} else if (typeof self !== 'undefined') {
  // Web Worker
  root = self;
} else {
  // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = void 0;
}

var Emitter = require('component-emitter');

var RequestBase = require('./request-base');

var isObject = require('./is-object');

var ResponseBase = require('./response-base');

var Agent = require('./agent-base');
/**
 * Noop.
 */


function noop() {}

;
/**
 * Expose `request`.
 */

var request = exports = module.exports = function (method, url) {
  // callback
  if ('function' == typeof url) {
    return new exports.Request('GET', method).end(url);
  } // url first


  if (1 == arguments.length) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
};

exports.Request = Request;
/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest && (!root.location || 'file:' != root.location.protocol || !root.ActiveXObject)) {
    return new XMLHttpRequest();
  } else {
    try {
      return new ActiveXObject('Microsoft.XMLHTTP');
    } catch (e) {}

    try {
      return new ActiveXObject('Msxml2.XMLHTTP.6.0');
    } catch (e) {}

    try {
      return new ActiveXObject('Msxml2.XMLHTTP.3.0');
    } catch (e) {}

    try {
      return new ActiveXObject('Msxml2.XMLHTTP');
    } catch (e) {}
  }

  throw Error("Browser-only version of superagent could not find XHR");
};
/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */


var trim = ''.trim ? function (s) {
  return s.trim();
} : function (s) {
  return s.replace(/(^\s*|\s*$)/g, '');
};
/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];

  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }

  return pairs.join('&');
}
/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */


function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function (v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for (var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}
/**
 * Expose serialization method.
 */


request.serializeObject = serialize;
/**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');

    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] = decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}
/**
 * Expose parser.
 */


request.parseString = parseString;
/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'text/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};
/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

request.serialize = {
  'application/x-www-form-urlencoded': serialize,
  'application/json': JSON.stringify
};
/**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};
/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');

    if (index === -1) {
      // could be empty line, just skip it
      continue;
    }

    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}
/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */


function isJSON(mime) {
  // should match /json or +json
  // but not /json-seq
  return /[\/+]json($|[^-\w])/.test(mime);
}
/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */


function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr; // responseText is accessible only if responseType is '' or 'text' and on older browsers

  this.text = this.req.method != 'HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text') || typeof this.xhr.responseType === 'undefined' ? this.xhr.responseText : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status; // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request

  if (status === 1223) {
    status = 204;
  }

  this._setStatusProperties(status);

  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders()); // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.

  this.header['content-type'] = this.xhr.getResponseHeader('content-type');

  this._setHeaderProperties(this.header);

  if (null === this.text && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method != 'HEAD' ? this._parseBody(this.text ? this.text : this.xhr.response) : null;
  }
}

ResponseBase(Response.prototype);
/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function (str) {
  var parse = request.parse[this.type];

  if (this.req._parser) {
    return this.req._parser(this, str);
  }

  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }

  return parse && str && (str.length || str instanceof Object) ? parse(str) : null;
};
/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */


Response.prototype.toError = function () {
  var req = this.req;
  var method = req.method;
  var url = req.url;
  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;
  return err;
};
/**
 * Expose `Response`.
 */


request.Response = Response;
/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case

  this._header = {}; // coerces header names to lowercase

  this.on('end', function () {
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch (e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e; // issue #675: return the raw response if the response parsing fails

      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response; // issue #876: return the http status code if the response parsing fails

        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);
    var new_err;

    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
      }
    } catch (custom_err) {
      new_err = custom_err; // ok() callback can throw
    } // #1000 don't catch errors from the callback to avoid double calling it


    if (new_err) {
      new_err.original = err;
      new_err.response = res;
      new_err.status = res.status;
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}
/**
 * Mixin `Emitter` and `RequestBase`.
 */


Emitter(Request.prototype);
RequestBase(Request.prototype);
/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function (type) {
  this.set('Content-Type', request.types[type] || type);
  return this;
};
/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */


Request.prototype.accept = function (type) {
  this.set('Accept', request.types[type] || type);
  return this;
};
/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */


Request.prototype.auth = function (user, pass, options) {
  if (1 === arguments.length) pass = '';

  if (_typeof(pass) === 'object' && pass !== null) {
    // pass is optional and can be replaced with options
    options = pass;
    pass = '';
  }

  if (!options) {
    options = {
      type: 'function' === typeof btoa ? 'basic' : 'auto'
    };
  }

  var encoder = function encoder(string) {
    if ('function' === typeof btoa) {
      return btoa(string);
    }

    throw new Error('Cannot use basic auth, btoa is not a function');
  };

  return this._auth(user, pass, options, encoder);
};
/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */


Request.prototype.query = function (val) {
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};
/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */


Request.prototype.attach = function (field, file, options) {
  if (file) {
    if (this._data) {
      throw Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }

  return this;
};

Request.prototype._getFormData = function () {
  if (!this._formData) {
    this._formData = new root.FormData();
  }

  return this._formData;
};
/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */


Request.prototype.callback = function (err, res) {
  if (this._shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};
/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */


Request.prototype.crossDomainError = function () {
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;
  err.status = this.status;
  err.method = this.method;
  err.url = this.url;
  this.callback(err);
}; // This only warns, because the request is still likely to work


Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function () {
  console.warn("This is not supported in browser version of superagent");
  return this;
}; // This throws, because it can't send/receive data as expected


Request.prototype.pipe = Request.prototype.write = function () {
  throw Error("Streaming is not supported in browser version of superagent");
};
/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */


Request.prototype._isHost = function _isHost(obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && 'object' === _typeof(obj) && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
};
/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */


Request.prototype.end = function (fn) {
  if (this._endCalled) {
    console.warn("Warning: .end() was called twice. This is not supported in superagent");
  }

  this._endCalled = true; // store callback

  this._callback = fn || noop; // querystring

  this._finalizeQueryString();

  return this._end();
};

Request.prototype._end = function () {
  var self = this;
  var xhr = this.xhr = request.getXHR();
  var data = this._formData || this._data;

  this._setTimeouts(); // state change


  xhr.onreadystatechange = function () {
    var readyState = xhr.readyState;

    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }

    if (4 != readyState) {
      return;
    } // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"


    var status;

    try {
      status = xhr.status;
    } catch (e) {
      status = 0;
    }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }

    self.emit('end');
  }; // progress


  var handleProgress = function handleProgress(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }

    e.direction = direction;
    self.emit('progress', e);
  };

  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');

      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch (e) {// Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  } // initiate request


  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  } // CORS


  if (this._withCredentials) xhr.withCredentials = true; // body

  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];

    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }

    if (serialize) data = serialize(data);
  } // set header fields


  for (var field in this.header) {
    if (null == this.header[field]) continue;
    if (this.header.hasOwnProperty(field)) xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  } // send stuff


  this.emit('request', this); // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined

  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};

request.agent = function () {
  return new Agent();
};

["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function (method) {
  Agent.prototype[method.toLowerCase()] = function (url, fn) {
    var req = new request.Request(method, url);

    this._setDefaults(req);

    if (fn) {
      req.end(fn);
    }

    return req;
  };
});
Agent.prototype.del = Agent.prototype['delete'];
/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function (url, data, fn) {
  var req = request('GET', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};
/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */


request.head = function (url, data, fn) {
  var req = request('HEAD', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};
/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */


request.options = function (url, data, fn) {
  var req = request('OPTIONS', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};
/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */


function del(url, data, fn) {
  var req = request('DELETE', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
}

request['del'] = del;
request['delete'] = del;
/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function (url, data, fn) {
  var req = request('PATCH', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};
/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */


request.post = function (url, data, fn) {
  var req = request('POST', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};
/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */


request.put = function (url, data, fn) {
  var req = request('PUT', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

},{"./agent-base":156,"./is-object":158,"./request-base":159,"./response-base":160,"component-emitter":137}],158:[function(require,module,exports){
'use strict';
/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function isObject(obj) {
  return null !== obj && 'object' === _typeof(obj);
}

module.exports = isObject;

},{}],159:[function(require,module,exports){
'use strict';
/**
 * Module of mixed-in functions shared between node and client code
 */

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isObject = require('./is-object');
/**
 * Expose `RequestBase`.
 */


module.exports = RequestBase;
/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}
/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */


function mixin(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }

  return obj;
}
/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.clearTimeout = function _clearTimeout() {
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  return this;
};
/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */


RequestBase.prototype.parse = function parse(fn) {
  this._parser = fn;
  return this;
};
/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.responseType = function (val) {
  this._responseType = val;
  return this;
};
/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */


RequestBase.prototype.serialize = function serialize(fn) {
  this._serializer = fn;
  return this;
};
/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.timeout = function timeout(options) {
  if (!options || 'object' !== _typeof(options)) {
    this._timeout = options;
    this._responseTimeout = 0;
    return this;
  }

  for (var option in options) {
    switch (option) {
      case 'deadline':
        this._timeout = options.deadline;
        break;

      case 'response':
        this._responseTimeout = options.response;
        break;

      default:
        console.warn("Unknown timeout option", option);
    }
  }

  return this;
};
/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.retry = function retry(count, fn) {
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  this._retryCallback = fn;
  return this;
};

var ERROR_CODES = ['ECONNRESET', 'ETIMEDOUT', 'EADDRINFO', 'ESOCKETTIMEDOUT'];
/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err
 * @param {Response} [res]
 * @returns {Boolean}
 */

RequestBase.prototype._shouldRetry = function (err, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
    return false;
  }

  if (this._retryCallback) {
    try {
      var override = this._retryCallback(err, res);

      if (override === true) return true;
      if (override === false) return false; // undefined falls back to defaults
    } catch (e) {
      console.error(e);
    }
  }

  if (res && res.status && res.status >= 500 && res.status != 501) return true;

  if (err) {
    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true; // Superagent timeout

    if (err.timeout && err.code == 'ECONNABORTED') return true;
    if (err.crossDomain) return true;
  }

  return false;
};
/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */


RequestBase.prototype._retry = function () {
  this.clearTimeout(); // node

  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;
  return this._end();
};
/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */


RequestBase.prototype.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;

    if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }

    this._fullfilledPromise = new Promise(function (innerResolve, innerReject) {
      self.end(function (err, res) {
        if (err) innerReject(err);else innerResolve(res);
      });
    });
  }

  return this._fullfilledPromise.then(resolve, reject);
};

RequestBase.prototype['catch'] = function (cb) {
  return this.then(undefined, cb);
};
/**
 * Allow for extension
 */


RequestBase.prototype.use = function use(fn) {
  fn(this);
  return this;
};

RequestBase.prototype.ok = function (cb) {
  if ('function' !== typeof cb) throw Error("Callback required");
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function (res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};
/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */


RequestBase.prototype.get = function (field) {
  return this._header[field.toLowerCase()];
};
/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */


RequestBase.prototype.getHeader = RequestBase.prototype.get;
/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function (field, val) {
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }

    return this;
  }

  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};
/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */


RequestBase.prototype.unset = function (field) {
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};
/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.field = function (name, val) {
  // name should be either a string or an object.
  if (null === name || undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }

    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }

    return this;
  } // val should be defined now


  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }

  if ('boolean' === typeof val) {
    val = '' + val;
  }

  this._getFormData().append(name, val);

  return this;
};
/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */


RequestBase.prototype.abort = function () {
  if (this._aborted) {
    return this;
  }

  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser

  this.req && this.req.abort(); // node

  this.clearTimeout();
  this.emit('abort');
  return this;
};

RequestBase.prototype._auth = function (user, pass, options, base64Encoder) {
  switch (options.type) {
    case 'basic':
      this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
      break;

    case 'auto':
      this.username = user;
      this.password = pass;
      break;

    case 'bearer':
      // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', 'Bearer ' + user);
      break;
  }

  return this;
};
/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */


RequestBase.prototype.withCredentials = function (on) {
  // This is browser-only functionality. Node side is no-op.
  if (on == undefined) on = true;
  this._withCredentials = on;
  return this;
};
/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.redirects = function (n) {
  this._maxRedirects = n;
  return this;
};
/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n
 * @return {Request} for chaining
 */


RequestBase.prototype.maxResponseSize = function (n) {
  if ('number' !== typeof n) {
    throw TypeError("Invalid argument");
  }

  this._maxResponseSize = n;
  return this;
};
/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */


RequestBase.prototype.toJSON = function () {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header
  };
};
/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.send = function (data) {
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  } // merge


  if (isObj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];

    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data ? this._data + '&' + data : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  } // default to json


  if (!type) this.type('json');
  return this;
};
/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */


RequestBase.prototype.sortQuery = function (sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};
/**
 * Compose querystring to append to req.url
 *
 * @api private
 */


RequestBase.prototype._finalizeQueryString = function () {
  var query = this._query.join('&');

  if (query) {
    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
  }

  this._query.length = 0; // Makes the call idempotent

  if (this._sort) {
    var index = this.url.indexOf('?');

    if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split('&');

      if ('function' === typeof this._sort) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }

      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
    }
  }
}; // For backwards compat only


RequestBase.prototype._appendQueryString = function () {
  console.trace("Unsupported");
};
/**
 * Invoke callback with timeout error.
 *
 * @api private
 */


RequestBase.prototype._timeoutError = function (reason, timeout, errno) {
  if (this._aborted) {
    return;
  }

  var err = new Error(reason + timeout + 'ms exceeded');
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function () {
  var self = this; // deadline

  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function () {
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  } // response timeout


  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function () {
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
};

},{"./is-object":158}],160:[function(require,module,exports){
'use strict';
/**
 * Module dependencies.
 */

var utils = require('./utils');
/**
 * Expose `ResponseBase`.
 */


module.exports = ResponseBase;
/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}
/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */


function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }

  return obj;
}
/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */


ResponseBase.prototype.get = function (field) {
  return this.header[field.toLowerCase()];
};
/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */


ResponseBase.prototype._setHeaderProperties = function (header) {
  // TODO: moar!
  // TODO: make this a util
  // content-type
  var ct = header['content-type'] || '';
  this.type = utils.type(ct); // params

  var params = utils.params(ct);

  for (var key in params) {
    this[key] = params[key];
  }

  this.links = {}; // links

  try {
    if (header.link) {
      this.links = utils.parseLinks(header.link);
    }
  } catch (err) {// ignore
  }
};
/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */


ResponseBase.prototype._setStatusProperties = function (status) {
  var type = status / 100 | 0; // status / class

  this.status = this.statusCode = status;
  this.statusType = type; // basics

  this.info = 1 == type;
  this.ok = 2 == type;
  this.redirect = 3 == type;
  this.clientError = 4 == type;
  this.serverError = 5 == type;
  this.error = 4 == type || 5 == type ? this.toError() : false; // sugar

  this.created = 201 == status;
  this.accepted = 202 == status;
  this.noContent = 204 == status;
  this.badRequest = 400 == status;
  this.unauthorized = 401 == status;
  this.notAcceptable = 406 == status;
  this.forbidden = 403 == status;
  this.notFound = 404 == status;
  this.unprocessableEntity = 422 == status;
};

},{"./utils":161}],161:[function(require,module,exports){
'use strict';
/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = function (str) {
  return str.split(/ *; */).shift();
};
/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */


exports.params = function (str) {
  return str.split(/ *; */).reduce(function (obj, str) {
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();
    if (key && val) obj[key] = val;
    return obj;
  }, {});
};
/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */


exports.parseLinks = function (str) {
  return str.split(/ *, */).reduce(function (obj, str) {
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};
/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */


exports.cleanHeader = function (header, changesOrigin) {
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header['host']; // secuirty

  if (changesOrigin) {
    delete header['authorization'];
    delete header['cookie'];
  }

  return header;
};

},{}],162:[function(require,module,exports){
"use strict";

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;

    var TempCtor = function TempCtor() {};

    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  };
}

},{}],163:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function isBuffer(arg) {
  return arg && _typeof(arg) === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

},{}],164:[function(require,module,exports){
(function (process,global){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var formatRegExp = /%[sdj%]/g;

exports.format = function (f) {
  if (!isString(f)) {
    var objects = [];

    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }

    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function (x) {
    if (x === '%%') return '%';
    if (i >= len) return x;

    switch (x) {
      case '%s':
        return String(args[i++]);

      case '%d':
        return Number(args[i++]);

      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }

      default:
        return x;
    }
  });

  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }

  return str;
}; // Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.


exports.deprecate = function (fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function () {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;

  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }

      warned = true;
    }

    return fn.apply(this, arguments);
  }

  return deprecated;
};

var debugs = {};
var debugEnviron;

exports.debuglog = function (set) {
  if (isUndefined(debugEnviron)) debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();

  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;

      debugs[set] = function () {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function () {};
    }
  }

  return debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */

/* legacy: obj, showHidden, depth, colors*/


function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  }; // legacy...

  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];

  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  } // set default options


  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}

exports.inspect = inspect; // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics

inspect.colors = {
  'bold': [1, 22],
  'italic': [3, 23],
  'underline': [4, 24],
  'inverse': [7, 27],
  'white': [37, 39],
  'grey': [90, 39],
  'black': [30, 39],
  'blue': [34, 39],
  'cyan': [36, 39],
  'green': [32, 39],
  'magenta': [35, 39],
  'red': [31, 39],
  'yellow': [33, 39]
}; // Don't use 'blue' not visible on cmd.exe

inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};

function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return "\x1B[" + inspect.colors[style][0] + 'm' + str + "\x1B[" + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}

function stylizeNoColor(str, styleType) {
  return str;
}

function arrayToHash(array) {
  var hash = {};
  array.forEach(function (val, idx) {
    hash[val] = true;
  });
  return hash;
}

function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
  value.inspect !== exports.inspect && // Also filter out any prototype objects using the circular check.
  !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);

    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }

    return ret;
  } // Primitive types cannot have properties


  var primitive = formatPrimitive(ctx, value);

  if (primitive) {
    return primitive;
  } // Look up the keys of the object.


  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  } // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx


  if (isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  } // Some type of object without properties can be shortcutted.


  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }

    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }

    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }

    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '',
      array = false,
      braces = ['{', '}']; // Make Array say that they are Array

  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  } // Make functions say that they are functions


  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  } // Make RegExps say that they are RegExps


  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  } // Make dates with properties first say the date


  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  } // Make error with message first say the error


  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);
  var output;

  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function (key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();
  return reduceToSingleString(output, base, braces);
}

function formatPrimitive(ctx, value) {
  if (isUndefined(value)) return ctx.stylize('undefined', 'undefined');

  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }

  if (isNumber(value)) return ctx.stylize('' + value, 'number');
  if (isBoolean(value)) return ctx.stylize('' + value, 'boolean'); // For some reason typeof null is "object", so special case here.

  if (isNull(value)) return ctx.stylize('null', 'null');
}

function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}

function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];

  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    } else {
      output.push('');
    }
  }

  keys.forEach(function (key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    }
  });
  return output;
}

function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || {
    value: value[key]
  };

  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }

  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }

  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }

      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function (line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function (line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }

  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }

    name = JSON.stringify('' + key);

    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}

function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function (prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
} // NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.


function isArray(ar) {
  return Array.isArray(ar);
}

exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}

exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}

exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}

exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}

exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}

exports.isString = isString;

function isSymbol(arg) {
  return _typeof(arg) === 'symbol';
}

exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}

exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}

exports.isRegExp = isRegExp;

function isObject(arg) {
  return _typeof(arg) === 'object' && arg !== null;
}

exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}

exports.isDate = isDate;

function isError(e) {
  return isObject(e) && (objectToString(e) === '[object Error]' || e instanceof Error);
}

exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}

exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || _typeof(arg) === 'symbol' || // ES6 symbol
  typeof arg === 'undefined';
}

exports.isPrimitive = isPrimitive;
exports.isBuffer = require('./support/isBuffer');

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}

var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']; // 26 Feb 16:19:34

function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()), pad(d.getMinutes()), pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
} // log is just a thin wrapper to console.log that prepends a timestamp


exports.log = function () {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};
/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */


exports.inherits = require('inherits');

exports._extend = function (origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;
  var keys = Object.keys(add);
  var i = keys.length;

  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }

  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./support/isBuffer":163,"_process":154,"inherits":162}]},{},[1]);
